import { TranslationKey } from './en';

export const arStrings: Partial<Record<TranslationKey, string>> = {
  "documents.picker.appLanguage": "لغة التطبيق",
  "documents.picker.selectionMissing": "هذا التصميم لم يعد متاحًا. اختر القالب الافتراضي لنشاطك التجاري للمتابعة.",
  "documents.picker.useDefault": "استخدام القالب الافتراضي للنشاط التجاري",
  // Guided document template editor
  "documents.editor.setup": "الإعدادات",
  "documents.editor.design": "التصميم",
  "documents.editor.review": "المراجعة",
  "documents.editor.createTitle": "إنشاء قالب مستند",
  "documents.editor.noBusiness": "اختر نشاطًا تجاريًا قبل تعديل القوالب.",
  "documents.editor.starterError": "تعذّر تحميل التصميم الأساسي. أعد المحاولة للمتابعة.",
  "documents.editor.suggestedName": "{{type}} — التصميم القياسي",
  "documents.editor.copyName": "{{name}} — نسخة",
  "documents.editor.saveTemplate": "حفظ القالب",
  "documents.editor.saveError": "تعذّر حفظ القالب. حاول مرة أخرى.",
  "documents.editor.previewError": "تعذّر تحميل المعاينة. حاول مرة أخرى.",
  "documents.editor.invalidColors": "أدخل رمز لون صحيحًا مثل #1a56db لكلا لوني الهوية البصرية.",
  "documents.editor.emptyLayout": "أضف تصميمًا للمستند قبل الحفظ.",
  "documents.editor.readOnly": "يمكنك معاينة هذا القالب. تعديله يتطلب صلاحية إدارة الطلبات.",
  "documents.editor.typeFixed": "هذا القالب مخصّص لهذا النوع من المستندات فقط. اختر نوعًا آخر من صفحة قوالب المستندات.",
  "documents.editor.defaultTitle": "استخدامه تلقائيًا",
  "documents.editor.defaultHint": "يُستخدم هذا القالب عند إنشاء مستند من نوع {{type}} دون اختيار تصميم آخر. لا يؤثر ذلك على أنواع المستندات الأخرى.",
  "documents.editor.branding": "هويتك البصرية",
  "documents.editor.brandingHint": "اختر مجموعة ألوان. يستخدم التصميم بيانات نشاطك التجاري وشعاره.",
  "documents.editor.palette": "مجموعة الألوان {{number}}",
  "documents.editor.businessLogo": "استخدام شعار النشاط التجاري",
  "documents.editor.advancedBranding": "شعار وألوان مخصّصة",
  "documents.editor.mode.standard": "التصميم القياسي",
  "documents.editor.mode.canvas": "لوحة التصميم (متقدم)",
  "documents.editor.mode.code": "HTML (متقدم)",
  "documents.editor.standardTitle": "تصميم {{type}} مكتمل وجاهز للاستخدام",
  "documents.editor.standardHint": "تُملأ بيانات العميل والبنود والإجماليات تلقائيًا عند إنشاء مستند فعلي. يمكنك استخدام هذا التصميم كما هو.",
  "documents.editor.standardIncludesIdentity": "هوية النشاط التجاري وبيانات المستند",
  "documents.editor.standardIncludesItems": "بيانات العميل أو المورد وبنود المستند",
  "documents.editor.standardIncludesTotals": "الإجماليات وتفاصيل الدفع أو التسليم بحسب نوع المستند",
  "documents.editor.typeParty.quotation": "بيانات العميل وتاريخ صلاحية العرض",
  "documents.editor.typeParty.proforma_invoice": "بيانات العميل والتسليم",
  "documents.editor.typeParty.order_confirmation": "بيانات العميل والتسليم",
  "documents.editor.typeParty.invoice": "بيانات العميل والرقم الضريبي للمشتري وبيانات التسليم",
  "documents.editor.typeParty.receipt": "بيانات العميل والمبلغ المستلم",
  "documents.editor.typeParty.delivery_note": "بيانات العميل وعنوان التسليم",
  "documents.editor.typeParty.packing_slip": "بيانات المورد وعنوان التسليم",
  "documents.editor.typeParty.purchase_order": "بيانات المورد وعنوان التسليم إليه",
  "documents.editor.typeItems.quotation": "البنود بأسعارها والإجماليات والملاحظات",
  "documents.editor.typeItems.proforma_invoice": "البنود بأسعارها والضريبة والإجماليات وحالة الدفع",
  "documents.editor.typeItems.order_confirmation": "البنود بأسعارها والإجماليات وحالة الدفع",
  "documents.editor.typeItems.invoice": "البنود بأسعارها والضريبة والإجماليات وحالة الدفع ورمز الفاتورة الإلكترونية QR في السعودية",
  "documents.editor.typeItems.receipt": "البنود والإجماليات والمبلغ المستلم",
  "documents.editor.typeItems.delivery_note": "البنود والكميات بدون أسعار مع توقيع الاستلام",
  "documents.editor.typeItems.packing_slip": "البنود والكميات بدون أسعار مع قائمة التجهيز والتوقيعات",
  "documents.editor.typeItems.purchase_order": "البنود المطلوبة بأسعار التكلفة والإجماليات وتوقيع الاعتماد",
  "documents.messageTemplate.sendTitle": "إرسال عبر واتساب",
  "documents.messageTemplate.sendHint": "اختر قالب رسالة معتمدًا. تُعبّأ قيمه من هذا المستند.",
  "documents.messageTemplate.sendChooseHint": "اختر قالب الرسالة الذي يُرسل به هذا المستند.",
  "documents.send.failed": "تعذّر إرسال الرسالة.",
  "documents.send.noTemplatesTitle": "لا توجد قوالب رسائل معتمدة بعد",
  "documents.send.noTemplatesHint": "يتطلب إرسال المستند عبر واتساب قالب رسالة معتمدًا. أنشئ قالبًا، وسيظهر هنا بعد اعتماده من Meta.",
  "documents.send.createTemplate": "إنشاء قالب رسالة",
  "documents.send.to": "إرسال إلى {{name}}",
  "documents.send.sent": "تمت جدولة الإرسال إلى {{phone}}. سيصل خلال ثوانٍ.",
  "documents.send.sendNow": "أرسل الآن",
  "documents.send.fillValues": "عبّئ جميع قيم القالب للإرسال.",
  "documents.forQuotation": "عرض السعر {{number}}",
  "documents.sendQuotation": "المستندات والإرسال",
  "search.open": "بحث",
  "search.pill": "ابحث عن أي شيء…",
  "search.placeholder": "ابحث في الصفحات، جهات الاتصال، الطلبات، المنتجات…",
  "search.clear": "مسح",
  "search.cancel": "إلغاء",
  "search.close": "إغلاق البحث",
  "search.copy": "نسخ",
  "search.all": "الكل",
  "search.today": "اليوم",
  "search.yesterday": "أمس",
  "search.daysAgo": "قبل {{count}} أيام",
  "search.recentlyOpened": "فُتحت مؤخرًا",
  "search.recentSearches": "عمليات بحث سابقة",
  "search.emptyTitle": "اعثر على أي شيء في نشاطك",
  "search.emptyHint": "الصفحات والإعدادات، العملاء، الطلبات، عروض الأسعار، المنتجات، الموردون، القوائم، القوالب وغيرها — حسب صلاحياتك فقط.",
  "search.tryTitle": "حدّد البحث",
  "search.tryHint": "اكتب رقم جوال، أو رقم طلب أو عرض سعر، أو رمز منتج، أو بريدًا إلكترونيًا للوصول إليه مباشرة.",
  "search.errorTitle": "لم يستجب البحث",
  "search.retry": "أعد المحاولة",
  "search.noResults": "لا توجد نتائج لـ «{{query}}»",
  "search.noResultsInGroup": "لا شيء في {{group}}. جرّب البحث في الكل.",
  "search.noResultsHint": "تحقق من الكتابة، أو استخدم كلمات أقل، أو ابحث برقم الجوال أو الرقم أو الرمز.",
  "search.searchEverywhere": "ابحث في الكل",
  "search.seeAll": "عرض كل {{group}}",
  "search.assistant": "المساعد",
  "search.askAbout": "اسأل المساعد عن «{{query}}»",
  "search.askHint": "لأسئلة مثل الإجماليات والمقارنات و«أي العملاء…»",
  "search.partial": "تعذّر تحميل بعض النتائج. حاول بعد قليل.",
  "search.keys.move": "تنقّل",
  "search.keys.open": "فتح",
  "search.keys.filter": "تصفية",
  "search.keys.edit": "تعديل",
  "search.took": "{{ms}} م.ث",
  "search.group.actions": "إجراءات سريعة",
  "search.group.pages": "الصفحات والإعدادات",
  "search.group.contacts": "جهات الاتصال",
  "search.group.orders": "الطلبات",
  "search.group.quotations": "عروض الأسعار",
  "search.group.products": "المنتجات",
  "search.group.vendors": "الموردون",
  "search.group.catalogues": "الكتالوجات",
  "search.group.data_lists": "قوائم البيانات",
  "search.group.templates": "قوالب الرسائل",
  "search.group.documents": "قوالب المستندات",
  "search.group.flows": "سير العمل",
  "search.group.events": "التقويم",
  "search.group.team": "الفريق",
  "search.group.departments": "الأقسام",
  "avatarMenu.option.lightMode": "الوضع الفاتح",
  "avatarMenu.option.darkMode": "الوضع الداكن",
  "search.askEmpty": "اسأل المساعد",
  "documents.messageTemplate.title": "قالب الرسالة",
  "documents.messageTemplate.hint": "يُرسَل إلى العميل عبر واتساب عند {{event}}.",
  "documents.messageTemplate.builtInHint": "لم تختر قالبًا، لذا تُرسل DISLIX رسالتها المدمجة.",
  "documents.messageTemplate.status.active": "مفعّل",
  "documents.messageTemplate.status.builtIn": "مدمج",
  "documents.messageTemplate.header.document": "ملف",
  "documents.messageTemplate.header.image": "صورة",
  "documents.messageTemplate.header.video": "فيديو",
  "documents.messageTemplate.header.text": "نص",
  "documents.messageTemplate.progress": "تم ملء {{done}} من {{total}}",
  "documents.messageTemplate.ready": "لا شيء لملئه. هذا القالب جاهز للإرسال.",
  "documents.messageTemplate.search": "بحث في القوالب",
  "documents.messageTemplate.noMatch": "لا توجد قوالب مطابقة لبحثك.",
  "documents.messageTemplate.event.order_placed": "إنشاء طلب",
  "documents.messageTemplate.event.order_confirmed": "تأكيد طلب",
  "documents.messageTemplate.event.order_shipped": "شحن طلب",
  "documents.messageTemplate.event.order_delivered": "تسليم طلب",
  "documents.messageTemplate.event.order_paid": "دفع طلب كليًا أو جزئيًا",
  "documents.messageTemplate.builtIn": "الرسالة المدمجة",
  "documents.messageTemplate.choose": "اختر قالب رسالة",
  "documents.messageTemplate.change": "تغيير",
  "documents.messageTemplate.remove": "استخدام الرسالة المدمجة",
  "documents.messageTemplate.createNew": "إنشاء قالب رسالة جديد",
  "documents.messageTemplate.none": "لا توجد قوالب رسائل معتمدة بعد. أنشئ واحدًا وعد بعد اعتماده.",
  "documents.messageTemplate.loadError": "تعذّر تحميل قوالب الرسائل.",
  "documents.messageTemplate.unavailable": "قالب الرسالة المختار لم يعد متاحًا. اختر قالبًا آخر.",
  "documents.messageTemplate.notApproved": "قالب الرسالة هذا غير معتمد. اختر قالبًا آخر.",
  "documents.messageTemplate.mapTitle": "ملء قيم القالب",
  "documents.messageTemplate.fileAttached": "يُرفَق ملف PDF لهذا المستند تلقائيًا كملف القالب.",
  "documents.messageTemplate.ownMedia": "تُستخدم صورة أو فيديو القالب نفسه.",
  "documents.messageTemplate.noValues": "لا توجد قيم لملئها في هذا القالب.",
  "documents.messageTemplate.valueLabel": "القيمة {{position}} · {{section}}",
  "documents.messageTemplate.section.header": "العنوان",
  "documents.messageTemplate.section.body": "النص",
  "documents.messageTemplate.section.footer": "التذييل",
  "documents.messageTemplate.section.button": "الزر",
  "documents.messageTemplate.inputPlaceholder": "اكتب نصًا أو أضف حقلًا من المستند",
  "documents.messageTemplate.insertField": "إضافة حقل من المستند",
  "documents.messageTemplate.pickField": "اختر حقلًا من المستند",
  "documents.messageTemplate.incomplete": "أكمل كل قيم قالب الرسالة أو استخدم الرسالة المدمجة.",
  "documents.editor.canvasHint": "أنشئ تصميمًا مخصّصًا بإضافة العناصر وتحريكها وتعديلها. راجع المعاينة قبل الحفظ.",
  "documents.editor.codeHint": "للمستخدمين المتقدمين: عدّل HTML والمتغيرات الديناميكية للمستند. تُحفظ التصاميم المخصّصة الحالية كما هي.",
  "documents.editor.reviewDefault": "سيُستخدم هذا التصميم تلقائيًا لمستندات {{type}}.",
  "documents.editor.reviewOptional": "سيكون هذا التصميم متاحًا للاختيار عند إنشاء مستند من نوع {{type}}.",
  "documents.editor.sampleData": "تعرض المعاينة بيانات تجريبية، وليست بيانات عميل أو طلب فعلي.",
  "documents.editor.previewReady": "معاينة المستند جاهزة. افتحها لمراجعة التصميم كاملًا.",
  "documents.editor.openPreview": "فتح المعاينة الكاملة",
  "documents.editor.continueDesign": "متابعة إلى التصميم",
  "documents.editor.continueReview": "مراجعة القالب",
  "documents.editor.unsavedTitle": "المغادرة دون حفظ؟",
  "documents.editor.unsavedHint": "ستفقد التعديلات غير المحفوظة. احفظ القالب للاحتفاظ بها.",
  "documents.editor.replaceTitle": "استبدال التصميم الحالي؟",
  "documents.editor.replaceCanvasHint": "يبدأ هذا الإجراء لوحة تصميم جديدة ويستبدل التصميم الحالي في المسودة. لن يتغير القالب المحفوظ إلا عند الحفظ.",
  "documents.editor.replaceStandardHint": "يستعيد هذا الإجراء التصميم القياسي المكتمل في المسودة. لن يتغير القالب المحفوظ إلا عند الحفظ.",
  "documents.editor.discard": "تجاهل التعديلات",
  "documents.editor.replace": "استبدال التصميم",
  // Document template setup and selection
  "documents.hub.intro": "اختر نوع المستند، وعاين شكله، ثم خصّصه لنشاطك التجاري.",
  "documents.hub.chooseDocument": "أي مستند تريد تخصيصه؟",
  "documents.hub.customCount": "{{count}} قوالب مخصّصة",
  "documents.hub.currentDefault": "القالب الافتراضي الحالي",
  "documents.hub.defaultHelp": "يُستخدم تلقائيًا عند إنشاء مستند دون اختيار قالب آخر.",
  "documents.hub.backToTypes": "كل أنواع المستندات",
  "documents.hub.standardTitle": "التصميم القياسي",
  "documents.hub.standardHint": "تصميم مكتمل يعرض بيانات نشاطك التجاري، وجاهز للاستخدام مباشرة.",
  "documents.hub.customize": "تخصيص التصميم",
  "documents.hub.preview": "معاينة",
  "documents.hub.edit": "تعديل",
  "documents.hub.useDefault": "استخدامه كقالب افتراضي",
  "documents.hub.defaultBadge": "افتراضي",
  "documents.hub.defaultSaved": "تم تحديث التصميم الافتراضي",
  "documents.hub.defaultSaveError": "تعذّر تحديث التصميم الافتراضي. حاول مرة أخرى.",
  "documents.hub.copy": "إنشاء نسخة",
  "documents.hub.searchPlaceholder": "ابحث في قوالبك",
  "documents.hub.noMatches": "لا توجد قوالب تطابق البحث",
  "documents.hub.clearSearch": "مسح البحث",
  "documents.hub.customTitle": "قوالبك",
  "documents.hub.customEmpty": "أنشئ تصميمك الخاص",
  "documents.hub.customEmptyHint": "ابدأ بالتصميم القياسي، ثم عدّل الهوية البصرية واللغة والمحتوى.",
  "documents.hub.loadError": "تعذّر تحميل القوالب. أعد المحاولة لعرض إعداداتك الافتراضية الحالية.",
  "documents.hub.retry": "إعادة المحاولة",
  "documents.hub.readOnly": "يمكنك معاينة التصاميم. تعديلها يتطلب صلاحية إدارة قوالب الطلبات.",
  "documents.hub.previewTitle": "معاينة: {{name}}",
  "documents.hub.defaultLanguage": "اللغة: {{language}}",
  "documents.picker.change": "تغيير التصميم",
  "documents.picker.businessDefault": "القالب الافتراضي لنشاطك التجاري لهذا النوع من المستندات.",
  "documents.picker.thisDocumentOnly": "اختيار خاص بهذا المستند فقط.",
  "documents.picker.templateLanguage": "استخدام إعدادات القالب",
  "documents.picker.templateLanguageHint": "يستخدم اللغة المحفوظة في القالب. وتُحدَّد اللغة التلقائية وفق إعدادات المستند.",
  "documents.picker.languageOverrideHint": "اختيار اللغة هنا يخص هذا المستند فقط.",
  "documents.picker.loadError": "تعذّر تحميل التصاميم. أعد المحاولة قبل إنشاء المستند.",
  "documents.picker.invalidDate": "أدخل تاريخ تسليم صحيحًا بصيغة YYYY-MM-DD.",
  // ─── Quotation list filters ───
  "quotations.filterSection.quotation": "عرض السعر",
  "quotations.filterSection.items": "البنود",
  "quotations.filterSection.team": "الفريق والعملة",
  "quotations.filters.converted": "تحويل إلى طلب",
  "quotations.filters.convertedYes": "تم التحويل",
  "quotations.filters.convertedNo": "لم يُحوَّل بعد",
  "quotations.filters.products": "يحتوي على المنتج",
  "quotations.filters.vendors": "المورد",
  "quotations.filters.vendorsHint": "عروض الأسعار التي تحتوي منتجًا واحدًا على الأقل من منتجات المورد.",
  "quotations.sort.updated": "المحدَّثة مؤخرًا",
  "quotations.view.drafts": "المسودات",
  "quotations.view.awaiting": "بانتظار الرد",
  "quotations.view.toConvert": "مقبولة ولم تُحوَّل",
  "quotations.view.expiringSoon": "تنتهي خلال 7 أيام",
  "quotations.view.thisMonth": "هذا الشهر",
  // ─── Business documents & templates ───
  "businessProfile.legal": "البيانات القانونية والضريبية",
  "businessProfile.legalHint": "تُطبع على الفواتير والمستندات الأخرى. في السعودية يُستخدم الرقم الضريبي أيضًا في رمز QR للفاتورة الإلكترونية.",
  "businessProfile.legalName": "الاسم القانوني (المسجل)",
  "businessProfile.vatNumber": "الرقم الضريبي",
  "businessProfile.crNumber": "رقم السجل التجاري",
  "documents.title": "المستندات",
  "documents.templatesTitle": "قوالب المستندات",
  "documents.allTypes": "الكل",
  "documents.chooseType": "لأي مستند هذا القالب؟",
  "documents.newTemplateAction": "قالب جديد",
  "documents.newTemplate": "قالب {{type}} جديد",
  "documents.noTemplates": "لا توجد قوالب بعد",
  "documents.noTemplatesHint": "تستخدم المستندات التصميم الافتراضي حتى تضيف قالبًا.",
  "documents.typeLabel": "نوع المستند",
  "documents.language": "اللغة",
  "documents.languageHint": "«تلقائي» يستخدم لغة من يُنشئ المستند. «ثنائي اللغة» يطبع العناوين بالإنجليزية والعربية معًا.",
  "documents.lang.auto": "تلقائي",
  "documents.lang.en": "English",
  "documents.lang.ar": "العربية",
  "documents.lang.bilingual": "ثنائي اللغة (EN + AR)",
  "documents.startFromBuiltIn": "البدء من التصميم الافتراضي",
  "documents.template": "القالب",
  "documents.defaultTemplate": "الافتراضي: {{name}}",
  "documents.builtIn": "التصميم الافتراضي",
  "documents.create": "إنشاء مستند",
  "documents.createPdf": "إنشاء ملف PDF",
  "documents.forOrder": "الطلب {{number}}",
  "documents.hidePhone": "إخفاء هاتف العميل",
  "documents.deliverBy": "تاريخ التسليم المطلوب (اختياري)",
  "documents.noteToVendor": "ملاحظة للمورد (اختياري)",
  "documents.failed": "تعذّر إنشاء المستند",
  "documents.ready": "{{title}} {{number}} جاهز.",
  "documents.open": "فتح ملف PDF",
  "documents.sendWhatsapp": "إرسال عبر واتساب {{name}}",
  "documents.sendEmail": "إرسال بالبريد الإلكتروني",
  "documents.another": "إنشاء مستند آخر",
  "documents.shareText": "مرحبًا {{name}}، إليك {{title}} رقم {{number}}: {{url}}",
  "documents.receiptNeedsPayment": "متاح بعد دفع الطلب كليًا أو جزئيًا",
  "documents.type.quotation": "عرض سعر",
  "documents.type.proforma_invoice": "فاتورة مبدئية",
  "documents.type.order_confirmation": "تأكيد الطلب",
  "documents.type.invoice": "فاتورة ضريبية",
  "documents.type.receipt": "إيصال استلام",
  "documents.type.delivery_note": "إشعار تسليم",
  "documents.type.packing_slip": "إيصال تجهيز",
  "documents.type.purchase_order": "أمر شراء",
  "documents.typeHint.quotation": "عرض أسعار قبل طلب العميل",
  "documents.typeHint.proforma_invoice": "فاتورة مسبقة قبل التسليم أو الدفع",
  "documents.typeHint.order_confirmation": "الطلب كما تم الاتفاق عليه مع الأسعار",
  "documents.typeHint.invoice": "تفاصيل الضريبة ورمز QR للفاتورة الإلكترونية في السعودية",
  "documents.typeHint.receipt": "يؤكد المبلغ المدفوع",
  "documents.typeHint.delivery_note": "ما يتم تسليمه دون أسعار مع توقيع الاستلام",
  "documents.typeHint.packing_slip": "ما يجهزه المورد أو المستودع",
  "documents.typeHint.purchase_order": "ما تطلبه من المورد بأسعار التكلفة",
  // ─── List filters (orders, products, vendors, catalogues, data lists) ───
  "listFilters.filters": "التصفية",
  "listFilters.filtersWithCount": "التصفية ({{count}})",
  "listFilters.sortBy": "الترتيب حسب",
  "listFilters.reset": "إعادة تعيين",
  "listFilters.apply": "عرض النتائج",
  "listFilters.applyWithCount": "عرض النتائج ({{count}} عوامل)",
  "listFilters.clear": "مسح",
  "listFilters.clearAll": "مسح الكل",
  "listFilters.clearSearch": "مسح البحث",
  "listFilters.min": "من",
  "listFilters.max": "إلى",
  "listFilters.anyDate": "أي تاريخ",
  "listFilters.moreFields": "حقول أخرى",
  "listFilters.hasValue": "له قيمة",
  "listFilters.noValue": "بدون قيمة",
  "listFilters.noValues": "لا توجد قيم بعد",
  "listFilters.searchValues": "ابحث في القيم…",
  "listFilters.searchToAdd": "ابحث للإضافة…",
  "listFilters.removeFilter": "إزالة عامل التصفية: {{label}}",
  "listFilters.saveView": "حفظ العرض",
  "listFilters.saveViewTitle": "حفظ هذا العرض",
  "listFilters.saveViewHint": "يحفظ عوامل التصفية والترتيب والبحث الحالية كتبويب أعلى القائمة (على هذا الجهاز).",
  "listFilters.viewName": "اسم العرض، مثل «غير مدفوعة هذا الأسبوع»",
  "listFilters.savedViews": "العروض المحفوظة",
  "listFilters.manageViews": "إدارة العروض المحفوظة",
  "listFilters.deleteView": "حذف العرض {{name}}",
  "listFilters.noSavedViews": "لا توجد عروض محفوظة بعد.",
  "orders.filter.title": "تصفية الطلبات",
  "orders.filter.orderStatus": "حالة الطلب",
  "orders.filter.paymentStatus": "الدفع",
  "orders.filter.source": "المصدر",
  "orders.filter.orderDate": "تاريخ الطلب",
  "orders.filter.total": "إجمالي الطلب",
  "orders.filter.vendors": "المورد",
  "orders.filter.vendorsHint": "الطلبات التي تحتوي بندًا واحدًا على الأقل من هؤلاء الموردين.",
  "orders.filter.products": "يحتوي على المنتج",
  "orders.filter.invoice": "الفاتورة",
  "orders.filter.invoiceYes": "أُنشئت الفاتورة",
  "orders.filter.invoiceNo": "لا توجد فاتورة بعد",
  "orders.filter.slip": "إيصال التجهيز",
  "orders.filter.slipYes": "تمت طباعته",
  "orders.filter.slipNo": "لم يُطبع بعد",
  "orders.filterSection.order": "الطلب",
  "orders.filterSection.items": "البنود",
  "orders.filterSection.documents": "المستندات",
  "orders.sort.newest": "الأحدث أولًا",
  "orders.sort.oldest": "الأقدم أولًا",
  "orders.sort.totalDesc": "الأعلى إجمالًا",
  "orders.sort.totalAsc": "الأقل إجمالًا",
  "orders.sort.updated": "المحدَّثة مؤخرًا",
  "orders.view.toFulfil": "قيد التجهيز",
  "orders.view.unpaid": "غير مدفوعة",
  "orders.view.today": "اليوم",
  "orders.view.thisWeek": "هذا الأسبوع",
  "products.filter.title": "تصفية المنتجات",
  "products.filter.search": "ابحث بالاسم أو الرمز أو العلامة…",
  "products.filter.categories": "الفئة",
  "products.filter.vendors": "المورد",
  "products.filter.withoutVendor": "ارتباط المورد",
  "products.filter.withoutVendorYes": "بدون مورد",
  "products.filter.brand": "العلامة التجارية",
  "products.filter.type": "النوع",
  "products.filter.stock": "المخزون",
  "products.filter.availability": "التوفر",
  "products.filter.price": "السعر",
  "products.filter.condition": "الحالة",
  "products.filter.variants": "المتغيرات",
  "products.filter.withVariants": "له متغيرات",
  "products.filter.noVariants": "بدون متغيرات",
  "products.filter.photo": "الصورة",
  "products.filter.withPhoto": "له صورة",
  "products.filter.noPhoto": "بدون صورة",
  "products.filter.added": "تاريخ الإضافة",
  "products.filterSection.catalog": "الكتالوج",
  "products.filterSection.stock": "المخزون",
  "products.filterSection.details": "التفاصيل",
  "products.stock.in": "متوفر",
  "products.stock.low": "مخزون منخفض",
  "products.stock.out": "نفد من المخزون",
  "products.availability.in_stock": "متوفر",
  "products.availability.out_of_stock": "غير متوفر",
  "products.availability.preorder": "طلب مسبق",
  "products.availability.backorder": "طلب مؤجل",
  "products.condition.new": "جديد",
  "products.condition.refurbished": "مجدَّد",
  "products.condition.used": "مستعمل",
  "products.type.physical": "مادي",
  "products.type.digital": "رقمي",
  "products.type.service": "خدمة",
  "products.field.name": "الاسم",
  "products.field.sku": "رمز المنتج",
  "products.sort.newest": "الأحدث أولًا",
  "products.sort.name": "الاسم (أ–ي)",
  "products.sort.priceAsc": "الأقل سعرًا",
  "products.sort.priceDesc": "الأعلى سعرًا",
  "products.sort.stockAsc": "الأقل مخزونًا",
  "products.sort.updated": "المحدَّثة مؤخرًا",
  "products.view.lowStock": "مخزون منخفض",
  "products.view.outOfStock": "نفد من المخزون",
  "products.view.noVendor": "بدون مورد",
  "products.view.noPhoto": "بدون صورة",
  "products.view.new": "أُضيفت خلال 30 يومًا",
  "vendors.filterSection.sales": "المبيعات",
  "vendors.filterSection.vendor": "المورد",
  "vendors.filters.hasProducts": "لديه منتجات",
  "vendors.view.hasOrders": "لديه طلبات",
  "vendors.view.topRevenue": "الأعلى إيرادًا",
  "vendors.view.noProducts": "بدون منتجات",
  "vendors.view.withMinimum": "لديه حد أدنى للطلب",
  "catalogues.filter.title": "تصفية الكتالوجات",
  "catalogues.filter.search": "ابحث في الكتالوجات…",
  "catalogues.filter.products": "عدد المنتجات",
  "catalogues.filter.added": "تاريخ الإضافة",
  "catalogues.filter.kind": "النوع",
  "catalogues.field.name": "الاسم",
  "catalogues.field.currency": "العملة",
  "catalogues.field.locale": "اللغة",
  "catalogues.field.hasProducts": "لديه منتجات",
  "catalogues.sort.newest": "الأحدث أولًا",
  "catalogues.sort.name": "الاسم (أ–ي)",
  "catalogues.sort.products": "الأكثر منتجات",
  "catalogues.sort.updated": "المحدَّثة مؤخرًا",
  "catalogues.view.empty": "فارغة",
  "catalogues.view.new": "أُضيفت خلال 30 يومًا",
  "dataLists.filter.title": "تصفية قوائم البيانات",
  "dataLists.filter.type": "نوع القائمة",
  "dataLists.filter.module": "الوحدة",
  "dataLists.filter.source": "مصدر البيانات",
  "dataLists.filter.sourceManual": "يدوي",
  "dataLists.filter.sourceWebhook": "ويب هوك (مباشر)",
  "dataLists.filter.records": "السجلات",
  "dataLists.filter.hasRecords": "بها سجلات",
  "dataLists.filter.noRecords": "فارغة",
  "dataLists.filter.added": "تاريخ الإضافة",
  "dataLists.view.custom": "قوائم مخصصة",
  "dataLists.view.system": "قوائم النظام",
  "dataLists.view.webhook": "ويب هوك",
  "dataLists.view.empty": "فارغة",
  "dataLists.sort.newest": "الأحدث أولًا",
  "dataLists.sort.oldest": "الأقدم أولًا",
  "dataLists.sort.name": "الاسم (أ–ي)",
  "dataLists.sort.updated": "المحدَّثة مؤخرًا",
  "dataLists.sort.columnAsc": "{{name}} ↑",
  "dataLists.sort.columnDesc": "{{name}} ↓",
  "dataLists.records.filterTitle": "تصفية السجلات",
  "dataLists.records.filterContains": "يحتوي على…",
  "dataLists.schema.systemModule.vendors": "الموردون",
  "dataLists.schema.systemModule.quotations": "عروض الأسعار",
  // ─── Header action titles ───
  "common.download": "تنزيل",
  "common.import": "استيراد",
  "common.share": "مشاركة",
  "common.print": "طباعة",
  "common.refresh": "تحديث",
  "common.select": "تحديد",
  "common.settings": "الإعدادات",
  "common.options": "خيارات",
  "common.view": "عرض",
  "common.sort": "ترتيب",
  "common.send": "إرسال",
  "common.moreActions": "إجراءات أخرى",
  // ─── Vendors: list, orders, analytics, packing slips ───
  "workspaceAssistant.proposal.createQuotation": "إنشاء عرض السعر",
  "workspaceAssistant.quotation.check": "تأكد من المنتج",
  "workspaceAssistant.quotation.missing": "غير موجود في الكتالوج",
  "workspaceAssistant.quotation.remove": "استبعاد",
  "workspaceAssistant.quotation.restore": "إعادة",
  "workspaceAssistant.quotation.quantity": "الكمية",
  "workspaceAssistant.quotation.minimum": "الحد الأدنى للطلب: {{count}}",
  "workspaceAssistant.quotation.subtotal": "المجموع قبل الضريبة",
  "workspaceAssistant.quotation.taxNote": "تُضاف الضريبة والرسوم حسب إعدادات نشاطك عند الإنشاء.",
  "workspaceAssistant.quotation.openPdf": "فتح PDF عرض السعر",
  "workspaceAssistant.quotation.open": "فتح عرض السعر",
  "workspaceAssistant.proposal.createSlips": "إنشاء إيصالات التجهيز",
  "workspaceAssistant.proposal.openVendor": "فتح المورد",
  "workspaceAssistant.proposal.openOrder": "فتح الطلب",
  "orders.form.lineVendor": "مورد هذا البند",
  "orders.form.packingSlips": "إيصالات التجهيز",
  "orders.form.packingSlipsScope": "هذا الطلب — إيصال لكل مورد ({{count}})",
  "vendors.tab.overview": "نظرة عامة",
  "vendors.tab.products": "المنتجات",
  "vendors.tab.orders": "الطلبات",
  "vendors.tab.analytics": "التحليلات",
  "vendors.period.7d": "7 أيام",
  "vendors.period.30d": "30 يومًا",
  "vendors.period.90d": "90 يومًا",
  "vendors.period.month": "هذا الشهر",
  "vendors.period.year": "هذا العام",
  "vendors.period.all": "كل الفترات",
  "vendors.sort.newest": "الأحدث",
  "vendors.sort.name": "الاسم (أ–ي)",
  "vendors.sort.revenue": "الأعلى إيرادًا",
  "vendors.sort.orders": "الأكثر طلبات",
  "vendors.sort.units": "الأكثر وحدات",
  "vendors.sort.lastOrder": "أحدث طلب",
  "vendors.sort.products": "الأكثر منتجات",
  "vendors.list.title": "الموردون",
  "vendors.list.search": "ابحث عن مورد…",
  "vendors.list.count": "{{count}} مورد",
  "vendors.list.empty": "لا يوجد موردون بعد",
  "vendors.list.emptyHint": "اضغط + لإضافة أول مورد",
  "vendors.list.noMatch": "لا يوجد موردون يطابقون عوامل التصفية",
  "vendors.list.error": "خطأ",
  "vendors.list.loadFailed": "تعذّر تحميل الموردين",
  "vendors.list.exportCsv": "تنزيل بصيغة CSV (Excel)",
  "vendors.list.exportFailed": "تعذّر إنشاء ملف CSV",
  "vendors.list.select": "تحديد",
  "vendors.list.cancelSelection": "إلغاء التحديد",
  "vendors.list.selected": "تم تحديد {{count}}",
  "vendors.list.addProduct": "إضافة منتج",
  "vendors.list.addProductTitle": "إضافة منتج إلى الموردين",
  "vendors.list.addConfirm": "إضافة",
  "vendors.list.added": "تمت الإضافة",
  "vendors.list.productsAdded": "أُضيفت المنتجات إلى {{count}} مورد",
  "vendors.list.addFailed": "تعذّرت إضافة المنتجات",
  "vendors.list.bulkUpload": "رفع جماعي",
  "vendors.list.add": "إضافة مورد",
  "vendors.list.delete": "حذف",
  "vendors.list.deleteTitle": "حذف المورد",
  "vendors.list.deleteMessage": "هل تريد حذف هذا المورد؟ لا يمكن التراجع عن ذلك.",
  "vendors.list.deleted": "تم الحذف",
  "vendors.list.deletedMessage": "تم حذف المورد",
  "vendors.list.deleteFailed": "تعذّر حذف المورد",
  "vendors.row.products": "{{count}} منتج",
  "vendors.row.orders": "{{count}} طلب",
  "vendors.row.units": "{{count}} وحدة",
  "vendors.row.lastOrder": "آخر طلب {{date}}",
  "vendors.row.noOrders": "لا طلبات في هذه الفترة",
  "vendors.row.noContact": "لا توجد بيانات اتصال",
  "vendors.chip.minOrders": "{{count}} طلبات على الأقل",
  "vendors.chip.statuses": "{{count}} حالات طلب",
  "vendors.chip.clearAll": "مسح الكل",
  "vendors.chip.remove": "إزالة عامل التصفية: {{label}}",
  "vendors.csv.name": "الاسم",
  "vendors.csv.phone": "الهاتف",
  "vendors.csv.email": "البريد الإلكتروني",
  "vendors.csv.city": "المدينة",
  "vendors.csv.country": "الدولة",
  "vendors.csv.cr": "السجل التجاري",
  "vendors.csv.vat": "الرقم الضريبي",
  "vendors.csv.products": "المنتجات",
  "vendors.csv.orders": "الطلبات",
  "vendors.csv.units": "الوحدات",
  "vendors.csv.revenue": "الإيرادات",
  "vendors.csv.lastOrder": "آخر طلب",
  "vendors.csv.minimum": "الحد الأدنى للطلب",
  "vendors.csv.added": "تاريخ الإضافة",
  "vendors.filters.title": "الترتيب والتصفية",
  "vendors.filters.close": "إغلاق",
  "vendors.filters.reset": "إعادة تعيين",
  "vendors.filters.apply": "عرض الموردين",
  "vendors.filters.applyWithCount": "عرض الموردين ({{count}} عوامل)",
  "vendors.filters.sort": "الترتيب حسب",
  "vendors.filters.orders": "الطلبات في الفترة",
  "vendors.filters.ordersHint": "تُحسب للفترة المختارة أعلى القائمة.",
  "vendors.filters.hasOrders": "لديه طلبات",
  "vendors.filters.noOrders": "بدون طلبات",
  "vendors.filters.minOrders": "عدد الطلبات لا يقل عن",
  "vendors.filters.revenue": "الإيرادات",
  "vendors.filters.revenueIn": "الإيرادات ({{currency}})",
  "vendors.filters.min": "من",
  "vendors.filters.max": "إلى",
  "vendors.filters.countedStatuses": "الطلبات المحتسبة",
  "vendors.filters.countedStatusesHint": "افتراضيًا كل الطلبات عدا المعلّقة والملغاة.",
  "vendors.filters.products": "عدد المنتجات",
  "vendors.filters.minimum": "الحد الأدنى لقيمة الطلب",
  "vendors.filters.minimumSet": "لديه حد أدنى",
  "vendors.filters.minimumNone": "بدون حد أدنى",
  "vendors.filters.location": "الموقع",
  "vendors.filters.city": "المدينة",
  "vendors.filters.country": "الدولة",
  "vendors.filters.added": "تاريخ الإضافة",
  "vendors.filters.anyDate": "أي تاريخ",
  "vendors.filters.fields": "التصفية حسب الحقول",
  "vendors.filters.fieldsWithCount": "التصفية حسب الحقول ({{count}})",
  "vendors.detail.phone": "الهاتف",
  "vendors.detail.email": "البريد الإلكتروني",
  "vendors.detail.address": "العنوان",
  "vendors.detail.crNumber": "السجل التجاري",
  "vendors.detail.vatNumber": "الرقم الضريبي",
  "vendors.detail.notes": "ملاحظات",
  "vendors.detail.files": "الملفات",
  "vendors.detail.productsSupplied": "المنتجات المورَّدة ({{count}})",
  "vendors.detail.manageProducts": "إدارة المنتجات",
  "vendors.detail.noProducts": "لا توجد منتجات مرتبطة بهذا المورد بعد",
  "vendors.orders.search": "رقم الطلب أو العميل أو الهاتف",
  "vendors.orders.filters": "التصفية",
  "vendors.orders.filtersWithCount": "التصفية ({{count}})",
  "vendors.orders.status": "حالة الطلب",
  "vendors.orders.toFulfil": "قيد التجهيز",
  "vendors.orders.allPlaced": "كل الطلبات المؤكدة",
  "vendors.orders.payment": "الدفع",
  "vendors.orders.slip": "إيصال التجهيز",
  "vendors.orders.slipNo": "لم يُطبع بعد",
  "vendors.orders.slipYes": "تمت طباعته",
  "vendors.orders.product": "يحتوي على المنتج",
  "vendors.orders.count": "{{count}} طلب",
  "vendors.orders.selected": "تم تحديد {{count}}",
  "vendors.orders.select": "تحديد الطلب",
  "vendors.orders.slipsSelected": "إيصالات التجهيز ({{count}})",
  "vendors.orders.slipsAll": "إيصالات تجهيز للكل",
  "vendors.orders.units": "{{count}} وحدة",
  "vendors.orders.otherLines": "{{count}} بنود من موردين آخرين",
  "vendors.orders.slipPrinted": "طُبع الإيصال {{date}}",
  "vendors.orders.empty": "لا توجد طلبات لمنتجات هذا المورد تطابق التصفية",
  "vendors.orders.loadMore": "عرض المزيد ({{shown}} من {{total}})",
  "vendors.orders.loadFailed": "تعذّر تحميل الطلبات",
  "vendors.analytics.revenue": "الإيرادات",
  "vendors.analytics.orders": "الطلبات",
  "vendors.analytics.units": "الوحدات",
  "vendors.analytics.averageOrder": "متوسط الطلب",
  "vendors.analytics.customers": "العملاء",
  "vendors.analytics.minimumMet": "بلوغ الحد الأدنى",
  "vendors.analytics.minimumNote": "بلغ {{percent}}٪ من الطلبات الحد الأدنى للمورد البالغ {{amount}}.",
  "vendors.analytics.vsPrevious": "مقارنة بالفترة السابقة",
  "vendors.analytics.counting": "المحتسب:",
  "vendors.analytics.over.revenue": "الإيرادات عبر الزمن",
  "vendors.analytics.over.orders": "الطلبات عبر الزمن",
  "vendors.analytics.over.units": "الوحدات عبر الزمن",
  "vendors.analytics.topProducts": "أعلى المنتجات إيرادًا",
  "vendors.analytics.byStatus": "الطلبات حسب الحالة",
  "vendors.analytics.empty": "لا توجد طلبات لمنتجات هذا المورد في هذه الفترة",
  "vendors.analytics.truncated": "تُعرض أحدث 20,000 طلب في هذه الفترة.",
  "vendors.analytics.loadFailed": "تعذّر تحميل التحليلات",
  "vendors.slips.title": "إيصالات التجهيز",
  "vendors.slips.language": "اللغة",
  "vendors.slips.pickList": "قائمة التجميع أولًا",
  "vendors.slips.pickListHint": "إجمالي كل منتج عبر الطلبات، ثم إيصال لكل طلب.",
  "vendors.slips.showPrices": "إظهار الأسعار",
  "vendors.slips.showPricesHint": "مخفية افتراضيًا — فالإيصال يُرفق عادةً مع الشحنة.",
  "vendors.slips.hidePhone": "إخفاء هاتف العميل",
  "vendors.slips.generate": "إنشاء ملف PDF",
  "vendors.slips.failed": "تعذّر إنشاء إيصالات التجهيز",
  "vendors.slips.ready": "{{count}} إيصال تجهيز جاهز.",
  "vendors.slips.truncated": "يتضمن أول {{count}} طلب فقط.",
  "vendors.slips.open": "فتح ملف PDF",
  "vendors.slips.sendWhatsapp": "إرسال إلى المورد عبر واتساب",
  "vendors.slips.sendEmail": "إرسال إلى المورد بالبريد",
  "vendors.slips.emailSubject": "إيصالات التجهيز",
  "vendors.slips.shareText": "مرحبًا {{name}}، هذه إيصالات التجهيز المطلوب تجهيزها: {{url}}",
  "vendors.slips.scopeSelected": "{{count}} طلبات محددة",
  "vendors.slips.scopeAll": "كل الطلبات المطابقة للتصفية ({{count}})",
  'workspaceAssistant.savePdf': "تنزيل الإجابة بصيغة PDF",
  'workspaceAssistant.exportChatPdf': "تنزيل المحادثة بصيغة PDF",
  'workspaceAssistant.downloadPdf': "تنزيل PDF",
  'workspaceAssistant.pdfSaving': "جارٍ تجهيز PDF…",
  'workspaceAssistant.pdfFailed': "تعذّر إنشاء ملف PDF. حاول مرة أخرى.",
  'workspaceAssistant.table.chart': "عرض الرسم البياني",
  'workspaceAssistant.table.hideChart': "إخفاء الرسم البياني",
  'workspaceAssistant.paneTab.assistant': "المساعد الذكي",
  'workspaceAssistant.paneTab.chat': "المحادثة",
  'workspaceAssistant.paneTab.calls': "المكالمات",
  'workspaceAssistant.paneTab.form': "النموذج",
  'workspaceAssistant.paneTab.contacts': "جهات الاتصال",
  'workspaceAssistant.paneTab.contact': "جهة الاتصال",
  'workspaceAssistant.paneTab.settings': "الإعدادات",
  'workspaceAssistant.paneTab.details': "التفاصيل",
  'workspaceAssistant.table.copy': "نسخ الجدول (للصق في Excel / Sheets)",
  'workspaceAssistant.table.csv': "تنزيل CSV (Excel)",
  'workspaceAssistant.table.open': "فتح",
  'workspaceAssistant.table.chat': "فتح المحادثة",
  'workspaceAssistant.table.call': "اتصال",
  'workspaceAssistant.table.filter': "تصفية الصفوف",
  'workspaceAssistant.table.noMatch': "لا توجد صفوف مطابقة.",
  'workspaceAssistant.table.showing': "{{shown}} من {{total}}",
  'workspaceAssistant.table.showAll': "عرض الكل ({{count}})",
  'workspaceAssistant.table.showLess': "عرض أقل",
  'workspaceAssistant.table.loadMore': "تحميل المزيد",
  'workspaceAssistant.table.expand': "فتح الجدول",
  'workspaceAssistant.table.moreColumns': "+{{count}} أعمدة",
  'workspaceAssistant.table.close': "إغلاق",
  'workspaceAssistant.table.chatFailed': "تعذّر فتح المحادثة. جرّب من ملف جهة الاتصال.",
  'workspaceAssistant.table.callFailed': "لا يوجد رقم للاتصال بجهة الاتصال هذه.",
  'workspaceAssistant.onScreen': "في: {{screen}}",
  'workspaceAssistant.copy': "نسخ الرد",
  'workspaceAssistant.askAgain': "اسأل مرة أخرى",
  'workspaceAssistant.newReply': "رد جديد",
  'workspaceAssistant.enterHint': "Enter للإرسال · Shift+Enter لسطر جديد",
  'workspaceAssistant.screen.chat': "صندوق الوارد",
  'workspaceAssistant.screen.conversation': "محادثة",
  'workspaceAssistant.screen.contacts': "جهات الاتصال",
  'workspaceAssistant.screen.home': "الرئيسية",
  'workspaceAssistant.screen.products-list': "المنتجات",
  'workspaceAssistant.screen.product-detail': "منتج",
  'workspaceAssistant.screen.vendors': "الموردين",
  'workspaceAssistant.screen.orders': "الطلبات",
  'workspaceAssistant.screen.quotations': "عروض الأسعار",
  'workspaceAssistant.screen.dashboard': "لوحة التحكم",
  'workspaceAssistant.screen.performance': "التقارير",
  'workspaceAssistant.screen.template-management': "القوالب",
  'workspaceAssistant.screen.lead-finder': "باحث العملاء",
  'workspaceAssistant.screen.flows-list': "سير العمل",
  'workspaceAssistant.screen.data-lists': "قوائم البيانات",
  'workspaceAssistant.screen.settings': "الإعدادات",
  'workspaceAssistant.area.inbox': "صندوق الوارد",
  'workspaceAssistant.area.customers': "العملاء",
  'workspaceAssistant.area.products': "المنتجات والموردين",
  'workspaceAssistant.area.messages': "الرسائل والقوالب",
  'workspaceAssistant.area.analytics': "المبيعات والتحليلات",
  'workspaceAssistant.area.market': "مقارنة الأسعار",
  'workspaceAssistant.starter.inbox.waiting': "كم عدد العملاء الذين ينتظرون ردنا؟ رتّبهم من الأقدم مع آخر رسالة",
  'workspaceAssistant.starter.inbox.today': "من العملاء الذين راسلونا اليوم؟",
  'workspaceAssistant.starter.customers.find': "ابحث عن جهة الاتصال",
  'workspaceAssistant.starter.customers.mine': "ما جهات الاتصال المسندة إليّ؟",
  'workspaceAssistant.starter.products.coverage': "ما المنتجات التي تحتاج إلى موردين أو أصناف بديلة؟",
  'workspaceAssistant.starter.products.prices': "ما أسعار",
  'workspaceAssistant.starter.messages.received': "من استلم قوالبنا خلال آخر ٧ أيام؟",
  'workspaceAssistant.starter.messages.template': "اكتب قالب واتساب لعرض جديد",
  'workspaceAssistant.starter.analytics.sales': "مبيعات هذا الشهر مقارنةً بالشهر الماضي",
  'workspaceAssistant.starter.analytics.topCustomers': "من أكثر العملاء شراءً هذا الشهر؟",
  'workspaceAssistant.starter.market.compare': "قارن أسعارنا بأسعار هذا المتجر:",
  'workspaceAssistant.stage.history': "جارٍ قراءة المحادثة…",
  'workspaceAssistant.stage.business': "جارٍ قراءة بيانات النشاط…",
  'workspaceAssistant.stage.catalogue': "جارٍ البحث في المنتجات…",
  'workspaceAssistant.stage.lookup.conversations': "جارٍ مراجعة صندوق الوارد…",
  'workspaceAssistant.stage.lookup.messages': "جارٍ قراءة سجل الرسائل…",
  'workspaceAssistant.stage.lookup.contacts': "جارٍ البحث في جهات الاتصال…",
  'workspaceAssistant.stage.lookup.products': "جارٍ البحث في المنتجات…",
  'workspaceAssistant.stage.lookup.product_coverage': "جارٍ تحليل المنتجات…",
  'workspaceAssistant.stage.lookup.web_prices': "جارٍ قراءة أسعار المتجر…",
  'workspaceAssistant.stage.lookup.analytics': "جارٍ الحساب…",
  'workspaceAssistant.stage.lookup.orders': "جارٍ قراءة الطلبات…",
  'workspaceAssistant.stage.lookup.quotations': "جارٍ قراءة عروض الأسعار…",
  'workspaceAssistant.stage.lookup.vendors': "جارٍ قراءة الموردين…",
  'workspaceAssistant.stage.lookup.templates': "جارٍ قراءة القوالب…",
  'workspaceAssistant.stage.lookup.campaigns': "جارٍ قراءة الحملات…",
  'workspaceAssistant.stage.lookup.automations': "جارٍ مراجعة سير العمل والأتمتة…",
  'workspaceAssistant.stage.lookup.search_runs': "جارٍ قراءة عمليات البحث عن العملاء…",
  'workspaceAssistant.stage.lookup.search_results': "جارٍ قراءة نتائج البحث…",
  'workspaceAssistant.stage.lookup.data_lists': "جارٍ قراءة قوائم البيانات…",
  'workspaceAssistant.stage.lookup.list_records': "جارٍ قراءة صفوف القائمة…",
  'workspaceAssistant.stage.lookup.reports': "جارٍ قراءة التقارير…",
  'workspaceAssistant.stage.lookup.other': "جارٍ قراءة بيانات النشاط…",
  'workspaceAssistant.title': 'مساعد الذكاء الاصطناعي',
  'ai.activity.workspace_assistant': 'مساعد مساحة العمل',
  'ai.activity.workspace_agent': 'مساعد مساحة العمل',
  'workspaceAssistant.subtitle': 'دليلك للتطبيق ومعلومات نشاطك',
  'workspaceAssistant.contextTab': 'تفاصيل الشاشة',
  'workspaceAssistant.welcome': "ماذا تريد أن تفعل؟",
  'workspaceAssistant.intro': 'اسأل عن معلومات نشاطك أو الشاشات، أو جهّز قالب رسالة أو حملة أو قائمة جهات اتصال. راجع المعاينة واضغط زر التنفيذ.',
  'workspaceAssistant.proposal.status.draft': 'جاهز للمراجعة',
  'workspaceAssistant.proposal.status.executing': 'جارٍ التنفيذ — راجع السجل قبل إعادة المحاولة',
  'workspaceAssistant.proposal.status.completed': 'تم تنفيذ الإجراء',
  'workspaceAssistant.proposal.status.failed': 'فشل الإجراء — راجع السجل قبل إعادة المحاولة',
  'workspaceAssistant.proposal.sample': 'عينة من الجمهور',
  'workspaceAssistant.proposal.attachHeader': 'أرفق ملف الترويسة قبل الحفظ أو الإرسال.',
  'workspaceAssistant.proposal.startCampaign': 'إنشاء الحملة وإضافتها للإرسال',
  'workspaceAssistant.proposal.saveTemplate': 'حفظ القالب محليًا',
  'workspaceAssistant.proposal.submitTemplate': 'حفظ وإرسال القالب إلى Meta',
  'workspaceAssistant.proposal.contacts': 'جهات الاتصال المضافة',
  'workspaceAssistant.proposal.create': 'إنشاء كما هو موضح',
  'workspaceAssistant.proposal.open': 'فتح السجل المحفوظ',
  'workspaceAssistant.proposal.queued': 'جهات الاتصال في قائمة الإرسال',
  'workspaceAssistant.proposal.attached': 'الزيارات المنشأة',
  'workspaceAssistant.proposal.skippedLocation': 'تم تخطيها لعدم وجود موقع صالح',
  'workspaceAssistant.proposal.quotaLimited': 'تم تقليل عدد المستلمين حسب الحصة المتاحة في الاشتراك.',
  'workspaceAssistant.attach.add': 'إرفاق صور أو ملفات',
  'workspaceAssistant.attach.drop': 'أفلت الصور أو الملفات لإرفاقها',
  'workspaceAssistant.attach.reading': 'جارٍ القراءة…',
  'workspaceAssistant.attach.remove': 'إزالة الملف',
  'workspaceAssistant.attach.unsupported': 'استخدم صورة أو PDF أو Word أو Excel أو CSV أو ملفًا نصيًا',
  'workspaceAssistant.attach.tooLarge': 'الحد الأقصى 10 ميجابايت للملف',
  'workspaceAssistant.attach.failed': 'تعذّر الإرفاق. حاول مرة أخرى',
  'workspaceAssistant.placeholder': 'اسأل عن التطبيق أو نشاطك التجاري…',
  'workspaceAssistant.send': 'إرسال السؤال',
  'workspaceAssistant.you': 'أنت',
  'workspaceAssistant.thinking': 'جارٍ مراجعة سؤالك…',
  'workspaceAssistant.stop': 'إيقاف الرد الحالي',
  'workspaceAssistant.products.minimum': 'الحد الأدنى للكمية',
  'workspaceAssistant.products.notConfigured': 'غير مسجل',
  'workspaceAssistant.products.noPrice': 'السعر غير مسجل',
  'workspaceAssistant.products.unit': 'وحدة البيع',
  'workspaceAssistant.products.allSizes': 'عرض كل الأحجام',
  'workspaceAssistant.products.fewerSizes': 'عرض أحجام أقل',
  'workspaceAssistant.products.outOfStock': 'غير متوفر',
  'workspaceAssistant.products.suppliers': 'الموردون',
  'workspaceAssistant.products.categories': 'التصنيفات',
  'workspaceAssistant.products.stock': 'المخزون',
  'workspaceAssistant.products.open': 'فتح المنتج',
  'workspaceAssistant.products.details': 'المورد والتفاصيل',
  'workspaceAssistant.products.hideDetails': 'إخفاء التفاصيل',
  'workspaceAssistant.products.remainingSizes': 'افتح المنتج لعرض باقي الأحجام.',
  'workspaceAssistant.newChat': 'محادثة جديدة',
  'workspaceAssistant.resetConfirm': 'مسح محادثة المساعد والبدء من جديد؟',
  'workspaceAssistant.permission': 'اطلب من مسؤول النشاط منحك صلاحية استخدام مساعد الذكاء الاصطناعي.',
  'workspaceAssistant.setup': 'فتح إعداد الذكاء الاصطناعي',
  'workspaceAssistant.screenContext': 'الشاشة الحالية',
  'workspaceAssistant.prompt.profile': "كيف أغيّر صورتي الشخصية؟",
  'workspaceAssistant.prompt.quotation': "أريد إنشاء عرض سعر.",
  'workspaceAssistant.prompt.products': "ساعدني في معرفة أسعار المنتجات والحد الأدنى للكميات.",
  'workspaceAssistant.prompt.business': "ما المعلومات التي تعرفها عن نشاطنا؟",
  "phone.audio.speaker": "تبديل مكبر الصوت",
  "phone.audio.speakerOn": "مكبر الصوت مفعّل",
  "phone.audio.speakerOff": "مكبر الصوت مغلق",
  "phone.audio.close": "إغلاق المكالمة",
  "phone.audio.failed": "تعذّر ضبط صوت المكالمة. حاول مرة أخرى.",
  "phone.audio.microphoneRequired": "اسمح باستخدام الميكروفون لإجراء المكالمات.",
  "phone.audio.rebuildRequired": "ثبّت أحدث إصدار من تطبيق DISLIX لتفعيل المكالمات الأصلية.",

  "visits.timeline.title": "سجل الزيارة",
  "visits.timeline.scheduled": "الموعد المخطط",
  "visits.timeline.due": "الموعد النهائي",
  "visits.timeline.created": "تم الإنشاء",
  "visits.timeline.assigned": "تم الإسناد أو الاستلام",
  "visits.timeline.started": "بدء الزيارة / تسجيل الوصول",
  "visits.timeline.completed": "انتهاء الزيارة / تسجيل المغادرة",
  "visits.timeline.cancelled": "تم الإلغاء",
  "visits.timeline.outcome": "تسجيل النتيجة",
  "visits.timeline.rescheduled": "تعديل الموعد",
  "visits.timeline.updated": "تعديل الزيارة",
  "visits.timeline.photo_start": "التقاط صورة البدء",
  "visits.timeline.photo_end": "التقاط صورة الانتهاء",
  "visits.timeline.note": "إضافة ملاحظة",
  "visits.timeline.order": "إنشاء طلب",
  "visits.timeline.quotation": "إنشاء عرض سعر",
  "visits.timeline.vendor": "إضافة مورد",
  "visits.timeline.reminder": "إنشاء تذكير",
  "visits.timeline.list": "إضافة إلى قائمة",
  "visits.timeline.assignment": "إنشاء إسناد",
  "reports.visits.analytics": "أداء الزيارات والتحليلات",
  "reports.visits.unassigned": "غير مسندة / بانتظار الاستلام",
  "reports.visits.byStatus": "الزيارات حسب الحالة",
  "reports.visits.teamPerformance": "الزيارات المكتملة لكل عضو",
  "reports.visits.metricsHint": "الالتزام بالموعد محسوب من {{starts}} زيارة لها موعد مخطط ووقت بدء فعلي. النجاح محسوب من {{outcomes}} نتيجة مسجلة. القياسات الناقصة تظهر —؛ تأخر البدء الموجب يعني تأخيرًا والسالب يعني بدءًا مبكرًا.",
  "reports.visits.dateBasis": "تعتمد فترة التقرير على وقت الانتهاء أو الإلغاء الفعلي، ثم البدء الفعلي، وإلا فالموعد المخطط أو وقت الإنشاء. تُعرض الأوقات حسب المنطقة الزمنية لجهازك.",
  "reports.visits.metric.agent": "الموظف / القسم",
  "reports.visits.metric.total": "الزيارات",
  "reports.visits.metric.completed": "مكتملة",
  "reports.visits.metric.inProgress": "قيد التنفيذ",
  "reports.visits.metric.missed": "فائتة",
  "reports.visits.metric.cancelled": "ملغاة",
  "reports.visits.metric.completion": "نسبة الإكمال",
  "reports.visits.metric.punctuality": "البدء في الموعد",
  "reports.visits.metric.success": "نسبة نجاح النتائج",
  "reports.visits.metric.averageDuration": "متوسط مدة الزيارة",
  "reports.visits.metric.assignmentWait": "من الإسناد إلى البدء",
  "reports.visits.metric.startDelay": "متوسط تأخر البدء",
  "reports.visits.metric.totalDuration": "إجمالي وقت الزيارات",
  "reports.visits.metric.overdue": "زيارات مفتوحة متأخرة",
  'ai.quick.choicePreview': 'اختيارات مقترحة للعميل',
  'ai.quick.addChoices': 'استخدام الرد مع أزرار الاختيار',
  'ai.quick.clarifyFirst': 'وضّح المنتج أو الحجم أو الكمية أو وحدة البيع قبل تجهيز المستند.',
  'ai.choices.title': 'الخيارات المرفقة بهذه الرسالة',
  'ai.choices.asButtons': 'تُرسل كأزرار',
  'ai.choices.asList': 'تُرسل كقائمة',
  'ai.choices.optionPlaceholder': 'الخيار {{n}}',
  'ai.choices.descriptionPlaceholder': 'وصف (اختياري، يظهر في القائمة)',
  'ai.choices.tooLong': 'واتساب يعرض حتى {{max}} حرفًا هنا',
  'ai.choices.add': 'إضافة خيار',
  'ai.choices.remove': 'حذف الخيار',
  'ai.choices.moveUp': 'تحريك لأعلى',
  'ai.choices.moveDown': 'تحريك لأسفل',
  'ai.choices.menu': 'خيارات (أزرار)',
  'ai.media.sendProduct': 'إرسال بطاقة المنتج: {{name}}',
  'ai.media.sendCatalog': 'إرسال الكتالوج: {{name}}',
  'ai.media.sendPhotos': 'إرسال الصور: {{name}}',
  'flowRuns.contact.title': 'تشغيلات سير العمل',
  'flowRuns.contact.all': 'كل التشغيلات ({{count}})',
  'flowRuns.contact.empty': 'لم يعمل أي سير عمل لهذه الجهة بعد.',
  'flowRuns.contact.more': 'عرض المزيد',
  'flowRuns.status.active': 'قيد التشغيل',
  'flowRuns.status.waiting': 'بانتظار',
  'flowRuns.status.paused': 'متوقف مؤقتًا',
  'flowRuns.status.completed': 'مكتمل',
  'flowRuns.status.stopped': 'موقوف',
  'flowRuns.errors': '{{count}} أخطاء',
  'flowRuns.nowAt': 'الآن عند: {{step}}',
  'flowRuns.waitingUntil': 'بانتظار حتى {{date}}',
  'flowRuns.openConversation': 'فتح المحادثة',
  'flowRuns.showPath': 'عرض المسار على سير العمل',
  'flowRuns.resume': 'استئناف',
  'flowRuns.stop': 'إيقاف',
  'flowRuns.resumed': 'يستمر سير العمل في المحادثة.',
  'flowRuns.stopped': 'توقف سير العمل لهذه الجهة.',
  'flowRuns.moved': 'يستمر التشغيل من الخطوة المختارة.',
  'flowRuns.actionFailed': 'تعذر تنفيذ الإجراء',
  'flowRuns.move.action': 'المتابعة من خطوة…',
  'flowRuns.move.title': 'المتابعة من خطوة',
  'flowRuns.move.hint': 'يتابع التشغيل من الخطوة التي تختارها فورًا في محادثته، بالقيم المحفوظة لديه. التشغيل المنتهي يُعاد فتحه.',
  'flowRuns.move.search': 'ابحث في الخطوات',
  'flowRuns.move.current': 'الخطوة الحالية',
  'conversation.cart.summary': 'سلة مفتوحة: {{count}} أصناف · {{total}}',
  'conversation.cart.several': '{{count}} سلال',
  'conversation.cart.fromAssistant': 'من المساعد الذكي',
  'conversation.cart.fromFlow': 'من سير العمل: {{name}}',
  'conversation.cart.workflow': 'سير عمل',
  'conversation.cart.total': 'الإجمالي',
  'conversation.cart.createOrder': 'إنشاء طلب',
  'conversation.cart.createQuotation': 'إنشاء عرض سعر',
  'conversation.cart.clear': 'تفريغ السلة',
  'aiAgents.title': 'وكلاء الذكاء الاصطناعي',
  'aiAgents.count': '{{active}} من {{allowed}} نشط',
  'aiAgents.countUnlimited': '{{active}} نشط',
  'aiAgents.hint': 'مشمولون في اشتراكك إضافةً إلى المستخدمين. وكلاء الذكاء الاصطناعي لا يسجلون الدخول، وكل ما يقومون به يُسجَّل بأسمائهم.',
  'aiAgents.badge': 'وكيل ذكاء اصطناعي',
  'aiAgents.default': 'افتراضي',
  'aiAgents.noLogin': 'لا يمكنه تسجيل الدخول',
  'aiAgents.status.active': 'نشط',
  'aiAgents.status.paused': 'متوقف مؤقتًا',
  'aiAgents.status.suspended': 'معلّق',
  'aiAgents.suspended.planLimit': 'يتجاوز العدد المشمول في اشتراكك',
  'aiAgents.suspended.noAi': 'اشتراكك لا يشمل خدمة الذكاء الاصطناعي',
  'aiAgents.suspended.noSubscription': 'لا يوجد اشتراك نشط',
  'aiAgents.banner.noAi': 'اشتراكك لا يشمل خدمة الذكاء الاصطناعي، لذا جميع الوكلاء معلّقون. سجلهم محفوظ ويعودون عند إضافة الخدمة.',
  'aiAgents.banner.noSubscription': 'لا يوجد اشتراك نشط، لذا جميع الوكلاء معلّقون. سجلهم محفوظ ويعودون عند التجديد.',
  'aiAgents.settings': 'الإعدادات',
  'aiAgents.rename': 'إعادة التسمية',
  'aiAgents.pause': 'إيقاف مؤقت',
  'aiAgents.resume': 'استئناف',
  'aiAgents.makeDefault': 'تعيين كافتراضي',
  'aiAgents.keepActive': 'إبقاء هذا الوكيل نشطًا',
  'aiAgents.add': 'إضافة وكيل',
  'aiAgents.actionFailed': 'لم يتم حفظ التغيير',
  'aiAgents.form.title': '{{name}} — الإعدادات',
  'aiAgents.form.persona': 'الشخصية',
  'aiAgents.form.name': 'الاسم الذي يراه العميل',
  'aiAgents.form.tone': 'الأسلوب (مثل: ودود ومختصر)',
  'aiAgents.form.instructions': 'التعليمات: ما يركز عليه، السياسات، ما يتجنبه…',
  'aiAgents.form.languageAuto': 'لغة العميل',
  'aiAgents.form.coverage': 'أين ومتى يرد',
  'aiAgents.form.coverageHint': 'عدم الاختيار = كل القنوات والأرقام.',
  'aiAgents.form.hoursAlways': 'دائمًا',
  'aiAgents.form.hoursBusiness': 'ساعات العمل',
  'aiAgents.form.hoursAfter': 'خارج ساعات العمل',
  'aiAgents.form.actions': 'ما يمكنه فعله',
  'aiAgents.action.show_products': 'عرض المنتجات',
  'aiAgents.action.cart': 'تجهيز سلة',
  'aiAgents.action.orders': 'إنشاء الطلبات',
  'aiAgents.action.quotations': 'عروض الأسعار',
  'aiAgents.action.order_status': 'حالة الطلب',
  'aiAgents.action.media': 'الصور والكتالوجات',
  'aiAgents.form.products': 'المنتجات التي يعرضها',
  'aiAgents.form.productsHint': 'عدم الاختيار = كل المنتجات.',
  'aiAgents.form.noCatalogues': 'لا توجد كتالوجات بعد.',
  'aiAgents.form.handoff': 'التحويل إلى موظف',
  'aiAgents.form.handoffHint': 'يتوقف الوكيل عن الرد وتُسند جهة الاتصال إلى الموظف.',
  'aiAgents.form.toPrevious': 'من كان مسؤولًا عنها سابقًا',
  'aiAgents.form.toUser': 'موظف محدد',
  'aiAgents.form.toDepartment': 'قسم',
  'aiAgents.form.previousFallback': 'إذا لم يكن هناك مسؤول سابق: هذا القسم (وإلا المالك).',
  'aiAgents.form.onAskHuman': 'عندما يطلب العميل موظفًا',
  'aiAgents.form.onNegative': 'عندما يكون العميل منزعجًا أو يشتكي',
  'aiAgents.form.maxTurns': 'بعد هذا العدد من الرسائل',
  'aiAgents.form.keywords': 'عند ظهور هذه الكلمات (مفصولة بفواصل)',
  'aiAgents.form.other': 'أخرى',
  'aiAgents.form.isDefault': 'الرد على جهات الاتصال غير المسندة لأحد',
  'aiAgents.form.paused': 'متوقف مؤقتًا',
  'aiAgents.form.nameRequired': 'أدخل اسمًا للوكيل.',
  'aiAgents.form.saved': 'تم تحديث الوكيل.',
  'ai.quick.asAgent': 'وكيل الذكاء الاصطناعي: {{name}}',
  'home.aiActivity.title': 'نشاط الذكاء الاصطناعي',
  'home.aiActivity.conversations': 'محادثات',
  'home.aiActivity.replies': 'ردود',
  'home.aiActivity.orders': 'طلبات',
  'home.aiActivity.quotations': 'عروض أسعار',
  'home.aiActivity.handoffs': 'تحويل لموظف',
  'home.aiActivity.live': '{{count}} جارية',
  'home.aiActivity.errors': '{{count}} بها أخطاء',
  'home.flowRuns.title': 'تشغيلات سير العمل حسب جهة الاتصال ({{count}})',
  'home.flowRuns.all': 'كل التشغيلات',
  'home.flowRuns.unknown': 'جهة اتصال غير معروفة',
  'home.flowRuns.runs': '{{count}} تشغيل',
  'home.flowRuns.live': '{{count}} قيد التشغيل',
  'home.flowRuns.errors': '{{count}} أخطاء',
  'home.flowRuns.more': 'عرض {{count}} أخرى',
  'home.flowRuns.less': 'عرض أقل',
  'conversation.cart.fromAgent': 'وكيل الذكاء الاصطناعي: {{name}}',
  'conversation.cart.otherNumber': 'لدى هذا العميل سلة على رقمه الآخر: {{count}} منتجات · {{total}}',
  'conversation.cart.continueHere': 'أكملها هنا',
  'conversation.cart.startNew': 'ابدأ سلة جديدة',
  'conversation.cart.byCustomer': 'عدّلها العميل',
  'conversation.cart.byTeam': 'عدّلها الفريق',
  'conversation.cart.subtotal': 'المجموع',
  'conversation.cart.less': 'أقل بواحد',
  'conversation.cart.more': 'أكثر بواحد',
  'catalogues.temporaryFilter': 'كتالوجات الذكاء الاصطناعي المؤقتة',
  'aiAgents.form.presentation': 'عرض المنتجات',
  'aiAgents.form.presentationHint': 'صفحة المتجر ترسل بطاقة المنتج، أو عدة منتجات في صفحة كتالوج واحدة (تُنشأ فورًا عند الحاجة).',
  'aiAgents.form.presentationPage': 'صفحة المتجر',
  'aiAgents.form.presentationChat': 'قائمة داخل المحادثة',
  'ai.quick.draftChoices': 'الاختيارات المرفقة بهذه الرسالة',
  'ai.quick.removeChoices': 'إزالة الاختيارات وإرسال نص فقط',
  'ai.quick.title': 'ردود مقترحة',
  'ai.quick.refresh': 'تحديث الاقتراحات',
  'ai.quick.expand': 'إظهار الاقتراحات',
  'ai.quick.collapse': 'إخفاء الاقتراحات',
  'ai.quick.preparing': 'جارٍ تجهيز ردود على آخر رسالة من العميل…',
  'ai.quick.thinking': 'يقرأ المساعد المحادثة ويبحث عن المعلومات…',
  'ai.quick.summary': 'الملخص',
  'ai.quick.slow': 'يستغرق المساعد وقتًا أطول من المعتاد. اضغط تحديث للمحاولة مرة أخرى.',
  'ai.quick.manage': 'خيارات ذاكرة المساعد',
  'ai.quick.rebuild': 'إعادة بناء الاقتراحات',
  'ai.quick.clearMemory': 'مسح ذاكرة المساعد',
  'ai.quick.clearConfirm': 'هل تريد مسح ملخص هذه المحادثة والمنتجات المحفوظة والاقتراحات؟',
  'ai.quick.memoryCleared': 'تم مسح ذاكرة المساعد. ستظهر اقتراحات جديدة مع رسالة العميل التالية، أو اضغط تحديث.',
  'ai.quick.choosePrompt': 'أي منها تفضل؟',
  'ai.quick.recommended': 'الرد المقترح',
  'ai.quick.send': 'إرسال',
  'ai.quick.edit': 'تعديل قبل الإرسال',
  'ai.quick.cartSummary': 'سلة مبدئية: {{count}} قطعة · {{total}}',
  'ai.quick.needsHuman': 'هذا العميل يحتاج موظفاً: شكوى أو طلب لا يجب أن يتولاه المساعد.',
  'ai.knowledge.title': 'معلومات النشاط التجاري',
  'ai.knowledge.description': 'ما يجب أن يعرفه المساعد للرد على العملاء: مناطق ومواعيد التوصيل، طرق الدفع، الاسترجاع، مواعيد العمل، أسلوب الرد. يجيب منها ولا يخترع هذه التفاصيل.',
  'ai.knowledge.placeholder': 'مثال: نوصّل داخل القاهرة والجيزة خلال 24 ساعة (50 جنيه، مجاناً فوق 1000). الدفع: كاش عند الاستلام أو رابط دفع. الاسترجاع خلال 7 أيام إذا لم يُفتح المنتج.',
  'ai.knowledge.save': 'حفظ المعلومات',
  'ai.knowledge.saved': 'تم الحفظ',
  'ai.quick.quickReplies': 'تم إرسال الرد. الردود السريعة حتى يكتب العميل مرة أخرى:',
  'ai.quick.noQuickReplies': 'لا توجد ردود سريعة بعد. أضفها من الإعدادات ← الردود السريعة.',
  'share.sendQuotation': 'إرسال عرض سعر',
  'share.sendOrder': 'إرسال طلب',
  'share.newQuotation': 'عرض سعر جديد',
  'share.newOrder': 'طلب جديد',
  'share.search': 'ابحث بالرقم أو الاسم أو الهاتف',
  'share.noContact': 'هذه المحادثة غير مرتبطة بجهة اتصال محفوظة بعد: يتم عرض أحدث السجلات للنشاط التجاري.',
  'share.noQuotations': 'لا توجد عروض أسعار لهذا العميل بعد.',
  'share.noOrders': 'لا توجد طلبات لهذا العميل بعد.',
  'share.items': 'منتجات',
  'share.what': 'ماذا ترسل',
  'share.details': 'التفاصيل',
  'share.pdf': 'ملف PDF',
  'share.both': 'التفاصيل + PDF',
  'share.quotationButtons': 'إضافة زري قبول العرض / طلب تعديل',
  'share.orderButtons': 'إضافة زري تأكيد / إلغاء الطلب',
  'share.send': 'إرسال',
  'share.sent': 'تم الإرسال للعميل.',
  'share.failed': 'تعذّر الإرسال. حاول مرة أخرى.',
  'ai.quick.useReply': 'استخدام الرد',
  'ai.quick.firstContact': 'ابدأ المحادثة بقالب معتمد.',
  'ai.quick.windowClosed': 'انتهت نافذة الرد في واتساب. استخدم قالبًا معتمدًا.',
  'ai.quick.prepareTemplate': 'تجهيز القالب',
  'ai.quick.templatePermission': 'اطلب من المسؤول منحك صلاحية استخدام قوالب واتساب.',
  'ai.quick.noTemplates': 'لا توجد قوالب معتمدة. أضف القوالب أو زامنها من إعدادات واتساب.',
  'ai.quick.noChannelTemplates': 'لم تصل رسالة من العميل بعد. اقتراح القوالب المعتمدة متاح حاليًا لواتساب.',
  'ai.quick.order': 'تجهيز طلب',
  'ai.quick.quotation': 'تجهيز عرض سعر',
  'permissions.ai.useAssistant.label': 'استخدام مساعد الذكاء الاصطناعي',
  'permissions.ai.useAssistant.description': 'اقتراح ردود وعروض أسعار باستخدام بيانات النشاط المسموح بها.',
  'ai.activity.suggested_reply': 'رد مقترح',
  'ai.activity.quotation_proposal': 'اقتراح عرض سعر',
  'ai.assistant.open': 'مساعد الذكاء الاصطناعي',
  'ai.assistant.checkingSetup': 'جارٍ التحقق من اتصال الذكاء الاصطناعي…',
  'ai.assistant.setupRequired': 'اربط نموذجًا واختبره من الإعدادات ← مساعد الذكاء الاصطناعي، ثم تحقق مجددًا هنا.',
  'ai.assistant.retrySetup': 'التحقق من الاتصال مجددًا',
  'ai.assistant.close': 'إغلاق المساعد',
  'ai.assistant.description': 'اقترح ردًا باستخدام الرسائل الأخيرة والبحث المباشر عن المنتجات. راجع النتيجة قبل استخدامها. لا يتم إرسال أي شيء تلقائيًا.',
  'ai.assistant.productSearch': 'اسم المنتج أو رمزه (اختياري للردود)',
  'ai.assistant.searchPlaceholder': 'ابحث عن منتج، مثل بيبسي',
  'ai.assistant.instructions': 'بماذا تريد مساعدة المساعد؟',
  'ai.assistant.instructionsPlaceholder': 'مثال: أجب عن سؤال السعر، أو اقترح عرض سعر لوحدتين.',
  'ai.assistant.suggest': 'اقتراح رد',
  'ai.assistant.proposeQuotation': 'اقتراح بنود عرض سعر',
  'ai.assistant.working': 'جارٍ العمل… قد يستغرق النموذج المحلي بعض الوقت.',
  'ai.assistant.reviewReply': 'راجع الرد وعدّله',
  'ai.assistant.insertReply': 'إدراج في محرر الرسالة',
  'ai.assistant.reviewQuotation': 'مراجعة عرض السعر المقترح',
  'ai.assistant.total': 'الإجمالي',
  'ai.assistant.quotationTerms': 'أسعار الكتالوج دون ضرائب أو مصاريف توصيل أو خصومات إضافية. الموافقة تُنشئ مسودة عرض سعر دون إرسالها. تنتهي صلاحية الاقتراح بعد ١٥ دقيقة.',
  'ai.assistant.customerName': 'اسم العميل',
  'ai.assistant.customerPhone': 'هاتف العميل',
  'ai.assistant.approveQuotation': 'الموافقة وإنشاء مسودة عرض سعر',
  'ai.assistant.created': 'تم إنشاء مسودة عرض السعر {{number}}. افتح عروض الأسعار لمراجعتها.',
  'ai.assistant.sources': 'البيانات المستخدمة',
  'ai.assistant.contextCount': '{{messages}} رسائل حديثة و{{products}} منتجات مطابقة. نتائج البحث محدودة ولا يتم قراءة المرفقات.',
  'ai.setupTitle': 'مساعد الذكاء الاصطناعي',
  'ai.setupDescription': 'اربط نموذجًا متاحًا لنشاطك من خلال DISLIX AI.',
  'ai.historyTitle': 'سجل استخدام الذكاء الاصطناعي',
  'ai.historyDescription': 'راجع الطلبات واستهلاك النماذج وأوقات الاستجابة ونتائج نشاطك.',
  'ai.loadFailed': 'تعذر تحميل بيانات الذكاء الاصطناعي. حاول مرة أخرى.',
  'ai.actionFailed': 'تعذر إكمال الإجراء. حاول مرة أخرى.',
  'ai.accessDenied': 'ليست لديك صلاحية الوصول إلى هذه الصفحة.',
  'ai.notIncluded': 'الذكاء الاصطناعي غير مشمول في خطتك',
  'ai.notIncludedDescription': 'اطلب من مالك النشاط تفعيل الذكاء الاصطناعي من خلال خطة تشمل الخدمة.',
  'ai.viewPlan': 'عرض الاشتراك',
  'ai.connected': 'تم ربط نموذج الذكاء الاصطناعي',
  'ai.notConnected': 'اختر نموذج الذكاء الاصطناعي',
  'ai.selectModel': 'النماذج المتاحة',
  'ai.noModels': 'لم يتم إعداد نماذج بعد. اطلب من المسؤول إعداد DISLIX AI ثم حدّث القائمة.',
  'ai.source.local': 'نموذج DISLIX المحلي',
  'ai.source.platform': 'مقدم من DISLIX',
  'ai.source.business': 'مزود خاص بنشاطك',
  'ai.unavailable': 'غير متاح حاليًا',
  'ai.refreshModels': 'تحديث',
  'ai.connect': 'ربط النموذج واختباره',
  'ai.test': 'اختبار الاتصال',
  'ai.disconnect': 'قطع الاتصال',
  'ai.testSucceeded': 'استجاب النموذج بنجاح',
  'ai.testTime': 'وقت الاستجابة: {{seconds}} ثانية',
  'ai.pilotNote': 'تُسجل اختبارات الاتصال في سجل الاستخدام لتقييم الجودة ووقت الاستجابة.',
  'ai.unpricedNote': 'يجري قياس الاستخدام. فوترة استخدام الذكاء الاصطناعي غير مفعّلة.',
  'ai.dateFormat': 'أدخل تواريخ صحيحة بصيغة YYYY-MM-DD.',
  'ai.from': 'من',
  'ai.to': 'إلى',
  'ai.status.all': 'كل النتائج',
  'ai.status.completed': 'مكتمل',
  'ai.status.failed': 'فشل',
  'ai.status.pending': 'قيد التنفيذ',
  'ai.requests': 'الطلبات',
  'ai.tokens': 'الرموز المعالجة',
  'ai.failed': 'الطلبات الفاشلة',
  'ai.averageTime': 'متوسط الاستجابة الناجحة',
  'ai.noUsage': 'لا يوجد نشاط في هذه الفترة. اربط نموذجًا أو اختبره لتسجيل أول طلب.',
  'ai.activity.connection_test': 'اختبار الاتصال',
  'ai.activity.flow_step': 'خطوة ذكاء اصطناعي في سير العمل',
  'ai.tokenDetails': 'الإدخال: {{input}} رمز · الإخراج: {{output}} رمز',
  'ai.tokensUnknown': 'استهلاك الرموز غير متاح',
  'ai.requestId': 'الطلب',
  'ai.actorId': 'المستخدم',
  'ai.providerFailed': 'فشل طلب المزود. قد لا تتوفر بيانات استهلاك الرموز.',
  'ai.page': 'صفحة {{page}} من {{pages}}',
  'settings.entry.ai.title': 'مساعد الذكاء الاصطناعي',
  'settings.entry.ai.description': 'ربط نموذج الذكاء الاصطناعي لنشاطك واختباره.',
  'settings.entry.aiUsage.title': 'سجل استخدام الذكاء الاصطناعي',
  'settings.entry.aiUsage.description': 'الطلبات واستهلاك الرموز وأوقات الاستجابة.',
  'permissions.categoryLabel.ai': 'مساعد الذكاء الاصطناعي',
  'permissions.ai.manageConfig.label': 'إعداد الذكاء الاصطناعي',
  'permissions.ai.manageConfig.description': 'عرض النموذج المتصل أو تغييره وإجراء اختبارات الاتصال.',
  'permissions.ai.viewUsage.label': 'عرض استخدام الذكاء الاصطناعي',
  'permissions.ai.viewUsage.description': 'عرض استهلاك الذكاء الاصطناعي وسجل الطلبات للنشاط.',
  'setup.step.ai.title': 'ربط الذكاء الاصطناعي',
  'setup.step.ai.description': 'اختر نموذجًا لنشاطك واختبره.',
  // ─── Common ───────────────────────────────────────────────────────────────
  'common.error': 'خطأ',
  'common.success': 'تم بنجاح',
  'common.cancel': 'إلغاء',
  'common.apply': 'تطبيق',
  'common.save': 'حفظ',
  'common.delete': 'حذف',
  'common.copy': 'نسخ',
  'billing.paymentRef': 'مرجع الدفع',
  'billing.invoiceNo': 'الفاتورة',
  'common.edit': 'تعديل',
  'common.add': 'إضافة',
  'common.confirm': 'تأكيد',
  'common.close': 'إغلاق',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.done': 'تم',
  'common.loading': 'جارٍ التحميل...',
  'common.search': 'بحث',
  'common.filter': 'تصفية',
  'common.noResults': 'لا توجد نتائج',
  'common.retry': 'إعادة المحاولة',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.actions': 'الإجراءات',

  // ─── API Response Codes ───────────────────────────────────────────────────
  'api.1000': 'تم بنجاح',
  'api.1001': 'موجود مسبقاً',
  'api.1002': 'غير موجود',
  'api.1003': 'موجود',
  'api.0': 'حدث خطأ',
  'api.1010': 'مصرح',
  'api.1011': 'غير مصرح',
  'api.1004': 'غير مرتبط',
  'api.1005': 'يلزم التحقق',
  'api.1006': 'غير مكتمل',
  'api.1007': 'حقول مطلوبة مفقودة',
  'api.validationFailed': 'فشل التحقق من البيانات',
  'api.unauthorized': 'وصول غير مصرح',
  'api.forbidden': 'الوصول محظور',
  'api.notFound': 'العنصر غير موجود',
  'api.conflict': 'تعارض في البيانات',
  'api.serverError': 'خطأ في الخادم',
  'api.serviceUnavailable': 'الخدمة غير متاحة مؤقتاً',
  'api.rateLimitExceeded': 'طلبات كثيرة، حاول لاحقاً',
  'api.tokenInvalid': 'الجلسة منتهية أو غير صالحة',
  'api.invalidCredentials': 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  'api.fileTooLarge': 'حجم الملف يتجاوز الحد المسموح',
  'api.invalidFileType': 'نوع الملف غير مدعوم',
  'api.networkError': 'خطأ في الشبكة، تحقق من الاتصال',

  // ─── API Auth Errors ──────────────────────────────────────────────────────
  'api.auth.userAlreadyExists': 'حساب بهذا البريد موجود مسبقاً',
  'api.auth.invalidCredentials': 'البريد الإلكتروني أو كلمة المرور غير صحيح',
  'api.auth.tokenExpired': 'انتهت جلستك، سجّل الدخول مجدداً',
  'api.auth.tokenRevoked': 'تم إنهاء هذه الجلسة',
  'api.auth.tokenInvalid': 'رمز الجلسة غير صالح',
  'api.auth.refreshTokenInvalid': 'رمز التحديث منتهي أو غير صالح',
  'api.auth.verificationSent': 'تم إرسال رمز التحقق',
  'api.auth.passwordResetSuccess': 'تم إعادة تعيين كلمة المرور',
  'api.auth.passwordRequirements': 'كلمة المرور لا تستوفي المتطلبات',
  'api.auth.verificationRequired': 'يرجى التحقق من حسابك أولاً',
  'api.auth.providerNotSupported': 'طريقة تسجيل الدخول هذه غير مدعومة',

  // ─── API WhatsApp Errors ──────────────────────────────────────────────────
  'api.whatsapp.invalidPhoneFormat': 'صيغة رقم الهاتف غير صحيحة. أضف رمز الدولة (مثال: +966…)',
  'api.whatsapp.phoneAlreadyRegistered': 'هذا الرقم مسجّل في واتساب الشخصي، أزله أولاً',
  'api.whatsapp.businessNameFailed': 'فشل التحقق من اسم العمل. جرّب اسماً مختلفاً',
  'api.whatsapp.permissionsError': 'خطأ في صلاحيات التطبيق',
  'api.whatsapp.maxPhonesReached': 'وصلت للحد الأقصى من الأرقام. احذف رقماً لإضافة جديد',
  'api.whatsapp.verificationTooManyAttempts': 'محاولات كثيرة جداً، انتظر قبل المحاولة مجدداً',
  'api.whatsapp.verificationCodeInvalid': 'رمز التحقق غير صحيح، تحقق وحاول مجدداً',
  'api.whatsapp.verificationFailed': 'فشل التحقق، حاول مجدداً',
  'api.whatsapp.registeredLimitedName': 'الرقم نشط لكن التحقق من الاسم محدود',
  'api.whatsapp.phoneVerifiedSuccess': 'تم التحقق من رقم الهاتف بنجاح',
  'api.whatsapp.sendFailed': 'فشل إرسال الرسالة',
  'api.whatsapp.providerNotFound': 'مزود واتساب غير مهيأ',
  'api.whatsapp.noPageConfigured': 'لا توجد صفحات فيسبوك مهيأة لهذا العمل',
  'api.whatsapp.pageLimitReached': 'وصلت لحد الصفحات في اشتراكك',

  // ─── API Product Errors ───────────────────────────────────────────────────
  'api.product.nameRequired': 'اسم المنتج مطلوب',
  'api.product.nameTooLong': 'اسم المنتج يجب أن يكون أقل من 200 حرف',
  'api.product.priceRequired': 'سعر المنتج مطلوب',
  'api.product.priceNegative': 'السعر لا يمكن أن يكون سالباً',
  'api.product.salePriceTooHigh': 'سعر التخفيض يجب أن يكون أقل من السعر الأصلي',
  'api.product.skuInvalid': 'رمز المنتج يحتوي على أحرف أو أرقام أو شرطات فقط',
  'api.product.currencyInvalid': 'العملة يجب أن تكون رمزاً مكوناً من 3 أحرف',
  'api.product.tooManyImages': 'لا يمكن تجاوز 10 صور للمنتج',
  'api.product.imageUrlInvalid': 'رابط الصورة غير صالح',
  'api.product.variantsNotAllowed': 'المتغيرات يجب أن تكون فارغة عند تعطيلها',
  'api.product.invoiceExists': 'الفاتورة موجودة مسبقاً لهذا الطلب',
  'api.product.orderNoItems': 'الطلب يجب أن يحتوي على عنصر واحد على الأقل',
  'api.catalogue.businessRequired': 'معرّف العمل مطلوب',
  'api.catalogue.catalogueRequired': 'معرّف الكتالوج مطلوب',

  // ─── API Quick Reply Errors ───────────────────────────────────────────────
  'api.quickReply.maxDepthExceeded': 'تم تجاوز الحد الأقصى للتداخل',
  'api.quickReply.circularReference': 'مرجع دائري: لا يمكن تضمين مجموعة ردود بداخل نفسها',
  'api.quickReply.messageTypeRequired': 'نوع الرسالة مطلوب',
  'api.quickReply.textRequired': 'النص مطلوب لنوع الرسالة النصية',
  'api.quickReply.mediaUrlRequired': 'رابط الوسائط مطلوب',
  'api.quickReply.locationRequired': 'إحداثيات الموقع مطلوبة',
  'api.quickReply.urlInvalid': 'الرابط يجب أن يبدأ بـ http:// أو https://',
  'api.quickReply.taskTitleRequired': 'عنوان المهمة مطلوب',
  'api.quickReply.calendarFieldsRequired': 'عنوان التقويم وتاريخ البدء مطلوبان',
  'api.quickReply.assignUserRequired': 'مطلوب مستخدم واحد على الأقل للتعيين',
  'api.quickReply.assignDeptRequired': 'مطلوب قسم واحد على الأقل للتعيين',

  // ─── API Contact & User Errors ────────────────────────────────────────────
  'api.contact.fetchFailed': 'فشل تحميل جهات الاتصال',
  'api.contact.createFailed': 'فشل إنشاء جهة الاتصال',
  'api.contact.updateFailed': 'فشل تحديث جهة الاتصال',
  'api.contact.deleteFailed': 'فشل حذف جهة الاتصال',
  'api.contact.importFailed': 'فشل استيراد جهات الاتصال',
  'api.contact.exportSuccess': 'تم تصدير جهات الاتصال بنجاح',
  'api.contact.fileRequired': 'ملف مطلوب للاستيراد',
  'api.user.notAuthenticated': 'أنت غير مسجّل دخولك',
  'api.user.updateFailed': 'فشل تحديث المستخدم',
  'api.user.passwordChangeFailed': 'فشل تغيير كلمة المرور',
  'api.user.searchRequired': 'استعلام البحث مطلوب',

  // ─── Enum: Conversation / Order / Message Status ──────────────────────────
  'status.open': 'مفتوح',
  'status.closed': 'مغلق',
  'status.pending': 'معلق',
  'status.resolved': 'محلول',
  'status.archived': 'مؤرشف',
  'status.locked': 'مقفل',
  'status.transferred': 'محوَّل',
  'status.deleted': 'محذوف',
  'status.active': 'نشط',
  'status.completed': 'مكتمل',
  'status.cancelled': 'ملغى',
  'status.inProgress': 'جارٍ',
  'status.failed': 'فاشل',
  'status.sent': 'مُرسَل',
  'status.delivered': 'مُستلَم',
  'status.read': 'مقروء',

  // ─── Enum: Notification Status ────────────────────────────────────────────
  'status.notif.pending': 'في الانتظار',
  'status.notif.sent': 'مُرسَل',
  'status.notif.failed': 'فاشل',
  'status.notif.delivered': 'مُستلَم',

  // ─── Enum: Contact Status ─────────────────────────────────────────────────
  'contactStatus.lead': 'عميل محتمل',
  'contactStatus.prospect': 'مرتقب',
  'contactStatus.customer': 'عميل',
  'contactStatus.accepted': 'مقبول',
  'contactStatus.declined': 'مرفوض',
  'contactStatus.blocked': 'محظور',
  'contactStatus.inactive': 'غير نشط',

  // ─── Enum: Channel Status ─────────────────────────────────────────────────
  'channelStatus.connected': 'متصل',
  'channelStatus.disconnected': 'غير متصل',
  'channelStatus.alreadyInUse': 'قيد الاستخدام',
  'channelStatus.pendingVerification': 'في انتظار التحقق',
  'channelStatus.unknown': 'غير معروف',

  // ─── Enum: User Status ────────────────────────────────────────────────────
  'userStatus.active': 'نشط',
  'userStatus.inactive': 'غير نشط',
  'userStatus.suspended': 'موقوف',
  'userStatus.pending': 'معلق',

  // ─── Enum: Message Direction ──────────────────────────────────────────────
  'direction.inbound': 'وارد',
  'direction.outbound': 'صادر',

  // ─── Enum: Notification Types ─────────────────────────────────────────────
  'notifType.email': 'بريد إلكتروني',
  'notifType.sms': 'رسالة نصية',
  'notifType.push': 'إشعار فوري',
  'notifType.inApp': 'داخل التطبيق',

  // ─── Profile Completion Widget ──────────────────────────────────────────
  'profile.completion.title': 'اكتمال الملف الشخصي',
  'profile.completion.percentComplete': 'مكتمل',
  'profile.completion.allServices': 'جميع الخدمات',
  'profile.completion.configured': 'تم الإعداد',
  'profile.completion.incomplete': 'غير مكتمل',
  'profile.completion.notStarted': 'لم يبدأ',
  'profile.completion.unknown': 'غير معروف',
  'profile.completion.completeService': 'إكمال {{name}}',
  'profile.completion.configureService': 'إعداد {{name}}',
  'profile.completion.noServices': 'لا توجد خدمات متاحة',
  'profile.copy.successTitle': 'تم النسخ',
  'profile.copy.successMessage': 'تم النسخ إلى الحافظة',
  'profile.copy.errorTitle': 'خطأ',
  'profile.copy.errorMessage': 'فشل النسخ إلى الحافظة',
  'profile.whatsapp.noNumbers': 'لا توجد أرقام متصلة',
  'profile.whatsapp.oneNumber': '{{phone}}',
  'profile.whatsapp.multipleNumbers': '{{count}} أرقام متصلة',
  'profile.stats.contacts': 'جهات الاتصال',
  'profile.stats.messagesThisMonth': 'رسائل هذا الشهر',
  'profile.stats.teamMembers': 'الفريق',
  'profile.facebook.noPagesConnected': 'لا توجد صفحات متصلة',
  'profile.facebook.onePage': '{{name}}',
  'profile.facebook.connectedPages': '{{count}} صفحات متصلة',
  'profile.xtwitter.noAccountsConnected': 'لا توجد حسابات متصلة',
  'profile.xtwitter.oneAccount': '{{name}}',
  'profile.xtwitter.connectedAccounts': '{{count}} حسابات متصلة',
  'profile.phone.noAccountConnected': 'لا يوجد حساب متصل',
  'profile.phone.connectedVia': 'متصل عبر {{provider}}',

  // ─── Quick Actions ──────────────────────────────────────────────────────
  'quickActions.whatsappCampaign.title': 'حملة واتساب',
  'quickActions.whatsappCampaign.description': 'إرسال رسالة واتساب جماعية',
  'quickActions.addContact.title': 'إضافة جهة اتصال',
  'quickActions.addContact.description': 'إنشاء جهة اتصال جديدة',
  'quickActions.products.title': 'المنتجات',
  'quickActions.products.description': 'إدارة كتالوج المنتجات',
  'quickActions.quickReplies.title': 'الردود السريعة',
  'quickActions.quickReplies.description': 'إدارة قوالب الردود المحفوظة',
  'quickActions.orders.title': 'الطلبات',
  'quickActions.orders.description': 'عرض وإدارة الطلبات',
  'quickActions.vendors.title': 'الموردين',
  'quickActions.vendors.description': 'إدارة الموردين ومنتجاتهم',
  'quickActions.quotations.title': 'عروض الأسعار',
  'quickActions.quotations.description': 'إنشاء وإرسال عروض الأسعار',
  'quickActions.workflows.title': 'سير العمل',
  'quickActions.workflows.description': 'إنشاء وإدارة سير العمل الآلي',
  'quickActions.templateMessage.title': 'رسالة القالب',
  'quickActions.templateMessage.description': 'إدارة قوالب رسائل واتساب',
  'quickActions.calendarSetup.title': 'إعداد التقويم',
  'quickActions.calendarSetup.description': 'إدارة تقاويم الحجز',
  'quickActions.visits.title': 'الزيارات',
  'quickActions.visits.description': 'تتبع وتنفيذ الزيارات الميدانية',
  'quickActions.reports.title': 'التقارير',
  'quickActions.reports.description': 'قريباً',

  // ─── Platform Performance ───────────────────────────────────────────────
  'platformPerformance.title': 'الأداء',
  'platformPerformance.contacts': 'جهات الاتصال',
  'platformPerformance.conversations': 'المحادثات',
  'platformPerformance.messages': 'الرسائل',
  'platformPerformance.myActive': 'نشط',
  'platformPerformance.myCompleted': 'مكتمل',
  'platformPerformance.myOverdue': 'متأخر',
  'platformPerformance.myTotal': 'الإجمالي',
  'platformPerformance.loading': 'جارٍ تحميل بيانات الأداء...',
  'platformPerformance.empty': 'لا توجد بيانات أداء متاحة',
  'platformPerformance.messagesOverTime': 'الرسائل عبر الزمن',
  'platformPerformance.channelBreakdown': 'توزيع القنوات',
  'platformPerformance.whatsapp': 'واتساب',
  'platformPerformance.facebook': 'فيسبوك',
  'platformPerformance.xTwitter': 'إكس (تويتر)',
  'platformPerformance.chartsTab': 'الرسوم البيانية',
  'platformPerformance.tableTab': 'جدول',
  'platformPerformance.datePreset.today': 'اليوم',
  'platformPerformance.datePreset.7d': 'آخر 7 أيام',
  'platformPerformance.datePreset.30d': 'آخر 30 يومًا',
  'platformPerformance.searchAgents': 'بحث باسم الموظف',
  'platformPerformance.noAgents': 'لا يوجد نشاط للموظفين بعد',
  'platformPerformance.noAgentMatches': 'لا توجد نتائج',
  'platformPerformance.agentTotal': 'الإجمالي',
  'platformPerformance.agentActive': 'نشط',
  'platformPerformance.agentCompleted': 'مكتمل',
  'platformPerformance.agentOverdue': 'متأخر',
  'platformPerformance.phone': 'الهاتف',
  'platformPerformance.callsOverTime': 'المكالمات عبر الوقت',
  'platformPerformance.callsTitle': 'المكالمات',
  'platformPerformance.callsInbound': 'واردة',
  'platformPerformance.callsOutbound': 'صادرة',
  'platformPerformance.callsAvgDuration': 'متوسط المدة',
  'platformPerformance.callOutcomes': 'نتائج المكالمات',
  'platformPerformance.outcomeCompleted': 'مكتملة',
  'platformPerformance.outcomeNotResponded': 'لم يتم الرد',
  'platformPerformance.outcomeCancelled': 'مشغول',
  'platformPerformance.outcomeEnded': 'منتهية',
  'platformPerformance.outcomeFailed': 'فشلت',
  'platformPerformance.noCalls': 'لا توجد مكالمات بعد',
  'platformPerformance.providerSectionTitle': 'مزود الهاتف',
  'platformPerformance.providerNotConnected': 'لا يوجد مزود هاتف متصل',
  'platformPerformance.providerCallsTotal': 'إجمالي المكالمات',
  'platformPerformance.providerAvgDuration': 'متوسط المدة',

  // ─── Dashboard Analytics ─────────────────────────────────────────────────
  'dashboardAnalytics.campaigns.title': 'أداء الحملات',
  'dashboardAnalytics.campaigns.sent': 'مرسل',
  'dashboardAnalytics.campaigns.delivered': 'تم التوصيل',
  'dashboardAnalytics.campaigns.read': 'مقروء',
  'dashboardAnalytics.campaigns.empty': 'لا توجد حملات بعد',
  'dashboardAnalytics.campaigns.search': 'بحث باسم القالب',
  'dashboardAnalytics.campaigns.groupCount': 'حملات',
  'dashboardAnalytics.campaigns.groupCountOne': 'حملة',
  'dashboardAnalytics.campaigns.viewPerformance': 'عرض الأداء',
  'dashboardAnalytics.campaigns.templateOther': 'أخرى',
  'dashboardAnalytics.campaigns.grouping': 'جارٍ التجميع حسب القالب…',
  'dashboardAnalytics.campaigns.modalSubtitle': 'أداء القالب',
  'dashboardAnalytics.campaigns.totalCampaigns': 'الحملات',
  'dashboardAnalytics.campaigns.failed': 'فشل',
  'dashboardAnalytics.campaigns.successRate': 'معدل النجاح',
  'dashboardAnalytics.campaigns.campaignList': 'الحملات التي تستخدم هذا القالب',
  'dashboardAnalytics.campaigns.trendTitle': 'اتجاه حجم الإرسال',
  'dashboardAnalytics.campaigns.searchCampaigns': 'بحث في الحملات',
  'dashboardAnalytics.campaigns.sortDate': 'التاريخ',
  'dashboardAnalytics.campaigns.sortSent': 'المرسل',
  'dashboardAnalytics.campaigns.sortSuccess': 'النجاح',
  'dashboardAnalytics.campaigns.noMatches': 'لا توجد حملات مطابقة',
  'dashboardAnalytics.workflows.title': 'تنفيذ سير العمل',
  'dashboardAnalytics.workflows.active': 'نشط',
  'dashboardAnalytics.workflows.completed': 'مكتمل',
  'dashboardAnalytics.workflows.abandoned': 'متروك',
  'dashboardAnalytics.workflows.waiting_on_child': 'نشط',
  'dashboardAnalytics.workflows.manually_paused': 'متوقف مؤقتاً',
  'dashboardAnalytics.workflows.empty': 'لا يوجد نشاط لسير العمل بعد',
  'dashboardAnalytics.workflows.search': 'بحث باسم سير العمل',
  'dashboardAnalytics.actions.title': 'أكثر خطوات سير العمل نشاطًا',
  'dashboardAnalytics.actions.caption': 'يعكس الجلسات النشطة والحديثة، وليس الإجمالي الكلي',
  'dashboardAnalytics.actions.empty': 'لا يوجد نشاط لسير العمل بعد',
  'dashboardAnalytics.alerts.title': 'تنبيهات النظام',
  'dashboardAnalytics.alerts.total': 'الإجمالي',
  'dashboardAnalytics.alerts.unread': 'غير مقروء',
  'dashboardAnalytics.alerts.empty': 'لا توجد تنبيهات',

  // ─── Navigation Tabs ──────────────────────────────────────────────────────
  'tab.home': 'الرئيسية',
  'tab.contacts': 'جهات الاتصال',
  'tab.calendar': 'التقويم',
  'tab.orders': 'الطلبات',
  'tab.more': 'المزيد',
  'tab.inbox': 'صندوق الوارد',
  'tab.settings': 'الإعدادات',

  // ─── Auth Screens ─────────────────────────────────────────────────────────
  'auth.signIn': 'تسجيل الدخول',
  'auth.signUp': 'إنشاء حساب',
  'auth.pendingInvitations': 'الدعوات',
  'auth.invitedBy': 'دعوة من',
  'auth.invitationExpired': 'انتهت صلاحية الدعوة',
  'auth.email': 'البريد الإلكتروني',
  'auth.emailPlaceholder': 'أدخل بريدك الإلكتروني',
  'auth.password': 'كلمة المرور',
  'auth.passwordPlaceholder': 'أدخل كلمة المرور',
  'auth.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.noAccount': 'ليس لديك حساب؟ ',
  'auth.hasAccount': 'لديك حساب بالفعل؟ ',
  'auth.createAccount': 'إنشاء حساب',
  'auth.continue': 'متابعة',
  'auth.otpTitle': 'تحقق من بريدك الإلكتروني',
  'auth.otpTitlePhone': 'تحقق من رقمك',
  'auth.otpSubtitle': 'أدخل الرمز المرسل إلى',
  'auth.resendCode': 'لم تستلم الرمز؟ إعادة الإرسال',
  'auth.trustThisDevice': 'تذكر هذا الجهاز لمدة 30 يومًا',

  // إضافة/تأكيد الهوية (إكمال الملف الشخصي بوسيلة مصادقة ثانية)
  'identity.addEmailHeaderTitle': 'إضافة بريد إلكتروني',
  'identity.addMobileHeaderTitle': 'إضافة رقم هاتف',
  'identity.verifyHeaderTitle': 'تحقق',
  'identity.addEmailTitle': 'إضافة بريد إلكتروني',
  'identity.addMobileTitle': 'إضافة رقم هاتف',
  'identity.addEmailSubtitle': 'سنرسل رمز تحقق لتأكيد أن هذا البريد الإلكتروني ملكك.',
  'identity.addMobileSubtitle': 'سنرسل رمز تحقق عبر واتساب لتأكيد أن هذا الرقم ملكك.',
  'identity.sendCode': 'إرسال الرمز',
  'identity.enterCodeTitle': 'أدخل رمز التحقق',
  'identity.enterCodeSubtitleEmail': 'لقد أرسلنا رمزًا إلى',
  'identity.enterCodeSubtitleMobile': 'لقد أرسلنا رمزًا عبر واتساب إلى',
  'identity.verify': 'تحقق',
  'identity.changeEmail': 'تغيير البريد الإلكتروني',
  'identity.changeMobile': 'تغيير رقم الهاتف',
  'identity.resendCodeIn': 'إعادة الإرسال خلال {{seconds}} ثانية',
  'identity.requiredTitle': 'مطلوب',
  'identity.requiredEmail': 'يرجى إدخال بريد إلكتروني.',
  'identity.requiredMobile': 'يرجى إدخال رقم هاتف.',
  'identity.invalidTitle': 'غير صالح',
  'identity.invalidEmail': 'يرجى إدخال بريد إلكتروني صالح.',
  'identity.invalidMobile': 'يرجى إدخال رقم هاتف صالح.',
  'identity.codeSentTitle': 'تم إرسال الرمز',
  'identity.codeSentEmail': 'تم إرسال رمز التحقق إلى بريدك الإلكتروني.',
  'identity.codeSentMobile': 'تم إرسال رمز التحقق عبر واتساب.',
  'identity.codeResent': 'تم إرسال رمز جديد.',
  'identity.invalidCodeTitle': 'رمز غير صالح',
  'identity.invalidCodeMessage': 'يرجى إدخال رمز التحقق المكون من 6 أرقام كاملاً.',
  'identity.verifiedTitle': 'تم التحقق',
  'identity.verifiedEmail': 'تم التحقق من بريدك الإلكتروني.',
  'identity.verifiedMobile': 'تم التحقق من رقم هاتفك.',
  'auth.resetPassword': 'إعادة تعيين كلمة المرور',
  'auth.newPassword': 'كلمة المرور الجديدة',
  'auth.confirmPassword': 'تأكيد كلمة المرور الجديدة',
  'auth.forgotTitle': 'نسيت كلمة المرور؟',
  'auth.forgotSubtitle': 'أدخل بريدك الإلكتروني وسنرسل لك رمز التأكيد',
  'auth.sendResetEmail': 'إرسال رمز الاسترداد',
  'auth.rememberPassword': 'تتذكر كلمة مرورك؟ ',
  'auth.rememberMe': 'تذكرني',
  'auth.getStarted': 'ابدأ الآن ←',
  'auth.welcomeTagline': 'كل محادثاتك، في مكان واحد',
  'auth.welcomeSubtitle': 'رد وأتمت ونمِّ أعمالك عبر واتساب وماسنجر وغيرها — كل ذلك من مركز تحكم واحد مصمم للفرق الحديثة.',
  'auth.firstName': 'الاسم الأول',
  'auth.firstNamePlaceholder': 'أدخل اسمك الأول',
  'auth.lastName': 'اسم العائلة',
  'auth.lastNamePlaceholder': 'أدخل اسم العائلة',
  'auth.phoneNumber': 'رقم الهاتف',
  'auth.phoneNumberPlaceholder': 'أدخل رقم هاتفك',
  'auth.confirmPasswordPlaceholder': 'تأكيد كلمة المرور',
  'auth.createPasswordPlaceholder': 'أنشئ كلمة مرور',
  'auth.joinSubtitle': 'انضم إلى DISLIX وابدأ التواصل',
  'auth.backToLogin': 'العودة لتسجيل الدخول',
  'auth.backToRegistration': 'العودة للتسجيل',
  'auth.backToWelcome': 'العودة للترحيب',
  'auth.chooseYourPath': 'اختر طريقك',
  'auth.welcomeTitle': 'مرحباً بك في DISLIX! 🚀',
  'auth.welcomeDescription': 'اختر كيف تريد البدء بمنصة مركز التواصل التجاري',
  'auth.signInDescription': 'لديك حساب بالفعل؟ سجّل دخولك للوصول إلى لوحتك وإدارة اتصالات عملك.',
  'auth.createAccountDescription': 'جديد في DISLIX؟ أنشئ حسابك وابدأ بناء مركز التواصل التجاري من الصفر.',
  'auth.setPassword': 'تعيين كلمة المرور',
  'auth.setPasswordSubtitle': 'أنشئ كلمة مرور لإتمام دعوتك',
  'auth.resetPasswordSubtitle': 'أدخل رمز التأكيد وأنشئ كلمة مرور جديدة',

  // ─── Validation ───────────────────────────────────────────────────────────
  'validation.required': 'هذا الحقل مطلوب',
  'validation.emailInvalid': 'أدخل بريداً إلكترونياً صحيحاً',
  'validation.passwordMin': 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
  'validation.passwordMatch': 'كلمتا المرور غير متطابقتين',
  'validation.phoneInvalid': 'أدخل رقم هاتف صحيحاً',

  // ─── Inbox & Conversations ────────────────────────────────────────────────
  'inbox.title': 'صندوق الوارد',
  'inbox.empty': 'لا توجد محادثات بعد',
  'inbox.search': 'بحث في المحادثات',
  'inbox.assigned': 'معيّن',
  'inbox.unassigned': 'غير معيّن',
  'inbox.open': 'مفتوح',
  'inbox.closed': 'مغلق',
  'inbox.pending': 'معلق',
  'inbox.contactAdded': 'تمت إضافة جهة الاتصال',
  'inbox.contactAddedDesc': 'تمت إضافة {{name}} إلى جهات اتصالك',
  'inbox.conversationStarted': 'بدأت المحادثة',
  'inbox.conversationStartedDesc': 'تم بدء محادثة واتساب مع {{name}}',
  'inbox.loadingMore': 'جارٍ تحميل المزيد من المحادثات...',
  'inbox.loadMore': 'تحميل المزيد',
  'inbox.department': 'القسم',
  'inbox.inProgress': 'قيد التنفيذ',
  'inbox.completed': 'مكتملة',
  'inbox.completedWithDepartment': '{{department}} • مكتملة',
  'inbox.locked': 'مقفلة',
  'inbox.expired': 'منتهية الصلاحية',
  'inbox.windowClosed': 'انتهت النافذة',
  'inbox.timeLeftHoursMinutes': 'متبقٍ {{hours}} س {{minutes}} د',
  'inbox.timeLeftMinutes': 'متبقٍ {{minutes}} د',
  'inbox.noSearchResults': 'لا توجد محادثات مطابقة لبحثك',
  'inbox.noChannelResults': 'لا توجد محادثات {{channel}}',
  'inbox.noFilterResults': 'لا توجد محادثات {{filter}}',
  'inbox.filter.all': 'الكل',
  'inbox.filter.unread': 'غير مقروءة',
  'inbox.filter.active': 'نشطة',
  'inbox.filter.nearExpiry': 'قريبة الانتهاء',
  'inbox.filter.expired': 'منتهية',
  // ─── Product vendors ──────────────────────────────────────────────────────
  'productVendors.title': 'الموردون',
  'productVendors.add': 'إضافة مورد',
  'productVendors.remove': 'إزالة المورد',
  'productVendors.empty': 'هذا المنتج غير مرتبط بأي مورد بعد.',
  'productVendors.pickerTitle': 'إضافة موردين',
  'productVendors.pickerConfirm': 'ربط المحدد',
  'productVendors.added': 'تم الربط بـ {{count}} مورد',
  'productVendors.addFailed': 'تعذّر ربط بعض الموردين.',
  'productVendors.removeFailed': 'تعذّرت إزالة المورد.',
  'auth.socialLoginFailedTitle': 'تعذّر تسجيل الدخول',
  'auth.socialLoginFailedBody': 'تعذّر تسجيل دخولك بهذا الحساب. حاول مرة أخرى أو استخدم الهاتف أو البريد الإلكتروني.',
  'auth.resendCodeIn': 'إعادة الإرسال خلال {{seconds}} ث',
  // ─── Billing & plans ──────────────────────────────────────────────────────
  'billing.title': 'الفوترة',
  'billing.choosePlanTitle': 'اختر خطتك',
  'billing.changePlanTitle': 'تغيير الخطة',
  'billing.choosePlanSubtitle': 'اختر الخطة المناسبة لفريقك. يمكنك تغييرها في أي وقت.',
  'billing.choosePlanSubtitleTrial': 'ابدأ مجانًا — الخطط المدفوعة تتضمن فترة تجربة مجانية دون بطاقة.',
  'billing.choosePlan': 'اختر خطة',
  'billing.changePlan': 'تغيير الخطة',
  'billing.currentPlan': 'خطتك الحالية',
  'billing.cycle.monthly': 'شهري',
  'billing.cycle.quarterly': 'ربع سنوي',
  'billing.cycle.yearly': 'سنوي',
  'billing.per.monthly': 'شهر',
  'billing.per.quarterly': '3 أشهر',
  'billing.per.yearly': 'سنة',
  'billing.save': 'وفّر {{percent}}٪',
  'billing.saveVsMonthly': 'وفّر {{percent}}٪ مقارنة بالشهري',
  'billing.free': 'مجانية',
  'billing.popular': 'الأكثر طلبًا',
  'billing.trialBadge': 'تجربة مجانية {{days}} يوم',
  'billing.startFree': 'ابدأ مجانًا',
  'billing.startTrial': 'ابدأ تجربة مجانية {{days}} يوم',
  'billing.subscribeFor': 'اشترك · {{price}}',
  'billing.notOffered': 'غير متاحة لهذه المدة',
  'billing.unavailableTitle': 'غير متاح في التطبيق',
  'billing.unavailableInApp': 'الاشتراك في هذه الخطة غير متاح من التطبيق.',
  'billing.ownerOnly': 'يمكن لمالك النشاط أو المسؤول فقط تغيير الخطة أو الدفع.',
  'billing.plansLoadFailed': 'تعذّر تحميل الخطط. تحقق من الاتصال وحاول مرة أخرى.',
  'billing.keepCurrent': 'الإبقاء على خطتي الحالية',
  'billing.securityNote': 'تتم المدفوعات بأمان عبر كاشير. لا نطّلع على بيانات بطاقتك.',
  'billing.planActivatedTitle': 'تم تفعيل الخطة',
  'billing.trialStarted': 'بدأت تجربتك المجانية لمدة {{days}} يوم.',
  'billing.freeStarted': 'أنت الآن على الخطة المجانية.',
  'billing.errorTitle': 'حدث خطأ',
  'billing.errorGeneric': 'يرجى المحاولة مرة أخرى.',
  'billing.noPlan': 'لا توجد خطة بعد',
  'billing.status.active': 'نشطة',
  'billing.status.free': 'مجانية',
  'billing.status.trial': 'تجربة مجانية',
  'billing.status.expired': 'منتهية',
  'billing.status.none': 'بدون خطة',
  'billing.trialEnds': 'تنتهي التجربة في {{date}} (متبقٍ {{days}} يوم)',
  'billing.paidUntil': 'مدفوعة حتى {{date}} (متبقٍ {{days}} يوم)',
  'billing.freeForever': 'خطة مجانية — لا حاجة للدفع',
  'billing.endedOn': 'انتهت في {{date}}',
  'billing.payNow': 'ادفع الآن',
  'billing.renew': 'تجديد',
  'billing.manualRenewalNote': 'لا تتجدد الخطط تلقائيًا — جدّد قبل تاريخ الانتهاء لتجنب التوقف.',
  'billing.lockedBody': 'انتهى اشتراكك لذلك تم إيقاف مساحة العمل مؤقتًا. ادفع للمتابعة — كل بياناتك محفوظة.',
  'billing.lockedBodyNoPay': 'انتهى اشتراكك لذلك تم إيقاف مساحة العمل مؤقتًا. كل بياناتك محفوظة.',
  'billing.history': 'سجل المدفوعات',
  'billing.paymentStatus.completed': 'مدفوعة',
  'billing.paymentStatus.failed': 'فشلت',
  'billing.paymentStatus.refunded': 'مستردة',
  'billing.paymentStatus.pending': 'قيد الانتظار',
  'billing.paymentStatus.expired': 'منتهية',
  'billing.return.checking': 'جارٍ تأكيد الدفع…',
  'billing.return.checkingBody': 'يستغرق ذلك عادةً بضع ثوانٍ. يرجى إبقاء هذه الصفحة مفتوحة.',
  'billing.return.successTitle': 'تم الدفع بنجاح',
  'billing.return.successBody': 'خطتك نشطة حتى {{date}}. أرسلنا الإيصال إلى بريدك.',
  'billing.return.successBodyShort': 'خطتك نشطة. أرسلنا الإيصال إلى بريدك.',
  'billing.return.continueSetup': 'متابعة الإعداد',
  'billing.return.goToBilling': 'الذهاب إلى الفوترة',
  'billing.return.failedTitle': 'لم تتم عملية الدفع',
  'billing.return.failedBody': 'لم يتم خصم أي مبلغ. حاول مرة أخرى أو استخدم بطاقة أخرى.',
  'billing.return.tryAgain': 'حاول مرة أخرى',
  'billing.return.pendingTitle': 'ما زال التأكيد جاريًا',
  'billing.return.pendingBody': 'لم يصلنا التأكيد بعد. إذا كنت قد دفعت فستتحدث خطتك خلال دقائق.',
  'billing.status.grace': 'جدّد الآن',
  'billing.graceLine': 'انتهت في {{date}} — تستمر في العمل حتى {{lockDate}}',
  'billing.graceBanner': 'انتهت خطتك. سيستمر كل شيء في العمل لمدة {{days}} يوم إضافية (حتى {{date}}) — جدّد لتجنب الإيقاف.',
  'billing.switchBusiness': 'التبديل إلى نشاط آخر',
  'picker.billing.trialUntil': 'تجربة حتى {{date}}',
  'picker.billing.renewBy': 'جدّد قبل {{date}}',
  'picker.billing.paused': 'متوقف',
  'picker.billing.noPlan': 'بدون خطة',
  'picker.delete.action': 'حذف النشاط',
  'picker.delete.title': 'حذف النشاط',
  'picker.delete.message': 'سيُزال "{{name}}" لك ولكل أعضاء فريقه. اكتب اسم النشاط للتأكيد.',
  'picker.delete.placeholder': 'اسم النشاط',
  'picker.delete.done': 'تم حذف النشاط',
  'picker.delete.failed': 'تعذّر حذف النشاط',
  'home.billing.grace': 'انتهت خطتك — متبقٍ {{days}} يوم للتجديد قبل إيقاف مساحة العمل.',
  'home.billing.ended': 'انتهت خطتك وتم إيقاف مساحة العمل مؤقتًا.',
  'home.billing.trialEnding': 'تنتهي تجربتك المجانية خلال {{days}} يوم.',
  'home.billing.noPlan': 'اختر خطة لمواصلة استخدام DISLIX.',
  'home.billing.action': 'عرض',
  'billing.viewInvoice': 'عرض الفاتورة',
  'billing.emailInvoice': 'إرسال بالبريد',
  'billing.invoiceEmailedTitle': 'تم إرسال الفاتورة',
  'billing.invoiceEmailedBody': 'تم إرسال الفاتورة إلى بريدك الإلكتروني.',
  'billing.addons.title': 'الإضافات',
  'billing.addons.intro': 'أضف مستخدمين أو منتجات أو قنوات أو وحدات كاملة إلى خطتك في أي وقت. تدفع فقط عن الأيام المتبقية من الفترة الحالية، ثم تتجدد مع خطتك.',
  'billing.addons.yours': 'إضافاتك',
  'billing.addons.capacity': 'سعة إضافية',
  'billing.addons.modules': 'وحدات إضافية',
  'billing.addons.none': 'لا توجد إضافات متاحة لخطتك.',
  'billing.addons.youHave': 'حاليًا {{value}}',
  'billing.addons.active': 'مفعّلة',
  'billing.addons.add': 'إضافة',
  'billing.addons.added': 'تمت الإضافة',
  'billing.addons.keep': 'الإبقاء',
  'billing.addons.removeAtRenewal': 'إزالة عند التجديد',
  'billing.addons.removedAtRenewal': 'ستُزال عند التجديد القادم',
  'billing.addons.reducedAtRenewal': 'تتغير إلى {{n}} عند التجديد القادم',
  'billing.addons.payToday': '{{amount}} اليوم (متبقٍ {{days}} يوم)',
  'billing.addons.thenEach': 'ثم +{{amount}} / {{period}} مع خطتك',
  'billing.addons.afterTrial': 'الإضافات متاحة بعد الاشتراك في خطة مدفوعة.',
  'billing.addons.paidOnly': 'الإضافات متاحة في الخطط المدفوعة.',
  'billing.addons.renewFirst': 'انتهت خطتك — جدّدها أولًا ثم أضف المزيد.',
  'billing.addons.manage': 'إدارة',
  'billing.addons.addMore': 'إضافة المزيد',
  'billing.addons.pitch': 'تحتاج مستخدمين أو منتجات إضافية أو وحدة جديدة؟ أضف ما تحتاجه فقط.',
  'billing.return.addonsBody': 'إضافاتك مفعّلة الآن. أرسلنا الإيصال إلى بريدك.',
  'billing.unlimited': 'غير محدود',
  'billing.soon': 'قريبًا',
  // ─── Onboarding ───────────────────────────────────────────────────────────
  'onboarding.channels.title': 'اربط قنواتك',
  'onboarding.channels.subtitle': 'اربط ما تستخدمه الآن — ويمكنك إضافة الباقي لاحقًا من الرئيسية.',
  'onboarding.channels.connect': 'ربط',
  'onboarding.channels.connected': 'مرتبطة',
  'onboarding.channels.goToDashboard': 'الذهاب إلى لوحة التحكم',
  'onboarding.channels.skipForNow': 'تخطي الآن',
  'onboarding.channels.laterHint': 'يمكن ربط القنوات لاحقًا من الإعدادات.',
  'business.industryPlaceholder': 'مثال: صيدلية، تجزئة، عيادة',
  'business.phoneOptional': 'هاتف النشاط (اختياري)',
  'business.extrasTitle': 'الشعار والموقع',
  'business.extrasSubtitle': 'اختياري — يساعد العملاء على التعرف عليك. يمكنك إضافتها لاحقًا.',
  'business.addLogo': 'إضافة شعار',
  'business.createBusiness': 'إنشاء النشاط',
  'business.skipAndCreate': 'تخطي والإنشاء',
  'business.createFailed': 'تعذّر إنشاء النشاط',
  'business.createdTitle': 'تم إنشاء النشاط',
  'business.signInAgain': 'يرجى اختيار نشاطك للمتابعة.',
  'business.photoPermissionTitle': 'مطلوب إذن',
  'business.photoPermissionBody': 'اسمح بالوصول إلى الصور لإضافة شعار نشاطك.',
  // ─── Home dashboard ───────────────────────────────────────────────────────
  'home.range.today': 'اليوم',
  'home.range.week': '7 أيام',
  'home.range.month': '30 يومًا',
  'home.setup.title': 'أكمل إعداد مساحة العمل',
  'home.setup.action': 'متابعة',
  'setup.title': 'جهّز نشاطك التجاري',
  'setup.subtitle': 'خطوات أولى ليبدأ فريقك البيع. نفّذها بأي ترتيب — تبقى هذه القائمة في الرئيسية حتى تنتهي.',
  'setup.progress': 'تم {{done}} من {{total}}',
  'setup.next': 'التالي: {{step}}',
  'setup.start': 'ابدأ',
  'setup.done': 'تم',
  'setup.dismiss': 'إخفاء',
  'setup.allDone': 'نشاطك التجاري جاهز.',
  'setup.section.channels': 'القنوات',
  'setup.section.account': 'حسابك',
  'setup.section.customers': 'العملاء',
  'setup.section.catalogue': 'الكتالوج',
  'setup.section.team': 'الفريق',
  'setup.section.sales': 'المبيعات',
  'setup.section.calendar': 'التقويم',
  'setup.step.businessSettings.title': 'حدّد ساعات العمل والعملة',
  'setup.step.businessSettings.description': 'المنطقة الزمنية والعملة وأيام وساعات العمل.',
  'setup.step.calendars.title': 'أنشئ تقويم الحجوزات',
  'setup.step.calendars.description': 'دع العملاء يحجزون مواعيد ضمن ساعات عملك.',
  'setup.step.channels.title': 'اربط قناة',
  'setup.step.channels.description': 'واتساب أو ماسنجر أو X أو الهاتف — حيث يتواصل معك عملاؤك.',
  'setup.step.identity_email.title': 'أضف بريدك الإلكتروني',
  'setup.step.identity_email.description': 'لاستعادة الحساب والإشعارات.',
  'setup.step.identity_mobile.title': 'أضف رقم جوالك',
  'setup.step.identity_mobile.description': 'لتسجيل الدخول عبر واتساب واستعادة الحساب.',
  'setup.step.contacts.title': 'أضف جهات الاتصال',
  'setup.step.contacts.description': 'استورد ملفًا أو أضف العملاء واحدًا تلو الآخر.',
  'setup.step.catalogues.title': 'أنشئ تصنيفًا',
  'setup.step.catalogues.description': 'نظّم منتجاتك في كتالوجات يتصفحها العملاء.',
  'setup.step.products.title': 'أضف منتجات',
  'setup.step.products.description': 'الأسعار والصور والمخزون لما تبيعه.',
  'setup.step.vendors.title': 'أضف موردًا',
  'setup.step.vendors.description': 'من يورّد منتجاتك.',
  'setup.step.team.title': 'ادعُ فريقك',
  'setup.step.team.description': 'أضف من سيتولى المحادثات والمبيعات والزيارات.',
  'setup.step.departments.title': 'أنشئ قسمًا',
  'setup.step.departments.description': 'وجّه المحادثات والمهام إلى الفريق المناسب.',
  'setup.step.quotations.title': 'أرسل أول عرض سعر',
  'setup.step.quotations.description': 'جهّز عرضًا لأحد العملاء.',
  'setup.step.orders.title': 'أنشئ أول طلب',
  'setup.step.orders.description': 'سجّل عملية بيع لأحد العملاء.',
  'home.attention.title': 'بحاجة إلى انتباهك',
  'home.attention.allClear': 'كل شيء على ما يرام — لا يوجد ما يحتاجك الآن.',
  'home.attention.needsResponse': 'بانتظار الرد',
  'home.attention.expiringSoon': 'نافذة الرد تُغلق',
  'home.attention.followUpDue': 'متابعات مستحقة',
  'home.attention.overdueAssignments': 'تعيينات متأخرة',
  'home.attention.visitsToday': 'زيارات اليوم',
  'home.attention.visitsOverdue': 'زيارات متأخرة',
  'home.attention.eventsToday': 'مواعيد اليوم',
  'home.attention.pendingOrders': 'طلبات معلّقة',
  'home.attention.expiringQuotations': 'عروض أسعار تنتهي قريبًا',
  'home.kpi.title': 'الأداء',
  'home.kpi.messages': 'الرسائل المرسلة',
  'home.kpi.received': '{{count}} مستلمة',
  'home.kpi.reached': 'عملاء تم التواصل معهم',
  'home.kpi.calls': 'المكالمات',
  'home.kpi.callsDetail': '{{answered}} مُجابة · {{talk}} تحدث',
  'home.kpi.visits': 'الزيارات',
  'home.kpi.visitsDetail': '{{completed}} مكتملة · {{open}} مفتوحة',
  'home.kpi.orders': 'الطلبات',
  'home.kpi.quotations': 'عروض الأسعار',
  'home.kpi.quotationsDetail': '{{accepted}} مقبولة',
  'home.agenda.title': 'يومك',
  'home.agenda.empty': 'لا يوجد شيء آخر مجدول اليوم.',
  'home.agenda.visit': 'زيارة',
  'home.agenda.event': 'موعد',
  'home.trend.title': 'اتجاه النشاط',
  'home.trend.messages': 'الرسائل',
  'home.trend.calls': 'المكالمات',
  'home.trend.visits': 'الزيارات',
  'home.team.title': 'نشاط الفريق',
  'home.team.viewReports': 'عرض التقارير',
  'home.team.stats': '{{messages}} رسالة · {{calls}} مكالمة · {{visits}} زيارة',
  'home.shortcuts.title': 'اختصارات',
  'home.loadError': 'تعذّر تحميل لوحة المعلومات. اسحب للأسفل لإعادة المحاولة.',
  'outreachGuidance.title': 'من يجب التواصل معه الآن',
  'outreachGuidance.expiringSoon.title': 'على وشك الانتهاء',
  'outreachGuidance.expiringSoon.subtitle': '{{count}} جهة اتصال على وشك تفويت نافذة الرد أو تجاوز الموعد',
  'outreachGuidance.needsResponse.title': 'بحاجة إلى رد',
  'outreachGuidance.needsResponse.subtitle': '{{count}} جهة اتصال بانتظار ردك',
  'outreachGuidance.followUpDue.title': 'يحتاج متابعة',
  'outreachGuidance.followUpDue.subtitle': '{{count}} جهة اتصال لم يصل منها رد منذ {{days}}+ أيام',
  'outreachGuidance.neverContacted.title': 'لم يتم التواصل معه',
  'outreachGuidance.neverContacted.subtitle': '{{count}} جهة اتصال لم تتم مراسلتها على أي قناة',
  'outreachGuidance.neverContacted.navigateHint': '{{count}} جهة اتصال لم تتم مراسلتها على أي قناة',
  'inbox.channel.allChannels': 'كل القنوات',
  'inbox.channel.whatsapp': 'واتساب',
  'inbox.channel.facebook': 'فيسبوك',
  'inbox.channel.telegram': 'تيليجرام',
  'inbox.channel.xTwitter': 'إكس (تويتر)',
  'inbox.channel.email': 'البريد الإلكتروني',
  'inbox.groupByContact': 'تجميع حسب جهة الاتصال',
  'inbox.emptyUnified': 'صندوق الوارد الموحد فارغ. ابدأ محادثة على أي قناة متصلة!',
  'inbox.error.businessRequiredTitle': 'مطلوب اختيار نشاط تجاري',
  'inbox.error.businessRequiredMessage': 'يرجى اختيار نشاط تجاري لعرض المحادثات',
  'inbox.error.apiErrorTitle': 'خطأ في الواجهة البرمجية',
  'inbox.error.requestFailedWithStatus': 'فشل الطلب برمز الحالة {{status}}',
  'inbox.error.networkErrorTitle': 'خطأ في الشبكة',
  'inbox.error.networkErrorMessage': 'يرجى التحقق من اتصالك والمحاولة مرة أخرى',
  'inbox.error.genericTitle': 'خطأ',
  'inbox.error.loadFailed': 'فشل تحميل المحادثات',
  'inbox.noMessagesYet': 'لا توجد رسائل بعد',
  'inbox.templateMessageSent': '📋 تم إرسال رسالة قالب',

  // ─── Chat ─────────────────────────────────────────────────────────────────
  'chat.typeMessage': 'اكتب رسالة...',
  'chat.send': 'إرسال',
  'chat.reply': 'رد',
  'chat.forward': 'إعادة توجيه',
  'chat.delete': 'حذف',
  'chat.copy': 'نسخ',
  'chat.today': 'اليوم',
  'chat.yesterday': 'أمس',
  'chat.voiceNote': 'رسالة صوتية',
  'chat.document': 'مستند',
  'chat.image': 'صورة',
  'chat.video': 'فيديو',
  'chat.assignTo': 'تعيين إلى',
  'chat.closeConversation': 'إغلاق المحادثة',
  'chat.reopenConversation': 'إعادة فتح المحادثة',
  'chat.camera': 'الكاميرا',
  'chat.gallery': 'الصور',
  'chat.audio': 'صوت',
  'chat.location': 'الموقع',
  'chat.sendMedia': 'إرسال وسائط',
  'chat.replyingTo': 'رداً على {{name}}',
  'chat.templateMessage': 'رسالة قالب',
  'chat.isTyping': '{{name}} يكتب...',
  'chat.you': 'أنت',
  'chat.contact': 'جهة اتصال',
  'chat.errorLoadingQuickReplies': 'فشل تحميل مجموعات الردود السريعة',
  'chat.quickReplySent': 'تم إرسال مجموعة الردود السريعة بنجاح',
  'chat.quickReplySendFailed': 'فشل إرسال مجموعة الردود السريعة',
  'chat.errorLoadingCatalogues': 'فشل تحميل الكتالوجات',
  'chat.catalogueSent': 'تم إرسال الكتالوج بنجاح',
  'chat.catalogueSendFailed': 'فشل إرسال الكتالوج',
  'chat.conversationIdRequired': 'معرّف المحادثة مطلوب',
  'chat.searchStickers': 'ابحث عن ملصقات...',
  'chat.searchQuickReplies': 'ابحث في المجموعات...',
  'chat.searchCatalogs': 'ابحث في الكتالوجات...',
  'chat.interactiveReply': 'رد تفاعلي',
  'chat.quotedMessage': 'رسالة مقتبسة',
  'chat.previousMessage': 'رسالة سابقة',
  'chat.unknownContact': 'جهة اتصال غير معروفة',
  'chat.noPhoneNumber': 'لا يوجد رقم هاتف',
  'chat.sharedLocation': 'موقع مشترك',
  'chat.sharedContact': 'جهة اتصال مشتركة',
  'chat.openLink': 'فتح الرابط',
  'chat.replyLabel': 'رد',
  'chat.copyLabel': 'نسخ',
  'chat.shareLabel': 'مشاركة',
  'chat.forwardLabel': 'إعادة توجيه',
  'chat.contactLabel': 'جهة اتصال',
  'chat.imagePlaceholder': 'صورة',
  'chat.pdfLoadError': 'تعذّر تحميل ملف PDF',
  'chat.pdfLoading': 'جارٍ تحميل PDF\u2026',
  'chat.pdfRetry': 'إعادة المحاولة',
  'chat.previewUnavailable': 'المعاينة غير متاحة',
  'chat.previewUnavailableHint': 'لا يمكن معاينة هذا النوع من الملفات في المتصفح. استخدم التطبيق على هاتفك لعرضه.',
  'chat.sticker': 'ملصق',
  'chat.message': 'رسالة',
  'chat.interactiveMessage': 'رسالة تفاعلية',
  'chat.optionsSent': 'تم إرسال الخيارات',
  'chat.showOptions': 'عرض الخيارات',
  'chat.hideOptions': 'إخفاء الخيارات',
  'chat.deliveryFailedTitle': 'فشل الإرسال',
  'chat.deliveryFailedGeneric': 'تعذر تسليم هذه الرسالة.',
  'chat.deliveryThrottledExplanation': 'أوقف واتساب تسليم هذه الرسالة للحفاظ على جودة التسليم — يبدو أن جهة الاتصال هذه لم تتفاعل مع الرسائل الأخيرة. إعادة الإرسال فورًا غالبًا لن تنجح وقد تؤخر عودة التسليم أكثر. انتظر قليلاً قبل المحاولة مرة أخرى، أو تواصل معهم بطريقة أخرى.',

  // ─── Cards ────────────────────────────────────────────────────────────────
  'card.catalog': 'الكتالوج',
  'card.catalogProducts': '{{count}} منتجات',
  'card.catalogProduct': '{{count}} منتج',
  'card.viewCatalog': 'عرض الكتالوج',
  'card.product': 'منتج',
  'card.view': 'عرض',
  'card.sale': 'تخفيض',
  'card.viewAndOrder': 'عرض وطلب',
  'card.inProducts': 'في المنتجات',
  'card.quickReply': 'رد سريع',
  'card.selectedOption': 'الخيار المختار',
  'card.calendarEvent': 'حدث في التقويم',
  'card.eventStart': 'البداية: ',
  'card.eventEnd': 'النهاية: ',
  'card.eventStatus': 'الحالة: ',
  'card.viewEvent': 'عرض الحدث',
  'card.eventStatusTitle': 'حالة الحدث',
  'card.selectNewStatus': 'اختر حالة جديدة',
  'card.cancel': 'إلغاء',
  'card.statusScheduled': 'مجدول',
  'card.statusInProgress': 'جارٍ',
  'card.statusCompleted': 'مكتمل',
  'card.statusCancelled': 'ملغى',
  'card.order': 'طلب',
  'card.orderStatus': 'حالة الطلب',
  'card.orderNotes': 'ملاحظات الطلب',
  'card.ok': 'موافق',
  'card.viewOrder': 'عرض الطلب',
  'card.modifyOrder': 'تعديل',
  'card.orderTotal': 'الإجمالي: ',
  'card.orderStatusLabel': 'الحالة: ',
  'card.orderPayment': ' · الدفع: ',
  'card.statusTitle': 'الحالة',
  'card.orderPlacedDesc': 'تأكيد أو إلغاء أدناه',
  'card.orderConfirmedDesc': 'تتبع طلبك',
  'card.orderCancelledDesc': 'لا يلزم اتخاذ أي إجراء',
  'card.orderPlaced': 'تم تقديم الطلب',
  'card.orderConfirmed': 'تم تأكيد الطلب',
  'card.orderCancelledTitle': 'تم إلغاء الطلب',
  'card.statusPending': 'قيد الانتظار',
  'card.statusPlaced': 'مقدّم',
  'card.statusConfirmedOrder': 'مؤكد',
  'card.statusProcessing': 'قيد المعالجة',
  'card.statusShipped': 'تم الشحن',
  'card.statusDelivered': 'تم التسليم',
  'card.statusCancelledOrder': 'ملغى',
  'card.paymentUnpaid': 'غير مدفوع',
  'card.paymentPartial': 'جزئي',
  'card.paymentPaid': 'مدفوع',
  'card.paymentRefunded': 'مُستردّ',
  'card.customer': 'العميل',
  'card.confirmedOrder': '{{name}} أكّد الطلب',
  'card.cancelledOrder': '{{name}} ألغى الطلب',
  'card.orderCopied': 'تم النسخ',
  'card.orderCopiedDesc': 'تم نسخ رقم الطلب إلى الحافظة',
  'card.orderCopyFailed': 'فشل النسخ',
  'card.orderCopyFailedDesc': 'تعذّر النسخ إلى الحافظة',
  'card.statusUpdated': 'تم تحديث الحالة',
  'card.orderStatusUpdated': 'تم تعيين حالة الطلب إلى {{status}}',
  'card.eventStatusUpdated': 'تم تعيين حالة الحدث إلى {{status}}',
  'card.paymentUpdated': 'تم تحديث الدفع',
  'card.paymentStatusUpdated': 'تم تعيين حالة الدفع إلى {{status}}',
  'card.updateFailed': 'فشل التحديث',
  'card.updateOrderFailed': 'تعذّر تحديث حالة الطلب',
  'card.updatePaymentFailed': 'تعذّر تحديث حالة الدفع',
  'card.updateEventFailed': 'تعذّر تحديث حالة الحدث',

  // ─── Conversation ─────────────────────────────────────────────────────────
  'conversation.engagementCooldownTitle': 'تم إيقاف تسليم الرسائل لهذه الجهة مؤخرًا',
  'conversation.deliveryRetry.title': 'إعادة محاولة تسليم واتساب تلقائيًا',
  'conversation.deliveryRetry.enable': 'تفعيل إعادة المحاولة تلقائيًا',
  'conversation.deliveryRetry.stop': 'إيقاف إعادة المحاولة',
  'conversation.deliveryRetry.next': 'الفحص القادم',
  'conversation.deliveryRetry.hint': 'يُفحص الإرسال كل ساعة وتُعاد محاولة أحدث قالب فشل عندما تسمح فترة الانتظار. تتوقف المهمة عند تأكيد التسليم. تغيير القالب التسويقي لا يزيل هذا القيد.',
  'conversation.deliveryRetry.state.scheduled': 'تمت جدولة إعادة المحاولة',
  'conversation.deliveryRetry.state.cooldown': 'بانتظار انتهاء فترة إيقاف التسليم',
  'conversation.deliveryRetry.state.sending': 'جارٍ إعادة المحاولة',
  'conversation.deliveryRetry.state.awaiting_delivery': 'قبل واتساب الرسالة؛ بانتظار تأكيد التسليم',
  'conversation.deliveryRetry.state.delivered': 'تم التسليم وتوقفت إعادة المحاولة',
  'conversation.deliveryRetry.state.cancelled': 'تم إيقاف إعادة المحاولة',
  'conversation.deliveryRetry.state.stopped': 'توقفت المهمة لتغيّر جهة الاتصال أو قناة الإرسال',
  'conversation.deliveryRetry.state.needs_review': 'توقفت المهمة؛ الرسالة تحتاج إلى مراجعة',
  'conversation.engagementCooldownSubtext': 'يقوم واتساب بإيقاف تسليم الرسائل للحفاظ على جودة التسليم. إرسال رسالة الآن غالبًا لن ينجح — انتظر قليلاً قبل المحاولة، أو تواصل معهم بطريقة أخرى.',
  'conversation.loadFailed': 'فشل تحميل المحادثة',
  'conversation.messageLoadFailed': 'فشل تحميل الرسائل',
  'conversation.archived': 'تم الأرشفة',
  'conversation.archivedDesc': 'تم أرشفة المحادثة',
  'conversation.archiveFailed': 'فشل أرشفة المحادثة',
  'conversation.forwardMessage': 'إعادة توجيه رسالة',
  'conversation.copied': 'تم النسخ',
  'conversation.copiedDesc': 'تم نسخ الرسالة إلى الحافظة',
  'conversation.shared': 'مشاركة',
  'conversation.sharedDesc': 'تم فتح خيارات المشاركة',
  'conversation.starred': 'تم التمييز',
  'conversation.starredDesc': 'تم تمييز الرسالة',
  'conversation.contactUpdated': 'تم تحديث جهة الاتصال',
  'conversation.contactUpdatedDesc': 'تم تحديث {{name}}',
  'conversation.windowReopened': 'تم إعادة فتح النافذة',
  'conversation.windowReopenedDesc': 'يمكنك الآن إرسال رسائل عادية',
  'conversation.templateSent': 'تم إرسال القالب',
  'conversation.templateSentDesc': 'تم إعادة فتح نافذة المحادثة',
  'conversation.messageSent': 'تم الإرسال',
  'conversation.messageSentDesc': 'يمكنك الآن إرسال رسائل عادية',
  'conversation.sendFailed': 'فشل الإرسال',
  'conversation.messageError': 'خطأ في الرسالة',
  'conversation.messageErrorDesc': 'فشل تجهيز الرسالة للإرسال',
  'conversation.audioFailed': 'فشل إرسال الصوت',
  'conversation.audioFailedDesc': 'فشل إرسال الرسالة الصوتية. قد يكون الملف تالفاً أو محذوفاً.',
  'conversation.imageFailed': 'فشل إرسال الصورة',
  'conversation.imageFailedDesc': 'فشل إرسال الصورة. قد تكون تالفة أو محذوفة.',
  'conversation.videoFailed': 'فشل إرسال الفيديو',
  'conversation.videoFailedDesc': 'فشل إرسال الفيديو. قد يكون تالفاً أو محذوفاً.',
  'conversation.documentFailed': 'فشل إرسال المستند',
  'conversation.documentFailedDesc': 'فشل إرسال المستند. قد يكون تالفاً أو محذوفاً.',
  'conversation.messageFailed': 'فشلت الرسالة',
  'conversation.messageFailedDesc': 'فشل إرسال الرسالة. حاول مجدداً.',
  'conversation.audioFileIssue': 'مشكلة في الملف الصوتي',
  'conversation.audioFileIssueDesc': 'قد يكون الملف الصوتي تالفاً أو محذوفاً. حاول التسجيل مجدداً.',
  'conversation.imageFileIssue': 'مشكلة في ملف الصورة',
  'conversation.imageFileIssueDesc': 'قد تكون الصورة تالفة أو محذوفة. حاول اختيار صورة أخرى.',
  'conversation.videoFileIssue': 'مشكلة في ملف الفيديو',
  'conversation.videoFileIssueDesc': 'قد يكون الفيديو تالفاً أو محذوفاً. حاول اختيار فيديو آخر.',
  'conversation.documentFileIssue': 'مشكلة في ملف المستند',
  'conversation.documentFileIssueDesc': 'قد يكون المستند تالفاً أو محذوفاً. حاول اختيار مستند آخر.',
  'conversation.fileUploadError': 'خطأ في رفع الملف',
  'conversation.fileUploadErrorDesc': 'تعذّر رفع الملف. حاول مجدداً.',
  'conversation.loadingMoreMessages': 'جارٍ تحميل المزيد من الرسائل...',
  'conversation.online': 'متصل الآن',
  'conversation.discussionArchived': 'تم أرشفة هذه المحادثة',
  'conversation.discussionSpam': 'تم تصنيف هذه المحادثة كرسائل مزعجة',
  'conversation.noNewMessages': 'لا يمكن إرسال رسائل جديدة إلى هذه المحادثة',
  'conversation.windowClosed': 'انتهت نافذة المراسلة (24 ساعة)',
  'conversation.cannotReopen': 'لا يمكن إعادة فتح هذه المحادثة',
  'conversation.messagePlaceholderWithName': 'مراسلة {{name}}...',
  'conversation.sendAMessage': 'إرسال رسالة…',
  'conversation.groupActions': 'الإجراءات',
  'conversation.viewContact': 'عرض جهة الاتصال',
  'conversation.copyNumber': 'نسخ الرقم',
  'conversation.call': 'اتصال',
  'conversation.noPhoneNumber': 'لا يوجد رقم هاتف متاح لجهة الاتصال هذه',
  'conversation.assignTo': 'إسناد إلى',
  'conversation.notes': 'الملاحظات',
  'conversation.assignedTo': 'مسندة إلى {{name}}',
  'conversation.unassigned': 'غير مسندة',
  'conversation.noContactToView': 'لا توجد جهة اتصال لعرضها',
  'conversation.loadContactFailed': 'فشل تحميل جهة الاتصال',
  'conversation.copiedTitle': 'تم النسخ',
  'conversation.numberCopied': 'تم نسخ رقم الهاتف',
  'conversation.copyFailed': 'فشل نسخ رقم الهاتف',
  'conversation.addNoteFailed': 'فشل إضافة الملاحظة',
  'conversation.deleteNoteFailed': 'فشل حذف الملاحظة',

  // سجل المكالمات
  'callHistory.title': 'سجل المكالمات',
  'callHistory.noCalls': 'لا توجد مكالمات بعد',
  'callHistory.selectCallHint': 'اختر مكالمة لعرض التفاصيل',
  'callHistory.callBack': 'معاودة الاتصال',
  'callHistory.incoming': 'واردة',
  'callHistory.outgoing': 'صادرة',
  'callHistory.incomingCall': 'مكالمة واردة',
  'callHistory.outgoingCall': 'مكالمة صادرة',
  'callHistory.status.completed': 'مكتملة',
  'callHistory.status.notResponded': 'لم يتم الرد',
  'callHistory.status.cancelled': 'مشغول',
  'callHistory.status.ended': 'منتهية',
  'callHistory.status.failed': 'فشلت',
  'callHistory.status.ringing': 'جاري الاتصال…',
  'callHistory.status.answered': 'تم الرد',
  'callHistory.details.duration': 'المدة',
  'callHistory.details.started': 'بدأت',
  'callHistory.details.ended': 'انتهت',
  'callHistory.details.number': 'الرقم',
  'callHistory.details.provider': 'المزوّد',
  'callHistory.recording.label': 'التسجيل',
  'callHistory.recording.play': 'تشغيل التسجيل',
  'callHistory.recording.loading': 'جارٍ تحميل التسجيل…',
  'callHistory.recording.unavailable': 'لا يوجد تسجيل متاح لهذه المكالمة',
  'callHistory.recording.retry': 'فشل التحميل — أعد المحاولة',
  'callHistory.details.title': 'تفاصيل المكالمة',
  'callHistory.outcome.label': 'نتيجة المكالمة',
  'callHistory.outcome.record': 'تسجيل النتيجة',
  'callHistory.outcome.recorded': 'تم التسجيل',
  'reports.title': 'التقارير',
  'reports.noAccess': 'ليس لديك صلاحية الوصول إلى التقارير.',
  'reports.noData': 'لا توجد بيانات للفلاتر المحددة.',
  'reports.tabs.messages': 'الرسائل',
  'reports.tabs.calls': 'المكالمات',
  'reports.tabs.visits': 'الزيارات',
  'reports.tabs.performance': 'الأداء',
  'reports.group.visits': '{{count}} زيارة · {{completed}} مكتملة',
  'reports.group.missed': '{{count}} فائتة',
  'reports.group.calls': '{{count}} مكالمة · {{answered}} مُجابة',
  'reports.group.messages': '{{count}} رسالة',
  'reports.groupByContact': 'تجميع حسب جهة الاتصال',
  'reports.performance.activity': 'النشاط',
  'reports.performance.activityHint': 'تُحسب بنفس طريقة تبويب الكل. كل الرسائل = المرسلة من الموظفين (الردود والحملات) + المستلمة من العملاء + التلقائية (التدفقات والردود الآلية). عند تحديد موظف تُحسب رسائله المرسلة فقط. العملاء = عدد الأشخاص المختلفين الذين تمت مراسلتهم أو الاتصال بهم.',
  'reports.performance.messagesSent': 'الرسائل المرسلة',
  'reports.kpi.messagesTotal': 'كل الرسائل',
  'reports.performance.messagesAutomated': 'التلقائية',
  'reports.performance.messagesReceived': 'المستلمة',
  'reports.performance.messagesTotal': 'كل الرسائل',
  'reports.performance.callsMade': 'المكالمات',
  'reports.kpi.callTimeTotal': 'إجمالي وقت المكالمات',
  'reports.performance.col.callTimeTotal': 'إجمالي وقت المكالمات',
  'reports.performance.callTimeTotal': 'إجمالي وقت المكالمات',
  'reports.performance.talkTimeTotal': 'وقت المحادثة (المتصلة)',
  'reports.performance.col.talkTimeTotal': 'وقت المحادثة',
  'reports.kpi.talkTimeTotal': 'وقت المحادثة (المتصلة)',
  'reports.performance.visitsCount': 'الزيارات',
  'reports.performance.customersReached': 'العملاء الذين تم التواصل معهم',
  'reports.performance.assignmentsHint': 'الإسنادات الجديدة: جهات اتصال أسندها شخص آخر خلال الفترة (مدير أو قاعدة إسناد تلقائي أو قسم). المحادثات أو جهات الاتصال التي يفتحها الموظف بنفسه لا تُعد إسنادًا.',
  'reports.performance.col.messagesSent': 'الرسائل المرسلة',
  'reports.performance.col.calls': 'المكالمات',
  'reports.performance.col.customersReached': 'العملاء',
  'reports.kpi.messagesSent': 'الرسائل المرسلة',
  'reports.kpi.customersReached': 'العملاء الذين تم التواصل معهم',
  'reports.kpi.avgResponse': 'متوسط الرد',
  'reports.kpi.medianResponse': 'وسيط الرد',
  'reports.kpi.unanswered': 'بدون رد',
  'reports.kpi.answerRate': 'نسبة الرد على المكالمات',
  'reports.kpi.avgRing': 'متوسط الرنين',
  'reports.kpi.avgCallback': 'متوسط المعاودة',
  'reports.kpi.visitCompletion': 'إكمال الزيارات',
  'reports.kpi.avgServing': 'متوسط مدة الخدمة',
  'reports.kpi.firstTouch': 'الإسناد ← أول تفاعل',
  'reports.filters.contactsSelected': '{{count}} جهات اتصال',
  'reports.filters.agentsSelected': '{{count}} محدد',
  'reports.filters.clearSelection': 'مسح',
  'reports.filters.done': 'تم',
  'reports.filters.doneCount': 'تم ({{count}})',
  'reports.filters.departments': 'الأقسام',
  'reports.filters.agents': 'الموظفون',
  'reports.duration.s': 'ث',
  'reports.duration.m': 'د',
  'reports.duration.h': 'س',
  'reports.duration.d': 'ي',
  'reports.performance.note': 'أزمنة فعلية (بتوقيت الساعة) للفترة والفلاتر المحددة — المتوسط أولاً، ثم الوسيط وأبطأ ١٠٪ (P90) والمدى.',
  'reports.performance.computedAt': 'حُسبت {{time}}.',
  'reports.performance.median': 'الوسيط',
  'reports.performance.p90': 'P90',
  'reports.performance.range': 'المدى',
  'reports.performance.samples': '{{count}} عينة',
  'reports.performance.messages': 'الرسائل',
  'reports.performance.replied': 'محادثات تم الرد عليها',
  'reports.performance.unanswered': 'محادثات بانتظار الرد',
  'reports.performance.responseTime': 'زمن الرد',
  'reports.performance.responseTimeHint': 'يُقاس لكل دورة محادثة: رسالة/رسائل العميل ← أول رد من الموظف',
  'reports.performance.firstResponseTime': 'زمن أول رد',
  'reports.performance.firstResponseTimeHint': 'أول رسالة من العميل في كل محادثة خلال الفترة ← أول رد',
  'reports.performance.calls': 'المكالمات',
  'reports.performance.answered': 'تم الرد',
  'reports.performance.missedInbound': 'فائتة',
  'reports.performance.calledBack': 'تم معاودة الاتصال',
  'reports.performance.notCalledBack': 'لم يُعاوَد الاتصال',
  'reports.performance.answerRate': 'نسبة الرد',
  'reports.performance.callbackTime': 'زمن معاودة الاتصال',
  'reports.performance.callbackTimeHint': 'مكالمة فائتة ← أول مكالمة لنفس العميل',
  'reports.performance.talkTime': 'مدة المحادثة',
  'reports.performance.ringTime': 'مدة الرنين (مُجابة)',
  'reports.performance.ringTimeHint': 'بدء الرنين ← الرد',
  'reports.performance.unansweredRingTime': 'مدة الرنين (بدون رد)',
  'reports.performance.unansweredRingTimeHint': 'مدة رنين المكالمات غير المُجابة قبل إنهائها',
  'reports.performance.col.avgRing': 'متوسط الرنين',
  'reports.performance.visits': 'الزيارات',
  'reports.performance.completed': 'مكتملة',
  'reports.performance.inProgress': 'قيد التنفيذ',
  'reports.performance.open': 'مفتوحة',
  'reports.performance.missedVisits': 'فائتة',
  'reports.performance.completionRate': 'نسبة الإكمال',
  'reports.performance.assignmentToStart': 'الإسناد ← البدء',
  'reports.performance.startDelay': 'البدء مقابل الموعد',
  'reports.performance.startDelayHint': 'موجب = تأخير، سالب = مبكر',
  'reports.performance.servingTime': 'مدة الخدمة',
  'reports.performance.servingTimeHint': 'بدء الزيارة ← انتهاؤها',
  'reports.performance.assignments': 'الإسنادات',
  'reports.performance.currentlyAssigned': 'المُسند حاليًا',
  'reports.performance.reachedInPeriod': 'تم التواصل خلال الفترة',
  'reports.performance.notReachedInPeriod': 'لم يتم التواصل خلال الفترة',
  'reports.performance.currentlyAssignedHint': 'جهات الاتصال المُسندة للموظف الآن أيًا كان وقت إسنادها (مثل فلتر شاشة جهات الاتصال). تم التواصل = راسلها الموظف أو اتصل بها أو زارها خلال الفترة المحددة.',
  'reports.performance.newAssignments': 'إسنادات جديدة خلال الفترة: {{count}}',
  'reports.performance.col.assignedReached': 'المُسند الذي تم التواصل معه',
  'reports.performance.contacted': 'تم التواصل',
  'reports.performance.notContacted': 'لم يتم التواصل بعد',
  'reports.performance.timeToFirstInteraction': 'الإسناد ← أول تفاعل',
  'reports.performance.timeToFirstInteractionHint': 'أول رسالة أو مكالمة أو زيارة من الموظف المُسند إليه',
  'reports.performance.byAgent': 'حسب الموظف',
  'reports.performance.unassigned': 'غير مُسند',
  'reports.performance.col.agent': 'الموظف',
  'reports.performance.col.replies': 'الردود',
  'reports.performance.col.avgResponse': 'متوسط الرد',
  'reports.performance.col.unanswered': 'بدون رد',
  'reports.performance.col.callsAnswered': 'مكالمات مُجابة',
  'reports.performance.col.missed': 'مكالمات فائتة',
  'reports.performance.col.avgCallback': 'متوسط المعاودة',
  'reports.performance.col.visitsDone': 'زيارات مكتملة',
  'reports.performance.col.assignToStart': 'الإسناد ← البدء',
  'reports.performance.col.avgServing': 'متوسط الخدمة',
  'reports.performance.col.assignContacted': 'إسنادات تم التواصل',
  'reports.performance.col.firstInteraction': 'الإسناد ← أول تفاعل',
  'reports.datePreset.today': 'اليوم',
  'reports.datePreset.7d': 'آخر 7 أيام',
  'reports.datePreset.30d': 'آخر 30 يومًا',
  'reports.datePreset.custom': 'مخصص',
  'reports.filters.startDate': 'تاريخ البدء',
  'reports.filters.endDate': 'تاريخ الانتهاء',
  'reports.filters.contactId': 'معرّف جهة الاتصال',
  'reports.filters.actionType': 'الإجراء / النوع',
  'reports.filters.allTypes': 'كل الأنواع',
  'reports.filters.allContacts': 'كل جهات الاتصال',
  'reports.filters.contact': 'جهة الاتصال',
  'reports.filters.searchContacts': 'ابحث عن جهة اتصال بالاسم أو رقم الهاتف...',
  'reports.filters.noContactsFound': 'لم يتم العثور على جهات اتصال.',
  'reports.filters.allTemplates': 'كل القوالب',
  'reports.filters.template': 'القالب',
  'reports.filters.allStatuses': 'كل الحالات',
  'reports.filters.callStatus': 'حالة المكالمة',
  'reports.filters.visitStatus': 'حالة الزيارة',
  'reports.tabs.all': 'الكل',
  'reports.sort.title': 'ترتيب حسب',
  'reports.sort.time': 'الوقت',
  'reports.sort.name': 'الاسم',
  'reports.sort.status': 'الحالة',
  'reports.filters.user': 'الموظف',
  'reports.filters.allUsers': 'كل الموظفين',
  'reports.filters.searchUsers': 'ابحث عن موظف بالاسم أو البريد الإلكتروني...',
  'reports.filters.noUsersFound': 'لم يتم العثور على موظفين.',
  'reports.openConversation': 'فتح المحادثة',
  'reports.grouped.messageCount': 'الرسائل',
  'reports.grouped.lastMessage': 'آخر رسالة',
  'reports.filters.channel': 'القناة',
  'reports.selectRowHint': 'اختر صفًا لعرض التفاصيل.',
  'reports.export.title': 'تصدير التقرير',
  'reports.export.csv': 'تصدير CSV',
  'reports.export.excel': 'تصدير Excel',
  'reports.export.pdf': 'تصدير PDF',
  'reports.kpi.messages': 'الرسائل',
  'reports.kpi.inbound': 'واردة',
  'reports.kpi.outbound': 'صادرة',
  'reports.kpi.calls': 'المكالمات',
  'reports.kpi.completedCalls': 'المكالمات المكتملة',
  'reports.kpi.visits': 'الزيارات',
  'reports.kpi.completedVisits': 'الزيارات المكتملة',
  'reports.charts.messageVolume': 'حجم الرسائل',
  'reports.charts.callVolume': 'حجم المكالمات',
  'reports.charts.visitVolume': 'حجم الزيارات',
  'reports.charts.typeBreakdown': 'حسب النوع',
  'reports.charts.channelBreakdown': 'حسب القناة',
  'reports.charts.outcomeBreakdown': 'حسب النتيجة',
  'reports.calls.play': 'تشغيل',
  'reports.calls.noRecording': 'لا يوجد تسجيل',
  'reports.calls.recordingError': 'فشل التحميل',
  'reports.calls.direction': 'الاتجاه',
  'reports.calls.status': 'الحالة',
  'reports.calls.duration': 'المدة',
  'reports.calls.startedAt': 'وقت البدء',
  'reports.calls.answeredAt': 'وقت الرد',
  'reports.calls.endedAt': 'وقت الانتهاء',
  'reports.break.label': 'الاستراحة قبلها',
  'reports.break.before': 'استراحة {{time}} قبلها',
  'reports.break.firstOfDay': 'أول إجراء في اليوم',
  'reports.performance.breakTotal': 'إجمالي وقت الاستراحة',
  'reports.performance.breakTime': 'الاستراحة بين الإجراءات',
  'reports.performance.breakTimeHint': 'من نهاية مكالمة أو سلسلة رسائل حتى بداية التالية في نفس اليوم. الرسائل المتتالية لنفس جهة الاتصال تُعد سلسلة واحدة.',
  'reports.performance.col.avgBreak': 'متوسط الاستراحة',
  'reports.visits.priority': 'الأولوية',
  'reports.visits.scheduledFor': 'موعد الجدولة',
  'reports.visits.startedAt': 'وقت البدء',
  'reports.visits.endedAt': 'وقت الانتهاء',
  'reports.visits.minutes': 'دقيقة',
  'reports.visits.outcome': 'النتيجة',
  'reports.saved.title': 'التقارير المحفوظة',
  'reports.saved.empty': 'لا توجد تقارير محفوظة بعد.',
  'reports.saved.template': 'قالب',
  'reports.save.title': 'حفظ التقرير',
  'reports.save.namePlaceholder': 'اسم التقرير',
  'reports.save.asTemplate': 'حفظ كقالب مشترك',
  'conversation.notesTitle': 'ملاحظات جهة الاتصال',
  'conversation.notesPlaceholder': 'اكتب ملاحظة حول جهة الاتصال هذه...',
  'conversation.newNotesIndicator': 'ملاحظات جديدة',

  // ─── Assignment ───────────────────────────────────────────────────────────
  'assignment.started': 'بدأت المهمة',
  'assignment.startedDesc': 'تم تحديث حالة المهمة.',
  'assignment.startFailed': 'فشل البدء',
  'assignment.startFailedDesc': 'فشل بدء المهمة.',
  'assignment.transferred': 'تم تحويل المهمة',
  'assignment.transferredDesc': 'تم تحويل المهمة بنجاح.',
  'assignment.transferFailed': 'فشل التحويل',
  'assignment.transferFailedDesc': 'فشل تحويل المهمة.',
  'assignment.completed': 'اكتملت المهمة',
  'assignment.completedDesc': 'تم تحديد المهمة كمكتملة.',
  'assignment.completeFailed': 'فشل الإكمال',
  'assignment.completeFailedDesc': 'فشل إكمال المهمة.',
  'assignment.cancelled': 'تم إلغاء المهمة',
  'assignment.cancelledDesc': 'تم إلغاء المهمة بنجاح.',
  'assignment.cancelFailed': 'فشل الإلغاء',
  'assignment.cancelFailedDesc': 'فشل إلغاء المهمة.',
  'assignment.modal.assignContact': 'تعيين جهة الاتصال',
  'assignment.modal.assignFailed': 'فشل تحديث التعيين.',
  'assignment.modal.loadingAssignments': 'جارٍ تحميل التعيينات...',
  'assignment.modal.users': 'المستخدمون',
  'assignment.modal.selectUsers': 'اختر مستخدماً واحداً أو أكثر',
  'assignment.modal.loadingUsers': 'جارٍ تحميل المستخدمين...',
  'assignment.modal.noUsers': 'لا يوجد مستخدمون متاحون',
  'assignment.modal.departments': 'الأقسام',
  'assignment.modal.selectDepartments': 'اختر قسماً واحداً أو أكثر',
  'assignment.modal.loadingDepartments': 'جارٍ تحميل الأقسام...',
  'assignment.modal.noDepartments': 'لا توجد أقسام متاحة',
  'assignment.overlay.startTitle': 'اضغط لبدء المهمة',
  'assignment.overlay.startSubtitle': 'توجد مهمة نشطة لهذه المحادثة بانتظار البدء.',
  'assignment.action.start': 'بدء المهمة',
  'assignment.action.transfer': 'تحويل المهمة',
  'assignment.action.complete': 'إكمال المهمة',
  'assignment.action.cancel': 'إلغاء المهمة',
  'assignment.transfer.title': 'تحويل المهمة',
  'assignment.transfer.subtitle': 'اختر مستخدماً أو قسماً لتحويل هذه المهمة إليه',
  'assignment.manage.title': 'إدارة المهمة',
  'assignment.manage.subtitle': 'عيّن هذه المحادثة إلى مستخدمين أو أقسام',

  // ─── Settings Content (Left Pane) ───────────────────────────────────────
  'settings.items.profile.title': 'الملف الشخصي والتفضيلات',
  'settings.items.profile.description': 'حدّث معلوماتك الشخصية والمنطقة الزمنية ونغمة الإشعارات.',
  'settings.items.phone.title': 'أرقام الهاتف',
  'settings.items.phone.description': 'إدارة أرقام هاتفك وحالة التحقق منها.',
  'settings.items.notifications.title': 'التنبيهات والإشعارات',
  'settings.items.notifications.description': 'اختر كيفية إعلامك بالحملات والمحادثات.',
  'settings.items.business.title': 'إعدادات العمل',
  'settings.items.business.description': 'الموقع والمنطقة الزمنية والعملة وساعات العمل.',
  'settings.items.team.title': 'الفريق والصلاحيات',
  'settings.items.team.description': 'دعوة الزملاء وتعيين الأدوار وقفل الإجراءات الحساسة.',
  'settings.items.departments.title': 'الأقسام',
  'settings.items.departments.description': 'إنشاء الأقسام وتعيين المستخدمين وإدارة هيكل الفريق.',
  'settings.items.billing.title': 'الفوترة والاستخدام',
  'settings.items.billing.description': 'الفواتير وطرق الدفع واستخدام المحادثات.',
  'settings.items.devices.title': 'الأجهزة',
  'settings.items.devices.description': 'إدارة الماسحات والطابعات والكاميرات والأجهزة الأخرى.',
  'settings.items.units.title': 'الوحدات',
  'settings.items.units.description': 'تحديد وحدات القياس لمنتجاتك وخدماتك.',
  'settings.items.shippingMethods.title': 'طرق الشحن',
  'settings.items.shippingMethods.description': 'إعداد خيارات التوصيل وشركات الشحن وأسعار الشحن.',
  'settings.items.inventory.title': 'المخزون',
  'settings.items.inventory.description': 'تتبع مستويات المخزون وتعديل الكميات ومراقبة المنتجات منخفضة المخزون.',
  'settings.items.businessConfig.title': 'الضرائب والرسوم',
  'settings.items.businessConfig.description': 'إعداد معدلات الضرائب والرسوم الإضافية وإعدادات الخصم.',
  'settings.items.coupons.title': 'الكوبونات',
  'settings.items.coupons.description': 'إنشاء وإدارة رموز الخصم لعملائك.',
  'settings.items.referrals.title': 'برنامج الإحالة',
  'settings.items.referrals.description': 'إدارة رموز الإحالة وتتبع الاستردادات وإعداد قواعد المكافآت.',
  'settings.items.developer.title': 'وصول المطورين',
  'settings.items.developer.description': 'مفاتيح API والويب هوك الواردة ومرجع التكامل.',
  'settings.update.title': 'تحديث متاح',
  'settings.update.message': 'يوجد إصدار جديد جاهز. سيعاد تشغيل التطبيق لتطبيقه.',
  'settings.update.later': 'لاحقاً',
  'settings.update.now': 'التحديث الآن',
  'settings.deleteAccount.title': 'حذف الحساب',
  'settings.deleteAccount.confirmMessage': 'هل أنت متأكد أنك تريد حذف حسابك نهائياً؟ لا يمكن التراجع عن هذا الإجراء وستتم إزالة جميع بياناتك.',
  'settings.deleteAccount.cancel': 'إلغاء',
  'settings.deleteAccount.confirm': 'حذف الحساب',
  'settings.deleteAccount.successTitle': 'تم حذف الحساب',
  'settings.deleteAccount.successMessage': 'تم حذف حسابك بنجاح.',
  'settings.deleteAccount.errorTitle': 'خطأ',
  'settings.deleteAccount.errorMessage': 'فشل حذف الحساب. يرجى المحاولة مرة أخرى.',
  'settings.header.title': 'إعدادات مساحة العمل',
  'settings.header.subtitle': 'خصّص DISLIX ليتناسب مع طريقة عمل فريقك.',
  'settings.section.personalPreferences': 'التفضيلات الشخصية',
  'settings.language.title': 'اللغة',
  'settings.language.description': 'اختر لغة العرض المفضلة لديك',
  'settings.section.business': 'العمل',
  'settings.business.fallbackName': 'العمل النشط',
  'settings.business.active': 'نشط',
  'settings.brand.title': 'مظهر العلامة التجارية',
  'settings.brand.description': 'الشعارات والألوان والردود السريعة وقوالب المحادثة.',
  'settings.section.adminControls': 'ضوابط المسؤول',
  'settings.role.owner': 'مالك',
  'settings.role.admin': 'مسؤول',
  'comments.someone': 'شخص ما',
  'comments.like': 'إعجاب',
  'comments.reply': 'رد',
  'comments.replied': 'تم الرد',
  'comments.replyPlaceholder': 'رد على {{name}}…',
  'comments.replyOnMessenger': 'ماسنجر',
  'comments.openMessenger': 'فتح المحادثة',
  'comments.addContact': 'إضافة جهة اتصال',
  'comments.openContact': 'جهة الاتصال',
  'comments.messengerPlaceholder': 'راسل {{name}} بشكل خاص…',
  'comments.messengerHint': 'تُرسل كرسالة خاصة على ماسنجر. يسمح فيسبوك برسالة واحدة لكل تعليق.',
  'comments.messengerSent': 'أُرسلت على ماسنجر',
  'comments.messengerSentHint': 'عندما يرد، تستمر المحادثة في صندوق الوارد.',
  'comments.messengerFailed': 'تعذّر الإرسال على ماسنجر',
  'comments.messengerExpired': 'فات وقت الرد على ماسنجر',
  'comments.messengerExpiredHint': 'يسمح فيسبوك بذلك خلال 7 أيام فقط من التعليق. رد على المنشور بدلًا من ذلك.',
  'comments.contactAdded': 'تمت إضافة {{name}} إلى جهات الاتصال',
  'comments.contactFailed': 'تعذّرت إضافة جهة الاتصال',
  'comments.addContactTitle': 'إضافة {{name}}',
  'comments.newContact': 'جهة اتصال جديدة',
  'comments.newContactHint': 'أنشئ جهة اتصال لهذا الشخص.',
  'comments.existingContact': 'إضافة إلى جهة اتصال موجودة',
  'comments.existingContactHint': 'هذا الشخص موجود بالفعل في جهات اتصالك.',
  'comments.chooseContact': 'اختر جهة الاتصال',
  'comments.addHere': 'إضافة',
  'comments.addedToContact': 'تمت إضافة {{name}} إلى جهة الاتصال',
  'comments.messengerLinked': 'تم ربط محادثة ماسنجر بجهة الاتصال.',
  'comments.messengerLinksLater': 'يُربط ماسنجر عندما يراسل صفحتك، أو عندما ترد عليه على ماسنجر.',
  'notifications.title': 'الإشعارات',
  'notifications.markAllRead': 'تحديد الكل كمقروء',
  'notifications.settings': 'إعدادات الإشعارات',
  'notifications.empty': 'لا توجد إشعارات بعد',
  'notifications.emptyHint': 'ستظهر هنا الرسائل والطلبات والحجوزات وتحديثات الفريق.',
  'notifications.caughtUp': 'لا جديد لديك',
  'notifications.seeAll': 'عرض كل الإشعارات',
  'notifications.delete': 'حذف',
  'notifications.unreadCount': '{{count}} غير مقروء',
  'notifications.allRead': 'كلها مقروءة',
  'notifications.loadMore': 'تحميل المزيد',
  'notifications.filter.all': 'الكل',
  'notifications.filter.unread': 'غير المقروءة',
  'notifications.section.today': 'اليوم',
  'notifications.section.yesterday': 'أمس',
  'notifications.section.earlier': 'سابقًا',
  'notifications.time.now': 'الآن',
  'notifications.time.minutes': '{{count}} د',
  'notifications.time.hours': '{{count}} س',
  'notifications.time.yesterday': 'أمس',
  'notifications.group.messages': 'الرسائل',
  'notifications.group.social': 'نشاط الصفحة',
  'notifications.group.sales': 'المبيعات',
  'notifications.group.calendar': 'التقويم',
  'notifications.group.visits': 'الزيارات',
  'notifications.group.team': 'الفريق',
  'notifications.group.forms': 'النماذج',
  'notifications.group.campaigns': 'الحملات',
  'notifications.group.channels': 'القنوات',
  'notifications.group.billing': 'الفواتير',
  'notificationSettings.title': 'الإشعارات',
  'notificationSettings.subtitle': 'اختر ما يصلك وكيف يصلك.',
  'notificationSettings.saveFailed': 'تعذّر الحفظ — حاول مجددًا',
  'notificationSettings.loadFailed': 'تعذّر تحميل إعدادات الإشعارات.',
  'notificationSettings.pauseAll': 'إيقاف كل الإشعارات مؤقتًا',
  'notificationSettings.pauseAllHint': 'لن يصلك شيء حتى تعيد تشغيلها.',
  'notificationSettings.sendTest': 'أرسل لي إشعارًا تجريبيًا',
  'notificationSettings.testSent': 'تم إرسال التجربة',
  'notificationSettings.testSentHint': 'يجب أن يصل خلال ثوانٍ.',
  'notificationSettings.testFailed': 'تعذّر إرسال التجربة',
  'notificationSettings.scope.title': 'أي المحادثات',
  'notificationSettings.scope.hint': 'للرسائل والمكالمات الفائتة والعملاء في انتظار الرد.',
  'notificationSettings.scope.unassigned': 'غير المسندة ومحادثاتي',
  'notificationSettings.scope.unassignedHint': 'المحادثات التي لم تُسند بعد، والمسندة إليك.',
  'notificationSettings.scope.all': 'كل المحادثات',
  'notificationSettings.scope.allHint': 'كل شيء، بما فيها المسندة لغيرك.',
  'notificationSettings.scope.mine': 'محادثاتي فقط',
  'notificationSettings.scope.mineHint': 'المحادثات المسندة إليك فقط.',
  'notificationSettings.push': 'تنبيه',
  'notificationSettings.inApp': 'داخل التطبيق',
  'notificationSettings.onCount': '{{on}} من {{total}} مفعّل',
  'notificationSettings.turnAllOn': 'تشغيل الكل',
  'notificationSettings.turnAllOff': 'إيقاف الكل',
  'notificationSettings.type.new_message.title': 'رسائل جديدة',
  'notificationSettings.type.new_message.description': 'عندما يكتب عميل على واتساب أو ماسنجر أو X.',
  'notificationSettings.type.new_contact.title': 'جهات اتصال جديدة',
  'notificationSettings.type.new_contact.description': 'عندما يراسلك شخص لأول مرة.',
  'notificationSettings.type.conversation_expiring.title': 'في انتظار الرد',
  'notificationSettings.type.conversation_expiring.description': 'عندما تقترب نافذة الرد (24 ساعة) لعميل من الإغلاق.',
  'notificationSettings.type.missed_call.title': 'المكالمات الفائتة',
  'notificationSettings.type.missed_call.description': 'مكالمة واردة لم يرد عليها أحد.',
  'notificationSettings.type.facebook_post_comment.title': 'التعليقات على المنشورات',
  'notificationSettings.type.facebook_post_comment.description': 'عندما يعلّق شخص أو يرد على منشورات صفحتك.',
  'notificationSettings.type.facebook_post_reaction.title': 'التفاعلات على المنشورات',
  'notificationSettings.type.facebook_post_reaction.description': 'عندما يتفاعل شخص مع منشورات صفحتك.',
  'notificationSettings.type.new_order.title': 'الطلبات الجديدة',
  'notificationSettings.type.new_order.description': 'عند إنشاء طلب.',
  'notificationSettings.type.quotation_status.title': 'ردود عروض الأسعار',
  'notificationSettings.type.quotation_status.description': 'عند قبول أو رفض عرض سعر أنشأته.',
  'notificationSettings.type.quotation_expiring.title': 'عروض أسعار تنتهي',
  'notificationSettings.type.quotation_expiring.description': 'عندما تنتهي عروض أسعارك المرسلة خلال يومين دون رد.',
  'notificationSettings.type.low_stock.title': 'مخزون منخفض',
  'notificationSettings.type.low_stock.description': 'عندما يصل منتج إلى حد تنبيه المخزون.',
  'notificationSettings.type.calendar_reminder.title': 'تذكير بالمواعيد',
  'notificationSettings.type.calendar_reminder.description': 'قبل بدء مواعيدك.',
  'notificationSettings.type.new_booking.title': 'الحجوزات الجديدة',
  'notificationSettings.type.new_booking.description': 'عندما يحجز عميل موعدًا في تقويمك.',
  'notificationSettings.type.calendar_event_assigned.title': 'التقويمات المشتركة',
  'notificationSettings.type.calendar_event_assigned.description': 'عند مشاركة تقويم معك.',
  'notificationSettings.type.visit_assigned.title': 'الزيارات الجديدة',
  'notificationSettings.type.visit_assigned.description': 'عند إسناد زيارة إليك.',
  'notificationSettings.type.visit_sla_approaching.title': 'زيارات مستحقة قريبًا',
  'notificationSettings.type.visit_sla_approaching.description': 'عندما تقترب زيارة من موعدها النهائي.',
  'notificationSettings.type.visit_sla_breached.title': 'الزيارات المتأخرة',
  'notificationSettings.type.visit_sla_breached.description': 'عندما تتجاوز زيارة موعدها.',
  'notificationSettings.type.new_assignment.title': 'المسند إليك',
  'notificationSettings.type.new_assignment.description': 'عند إسناد جهة اتصال أو مهمة إليك.',
  'notificationSettings.type.assignment_update.title': 'تغييرات الإسناد',
  'notificationSettings.type.assignment_update.description': 'عند نقل أو إلغاء شيء مسند إليك.',
  'notificationSettings.type.member_joined.title': 'أعضاء الفريق الجدد',
  'notificationSettings.type.member_joined.description': 'عندما يقبل شخص دعوة.',
  'notificationSettings.type.new_data_list_submission.title': 'إدخالات النماذج',
  'notificationSettings.type.new_data_list_submission.description': 'عندما يملأ شخص أحد نماذجك.',
  'notificationSettings.type.campaign_finished.title': 'نتائج الحملات',
  'notificationSettings.type.campaign_finished.description': 'عند انتهاء حملة أو إيقافها.',
  'notificationSettings.type.task_finished.title': 'المهام المجدولة',
  'notificationSettings.type.task_finished.description': 'عند انتهاء مهمة مجدولة أو فشلها.',
  'notificationSettings.type.channel_problem.title': 'مشكلات القنوات',
  'notificationSettings.type.channel_problem.description': 'عندما تتوقف قناة عن العمل وتحتاج إلى إعادة الربط.',
  'notificationSettings.type.template_status_update.title': 'مراجعات القوالب',
  'notificationSettings.type.template_status_update.description': 'عندما توافق Meta على قالب أو ترفضه أو توقفه.',
  'notificationSettings.type.whatsapp_quality_alert.title': 'جودة الرقم',
  'notificationSettings.type.whatsapp_quality_alert.description': 'عند انخفاض جودة رقم واتساب.',
  'notificationSettings.type.whatsapp_account_alert.title': 'قيود الحساب',
  'notificationSettings.type.whatsapp_account_alert.description': 'عندما تقيّد Meta حساب واتساب أو تحظره.',
  'notificationSettings.type.subscription_reminder.title': 'تذكير التجديد',
  'notificationSettings.type.subscription_reminder.description': 'قبل انتهاء تجربتك أو خطتك.',
  'notificationSettings.type.subscription_expired.title': 'انتهاء الخطة',
  'notificationSettings.type.subscription_expired.description': 'عند انتهاء خطتك وإيقاف الحساب.',
  'notificationSettings.type.payment_succeeded.title': 'الدفعات المستلمة',
  'notificationSettings.type.payment_succeeded.description': 'عند اكتمال دفعة.',
  'notificationSettings.type.payment_failed.title': 'الدفعات الفاشلة',
  'notificationSettings.type.payment_failed.description': 'عندما لا تكتمل دفعة.',
  'posts.facebookPage': 'صفحة فيسبوك',
  'posts.scheduledFor': 'مجدول في {{date}}',
  'posts.justNow': 'الآن',
  'posts.status.published': 'منشور',
  'posts.status.scheduled': 'مجدول',
  'posts.status.draft': 'مسودة',
  'posts.status.failed': 'فشل',
  'posts.actions': 'إجراءات المنشور',
  'posts.insights': 'الإحصاءات',
  'posts.post': 'المنشور',
  'posts.error.permissions': 'لم يسمح فيسبوك لـ DISLIX بالنشر على هذه الصفحة. أعد ربط الصفحة من الإعدادات ← القنوات ← ماسنجر ووافق على النشر.',
  'posts.error.generic': 'لم ينشر فيسبوك هذا المنشور.',
  'posts.action.openOnFacebook': 'فتح على فيسبوك',
  'posts.action.schedule': 'جدولة',
  'posts.action.publishNow': 'انشر الآن',
  'posts.action.retry': 'حاول مجددًا',
  'posts.action.edit': 'تعديل',
  'posts.action.editText': 'تعديل النص',
  'posts.action.cancelSchedule': 'إلغاء الجدولة',
  'posts.action.delete': 'حذف',
  'posts.done.published': 'تم نشر المنشور',
  'posts.done.scheduled': 'تمت جدولة المنشور',
  'posts.done.draftSaved': 'تم حفظ المسودة',
  'posts.done.updated': 'تم تحديث المنشور',
  'posts.done.deleted': 'تم حذف المنشور',
  'posts.done.unscheduled': 'أُلغيت الجدولة — حُفظ كمسودة',
  'posts.failed.publish': 'تعذّر نشر المنشور',
  'posts.failed.delete': 'تعذّر حذف المنشور',
  'posts.failed.cancel': 'تعذّر إلغاء الجدولة',
  'posts.confirm.deleteTitle': 'حذف المنشور؟',
  'posts.confirm.deleteLive': 'سيُحذف من فيسبوك أيضًا. لا يمكن التراجع عن ذلك.',
  'posts.confirm.deleteLocal': 'لم يُنشر هذا المنشور على فيسبوك. سيُحذف من DISLIX.',
  'posts.confirm.cancelSchedule': 'لن يُنشر، وسيبقى لديك كمسودة.',
  'posts.noActions': 'لا توجد إجراءات لهذا المنشور.',
  'posts.composer.title': 'إنشاء منشور',
  'posts.composer.editTitle': 'تعديل المنشور',
  'posts.composer.page': 'الصفحة',
  'posts.composer.pages': 'النشر على',
  'posts.composer.placeholder': 'بماذا تفكر؟',
  'posts.composer.addPhotos': 'إضافة صور',
  'posts.composer.camera': 'التقاط صورة',
  'posts.composer.addVideo': 'إضافة فيديو',
  'posts.composer.addLink': 'إضافة رابط',
  'posts.composer.emoji': 'رموز تعبيرية',
  'posts.composer.when': 'التوقيت',
  'posts.composer.now': 'الآن',
  'posts.composer.later': 'جدولة',
  'posts.composer.publishAt': 'موعد النشر',
  'posts.composer.pickTime': 'اختر التاريخ والوقت',
  'posts.composer.tooSoon': 'جدول بعد 10 دقائق على الأقل.',
  'posts.composer.tooFar': 'يجدول فيسبوك المنشورات حتى 75 يومًا مقدمًا.',
  'posts.composer.preview': 'معاينة',
  'posts.composer.saveDraft': 'حفظ كمسودة',
  'posts.composer.publish': 'نشر',
  'posts.composer.schedule': 'جدولة',
  'posts.composer.saveChanges': 'حفظ التغييرات',
  'posts.composer.uploadFailed': 'فشل الرفع — حاول مجددًا',
  'posts.composer.failed': 'تعذّر حفظ المنشور',
  'posts.composer.partial': 'لم يُنشر على {{count}} صفحة',
  'posts.composer.partialHint': 'راجع تبويب «فشل» لإعادة المحاولة.',
  'posts.composer.multiHint': 'سيُنشر منشور على كل صفحة من الصفحات الـ {{count}}.',
  'posts.noPages': 'اربط صفحة فيسبوك لنشر المنشورات.',
  'posts.connectPage': 'ربط صفحة',
  'posts.synced': 'تمت المزامنة',
  'posts.syncedCount': 'تم استيراد {{count}} منشور من فيسبوك',
  'posts.syncFailed': 'فشلت المزامنة',
  'posts.sync': 'استيراد المنشورات الأقدم',
  'posts.noMatches': 'لا توجد منشورات مطابقة لبحثك.',
  'posts.selectPost': 'اختر منشورًا لعرض تفاصيله وتعليقاته.',
  'posts.empty.published': 'لا توجد منشورات منشورة بعد.',
  'posts.empty.scheduled': 'لا يوجد ما هو مجدول.',
  'posts.empty.draft': 'لا توجد مسودات.',
  'posts.empty.failed': 'لا توجد منشورات فاشلة.',
  'posts.allPages': 'كل الصفحات',
  'posts.tab.published': 'المنشورة',
  'posts.tab.scheduled': 'المجدولة',
  'posts.tab.draft': 'المسودات',
  'posts.tab.failed': 'الفاشلة',
  'posts.search': 'ابحث في المنشورات',
  'posts.videoPost': 'فيديو',
  'posts.photoPost': 'صورة',
  'home.posts.title': 'منشورات الصفحة',
  'home.posts.empty': 'لا توجد منشورات بعد',
  'home.posts.viewAll': 'عرض الكل',
  'home.posts.create': 'إنشاء منشور',
  'home.posts.shortcut': 'انشر وراجع منشورات صفحتك على فيسبوك',
  'settings.entry.posts.title': 'منشورات الصفحة',
  'settings.entry.posts.description': 'انشر وجدول وراجع منشورات صفحة فيسبوك.',
  'settings.role.manager': 'مدير',
  'settings.role.member': 'عضو',
  'settings.role.viewer': 'مشاهد',
  'settings.search': 'ابحث في الإعدادات',
  'settings.noResults': 'لا توجد إعدادات مطابقة لبحثك.',
  'settings.upgrade': 'ترقية',
  'settings.selectFromMenu': 'اختر إعدادًا من القائمة.',
  'settings.theme.title': 'المظهر',
  'settings.theme.light': 'فاتح',
  'settings.theme.dark': 'داكن',
  'settings.group.preferences': 'التفضيلات',
  'settings.group.account': 'الحساب',
  'settings.group.business': 'النشاط التجاري',
  'settings.group.team': 'الفريق',
  'settings.group.channels': 'القنوات',
  'settings.group.sales': 'المبيعات والكتالوج',
  'settings.group.messaging': 'الرسائل',
  'settings.group.advanced': 'متقدم',
  'settings.entry.profile.title': 'الملف الشخصي',
  'settings.entry.profile.description': 'اسمك وصورتك وبياناتك الشخصية.',
  'settings.entry.phone.title': 'تسجيل الدخول وأرقام الهاتف',
  'settings.entry.phone.description': 'أرقام الهاتف والبريد الذي تسجّل الدخول بهما.',
  'settings.entry.notifications.title': 'الإشعارات',
  'settings.entry.notifications.description': 'التنبيهات التي تصلك وطريقتها.',
  'settings.entry.business.title': 'الملف التجاري',
  'settings.entry.business.description': 'الاسم والشعار والموقع والمنطقة الزمنية والعملة وساعات العمل.',
  'settings.entry.billing.title': 'الخطة والفواتير',
  'settings.entry.billing.description': 'خطتك والإضافات والمدفوعات والفواتير.',
  'settings.entry.setup.title': 'جهّز نشاطك التجاري',
  'settings.entry.setup.description': 'قائمة الإعداد وما تبقى منها.',
  'settings.entry.team.title': 'أعضاء الفريق',
  'settings.entry.team.description': 'ادعُ الأشخاص وأدر أدوارهم.',
  'settings.entry.permissions.title': 'الصلاحيات',
  'settings.entry.permissions.description': 'ما يمكن لكل شخص وقسم رؤيته وفعله.',
  'settings.entry.departments.title': 'الأقسام',
  'settings.entry.departments.description': 'نظّم فريقك ووجّه العمل إليه.',
  'settings.entry.whatsapp.title': 'واتساب',
  'settings.entry.whatsapp.description': 'اربط أرقام واتساب وأدرها.',
  'settings.entry.messenger.title': 'ماسنجر',
  'settings.entry.messenger.description': 'اربط صفحات فيسبوك.',
  'settings.entry.x.title': 'X (تويتر)',
  'settings.entry.x.description': 'اربط حسابات X للرسائل المباشرة.',
  'settings.entry.phoneChannel.title': 'المكالمات الهاتفية',
  'settings.entry.phoneChannel.description': 'الاتصال لفريقك.',
  'settings.entry.visits.title': 'الزيارات الميدانية',
  'settings.entry.visits.description': 'قواعد الزيارات والمسارات وتسجيل الحضور.',
  'settings.entry.taxes.title': 'الضرائب والرسوم',
  'settings.entry.taxes.description': 'نسب الضرائب والرسوم الإضافية والخصومات على الطلبات.',
  'settings.entry.shipping.title': 'طرق الشحن',
  'settings.entry.shipping.description': 'كيف وأين توصّل طلباتك.',
  'settings.entry.units.title': 'الوحدات',
  'settings.entry.units.description': 'وحدات القياس لمنتجاتك.',
  'settings.entry.inventory.title': 'المخزون',
  'settings.entry.inventory.description': 'مستويات المخزون ومواقعه.',
  'settings.entry.coupons.title': 'القسائم',
  'settings.entry.coupons.description': 'أكواد الخصم لعملائك.',
  'settings.entry.referrals.title': 'برنامج الإحالة',
  'settings.entry.referrals.description': 'كافئ العملاء الذين يجلبون غيرهم.',
  'settings.entry.quotationTemplates.title': 'قوالب المستندات',
  'settings.entry.quotationTemplates.description': 'الفواتير وعروض الأسعار والإيصالات وإشعارات التسليم وإيصالات التجهيز وأوامر الشراء.',
  'settings.entry.templates.title': 'قوالب الرسائل',
  'settings.entry.templates.description': 'قوالب واتساب المعتمدة.',
  'settings.entry.quickReplies.title': 'الردود السريعة',
  'settings.entry.quickReplies.description': 'إجابات محفوظة يرسلها فريقك بضغطة.',
  'settings.entry.devices.title': 'الأجهزة',
  'settings.entry.devices.description': 'الماسحات والطابعات والأجهزة المتصلة.',
  'settings.entry.developer.title': 'وصول المطورين',
  'settings.entry.developer.description': 'مفاتيح API والتكاملات.',
  'settings.section.account': 'الحساب',
  'settings.deleteAccount.cardTitle': 'حذف الحساب',
  'settings.deleteAccount.cardDescription': 'حذف حسابك وجميع البيانات المرتبطة به نهائياً.',
  'settings.version.label': 'الإصدار {{version}}',
  'settings.version.builtIn': 'الأساسي',
  'settings.version.update': 'تحديث {{date}} ({{commit}})',
  'settings.version.upToDate': 'محدّث',
  'settings.version.checkForUpdate': 'التحقق من التحديث',

  // ─── Contacts List (Right Pane) ──────────────────────────────────────────
  'contacts.header.title': 'جهات الاتصال',
  'contacts.header.selectedCount': '{{count}} محدد',
  'contacts.header.selectContacts': 'تحديد جهات الاتصال',
  'contacts.header.createVisits': 'إنشاء زيارات',
  'contacts.search.placeholder': 'بحث في جهات الاتصال...',
  'contacts.quickFilter.needsResponse': '{{count}} بحاجة إلى رد',
  'contacts.quickFilter.followUpDue': '{{count}} يحتاج متابعة',
  'contacts.quickFilter.neverContacted': '{{count}} لم يتم التواصل معه',
  'contacts.quickFilter.expiringSoon': '{{count}} على وشك الانتهاء',
  'contacts.provider.whatsapp': 'واتساب',
  'contacts.provider.messenger': 'ماسنجر',
  'contacts.provider.xTwitter': 'X (تويتر)',
  'contacts.provider.phone': 'الهاتف',
  'contacts.provider.telegram': 'تيليجرام',
  'contacts.provider.email': 'البريد الإلكتروني',
  'contacts.filter.allChannels': 'جميع القنوات',
  'contacts.filter.allAssignments': 'جميع التعيينات',
  'contacts.filter.unassigned': 'غير معيّن',
  'contacts.filter.users': 'المستخدمون',
  'contacts.filter.loadingUsers': 'جارٍ تحميل المستخدمين...',
  'contacts.filter.noUsers': 'لا يوجد مستخدمون متاحون',
  'contacts.filter.departments': 'الأقسام',
  'contacts.filter.loadingDepartments': 'جارٍ تحميل الأقسام...',
  'contacts.filter.noDepartments': 'لا توجد أقسام متاحة',
  'contacts.filter.channel': 'القناة',
  'contacts.filter.pageSize': 'عدد جهات الاتصال في الصفحة',
  'contacts.filter.pageSizeRange': '{{min}}+ جهة اتصال',
  'contacts.filter.clearAll': 'مسح كل عوامل التصفية',
  'contacts.filter.assignment': 'التعيين',
  'contacts.filter.tags': 'الوسوم',
  'contacts.filter.clearTagFilters': 'مسح جميع مرشحات الوسوم',
  'contacts.filter.excludedSuffix': ' (مستبعد)',
  'contacts.filter.searchTagsPlaceholder': 'ابحث عن الوسوم...',
  'contacts.filter.noTagsMatch': 'لا توجد وسوم مطابقة لبحثك',
  'contacts.filter.loadMore': 'تحميل {{count}} إضافية',
  'contacts.filter.dataList': 'قائمة البيانات',
  'contacts.filter.allDataLists': 'كل جهات الاتصال',
  'contacts.filter.location.filterTitle': 'تصفية حسب الموقع',
  'contacts.filter.location.cityPlaceholder': 'المدينة',
  'contacts.filter.location.anyCity': 'أي مدينة',
  'contacts.filter.location.anyCountry': 'أي دولة',
  'contacts.filter.location.noCities': 'لا توجد مدن مسجلة بعد',
  'contacts.filter.location.countryPlaceholder': 'الدولة',
  'contacts.filter.location.sortTitle': 'الترتيب حسب المسافة',
  'contacts.filter.location.nearest': 'الأقرب إليّ',
  'contacts.filter.location.farthest': 'الأبعد عني',
  'contacts.filter.location.pickOnMap': 'أو اختر نقطة على الخريطة',
  'contactsBulkUpload.mapper.title': 'اربط أعمدة الملف',
  'contactsBulkUpload.mapper.subtitle': 'اختر معنى كل عمود — تم العثور على {{count}} صف',
  'contactsBulkUpload.mapper.rememberedBanner': 'تم التعبئة تلقائياً من آخر استيراد لملف بنفس الأعمدة',
  'contactsBulkUpload.mapper.sample': 'مثال',
  'contactsBulkUpload.mapper.customFieldNamePlaceholder': 'اسم الحقل المخصص',
  'contactsBulkUpload.mapper.unmappedBecomeCustom': 'سيتم استيراد {{count}} عمود غير مرتبط كحقول مخصصة',
  'contactsBulkUpload.mapper.needsName': 'اربط عموداً واحداً على الأقل بـ "الاسم" للمتابعة',
  'contactsBulkUpload.mapper.needsIdentifier': 'اربط عموداً واحداً على الأقل بالهاتف أو البريد أو واتساب أو معرّف آخر للمتابعة',
  'contactsBulkUpload.mapper.confirm': 'استيراد {{count}} جهة اتصال',
  'contactsBulkUpload.mapper.processingInBackground': 'جارٍ الاستيراد في الخلفية — قد يستغرق هذا بضع دقائق للملفات الكبيرة. يمكنك مغادرة هذه الشاشة، وسيستمر الاستيراد في العمل.',
  'contacts.filter.location.radiusPlaceholder': 'النطاق (كم)',
  'contacts.filter.location.includeUnlocated': 'تضمين جهات الاتصال التي لديها مدينة/عنوان فقط (بدون تحديد دقيق)',
  'contacts.filter.location.apply': 'تطبيق',
  'contacts.filter.moreFilters': 'المزيد من الفلاتر',
  'contacts.analyticalFilters.title': 'فلاتر تحليلية',
  'contacts.analyticalFilters.responseSection': 'حالة الرد',
  'contacts.analyticalFilters.responseHint': 'بحاجة إلى رد: راسلونا ولم نرد بعد. على وشك الانتهاء: نافذة رد واتساب (20-24 ساعة منذ آخر رسالة لهم) على وشك الإغلاق. لم يتم التواصل: صفر رسائل أو مكالمات أو طلبات على الإطلاق.',
  'contacts.analyticalFilters.noReplySection': 'لم يعد للتواصل',
  'contacts.analyticalFilters.noReplyHint': 'جهات الاتصال التي لم ترد منذ آخر تواصل معها — قائمة "بحاجة إلى متابعة" الكلاسيكية. أنت تحدد مدة الصمت.',
  'contacts.analyticalFilters.noReplyPrefix': 'لا رد منذ',
  'contacts.analyticalFilters.noReplySuffix': 'يوم على الأقل',
  'contacts.analyticalFilters.orderSection': 'المنتجات / الطلبات',
  'contacts.analyticalFilters.orderHint': 'هل قامت جهة الاتصال هذه بطلب من قبل؟',
  'contacts.analyticalFilters.orderDateHint': 'يمكنك تضييق النطاق إلى الطلبات خلال فترة زمنية محددة.',
  'contacts.analyticalFilters.hasOrder': 'لديه طلب',
  'contacts.analyticalFilters.noOrder': 'بدون طلب',
  'contacts.analyticalFilters.contactedSection': 'التواصل',
  'contacts.analyticalFilters.contactedHint': 'ابحث عن جهات الاتصال التي تم التواصل معها عبر أي قناة، أو قناة محددة، خلال فترة زمنية تحددها.',
  'contacts.analyticalFilters.wasContacted': 'تم التواصل',
  'contacts.analyticalFilters.wasNotContacted': 'لم يتم التواصل',
  'contacts.analyticalFilters.returnedMultipleSection': 'عاد للتواصل عدة مرات',
  'contacts.analyticalFilters.returnedMultipleHint': 'جهات الاتصال التي تراسلت مع العمل ذهابًا وإيابًا بشكل متكرر، وليس مرة واحدة فقط.',
  'contacts.analyticalFilters.returnedMultiplePrefix': 'تواصلوا معنا على الأقل',
  'contacts.analyticalFilters.returnedMultipleSuffix': 'مرات',
  'contacts.analyticalFilters.applyWithCount': 'تطبيق ({{count}})',
  'contacts.sort.field.name': 'الاسم',
  'contacts.sort.field.phone': 'الهاتف',
  'contacts.sort.field.email': 'البريد الإلكتروني',
  'contacts.sort.field.city': 'المدينة',
  'contacts.sort.field.country': 'الدولة',
  'contacts.sort.field.nationality': 'الجنسية',
  'contacts.sort.field.location': 'الموقع',
  'contacts.sort.field.hasChannels': 'تم التواصل (أي قناة)',
  'contacts.sort.field.needsResponse': 'بحاجة إلى رد',
  'contacts.sort.field.followUpDue': 'يحتاج متابعة',
  'contacts.sort.field.expiringSoon': 'على وشك الانتهاء',
  'contacts.sort.field.createdAt': 'تاريخ الإضافة',
  'contacts.sort.field.lastActivityAt': 'آخر نشاط',
  'contacts.sort.sortTitle': 'ترتيب حسب',
  'contacts.sort.clearSort': 'إلغاء الترتيب',
  'contacts.sort.extraFieldsTitle': 'حقول إضافية',
  'contacts.sort.extraFieldsHint': 'حقول مخصصة موجودة في الملفات التي قمت باستيرادها',
  'contacts.sort.anyValue': 'أي قيمة',
  'contacts.sort.hasValue': 'يحتوي على قيمة',
  'contacts.sort.noValueOption': 'بدون قيمة',
  'contacts.sort.noValues': 'لا توجد قيم',
  'contacts.sort.modalTitle': 'ترتيب وتصفية',
  'contacts.sort.reset': 'إعادة تعيين',
  'contacts.sort.searchFieldsPlaceholder': 'ابحث عن حقل',
  'contacts.sort.ascending': 'تصاعدي',
  'contacts.sort.descending': 'تنازلي',
  'contacts.sort.noFieldsMatch': 'لا توجد حقول مطابقة لبحثك',
  'contacts.sort.filterTitle': 'تصفية حسب القيمة',
  'contacts.sort.filterHint': 'اضغط على حقل للبحث في قيمه واختيار واحدة أو أكثر',
  'contacts.sort.searchValuesPlaceholder': 'ابحث في القيم',
  'contacts.sort.selected': 'محدد',
  'contacts.sort.noValuesMatchSearch': 'لا توجد قيم مطابقة لبحثك',
  'contacts.filter.location.geolocationUnavailable': 'تحديد الموقع الجغرافي غير مدعوم في هذا المتصفح.',
  'contacts.filter.location.geolocationFailed': 'تعذّر الحصول على موقعك الحالي.',
  'contacts.filter.location.geolocationPermissionDenied': 'إذن الموقع مطلوب لهذا الترتيب.',
  'contacts.fallback.user': 'مستخدم',
  'contacts.fallback.department': 'قسم',
  'contacts.empty.loading': 'جارٍ تحميل جهات الاتصال...',
  'contacts.empty.updating': 'جارٍ التحديث...',
  'contacts.empty.noConfiguredChannels': 'لا توجد قنوات مُعدّة',
  'contacts.empty.noConfiguredChannelsHint': 'قم بإعداد واتساب أو فيسبوك ماسنجر لرؤية جهات الاتصال هنا',
  'contacts.empty.noResultsFound': 'لم يتم العثور على جهات اتصال',
  'contacts.empty.noContactsYet': 'لا توجد جهات اتصال بعد',
  'contacts.empty.tryAdjusting': 'حاول تعديل البحث أو المرشحات',
  'contacts.empty.willAppear': 'ستظهر جهات الاتصال هنا بمجرد بدء المحادثات',
  'contacts.loadingMore': 'جارٍ تحميل المزيد من جهات الاتصال...',
  'contacts.loadMore': 'تحميل المزيد',
  'contacts.loadMoreRemaining': '{{count}} متبقٍ',
  'contacts.bulkAssign.title': 'تعيين جهات الاتصال المحددة',
  'contacts.bulkAssign.assignTab': 'تعيين',
  'contacts.bulkAssign.unassignTab': 'إلغاء التعيين',
  'contacts.bulkAssign.close': 'إغلاق',
  'contacts.bulkTag.title': 'وسم جهات الاتصال المحددة',
  'contacts.bulkUploadProgress.singleTitle': 'جاري استيراد جهات الاتصال',
  'contacts.bulkUploadProgress.multipleTitle': 'جاري الاستيراد ({{count}} عمليات)',
  'contacts.bulkUploadProgress.countLabel': '{{processed}}/{{total}} جهة اتصال',
  'contacts.bulkUploadProgress.modalTitle': 'عمليات الاستيراد الجارية',
  'contacts.bulkUploadProgress.close': 'إغلاق',
  'contacts.bulkUploadProgress.doneTitle': 'اكتمل الاستيراد',
  'contacts.bulkUploadProgress.doneMessage': 'اكتمل استيراد جهات الاتصال بشكل جماعي — تحقق من جهات الاتصال لمعرفة النتائج.',
  'contacts.bulkUploadProgress.pause': 'إيقاف مؤقت',
  'contacts.bulkUploadProgress.resume': 'استئناف',
  'contacts.bulkUploadProgress.cancel': 'إلغاء',
  'contacts.bulkUploadProgress.pausedBadge': 'متوقف مؤقتًا',
  'contacts.bulkUploadProgress.actionErrorTitle': 'حدث خطأ ما',
  'contacts.bulkUploadProgress.pauseFailed': 'تعذر إيقاف هذا الاستيراد مؤقتًا. حاول مرة أخرى.',
  'contacts.bulkUploadProgress.resumeFailed': 'تعذر استئناف هذا الاستيراد. حاول مرة أخرى.',
  'contacts.bulkUploadProgress.cancelFailed': 'تعذر إلغاء هذا الاستيراد. حاول مرة أخرى.',
  'contacts.bulkUploadProgress.cancelConfirmTitle': 'إلغاء هذا الاستيراد؟',
  'contacts.bulkUploadProgress.cancelConfirmMessage': 'جهات الاتصال التي تم استيرادها بالفعل ستبقى — سيتم تخطي الصفوف المتبقية فقط. لا يمكن التراجع عن هذا.',
  'contacts.bulkUploadProgress.cancelConfirmAction': 'إلغاء الاستيراد',
  'contacts.bulkUploadProgress.cancelConfirmDismiss': 'المتابعة',
  'contacts.bulkTag.addTags': 'إضافة وسوم',
  'contacts.bulkTag.removeTags': 'إزالة وسوم',
  'contacts.bulkTag.placeholder': 'مثال: VIP، متابعة، نشرة إخبارية',
  'contacts.bulkTag.hint': 'افصل بين الوسوم المتعددة بفواصل',
  'contacts.bulkTag.removeHint': 'اضغط على الوسوم لتحديدها للإزالة',
  'contacts.bulkTag.cancel': 'إلغاء',
  'contacts.bulkTag.submitAdd': 'إضافة الوسوم',
  'contacts.bulkTag.submitRemove': 'إزالة الوسوم',
  'contacts.bulkList.title': 'إضافة/إزالة من قائمة البيانات',
  'contacts.bulkList.addTo': 'إضافة إلى القائمة',
  'contacts.bulkList.removeFrom': 'إزالة من القائمة',
  'contacts.bulkList.submitAdd': 'إضافة إلى القائمة',
  'contacts.bulkList.submitRemove': 'إزالة من القائمة',
  'contacts.errors.bulkAssignFailed': 'فشل تعيين جهات الاتصال بشكل جماعي',
  'contacts.errors.bulkUnassignFailed': 'فشل إلغاء تعيين جهات الاتصال بشكل جماعي',
  'contacts.errors.bulkTagFailed': 'فشل تحديث الوسوم',
  'contacts.errors.bulkListFailed': 'فشل تحديث عضوية القائمة',
  'contacts.errors.prefix': 'خطأ: {{message}}',
  'contacts.tags.viewAll': 'عرض الوسوم',
  'contacts.tags.title': 'الوسوم',
  'contacts.primary': 'أساسي',

  // ─── شاشة جهات الاتصال (رأس القائمة + الإجراءات) ─────────────────────────
  'contactsScreen.title': 'جميع جهات الاتصال',
  'contactsScreen.searchPlaceholder': 'ابحث عن جهات الاتصال بالاسم أو الهاتف...',
  'contactsScreen.selectContact.title': 'اختر جهة اتصال للعرض',
  'contactsScreen.selectContact.hint': 'اختر جهة اتصال من القائمة لعرض تفاصيلها هنا.',
  'contactsScreen.moreActions': 'المزيد من الإجراءات',
  'contactsScreen.actions.addContact': 'إضافة جهة اتصال',
  'contactsScreen.actions.downloadCsv': 'تنزيل CSV',
  'contactsScreen.actions.importContacts': 'استيراد جهات الاتصال',
  'contactsScreen.bulkSendWhatsApp': 'إرسال واتساب ({{count}})',
  'contactsScreen.notifications.contactAddedTitle': 'تمت إضافة جهة الاتصال',
  'contactsScreen.notifications.contactAddedMessage': 'تمت إضافة {{name}} بنجاح',
  'contactsScreen.notifications.conversationStartedTitle': 'بدأت المحادثة',
  'contactsScreen.notifications.conversationStartedMessage': 'تم بدء المحادثة مع {{name}}',
  'contactsScreen.notifications.contactUpdatedTitle': 'تم تحديث جهة الاتصال',
  'contactsScreen.notifications.contactUpdatedMessage': 'تم تحديث {{name}} بنجاح',
  'contactsScreen.notifications.contactDeletedTitle': 'تم حذف جهة الاتصال',
  'contactsScreen.notifications.contactDeletedMessage': 'تم حذف جهة الاتصال بنجاح',
  'contactsScreen.export.title': 'تنزيل جهات الاتصال',
  'contactsScreen.export.templateTitle': 'نموذج فارغ',
  'contactsScreen.export.templateSubtitle': 'ملف CSV فارغ بالأعمدة الصحيحة، جاهز للتعبئة والرفع',
  'contactsScreen.export.selectionTitle': '{{count}} جهة اتصال محددة',
  'contactsScreen.export.allTitle': 'كل جهات الاتصال',
  'contactsScreen.export.selectionSubtitle': 'أرقام الهاتف مُخفاة جزئياً ما لم يكن لديك صلاحية عرضها',
  'contactsScreen.export.allExportedMessage': 'تم تصدير جميع جهات الاتصال',
  'contactsScreen.export.nativeUnsupported': 'تنزيل الملفات غير مدعوم على هذا الجهاز بعد — جرّب من تطبيق الويب',
  'contactsScreen.export.fieldsModalTitle': 'اختر الحقول للتصدير',
  'contactsScreen.export.selectAll': 'تحديد الكل',
  'contactsScreen.export.selectNone': 'إلغاء التحديد',
  'contactsScreen.export.fixedFieldsTitle': 'حقول جهة الاتصال',
  'contactsScreen.export.field.tags': 'الوسوم',
  'contactsScreen.export.maskedHint': 'مخفي جزئيًا ما لم يكن لديك صلاحية عرض أرقام الهاتف',
  'contactsScreen.export.formatTitle': 'صيغة الملف',
  'contactsScreen.export.formatExcel': 'إكسل (.xlsx)',
  'contactsScreen.export.formatCsv': 'CSV',
  'contactsScreen.export.csvEncodingHint': 'قد تسيء بعض برامج الجداول قراءة النص العربي في ملفات CSV — استخدم صيغة إكسل إذا حدث ذلك',
  'contactsScreen.export.downloadButton': 'تنزيل ({{count}} حقول)',
  'contactsScreen.notifications.exportCompleteTitle': 'اكتمل التصدير',
  'contactsScreen.notifications.exportCompleteMessage': 'تم تنزيل {{count}} جهة اتصال بصيغة CSV',
  'contactsScreen.errors.title': 'خطأ',
  'contactsScreen.errors.resolveSendTargetsFailed': 'فشل في استرداد أرقام الهواتف لجهات الاتصال المحددة. حاول مرة أخرى.',
  'contactsScreen.notifications.templateDownloadedTitle': 'تم تنزيل القالب',
  'contactsScreen.notifications.templateDownloadedEmptyMessage': 'تم تنزيل قالب CSV فارغ. املأه بجهات اتصالك ثم ارفعه.',
  'contactsScreen.notifications.templateDownloadedFallbackMessage': 'تم تنزيل قالب CSV. املأه بجهات اتصالك ثم ارفعه.',

  // ─── Contact Edit Form (Right Pane) ─────────────────────────────────────
  'contactEdit.permission.title': 'الإذن مطلوب',
  'contactEdit.permission.message': 'يرجى منح الإذن للوصول إلى مكتبة الصور الخاصة بك.',
  'contactEdit.errors.avatarUpload': 'فشل رفع الصورة الرمزية. يرجى المحاولة مرة أخرى.',
  'contactEdit.info.title': 'معلومة',
  'contactEdit.info.saveContactFirst': 'يرجى حفظ جهة الاتصال أولاً قبل رفع المستندات',
  'contactEdit.errors.documentUpload': 'فشل رفع المستند. يرجى المحاولة مرة أخرى.',
  'contactEdit.validation.title': 'خطأ في التحقق',
  'contactEdit.validation.nameRequired': 'اسم جهة الاتصال مطلوب',
  'contactEdit.validation.identifierRequired': 'مطلوب معرّف واحد على الأقل لجهة الاتصال (هاتف، بريد إلكتروني، إلخ)',
  'contactEdit.success.title': 'نجاح',
  'contactEdit.success.updated': 'تم تحديث جهة الاتصال بنجاح',
  'contactEdit.success.created': 'تم إنشاء جهة الاتصال بنجاح',
  'contactEdit.errors.title': 'خطأ',
  'contactEdit.errors.saveFailed': 'فشل حفظ جهة الاتصال',
  'contactEdit.errors.addNoteFailed': 'فشل إضافة الملاحظة',
  'contactEdit.errors.deleteNoteFailed': 'فشل حذف الملاحظة',
  'contactEdit.errors.setPrimaryFailed': 'فشل تعيين المعرّف الأساسي',
  'contactEdit.delete.title': 'حذف جهة الاتصال',
  'contactEdit.delete.confirmMessage': 'هل أنت متأكد أنك تريد حذف {{name}}؟',
  'contactEdit.delete.cancel': 'إلغاء',
  'contactEdit.delete.confirm': 'حذف',
  'contactEdit.delete.success': 'تم حذف جهة الاتصال بنجاح',
  'contactEdit.delete.failed': 'فشل حذف جهة الاتصال',
  'contactEdit.header.addContact': 'إضافة جهة اتصال',
  'contactEdit.header.editContact': 'تعديل جهة الاتصال',
  'contactEdit.photo.change': 'تغيير الصورة',
  'contactEdit.photo.add': 'إضافة صورة',
  'contactEdit.section.basicInfo': 'المعلومات الأساسية',
  'contactEdit.field.name': 'الاسم *',
  'contactEdit.field.namePlaceholder': 'أدخل اسم جهة الاتصال',
  'contactEdit.section.identifiers': 'معرّفات جهة الاتصال',
  'contactEdit.channel.phone': 'الهاتف',
  'contactEdit.channel.email': 'البريد الإلكتروني',
  'contactEdit.channel.whatsapp': 'واتساب',
  'contactEdit.channel.facebookMessenger': 'فيسبوك ماسنجر',
  'contactEdit.channel.facebook': 'فيسبوك',
  'contactEdit.channel.instagram': 'إنستغرام',
  'contactEdit.channel.telegram': 'تيليجرام',
  'contactEdit.identifier.enterNumber': 'أدخل رقم {{channel}}',
  'contactEdit.identifier.enter': 'أدخل {{channel}}',
  'contactEdit.identifier.emptyHint': 'أضف معرّفاً واحداً على الأقل (هاتف، بريد إلكتروني، إلخ)',
  'contactEdit.identifier.setPrimary': 'تعيين كأساسي',
  'contactEdit.identifier.addForChannel': 'إضافة لـ {{channel}}',
  'contactEdit.identifier.useForChannel': 'استخدامه لـ {{channel}} أيضاً',
  'contactEdit.identifier.undoAdd': 'تراجع',
  'contactEdit.section.location': 'الموقع',
  'contactEdit.location.select': 'اختر الموقع',
  'contactEdit.location.addressLine': 'العنوان',
  'contactEdit.location.city': 'المدينة',
  'contactEdit.location.country': 'الدولة',
  'contactEdit.location.nationality': 'الجنسية',
  'contactEdit.location.pasteLinkPlaceholder': 'الصق رابط خرائط جوجل/آبل',
  'contactEdit.location.linkResolved.title': 'تم العثور على الموقع',
  'contactEdit.location.linkResolved.message': 'تم تعبئة تفاصيل العنوان من الرابط.',
  'contactEdit.location.linkFailed.title': 'تعذّرت قراءة الرابط',
  'contactEdit.location.linkFailed.message': 'تعذّر استخراج موقع من هذا الرابط.',
  'contactEdit.location.showLinkPaste': 'لصق رابط خرائط بدلاً من ذلك',
  'contactEdit.location.hideLinkPaste': 'إخفاء لصق الرابط',
  'contactEdit.section.assignment': 'التعيين',
  'contactEdit.assignment.reassign': 'إعادة التعيين',
  'contactEdit.assignment.unassigned': 'غير مُعيَّن',
  'contactEdit.section.orders': 'الطلبات',
  'contactEdit.orders.empty': 'لا توجد طلبات بعد',
  'contactEdit.section.quotations': 'عروض الأسعار',
  'contactEdit.quotations.empty': 'لا توجد عروض أسعار بعد',
  'contactEdit.section.visits': 'الزيارات',
  'contactEdit.visits.empty': 'لا توجد زيارات بعد',
  'contactEdit.visits.endVisit': 'إنهاء الزيارة',
  'contactEdit.visits.showAll': 'عرض الكل ({{count}})',
  'contactEdit.visits.showLess': 'عرض أقل',
  'orders.form.extraFieldsUpdated': 'تم تحديث الحقول الإضافية بنجاح.',
  'orders.form.extraFieldsFailed': 'تعذر تحديث الحقول الإضافية',
  'orders.form.businessNotFound': 'لم يتم العثور على النشاط التجاري',
  'orders.form.couponInvalidMsg': 'الكوبون غير صالح',
  'orders.form.zoneUnavailableCustomer': 'طريقة الشحن هذه غير متاحة لموقع العميل.',
  'orders.form.zoneUnavailableLocation': 'الموقع المحدد خارج نطاق طريقة الشحن هذه.',
  'orders.form.orderIdRequired': 'معرّف الطلب مطلوب',
  'orders.form.loadFailed': 'تعذر تحميل الطلب',
  'orders.form.productLoadFailed': 'تعذر تحميل تفاصيل المنتج',
  'orders.form.addProductsFailed': 'تعذر إضافة المنتجات إلى الطلب',
  'orders.form.scannedAdded': 'تمت إضافة المنتج الممسوح إلى الطلب.',
  'orders.form.customerPrefilled': 'تم اختيار عميل الطلب من جهة الاتصال.',
  'orders.form.errCustomerName': 'يرجى اختيار جهة اتصال أو إدخال اسم العميل',
  'orders.form.errCustomerPhone': 'يرجى اختيار جهة اتصال أو إدخال رقم الهاتف',
  'orders.form.errItems': 'يجب أن يحتوي الطلب على عنصر واحد على الأقل',
  'orders.form.errTotal': 'يجب أن يكون الإجمالي أكبر من 0',
  'orders.form.fixErrors': 'يرجى تصحيح الأخطاء في النموذج',
  'orders.form.businessIdRequired': 'معرّف النشاط التجاري مطلوب',
  'orders.form.created': 'تم إنشاء الطلب بنجاح.',
  'orders.form.updated': 'تم تحديث الطلب بنجاح.',
  'orders.form.copyNumber': 'نسخ رقم الطلب',
  'orders.form.couponApplied': 'تم تطبيق الكوبون',
  'orders.form.couponInvalid': 'كوبون غير صالح',
  'orders.form.zoneUnavailable': 'المنطقة غير متاحة',
  'orders.form.productAdded': 'تمت إضافة المنتج',
  'orders.form.orderCustomer': 'عميل الطلب',
  'orders.form.validationError': 'خطأ في التحقق',
  'orders.form.editTitle': 'تعديل الطلب',
  'orders.form.newTitle': 'طلب جديد',
  'orders.form.free': 'مجاني',
  'orders.form.typePhysical': 'منتج مادي',
  'orders.form.typeDigital': 'منتج رقمي',
  'orders.form.typeService': 'خدمة',
  'orders.form.couponSaved': 'وفّرت {{amount}} {{currency}}',
  'orders.form.loading': 'جارٍ تحميل الطلب...',
  'orders.form.viewQuotation': 'عرض عرض السعر الأصلي',
  'orders.form.customerInfo': 'معلومات العميل',
  'orders.form.shippingInfo': 'معلومات الشحن',
  'orders.form.shippingAddress': 'عنوان الشحن',
  'orders.form.locationOptional': 'الموقع (اختياري)',
  'orders.form.selectLocation': 'اختر الموقع',
  'orders.form.shippingMethod': 'طريقة الشحن',
  'orders.form.selectShippingMethod': 'اختر طريقة الشحن',
  'orders.form.items': 'عناصر الطلب',
  'orders.form.add': 'إضافة',
  'orders.form.addons': 'الإضافات:',
  'orders.form.apply': 'تطبيق',
  'orders.form.subtotal': 'المجموع الفرعي',
  'orders.form.total': 'الإجمالي',
  'orders.form.noItems': 'لا توجد عناصر في هذا الطلب',
  'orders.form.addItems': 'إضافة عناصر',
  'orders.form.extraFields': 'حقول إضافية',
  'orders.form.selectShippingMethodTitle': 'اختر طريقة الشحن',
  'orders.form.noShippingMethods': 'لا توجد طرق شحن مُعدّة',
  'orders.form.express': 'سريع',
  'orders.form.selectStatus': 'اختر الحالة',
  'orders.form.selectPaymentStatus': 'اختر حالة الدفع',
  'orders.form.enterShippingAddress': 'أدخل عنوان الشحن',
  'orders.form.trackingNumber': 'رقم التتبع',
  'orders.form.enterTrackingNumber': 'أدخل رقم التتبع',
  'orders.form.couponCode': 'رمز الكوبون',
  'orders.form.discountReason': 'سبب الخصم (اختياري)',
  'orders.form.notePlaceholder': 'أضف ملاحظة عن هذا الطلب...',
  'orders.form.notes': 'الملاحظات',
  'orders.form.saveExtraFields': 'حفظ الحقول الإضافية',
  'orders.form.addProductsTitle': 'إضافة منتجات إلى الطلب',
  'orders.form.lowStockTitle': 'تحذير انخفاض المخزون',
  'orders.form.proceedAnyway': 'المتابعة على أي حال',
  'orders.form.delivery': 'التوصيل',
  'orders.form.freeAbove': 'مجاني للطلبات فوق {{amount}} {{currency}}',
  'orders.form.discount': 'الخصم',
  'orders.status.pending': 'قيد الانتظار',
  'orders.status.placed': 'تم الطلب',
  'orders.status.confirmed': 'مؤكد',
  'orders.status.processing': 'قيد التجهيز',
  'orders.status.shipped': 'تم الشحن',
  'orders.status.delivered': 'تم التوصيل',
  'orders.status.cancelled': 'ملغي',
  'orders.payment.unpaid': 'غير مدفوع',
  'orders.payment.partial': 'مدفوع جزئيًا',
  'orders.payment.paid': 'مدفوع',
  'orders.payment.refunded': 'مسترد',
  'orders.source.checkout': 'الدفع الإلكتروني',
  'orders.source.catalog': 'الكتالوج',
  'orders.source.quick_reply': 'رد سريع',
  'orders.source.manual': 'يدوي',
  'orders.source.api': 'API',
  'orders.field.orderStatus': 'حالة الطلب',
  'orders.field.paymentStatus': 'حالة الدفع',
  'orders.field.source': 'المصدر',
  'orders.field.currency': 'العملة',
  'orders.field.orderDate': 'تاريخ الطلب',
  'orders.field.totalPrice': 'الإجمالي',
  'orders.common.error': 'خطأ',
  'orders.common.success': 'تم بنجاح',
  'orders.msg.loginAgain': 'يرجى تسجيل الدخول مرة أخرى',
  'orders.msg.statusUpdated': 'تم تحديث حالة الطلب بنجاح',
  'orders.msg.statusFailed': 'تعذر تحديث حالة الطلب',
  'orders.msg.paymentUpdated': 'تم تحديث حالة الدفع بنجاح',
  'orders.msg.paymentFailed': 'تعذر تحديث حالة الدفع',
  'orders.msg.generatingInvoice': 'جارٍ إنشاء الفاتورة...',
  'orders.msg.invoiceRegenerated': 'تمت إعادة إنشاء الفاتورة',
  'orders.msg.invoiceGenerated': 'تم إنشاء الفاتورة',
  'orders.msg.invoiceFailed': 'تعذر إنشاء الفاتورة',
  'orders.msg.deleted': 'تم حذف الطلب بنجاح',
  'orders.msg.deleteFailed': 'تعذر حذف الطلب',
  'orders.msg.numberCopied': 'تم نسخ رقم الطلب',
  'orders.msg.copyFailed': 'تعذر نسخ رقم الطلب',
  'orders.msg.regenerating': 'جارٍ إعادة الإنشاء',
  'orders.msg.generating': 'جارٍ الإنشاء',
  'orders.msg.copied': 'تم النسخ',
  'orders.action.edit': 'تعديل',
  'orders.action.invoice': 'الفاتورة',
  'orders.action.regen': 'إعادة إنشاء',
  'orders.list.loading': 'جارٍ تحميل الطلبات...',
  'orders.list.loadErrorTitle': 'تعذر تحميل الطلبات',
  'orders.list.tryAgain': 'حاول مرة أخرى',
  'orders.list.emptyTitle': 'لا توجد طلبات بعد',
  'orders.list.emptyText': 'أنشئ أول طلب أو عرض سعر للبدء!',
  'orders.list.createOrder': 'إنشاء طلب',
  'orders.list.loadingMore': 'جارٍ تحميل المزيد من الطلبات...',
  'orders.list.exitToDataLists': 'العودة إلى قوائم البيانات',
  'orders.list.exitToOrders': 'العودة إلى الطلبات',
  'orders.filter.from': 'من',
  'orders.filter.to': 'إلى',
  'orders.filter.clear': 'مسح',
  'orders.modal.updateStatus': 'تحديث حالة الطلب',
  'orders.modal.updatePayment': 'تحديث حالة الدفع',
  'orders.filter.search': 'بحث...',
  'orders.delete.title': 'حذف الطلب',
  'orders.delete.message': 'هل أنت متأكد من حذف هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.',
  'orders.delete.confirm': 'حذف',
  'orders.common.cancel': 'إلغاء',
  'orders.toolbar.sortFilter': 'ترتيب وتصفية الحقول',
  'orders.toolbar.filters': 'الفلاتر',
  'settings.pushDiagnostics.title': 'حالة الإشعارات الفورية',
  'settings.pushDiagnostics.permission': 'الإذن',
  'settings.pushDiagnostics.registration': 'التسجيل في الخادم',
  'settings.pushDiagnostics.test': 'آخر اختبار',
  'settings.pushDiagnostics.reRegister': 'إعادة التسجيل',
  'settings.pushDiagnostics.sendTest': 'إرسال إشعار تجريبي',
  'quotations.form.customerPrefilled': 'تم اختيار عميل عرض السعر من جهة الاتصال.',
  'orders.toolbar.createQuotation': 'إنشاء عرض سعر',
  'orders.list.itemsCount': '{{count}} عنصر',
  'contactEdit.status.none': 'لا يوجد',
  'contactEdit.status.order.pending': 'قيد الانتظار',
  'contactEdit.status.order.placed': 'تم الطلب',
  'contactEdit.status.order.confirmed': 'مؤكد',
  'contactEdit.status.order.processing': 'قيد التجهيز',
  'contactEdit.status.order.shipped': 'تم الشحن',
  'contactEdit.status.order.delivered': 'تم التوصيل',
  'contactEdit.status.order.cancelled': 'ملغي',
  'contactEdit.status.payment.unpaid': 'غير مدفوع',
  'contactEdit.status.payment.partial': 'مدفوع جزئيًا',
  'contactEdit.status.payment.paid': 'مدفوع',
  'contactEdit.status.payment.refunded': 'مسترد',
  'contactEdit.status.quotation.draft': 'مسودة',
  'contactEdit.status.quotation.sent': 'مُرسل',
  'contactEdit.status.quotation.accepted': 'مقبول',
  'contactEdit.status.quotation.converted': 'تم التحويل',
  'contactEdit.status.quotation.rejected': 'مرفوض',
  'contactEdit.status.quotation.expired': 'منتهي',
  'contactEdit.status.assignment.active': 'نشط',
  'contactEdit.status.assignment.inProgress': 'قيد التنفيذ',
  'contactEdit.status.assignment.completed': 'مكتمل',
  'contactEdit.status.assignment.cancelled': 'ملغي',
  'contactEdit.status.assignment.transferred': 'محوّل',
  'contactEdit.cards.copied': 'تم النسخ',
  'contactEdit.cards.copiedMessage': 'تم نسخ {{label}}',
  'contactEdit.cards.copyFailed': 'تعذر النسخ',
  'contactEdit.cards.extraFields': 'حقول إضافية',
  'contactEdit.cards.extraFieldsUpdated': 'تم تحديث الحقول الإضافية بنجاح.',
  'contactEdit.cards.extraFieldsFailed': 'تعذر تحديث الحقول الإضافية',
  'contactEdit.cards.updated': 'تم التحديث',
  'contactEdit.cards.updateFailed': 'فشل التحديث',
  'contactEdit.cards.orderStatusUpdated': 'تم تحديث حالة الطلب',
  'contactEdit.cards.paymentStatusUpdated': 'تم تحديث حالة الدفع',
  'contactEdit.cards.orderUpdateFailed': 'تعذر تحديث الطلب',
  'contactEdit.cards.quotationStatusUpdated': 'تم تحديث حالة عرض السعر',
  'contactEdit.cards.quotationUpdateFailed': 'تعذر تحديث عرض السعر',
  'contactEdit.cards.assignmentUpdated': 'أصبحت حالة الإسناد: {{status}}',
  'contactEdit.cards.assignmentUpdateFailed': 'تعذر تحديث الإسناد',
  'contactEdit.cards.listUpdateFailed': 'فشل تحديث القائمة',
  'contactEdit.cards.listUpdateFailedMessage': 'تعذر تحديث عضوية القائمة',
  'contactEdit.cards.start': 'بدء',
  'contactEdit.cards.complete': 'إكمال',
  'contactEdit.cards.lists': 'القوائم',
  'contactEdit.cards.listsAdded': 'مضاف إلى',
  'contactEdit.cards.listsAvailable': 'متاحة',
  'contactEdit.cards.listsEmpty': 'غير مضاف إلى أي قائمة.',
  'contactEdit.cards.listsNoOthers': 'لا توجد قوائم جهات اتصال أخرى.',
  'contactEdit.cards.order': 'طلب',
  'contactEdit.cards.orderNumber': 'رقم الطلب',
  'contactEdit.cards.orderDetails': 'تفاصيل الطلب',
  'contactEdit.cards.orderStatus': 'حالة الطلب',
  'contactEdit.cards.paymentStatus': 'حالة الدفع',
  'contactEdit.cards.quotation': 'عرض سعر',
  'contactEdit.cards.quotationNumber': 'رقم عرض السعر',
  'contactEdit.cards.quotationDetails': 'تفاصيل عرض السعر',
  'contactEdit.cards.quotationStatus': 'حالة عرض السعر',
  'contactEdit.cards.itemsCount': '{{count}} عنصر',
  'contactEdit.cards.edit': 'تعديل',
  'contactEdit.documents.deleteFailed': 'فشل حذف المستند',
  'contactEdit.section.tags': 'الوسوم',
  'contactEdit.tags.addPlaceholder': 'إضافة وسم',
  'contactEdit.tags.searchPlaceholder': 'بحث عن وسم…',
  'contactEdit.tags.noMatch': 'لا توجد وسوم مطابقة لبحثك',
  'contactEdit.section.notes': 'الملاحظات',
  'contactEdit.notes.loading': 'جارٍ تحميل الملاحظات…',
  'contactEdit.section.documents': 'المستندات',
  'contactEdit.documents.sizeKb': '{{size}} كيلوبايت',
  'contactEdit.documents.empty': 'لا توجد مستندات مرفقة',
  'contactEdit.action.saving': 'جارٍ الحفظ...',
  'contactEdit.action.create': 'إنشاء جهة اتصال',
  'contactEdit.action.save': 'حفظ التغييرات',
  'contactEdit.action.delete': 'حذف جهة الاتصال',

  // ─── إعداد الهاتف ─────────────────────────────────────────────────────────
  'phoneSetup.headerTitle': 'الهاتف',
  'phoneSetup.heroTitle': 'الهاتف',
  'phoneSetup.heroSubtitle': 'اربط مزود هاتف لإجراء المكالمات وتتبعها مع جهات اتصالك مباشرة من صندوق الوارد.',
  'phoneSetup.accessDeniedTitle': 'الوصول مرفوض',
  'phoneSetup.accessDeniedText': 'يجب أن تكون مسؤولاً أو مالكاً لإدارة قناة الهاتف.',
  'phoneSetup.goBack': 'رجوع',
  'phoneSetup.field.apiId': 'معرّف API',
  'phoneSetup.field.apiIdPlaceholder': 'من Developer > API Gateway Credentials',
  'phoneSetup.field.apiSecret': 'المفتاح السري لـ API',
  'phoneSetup.field.apiSecretPlaceholder': 'من Developer > API Gateway Credentials',
  'phoneSetup.field.apiKey': 'مفتاح API',
  'phoneSetup.field.apiKeyPlaceholder': 'من تبويب WebRTC credentials',
  'phoneSetup.field.campaignId': 'معرّف الحملة (اختياري)',
  'phoneSetup.field.campaignIdPlaceholder': 'مطلوب فقط للاتصال التلقائي بالحملات',
  'phoneSetup.field.callerNumber': 'رقم المتصل (اختياري)',
  'phoneSetup.field.callerNumberPlaceholder': 'معرف المتصل الصادر الخاص بك',
  'phoneSetup.connectButton': 'ربط حساب InnoCalls',
  'phoneSetup.missingFieldsTitle': 'حقول ناقصة',
  'phoneSetup.missingFieldsMessage': 'معرّف API والمفتاح السري ومفتاح API مطلوبة جميعاً.',
  'phoneSetup.connectedTitle': 'تم الربط!',
  'phoneSetup.connectedMessage': 'تم ربط حساب هاتفك بنجاح.',
  'phoneSetup.connectionFailedTitle': 'فشل الربط',
  'phoneSetup.connectionFailedMessage': 'فشل ربط حساب الهاتف. تحقق من بياناتك وحاول مرة أخرى.',
  'phoneSetup.disconnectedTitle': 'تم قطع الاتصال',
  'phoneSetup.disconnectedMessage': 'تم قطع اتصال حساب هاتفك.',
  'phoneSetup.errorTitle': 'خطأ',
  'phoneSetup.disconnectFailed': 'فشل قطع اتصال الحساب',
  'phoneSetup.agentsSectionTitle': 'وكلاء المكالمات',
  'phoneSetup.agentsSectionSubtitle': 'التحويلات (extensions) الموجودة على حساب InnoCalls المتصل. عيّن كل واحدة لأحد الزملاء ليتمكن من إجراء المكالمات واستقبالها.',
  'phoneSetup.noAgentsFound': 'لم يتم العثور على أي تحويلات في حساب InnoCalls هذا بعد. أنشئ واحدة من لوحة تحكم InnoCalls ثم اضغط تحديث.',
  'phoneSetup.extensionLabel': 'تحويلة {{extension}}',
  'phoneSetup.notAssigned': 'غير مُعيّنة',
  'phoneSetup.assign': 'تعيين',
  'phoneSetup.reassign': 'إعادة تعيين',
  'phoneSetup.discoveryFailedTitle': 'فشل الاكتشاف',
  'phoneSetup.discoveryFailedMessage': 'فشل اكتشاف تحويلات InnoCalls.',
  'phoneSetup.assignExtensionTitle': 'تعيين التحويلة {{extension}}',
  'phoneSetup.pinRequiredTitle': 'الرمز السري مطلوب',
  'phoneSetup.pinRequiredMessage': 'أدخل الرمز السري لهذه التحويلة لتأكيد التعيين.',
  'phoneSetup.agentLinkedTitle': 'تم ربط الوكيل',
  'phoneSetup.agentLinkedMessage': 'التحويلة {{extension}} مُعيّنة الآن.',
  'phoneSetup.assignmentFailedTitle': 'فشل التعيين',
  'phoneSetup.assignmentFailedMessage': 'فشل ربط هذه التحويلة. تأكد من أن التحويلة ما زالت موجودة على InnoCalls.',
  'phoneSetup.confirmPinTitle': 'تأكيد الرمز السري للتحويلة',
  'phoneSetup.confirmPinText': 'أدخل الرمز السري للتحويلة {{extension}} لربطها بـ {{user}}.',
  'phoneSetup.confirmPinThisUser': 'هذا المستخدم',
  'phoneSetup.pinPlaceholder': 'الرمز السري',
  'phoneSetup.confirmAndLink': 'تأكيد وربط',

  // ─── Avatar / Account Menu ───────────────────────────────────────────────
  'avatarMenu.loadingBusinesses': 'جارٍ تحميل الأعمال…',
  'avatarMenu.business': 'العمل',
  'avatarMenu.fallbackBusinessName': 'العمل',
  'avatarMenu.fallbackUserName': 'مستخدم',
  'avatarMenu.role.owner': 'مالك',
  'avatarMenu.createBusiness': 'إنشاء عمل',
  'avatarMenu.switchBusiness.title': 'تبديل العمل',
  'avatarMenu.switchBusiness.message': 'ميزة تبديل العمل قيد الإعداد. يرجى التواصل مع الدعم للمساعدة.',
  'avatarMenu.option.userManagement': 'إدارة المستخدمين',
  'avatarMenu.option.departments': 'الأقسام',
  'avatarMenu.option.subscription': 'الاشتراك',
  'avatarMenu.option.products': 'المنتجات',
  'avatarMenu.option.taskHistory': 'سجل المهام',
  'avatarMenu.option.notifications': 'الإشعارات',
  'avatarMenu.option.settings': 'الإعدادات',
  'avatarMenu.option.setupProgress': 'جهّز نشاطك التجاري',
  'businessHours.title': 'طريقة عملك',
  'businessHours.subtitle': 'تُستخدم في الطلبات والحجوزات والتقارير. يمكنك تغييرها لاحقًا من الإعدادات.',
  'businessHours.timezone': 'المنطقة الزمنية',
  'businessHours.currency': 'العملة',
  'businessHours.workingDays': 'أيام العمل',
  'businessHours.workingHours': 'ساعات العمل',
  'businessHours.opens': 'يفتح',
  'businessHours.closes': 'يغلق',
  'businessHours.perDay': 'ساعات مختلفة لكل يوم',
  'businessHours.sameHours': 'نفس الساعات لكل الأيام',
  'businessHours.skipLocation': 'تخطي الآن',
  'businessHours.errorNoDays': 'اختر يوم عمل واحدًا على الأقل.',
  'businessHours.errorTimes': 'يجب أن يكون وقت الإغلاق بعد وقت الفتح.',
  'businessHours.day.sunday': 'الأحد',
  'businessHours.day.monday': 'الاثنين',
  'businessHours.day.tuesday': 'الثلاثاء',
  'businessHours.day.wednesday': 'الأربعاء',
  'businessHours.day.thursday': 'الخميس',
  'businessHours.day.friday': 'الجمعة',
  'businessHours.day.saturday': 'السبت',
  'businessHours.dayShort.sunday': 'أحد',
  'businessHours.dayShort.monday': 'اثنين',
  'businessHours.dayShort.tuesday': 'ثلاثاء',
  'businessHours.dayShort.wednesday': 'أربعاء',
  'businessHours.dayShort.thursday': 'خميس',
  'businessHours.dayShort.friday': 'جمعة',
  'businessHours.dayShort.saturday': 'سبت',
  'businessProfile.title': 'الملف التجاري',
  'businessProfile.details': 'بيانات النشاط',
  'businessProfile.changeLogo': 'تغيير الشعار',
  'businessProfile.detailsInvalid': 'أدخل اسم النشاط وبريدًا إلكترونيًا صحيحًا.',
  'businessProfile.location': 'الموقع',
  'businessProfile.address': 'العنوان',
  'businessProfile.pinSet': 'تم تحديد الموقع على الخريطة',
  'businessProfile.saved': 'تم حفظ الملف التجاري',
  'businessProfile.saveFailed': 'تعذّر حفظ الملف التجاري',
  'avatarMenu.option.faq': 'الأسئلة الشائعة',
  'avatarMenu.option.logout': 'تسجيل الخروج',
  'avatarMenu.faq.title': 'الأسئلة الشائعة',
  'avatarMenu.faq.message': 'الأسئلة الشائعة قيد الإعداد. يرجى التواصل مع الدعم للمساعدة.',
  'avatarMenu.logout.title': 'تم تسجيل الخروج',
  'avatarMenu.logout.message': 'تم تسجيل خروجك بنجاح.',

  // User Setup / Team Members
  'userSetup.pendingInvite': 'دعوة معلّقة',
  'userSetup.teamMembers': 'أعضاء الفريق',
  'userSetup.teamMembersCount': 'أعضاء الفريق ({{count}})',
  'userSetup.teamMembersFiltered': 'أعضاء الفريق ({{filtered}} من {{total}})',
  'userSetup.inviteUser': 'دعوة مستخدم',
  'userSetup.userLimits': 'حدود المستخدمين',
  'userSetup.slotsRemaining': 'متبقٍ {{count}} مقعد',
  'userSetup.currentUsers': 'المستخدمون الحاليون',
  'userSetup.maximumUsers': 'الحد الأقصى للمستخدمين',
  'userSetup.usersOfMax': '{{current}} من {{max}} مستخدم',
  'userSetup.searchPlaceholder': 'ابحث عن المستخدمين بالاسم أو البريد الإلكتروني أو الهاتف...',
  'userSetup.searchPlaceholderLoading': 'جارٍ تحميل النشاط التجاري...',
  'userSetup.searchPlaceholderNoBusiness': 'يرجى اختيار نشاط تجاري أولاً',
  'userSetup.loadingBusiness': 'جارٍ تحميل النشاط التجاري...',
  'userSetup.loadingUsers': 'جارٍ تحميل المستخدمين...',
  'userSetup.noBusinessFound': 'لم يتم العثور على نشاط تجاري',
  'userSetup.noBusinessFoundDesc': 'يرجى إنشاء نشاط تجاري أولاً لإدارة المستخدمين',
  'userSetup.createBusiness': 'إنشاء نشاط تجاري',
  'userSetup.reloadBusiness': 'إعادة تحميل النشاط التجاري',
  'userSetup.debugInfo': 'معلومات التصحيح:',
  'userSetup.debugBusiness': 'النشاط التجاري: {{value}}',
  'userSetup.debugLoading': 'التحميل: {{value}}',
  'userSetup.debugUser': 'المستخدم: {{value}}',
  'userSetup.debugBusinessId': 'معرّف النشاط التجاري: {{id}}',
  'userSetup.found': 'موجود',
  'userSetup.notFound': 'غير موجود',
  'userSetup.yes': 'نعم',
  'userSetup.no': 'لا',
  'userSetup.loggedIn': 'تم تسجيل الدخول',
  'userSetup.notLoggedIn': 'لم يتم تسجيل الدخول',
  'userSetup.demoModeTitle': 'وضع تجريبي مؤقت',
  'userSetup.demoModeDesc': 'نظراً لعدم اكتشاف نشاط تجاري، إليك عرضاً تجريبياً لواجهة إدارة المستخدمين:',
  'userSetup.demoUsersCount': 'مستخدمون تجريبيون ({{count}})',
  'userSetup.demoModeRoleChange': 'هذا وضع تجريبي - تغيير الدور غير متاح',
  'userSetup.demoModeRemove': 'هذا وضع تجريبي - إزالة المستخدم غير متاحة',
  'userSetup.noUsersFound': 'لم يتم العثور على مستخدمين',
  'userSetup.inviteFirstUser': 'ادعُ أول مستخدم للبدء',
  'userSetup.userLimitReached': 'تم بلوغ الحد الأقصى للمستخدمين. قم بترقية باقتك لإضافة المزيد.',
  'userSetup.noUsersMatchSearch': 'لا يوجد مستخدمون مطابقون لبحثك عن "{{query}}"',
  'userSetup.clearSearch': 'مسح البحث',
  'userSetup.owner': 'مالك',
  'userSetup.noDepartmentsAssigned': 'لا توجد أقسام معينة',
  'userSetup.roleAdmin': 'مسؤول',
  'userSetup.roleManager': 'مدير',
  'userSetup.roleMember': 'عضو',
  'userSetup.roleViewer': 'مشاهد',
  'userSetup.statusActive': 'نشط',
  'userSetup.statusPending': 'قيد الانتظار',
  'userSetup.statusSuspended': 'موقوف',
  'userSetup.statusLeft': 'غادر',
  'userSetup.inviteModalTitle': 'دعوة مستخدم جديد',
  'userSetup.emailAddress': 'البريد الإلكتروني',
  'userSetup.emailPlaceholder': 'user@example.com',
  'userSetup.emailRequired': 'البريد الإلكتروني مطلوب',
  'userSetup.firstName': 'الاسم الأول',
  'userSetup.firstNamePlaceholder': 'محمد',
  'userSetup.firstNameRequired': 'الاسم الأول مطلوب',
  'userSetup.lastName': 'اسم العائلة',
  'userSetup.lastNamePlaceholder': 'أحمد',
  'userSetup.lastNameRequired': 'اسم العائلة مطلوب',
  'userSetup.role': 'الدور',
  'userSetup.departmentsOptional': 'الأقسام (اختياري)',
  'userSetup.selectDepartments': 'اختر الأقسام',
  'userSetup.noDepartmentsSelected': 'لم يتم اختيار أي قسم',
  'userSetup.notesOptional': 'ملاحظات (اختياري)',
  'userSetup.notesPlaceholder': 'ملاحظات إضافية حول هذا المستخدم...',
  'userSetup.cancel': 'إلغاء',
  'userSetup.sending': 'جارٍ الإرسال...',
  'userSetup.sendInvitation': 'إرسال الدعوة',
  'userSetup.removeUserTitle': 'إزالة المستخدم',
  'userSetup.removeUserMessage': 'سيؤدي هذا إلى إزالة {{name}} من نشاطك التجاري. لا يمكن التراجع عن هذا الإجراء.',
  'userSetup.resendInvitationTitle': 'إعادة إرسال الدعوة',
  'userSetup.resendInvitationMessage': 'سيتم إرسال دعوة جديدة عبر البريد الإلكتروني إلى {{name}}.',
  'userSetup.resendInvitationConfirm': 'إعادة إرسال الدعوة',
  'userSetup.changeRoleTitle': 'تغيير الدور',
  'userSetup.selectNewRoleFor': 'اختر دوراً جديداً لـ {{name}}',
  'userSetup.noBusinessError': 'لا يوجد نشاط تجاري',
  'userSetup.noBusinessErrorDesc': 'يرجى اختيار نشاط تجاري أولاً',
  'userSetup.emailRequiredTitle': 'البريد الإلكتروني مطلوب',
  'userSetup.emailRequiredDesc': 'يرجى إدخال بريد إلكتروني صحيح',
  'userSetup.firstNameRequiredTitle': 'الاسم الأول مطلوب',
  'userSetup.firstNameRequiredDesc': 'يرجى إدخال الاسم الأول للمستخدم',
  'userSetup.lastNameRequiredTitle': 'اسم العائلة مطلوب',
  'userSetup.lastNameRequiredDesc': 'يرجى إدخال اسم عائلة المستخدم',
  'userSetup.invalidEmailTitle': 'بريد إلكتروني غير صالح',
  'userSetup.invalidEmailDesc': 'يرجى إدخال بريد إلكتروني صحيح',
  'userSetup.invitationSentTitle': 'تم إرسال الدعوة',
  'userSetup.invitationSentDesc': 'تم إرسال الدعوة إلى {{email}}',
  'userSetup.invitationFailedTitle': 'فشل إرسال الدعوة',
  'userSetup.invitationFailedDefault': 'فشل إرسال الدعوة',
  'userSetup.errorTitle': 'خطأ',
  'userSetup.userRemovedTitle': 'تمت إزالة المستخدم',
  'userSetup.userRemovedDesc': 'تمت إزالة المستخدم من النشاط التجاري',
  'userSetup.removeFailedTitle': 'فشلت الإزالة',
  'userSetup.removeFailedDefault': 'فشل إزالة المستخدم',
  'userSetup.removeUserErrorDefault': 'فشل إزالة المستخدم',
  'userSetup.invitationResentTitle': 'تمت إعادة إرسال الدعوة',
  'userSetup.invitationResentDesc': 'تمت إعادة إرسال الدعوة إلى المستخدم',
  'userSetup.resendFailedTitle': 'فشلت إعادة الإرسال',
  'userSetup.resendFailedDefault': 'فشلت إعادة إرسال الدعوة',
  'userSetup.resendErrorDefault': 'فشلت إعادة إرسال الدعوة',
  'userSetup.roleUpdatedTitle': 'تم تحديث الدور',
  'userSetup.roleUpdatedDesc': 'تم تحديث دور المستخدم بنجاح',
  'userSetup.updateFailedTitle': 'فشل التحديث',
  'userSetup.updateFailedDefault': 'فشل تحديث دور المستخدم',
  'userSetup.updateRoleErrorDefault': 'فشل تحديث دور المستخدم',
  'userSetup.failedToLoadUsersTitle': 'فشل تحميل المستخدمين',
  'userSetup.failedToLoadLimitsTitle': 'فشل تحميل الحدود',
  'userSetup.unknownError': 'خطأ غير معروف',
  'userSetup.loadUserDataError': 'فشل تحميل بيانات المستخدم',
  'userSetup.debugModeTitle': 'تصحيح',
  'userSetup.debugModeReloading': 'جارٍ إعادة تحميل الأنشطة التجارية...',

  // ─── قوائم البيانات ───────────────────────────────────────────────────────
  'assignmentRules.title': "إعداد الإسناد",
  'assignmentRules.subtitle': "{{count}} قواعد",
  'assignmentRules.new': "قاعدة جديدة",
  'assignmentRules.save': "حفظ القاعدة",
  'assignmentRules.saved': "تم حفظ القاعدة.",
  'assignmentRules.delete': "حذف القاعدة",
  'assignmentRules.deleteTitle': "حذف هذه القاعدة؟",
  'assignmentRules.deleteMessage': "تتوقف فوراً، ويتم تخطي إجراءاتها المنتظرة.",
  'assignmentRules.error.load': "تعذر تحميل قواعد الإسناد.",
  'assignmentRules.error.save': "تعذر حفظ القاعدة.",
  'assignmentRules.intro': "تعمل القواعد عند إسناد شيء — لأي شخص أو لأشخاص أو أقسام محددة. في الإسناد الجماعي تعمل القاعدة مرة لكل عنصر مُسند وتصلك خلاصة واحدة.",
  'assignmentRules.empty.title': "لا توجد قواعد إسناد بعد",
  'assignmentRules.empty.message': "مثال: عند إسناد جهة اتصال لقسم المبيعات، شغّل سير عمل الترحيب على واتساب وصعّد للمدير إذا لم يبدأ أحد خلال 4 ساعات.",
  'assignmentRules.when': "عند الإسناد إلى {{who}}",
  'assignmentRules.to.anyone': "أي شخص",
  'assignmentRules.to.users': "أشخاص محددون",
  'assignmentRules.to.departments': "أقسام محددة",
  'assignmentRules.type.contact': "جهات الاتصال",
  'assignmentRules.type.conversation': "المحادثات",
  'assignmentRules.type.task': "المهام",
  'assignmentRules.type.ticket': "التذاكر",
  'assignmentRules.type.calendar': "التقويم",
  'assignmentRules.type.email': "البريد",
  'assignmentRules.type.lead': "العملاء المحتملون",
  'assignmentRules.type.deal': "الصفقات",
  'assignmentRules.type.project': "المشاريع",
  'assignmentRules.type.visit': "الزيارات",
  'assignmentRules.type.phone_call': "المكالمات",
  'assignmentRules.batch.any': "فردي أو جماعي",
  'assignmentRules.batch.single': "فردي فقط",
  'assignmentRules.batch.bulk': "جماعي",
  'assignmentRules.source.manual': "يدوياً",
  'assignmentRules.source.bulk': "إسناد جماعي",
  'assignmentRules.source.flow': "سير العمل والذكاء الاصطناعي",
  'assignmentRules.source.channel_settings': "الإسناد التلقائي للقناة",
  'assignmentRules.source.quick_reply': "الردود السريعة",
  'assignmentRules.source.webhook': "API / ويب هوك",
  'assignmentRules.source.conversation_create': "محادثة جديدة",
  'assignmentRules.source.contact_add': "جهة اتصال جديدة",
  'assignmentRules.summary.workflow': "تشغيل \"{{name}}\"",
  'assignmentRules.summary.notify': "إشعار",
  'assignmentRules.summary.tags': "وسوم",
  'assignmentRules.summary.due': "مستحق خلال {{hours}} س",
  'assignmentRules.summary.priority': "تحديد الأولوية",
  'assignmentRules.summary.escalate': "تصعيد بعد {{hours}} س",
  'assignmentRules.stats.handled': "تمت معالجة {{count}}",
  'assignmentRules.stats.failed': "فشل {{count}}",
  'assignmentRules.stats.last': "آخر تشغيل: {{done}} من {{total}} · {{when}}",
  'assignmentRules.section.when': "عندما",
  'assignmentRules.section.then': "ثم",
  'assignmentRules.section.history': "آخر التشغيلات",
  'assignmentRules.field.name': "اسم القاعدة",
  'assignmentRules.field.active': "القاعدة مفعّلة",
  'assignmentRules.field.assignedTo': "مُسند إلى",
  'assignmentRules.field.types': "ما الذي يُسند",
  'assignmentRules.field.batch': "فردي أو جماعي",
  'assignmentRules.field.sources': "مصدر الإسناد",
  'assignmentRules.field.workflow': "سير العمل",
  'assignmentRules.field.channel': "تشغيله على",
  'assignmentRules.field.managers': "مدير القسم",
  'assignmentRules.field.people': "هؤلاء الأشخاص",
  'assignmentRules.field.message': "رسالة (اختياري)",
  'assignmentRules.field.tagsAdd': "إضافة وسوم",
  'assignmentRules.field.tagsRemove': "إزالة وسوم",
  'assignmentRules.field.priority': "الأولوية",
  'assignmentRules.field.dueIn': "مستحق خلال (ساعات)",
  'assignmentRules.field.after': "بعد (ساعات)",
  'assignmentRules.field.reassignUser': "إعادة الإسناد لشخص",
  'assignmentRules.field.reassignDepartment': "أو لقسم",
  'assignmentRules.field.notifyManagers': "إشعار مدير القسم",
  'assignmentRules.field.notifyPeople': "إشعار هؤلاء الأشخاص",
  'assignmentRules.hint.anyType': "بدون اختيار = أي شيء يُسند.",
  'assignmentRules.hint.anySource': "بدون اختيار = من أي مصدر.",
  'assignmentRules.hint.bulk': "تعمل الإجراءات بهذا الترتيب، وفي الإسناد الجماعي تتكرر لكل عنصر مُسند.",
  'assignmentRules.hint.template': "يسمح واتساب بالرسائل الحرة خلال 24 ساعة من آخر رسالة لجهة الاتصال فقط. ابدأ سير العمل برسالة قالب للوصول لمن هم خارج هذه المدة.",
  'assignmentRules.action.workflow': "تشغيل سير عمل",
  'assignmentRules.action.workflowHint': "لجهة الاتصال المُسندة، في محادثتها.",
  'assignmentRules.action.notify': "إشعار أشخاص",
  'assignmentRules.action.notifyHint': "إضافة إلى الإشعار المعتاد لمن تم الإسناد إليه.",
  'assignmentRules.action.tags': "وسم جهة الاتصال",
  'assignmentRules.action.tagsHint': "إضافة أو إزالة وسوم جهة الاتصال.",
  'assignmentRules.action.deadline': "تحديد موعد",
  'assignmentRules.action.deadlineHint': "الأولوية وموعد الاستحقاق.",
  'assignmentRules.action.escalate': "التصعيد إذا لم تتم المعالجة",
  'assignmentRules.action.escalateHint': "بعد عدد من الساعات، أعد الإسناد أو أبلغ أحداً.",
  'assignmentRules.when.not_started': "إذا لم يبدأ",
  'assignmentRules.when.not_completed': "إذا لم يكتمل",
  'assignmentRules.channel.whatsapp': "واتساب",
  'assignmentRules.channel.facebook_messenger': "ماسنجر",
  'assignmentRules.priority.low': "منخفضة",
  'assignmentRules.priority.normal': "عادية",
  'assignmentRules.priority.high': "عالية",
  'assignmentRules.priority.urgent': "عاجلة",
  'assignmentRules.flow.unpublished': "غير منشور",
  'assignmentRules.none.users': "لا يوجد أعضاء فريق بعد.",
  'assignmentRules.none.departments': "لا توجد أقسام بعد.",
  'assignmentRules.none.flows': "لا يوجد سير عمل بعد — أنشئ واحداً من سير العمل.",
  'assignmentRules.placeholder.name': "مثال: الترحيب بجهات اتصال المبيعات الجديدة",
  'assignmentRules.placeholder.message': "مثال: جهة اتصال جديدة لك — اتصل خلال ساعة",
  'assignmentRules.placeholder.tags': "افصل بفاصلة — مثال: عميل-جديد، مبيعات",
  'assignmentRules.history.actions': "الإجراءات",
  'assignmentRules.history.escalate': "فحص التصعيد",
  'assignmentRules.history.counts': "{{done}} من {{total}}",
  'assignmentRules.history.skipped': "تم تخطي {{count}}",
  'assignmentRules.history.empty': "لم تعمل هذه القاعدة بعد.",
  'setup.step.assignmentRules.title': "أعدّ قواعد الإسناد",
  'setup.step.assignmentRules.description': "شغّل سير عمل أو أرسل إشعاراً أو صعّد عند إسناد جهات الاتصال",
  'settings.items.assignmentRules.title': "إعداد الإسناد",
  'settings.items.assignmentRules.description': "ما يحدث عند إسناد شيء",
  'permissions.general.assignmentRules.label': "قواعد الإسناد",
  'permissions.general.assignmentRules.description': "عرض وتعديل ما يحدث عند إسناد شيء (إعداد الإسناد)",
  'leadFinder.rerun.action': "إعادة التشغيل",
  'leadFinder.rerun.title': "تشغيل هذا البحث مرة أخرى؟",
  'leadFinder.rerun.hint': "يبدأ بحثاً جديداً بنفس الإعدادات، ويُحتسب ضمن عمليات البحث لهذا الشهر.",
  'leadFinder.rerun.onlyNew': "الأنشطة الجديدة فقط",
  'leadFinder.rerun.onlyNewHint': "تخطي الأنشطة التي وجدتها عمليات التشغيل السابقة لهذا البحث.",
  'leadFinder.rerun.start': "تشغيل مرة أخرى",
  'leadFinder.rerun.started': "يتم تشغيل البحث مرة أخرى.",
  'leadFinder.duplicate.action': "نسخ",
  'leadFinder.form.duplicateTitle': "بحث جديد من نسخة",
  'leadFinder.form.phoneType': "يجب أن يكون الهاتف",
  'leadFinder.phoneType.any': "جوال أو أرضي",
  'leadFinder.phoneType.mobile': "جوال",
  'leadFinder.phoneType.landline': "أرضي",
  'leadFinder.filter.hasMobile': "لديه جوال",
  'leadFinder.stat.previous': "وُجدت سابقاً",
  'leadFinder.act.toList': "إضافة إلى قائمة",
  'leadFinder.act.list': "قائمة",
  'leadFinder.result.inLists': "في {{count}} قائمة",
  'leadFinder.addList.title': "إضافة {{count}} إلى قائمة",
  'leadFinder.addList.locked': "قوائم البيانات غير متاحة في باقتك.",
  'leadFinder.addList.existing': "قائمة موجودة",
  'leadFinder.addList.new': "قائمة جديدة",
  'leadFinder.addList.namePlaceholder': "اسم القائمة — مثال: مقاهي الرياض",
  'leadFinder.addList.kind.static': "قائمة ثابتة",
  'leadFinder.addList.kind.contacts': "قائمة جهات اتصال",
  'leadFinder.addList.staticHint': "صف لكل نشاط بالاسم والهاتف والجوال والبريد والموقع والعنوان والمدينة والتصنيف والتقييم وروابط التواصل والخريطة.",
  'leadFinder.addList.contactsHint': "يصبح كل نشاط جهة اتصال (أو يستخدم جهة الاتصال الموجودة) وينضم إلى القائمة.",
  'leadFinder.addList.mapping': "املأ كل عمود بـ",
  'leadFinder.addList.skip': "اتركه فارغاً",
  'leadFinder.addList.add': "إضافة إلى القائمة",
  'leadFinder.addList.done': "تمت إضافة {{count}} إلى \"{{name}}\".",
  'leadFinder.addList.failed': "فشل {{count}}",
  'leadFinder.listField.name': "الاسم",
  'leadFinder.listField.phone': "الهاتف",
  'leadFinder.listField.mobile': "الجوال",
  'leadFinder.listField.landline': "الأرضي",
  'leadFinder.listField.email': "البريد",
  'leadFinder.listField.website': "الموقع",
  'leadFinder.listField.address': "العنوان",
  'leadFinder.listField.city': "المدينة",
  'leadFinder.listField.country': "الدولة",
  'leadFinder.listField.category': "التصنيف",
  'leadFinder.listField.description': "الوصف",
  'leadFinder.listField.rating': "التقييم",
  'leadFinder.listField.reviews': "المراجعات",
  'leadFinder.listField.socials': "روابط التواصل",
  'leadFinder.listField.mapLink': "رابط الخريطة",
  'leadFinder.listField.aiScore': "تقييم الملاءمة",
  'leadFinder.listField.source': "المصدر",
  'contacts.bulkList.createFailed': "تعذر إنشاء القائمة.",
  'contacts.bulkList.locked': "قوائم البيانات غير متاحة في باقتك — قم بالترقية لتجميع جهات الاتصال في قوائم.",
  'contacts.bulkList.upgrade': "عرض الباقات",
  'contacts.bulkList.newPlaceholder': "اسم القائمة الجديدة",
  'contacts.bulkList.create': "إنشاء",
  'contacts.bulkList.empty': "لا توجد قوائم جهات اتصال بعد — اكتب اسماً بالأعلى لإنشائها.",
  'leadFinder.title': "باحث العملاء",
  'leadFinder.shortcut': "اعثر على أنشطة تجارية للتواصل معها بالذكاء الاصطناعي",
  'leadFinder.refresh': "تحديث",
  'leadFinder.subtitle.one': "بحث واحد",
  'leadFinder.subtitle.count': "{{count}} عمليات بحث",
  'leadFinder.started': "بدأ البحث \"{{name}}\" — تظهر النتائج فور العثور عليها.",
  'leadFinder.error.load': "تعذر تحميل باحث العملاء.",
  'leadFinder.error.start': "تعذر بدء البحث.",
  'leadFinder.error.plan': "لم يتمكن الذكاء الاصطناعي من إعداد البحث. جرّب وصفاً مختلفاً.",
  'leadFinder.error.act': "تعذر تحديث النتائج.",
  'leadFinder.error.export': "تعذر تصدير النتائج.",
  'leadFinder.locked.title': "باحث العملاء غير متاح في باقتك",
  'leadFinder.locked.message': "ابحث عن الأنشطة التجارية حسب المنطقة والتصنيف والمنصة، ثم أضفها كجهات اتصال أو موردين. قم بالترقية لاستخدامه.",
  'leadFinder.locked.upgrade': "عرض الباقات",
  'leadFinder.ai.title': "صِف من تبحث عنه",
  'leadFinder.ai.hint': "صف الجهات أو الأفراد والمعلومات المطلوبة. يحول الذكاء الاصطناعي طلبك إلى فلاتر تراجعها قبل البحث.",
  'leadFinder.ai.placeholder': "مثال: مقاهي في الرياض لديها رقم هاتف وحساب إنستغرام",
  'leadFinder.ai.run': "ابحث بالذكاء الاصطناعي",
  'leadFinder.ai.plan': "راجع الإعدادات أولاً",
  'leadFinder.form.manual': "أو أعدّه بنفسك",
  'leadFinder.form.title': "بحث جديد",
  'leadFinder.form.reviewTitle': "راجع بحث الذكاء الاصطناعي",
  'leadFinder.form.name': "الاسم",
  'leadFinder.form.namePlaceholder': "مثال: مقاهي الرياض",
  'leadFinder.form.keywords': "الكلمات المفتاحية",
  'leadFinder.form.keywordsPlaceholder': "افصل بينها بفاصلة، بأي لغة — مثال: قهوة، coffee",
  'leadFinder.form.categories': "تصنيفات الخريطة",
  'leadFinder.form.categoriesPlaceholder': "ابحث في التصنيفات — مثال: restaurant، clinic",
  'leadFinder.form.region': "المنطقة",
  'leadFinder.form.regionPick': "اختر من الخريطة",
  'leadFinder.form.regionChange': "تغيير المنطقة",
  'leadFinder.form.regionPicked': "المنطقة المحددة",
  'leadFinder.form.sources': "ابحث في",
  'leadFinder.form.notInPlan': "غير متاح في الباقة",
  'leadFinder.form.links': "الروابط",
  'leadFinder.form.linksPlaceholder': "رابط في كل سطر — مواقع، صفحات فيسبوك / إنستغرام، أماكن خرائط جوجل",
  'leadFinder.form.required': "يجب أن تحتوي كل نتيجة على",
  'leadFinder.form.platforms': "المنصات المطلوبة",
  'leadFinder.form.platformsHint': "تُفضَّل النتائج الموجودة على هذه المنصات (بدون اختيار = أي منصة).",
  'leadFinder.form.enrich': "قراءة مواقعهم",
  'leadFinder.form.enrichHint': "يكمل الهواتف والبريد وصفحات التواصل والوصف الناقصة من موقع كل نشاط.",
  'leadFinder.form.limit': "الحد الأقصى للنتائج",
  'leadFinder.form.start': "ابدأ البحث",
  'leadFinder.map.title': "منطقة البحث",
  'leadFinder.map.confirm': "استخدم هذه المنطقة",
  'leadFinder.map.name': "اسم المنطقة",
  'leadFinder.usage.title': "هذا الشهر",
  'leadFinder.usage.runsLabel': "عمليات البحث",
  'leadFinder.usage.resultsLabel': "النتائج",
  'leadFinder.usage.runs': "{{used}} من {{limit}} عمليات بحث",
  'leadFinder.usage.runsUnlimited': "{{used}} عمليات بحث",
  'leadFinder.usage.results': "{{used}} من {{limit}} نتيجة",
  'leadFinder.usage.resultsUnlimited': "{{used}} نتيجة",
  'leadFinder.usage.perRun': "حتى {{limit}} نتيجة لكل بحث",
  'leadFinder.usage.noGoogle': "البحث في خرائط جوجل غير متاح في باقتك — يتم البحث في خريطة ديسلكس والمواقع والروابط.",
  'leadFinder.runs.title': "عمليات البحث",
  'leadFinder.runs.empty': "لا توجد عمليات بحث بعد. صِف من تبحث عنه بالأعلى.",
  'leadFinder.origin.workflow': "من سير عمل",
  'leadFinder.status.queued': "بانتظار البدء",
  'leadFinder.status.running': "جارٍ",
  'leadFinder.status.done': "اكتمل",
  'leadFinder.status.partial': "لم يكتمل العدد المطلوب",
  'leadFinder.run.shortfall': "تم العثور على {{count}} من أصل {{target}} نشاطًا مطلوبًا. راجع ملاحظات المصادر أدناه، ثم عدّل البحث أو أضف مصادر وأعد المحاولة.",
  'leadFinder.status.failed': "فشل",
  'leadFinder.status.cancelled': "متوقف",
  'leadFinder.phase.sources': "جارٍ البدء…",
  'leadFinder.phase.links': "قراءة روابطك…",
  'leadFinder.phase.map': "البحث في خريطة ديسلكس…",
  'leadFinder.phase.google_maps': "البحث في خرائط جوجل…",
  'leadFinder.phase.enrich': "قراءة المواقع لاستخراج بيانات التواصل…",
  'leadFinder.phase.checking': "المقارنة مع جهات اتصالك ومورديك…",
  'leadFinder.phase.scoring': "الذكاء الاصطناعي يقيّم كل نتيجة…",
  'leadFinder.progress': "{{kept}} محفوظة · {{found}} تم العثور عليها · {{duplicates}} مكررة · {{existing}} موجودة لديك",
  'leadFinder.stat.kept': "مطابقات الذكاء الاصطناعي",
  'leadFinder.stat.found': "تم العثور عليها",
  'leadFinder.stat.duplicates': "مكررة",
  'leadFinder.stat.rejected': "نتائج أخرى",
  'leadFinder.view.matches': "مطابقات الذكاء الاصطناعي",
  'leadFinder.view.other': "نتائج أخرى",
  'leadFinder.view.otherHint': "نتائج وُجدت واستُبعدت بأحد الفحوص (السبب ظاهر). احتفظ بأي منها لتصبح مطابقة بكامل بياناتها — وتُحتسب حينها من نتائج هذا الشهر.",
  'leadFinder.act.keep': "احتفاظ",
  'leadFinder.act.done.keep': "تم الاحتفاظ بـ {{count}} كمطابقات.",
  'leadFinder.rejection.outside_area': 'خارج المنطقة',
  'leadFinder.rejection.missing_contact': 'لا يوجد هاتف أو موقع صالح',
  'leadFinder.suggestions.title': 'عمليات بحث مقترحة لنشاطك',
  'leadFinder.suggestions.hint': 'نقترح عملاء أو شركاء مناسبين بناءً على ملف نشاطك وشخصية المساعد. راجع الطلب والفلاتر قبل بدء البحث.',
  'leadFinder.suggestions.loading': 'جارٍ مراجعة نشاطك وإعداد الاقتراحات…',
  'leadFinder.suggestions.failed': 'تعذر إعداد الاقتراحات. أعد المحاولة أو اكتب طلب البحث بالأسفل.',
  'leadFinder.suggestions.review': 'مراجعة هذا البحث',
  'leadFinder.suggestions.refresh': 'تحديث الاقتراحات',
  'leadFinder.suggestions.source.business_profile': 'ملف النشاط',
  'leadFinder.suggestions.source.business_settings': 'إعدادات النشاط',
  'leadFinder.suggestions.source.ai_knowledge': 'معرفة المساعد بالنشاط',
  'leadFinder.suggestions.source.ai_persona': 'شخصية المساعد',
  'leadFinder.suggestions.source.products': 'المنتجات والخدمات',
  'leadFinder.rejection.outside_area_or_missing_details': 'خارج المنطقة أو بيانات تواصل ناقصة',
  'leadFinder.rejection.missing_details': 'بيانات مطلوبة ناقصة',
  'leadFinder.rejection.excluded': 'نشاط مستبعد',
  'leadFinder.rejection.wrong_type': 'نوع النتيجة غير مطابق',
  'leadFinder.rejection.topic_unverified': 'المهنة أو النشاط غير موثّق',
  'leadFinder.rejection.ai_mismatch': 'غير مطابق للطلب',
  'leadFinder.rejection.type_unverified': 'لم يتم التحقق من كونه فردًا أو مؤسسة',
  'leadFinder.rejection.missing_requested_fields': 'حقول مخصصة مطلوبة غير موثّقة',
  'leadFinder.rejection.below_min_score': 'أقل من الحد الأدنى للتقييم',
  'leadFinder.stat.enriched': "من المواقع",
  'leadFinder.stat.existing': "موجودة لديك",
  'leadFinder.source.map': "خريطة ديسلكس",
  'leadFinder.source.google_maps': "خرائط جوجل",
  'leadFinder.source.links': "الروابط",
  'leadFinder.source.web': "الويب (الحسابات والمواقع)",
  'leadFinder.phase.web': "البحث في الويب…",
  'leadFinder.usage.noWeb': "البحث في الويب (لينكدإن والحسابات العامة الأخرى ومواقع الشركات) غير متاح في باقتك.",
  'leadFinder.opener.title': "رسالة افتتاحية مقترحة",
  'leadFinder.opener.copy': "نسخ الرسالة الافتتاحية المقترحة",
  'leadFinder.opener.copied': "تم النسخ — الصقها في رسالتك.",
  'leadFinder.field.name': "الاسم",
  'leadFinder.field.phone': "الهاتف",
  'leadFinder.field.location': "الموقع",
  'leadFinder.field.email': "البريد الإلكتروني",
  'leadFinder.field.website': "الموقع الإلكتروني",
  'leadFinder.field.description': "الوصف",
  'leadFinder.platform.website': "موقع إلكتروني",
  'leadFinder.platform.google': "جوجل",
  'leadFinder.platform.facebook': "فيسبوك",
  'leadFinder.platform.instagram': "إنستغرام",
  'leadFinder.platform.linkedin': "لينكدإن",
  'leadFinder.platform.x': "إكس",
  'leadFinder.platform.tiktok': "تيك توك",
  'leadFinder.platform.youtube': "يوتيوب",
  'leadFinder.platform.snapchat': "سناب شات",
  'leadFinder.platform.whatsapp': "واتساب",
  'leadFinder.tab.new': "للمراجعة",
  'leadFinder.tab.contact': "جهات اتصال",
  'leadFinder.tab.vendor': "موردون",
  'leadFinder.tab.dismissed': "مستبعدة",
  'leadFinder.tab.all': "الكل",
  'leadFinder.results.search': "ابحث بالاسم أو التصنيف أو المدينة أو الهاتف",
  'leadFinder.results.selectAll': "تحديد الكل",
  'leadFinder.results.count': "{{count}} نتيجة",
  'leadFinder.results.selected': "تم تحديد {{count}}",
  'leadFinder.results.waiting': "جارٍ البحث — تظهر النتائج هنا فور العثور عليها.",
  'leadFinder.results.empty': "لا توجد نتائج هنا.",
  'leadFinder.filter.hasPhone': "لديه هاتف",
  'leadFinder.filter.hasEmail': "لديه بريد",
  'leadFinder.filter.hasWebsite': "لديه موقع",
  'leadFinder.filter.notExisting': "ليس جهة اتصال بعد",
  'leadFinder.filter.goodFit': "مناسب (تقييم 70+)",
  'leadFinder.target.any': 'جهات وأفراد',
  'leadFinder.target.entity': 'جهات / منشآت',
  'leadFinder.target.individual': 'أفراد مهنيون',
  'leadFinder.criteria.target': 'عمّن تبحث؟',
  'leadFinder.criteria.purpose': 'هدف البحث ومعايير التقييم',
  'leadFinder.criteria.professions': 'مهن / أنشطة محددة (افصل بفاصلة)',
  'leadFinder.criteria.professionsPlaceholder': 'مثال: مدرب حياة، life coach',
  'leadFinder.criteria.exclude': 'كلمات أو أنشطة مستبعدة (افصل بفاصلة)',
  'leadFinder.criteria.minimum': 'الحد الأدنى للملاءمة (0–100)',
  'leadFinder.criteria.useAi': 'تقييم الملاءمة واستخراج الحقول بالذكاء الاصطناعي',
  'leadFinder.criteria.evaluationHint': 'يتم التحقق من الملاءمة قبل احتساب النتيجة. تُستخدم قواعد المطابقة عندما يتعذر تقييم النتيجة بالذكاء الاصطناعي.',
  'leadFinder.criteria.noAi': 'الذكاء الاصطناعي غير متصل. حدد الفلاتر أدناه لتقييم النتائج بالأدلة المنشورة وقواعد المطابقة.',
  'leadFinder.criteria.individualHint': 'يعتمد البحث على الصفحات المهنية العامة. تحتوي الخرائط أساساً على أماكن؛ أضف روابط الصفحات العامة للأفراد غير المدرجين. لن يتم احتساب الأشخاص دون دليل على نوعهم ومهنتهم.',
  'leadFinder.criteria.fields': 'حقول مطلوبة لهذا البحث',
  'leadFinder.criteria.fieldsHint': 'اختر أسماء الحقول. تُحفظ القيم المتاحة كحقول مخصصة للجهة وأعمدة للقائمة. تبقى القيم المجهولة فارغة، والحقول المطلوبة تحتاج إلى دليل منشور.',
  'leadFinder.criteria.fieldPlaceholder': 'مثال: التخصص، اللغات، سنوات الخبرة',
  'leadFinder.criteria.addField': 'إضافة حقل',
  'leadFinder.criteria.remove': 'إزالة',
  'leadFinder.criteria.required': 'اشتراط وجود قيمة منشورة',
  'leadFinder.criteria.expected': 'قيمة اختيارية للمطابقة (نعم/لا للحقل المنطقي)',
  'leadFinder.criteria.type.text': 'نص',
  'leadFinder.criteria.type.number': 'رقم',
  'leadFinder.criteria.type.boolean': 'نعم / لا',
  'leadFinder.criteria.scoreRange': 'نطاق درجة الملاءمة (0–100)',
  'leadFinder.criteria.min': 'الحد الأدنى',
  'leadFinder.criteria.max': 'الحد الأقصى',
  'leadFinder.criteria.filterValue': 'القيمة المطابقة للحقل',
  'leadFinder.criteria.method.ai': 'تقييم بالذكاء الاصطناعي',
  'leadFinder.criteria.method.rules': 'تقييم بقواعد المطابقة',
  'leadFinder.listField.profession': 'المهنة',
  'leadFinder.listField.entityType': 'نوع الجهة',
  'leadFinder.sort.title': "الترتيب:",
  'leadFinder.sort.score': "الأنسب",
  'leadFinder.sort.rating': "التقييم",
  'leadFinder.sort.name': "الاسم",
  'leadFinder.result.new': "للمراجعة",
  'leadFinder.result.contact': "جهة اتصال",
  'leadFinder.result.vendor': "مورد",
  'leadFinder.result.dismissed': "مستبعدة",
  'leadFinder.result.platformMatch': 'على منصة مطلوبة',
  'leadFinder.result.existingContact': "جهة اتصال موجودة",
  'leadFinder.result.existingVendor': "مورد موجود",
  'leadFinder.act.contact': "إضافة جهة اتصال",
  'leadFinder.act.linkContact': "استخدام جهة الاتصال الموجودة",
  'leadFinder.act.vendor': "إضافة مورد",
  'leadFinder.act.restore': "استعادة",
  'leadFinder.act.message': "مراسلة",
  'leadFinder.act.openVendors': "فتح الموردين",
  'leadFinder.act.contacts': "إضافة كجهات اتصال",
  'leadFinder.act.vendors': "إضافة كموردين",
  'leadFinder.act.dismiss': "استبعاد",
  'leadFinder.act.done.contact': "تمت إضافة {{count}} كجهات اتصال.",
  'leadFinder.act.done.vendor': "تمت إضافة {{count}} كموردين.",
  'leadFinder.act.done.dismiss': "تم استبعاد {{count}}.",
  'leadFinder.act.done.restore': "تمت استعادة {{count}}.",
  'leadFinder.act.partial': "تم {{done}}، وفشل {{failed}}",
  'leadFinder.assign.title': "إضافة {{count}} كجهات اتصال",
  'leadFinder.assign.hint': "أسندها إلى أحد أعضاء الفريق للمتابعة، أو أضفها فقط.",
  'leadFinder.assign.nobody': "أضفها فقط (بدون إسناد)",
  'leadFinder.run.cancel': "إيقاف البحث",
  'leadFinder.run.cancelTitle': "إيقاف هذا البحث؟",
  'leadFinder.run.cancelMessage': "سيتم الاحتفاظ بما تم العثور عليه حتى الآن.",
  'leadFinder.run.cancelled': "جارٍ إيقاف البحث.",
  'leadFinder.run.stopping': "جارٍ الإيقاف…",
  'leadFinder.run.export': "تصدير CSV",
  'leadFinder.run.exportWebOnly': "التصدير متاح على تطبيق الويب.",
  'dataLists.title': 'قوائم البيانات',
  'dataLists.subtitle.count': '{{count}} قائمة',
  'dataLists.subtitle.countOne': 'قائمة واحدة',
  'dataLists.searchPlaceholder': 'ابحث في القوائم...',
  'dataLists.create': 'إنشاء قائمة',
  'dataLists.empty.title': 'لا توجد قوائم بيانات بعد',
  'dataLists.empty.message': 'أنشئ أول قائمة لك لبدء جمع سجلات منظمة.',
  'dataLists.loading': 'جارٍ تحميل القوائم...',
  'dataLists.error.loadTitle': 'تعذّر تحميل القوائم',
  'dataLists.error.loadFailed': 'فشل تحميل قوائم البيانات',
  'dataLists.card.columns': '{{count}} أعمدة',
  'dataLists.card.columnsOne': 'عمود واحد',
  'dataLists.card.hasRecords': 'تحتوي على سجلات',
  'dataLists.card.noRecords': 'فارغة',
  'dataLists.actions.edit': 'تعديل البنية',
  'dataLists.actions.records': 'السجلات',
  'dataLists.actions.delete': 'حذف',
  'dataLists.delete.title': 'حذف القائمة',
  'dataLists.delete.message': 'هل أنت متأكد من حذف "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
  'dataLists.delete.confirm': 'حذف',
  'dataLists.delete.cancel': 'إلغاء',
  'dataLists.delete.success': 'تم حذف القائمة بنجاح',
  'dataLists.delete.failed': 'فشل حذف القائمة',
  'dataLists.notifications.errorTitle': 'خطأ',
  'dataLists.notifications.successTitle': 'نجاح',

  // شاشة البنية
  'dataLists.schema.createTitle': 'إنشاء قائمة',
  'dataLists.schema.editTitle': 'تعديل القائمة',
  'dataLists.schema.nameLabel': 'الاسم',
  'dataLists.schema.namePlaceholder': 'مثال: تذاكر الدعم',
  'dataLists.schema.descriptionLabel': 'الوصف (اختياري)',
  'dataLists.schema.descriptionPlaceholder': 'ما الغرض من هذه القائمة؟',
  'dataLists.schema.aiMeaningLabel': 'الذكاء الاصطناعي يفهم هذه القائمة',
  'dataLists.schema.aiMeaningHint': 'يجد المساعد الذكي السجلات حسب معناها وبأي لغة، وليس فقط بالكلمات المطابقة. فعّلها للقوائم التي تسأل عنها كثيرًا (مثل الخدمات أو الغرف أو الموديلات). حقول الهاتف والبريد لا تُرسل للذكاء الاصطناعي أبدًا.',
  'dataLists.schema.aiMeaningFailed': 'تعذّر تفعيل فهم الذكاء الاصطناعي لهذه القائمة.',
  'dataLists.schema.columnsSection': 'الأعمدة',
  'dataLists.schema.addColumn': 'إضافة عمود',
  'dataLists.schema.repeaterFieldsHint': 'حدد الحقول التي سيحتوي عليها كل صف في هذه القائمة',
  'dataLists.schema.repeaterFieldNamePlaceholder': 'اسم الحقل',
  'dataLists.schema.addRepeaterField': 'إضافة حقل',
  'dataLists.schema.columnName': 'اسم العمود',
  'dataLists.schema.columnNamePlaceholder': 'مثال: الاسم الكامل',
  'dataLists.schema.columnType': 'النوع',
  'dataLists.schema.typeLocked': 'النوع مقفل لأن هذه القائمة تحتوي على سجلات بالفعل.',
  'dataLists.schema.nullable': 'يقبل الفراغ',
  'dataLists.schema.notNullable': 'غير فارغ',
  'dataLists.schema.required': 'مطلوب',
  'dataLists.schema.unique': 'فريد',
  'dataLists.schema.advanced': 'خيارات متقدمة',
  'dataLists.schema.dateOnly': 'تاريخ فقط',
  'dataLists.schema.dateTime': 'تاريخ ووقت',
  'dataLists.schema.relationMultiple': 'علاقة متعددة (عدة سجلات)',
  'dataLists.schema.min': 'الحد الأدنى',
  'dataLists.schema.max': 'الحد الأقصى',
  'dataLists.schema.enum': 'القيم المسموح بها (مفصولة بفواصل)',
  'dataLists.schema.enumPlaceholder': 'أحمر، أخضر، أزرق',
  'dataLists.schema.regex': 'نمط التعبير النمطي',
  'dataLists.schema.regexPlaceholder': '^[A-Z]{3}$',
  'dataLists.schema.relationTarget': 'القائمة المرتبطة',
  'dataLists.schema.relationTargetPlaceholder': 'اختر قائمة',
  'dataLists.schema.onDelete': 'عند الحذف',
  'dataLists.schema.onDelete.cascade': 'حذف متتالٍ',
  'dataLists.schema.onDelete.setNull': 'تعيين فارغ',
  'dataLists.schema.onDelete.restrict': 'منع',
  'dataLists.schema.moveUp': 'تحريك لأعلى',
  'dataLists.schema.moveDown': 'تحريك لأسفل',
  'dataLists.schema.removeColumn': 'إزالة العمود',
  'dataLists.schema.assignedSection': 'مُسنَد إلى',
  'dataLists.schema.assignedHint': 'المستخدمون أو الأقسام المُسنَدون فقط (بالإضافة إلى المسؤولين) يمكنهم إدارة السجلات يدويًا. اتركه فارغًا ليتاح للجميع.',
  'dataLists.schema.assignUsers': 'المستخدمون',
  'dataLists.schema.assignDepartments': 'الأقسام',
  'dataLists.schema.selectUsers': 'اختر المستخدمين',
  'dataLists.schema.selectDepartments': 'اختر الأقسام',
  'dataLists.schema.usersSelected': 'تم اختيار {{count}}',
  'dataLists.schema.save': 'حفظ القائمة',
  'dataLists.schema.creating': 'جارٍ الإنشاء...',
  'dataLists.schema.saving': 'جارٍ الحفظ...',
  'dataLists.schema.validation.nameRequired': 'اسم القائمة مطلوب',
  'dataLists.schema.validation.columnRequired': 'أضف عمودًا واحدًا على الأقل',
  'dataLists.schema.validation.columnNameRequired': 'كل عمود يحتاج إلى اسم',
  'dataLists.schema.validation.relationTargetRequired': 'أعمدة العلاقة تحتاج إلى قائمة مستهدفة',
  'dataLists.schema.createSuccess': 'تم إنشاء القائمة بنجاح',
  'dataLists.schema.updateSuccess': 'تم تحديث القائمة بنجاح',
  'dataLists.schema.saveFailed': 'فشل حفظ القائمة',
  'dataLists.schema.loadFailed': 'فشل تحميل القائمة',
  'dataLists.schema.validation.systemModuleRequired': 'اختر وحدة نظام',
  'dataLists.schema.validation.webhookUrlRequired': 'رابط الويب هوك مطلوب',
  'dataLists.schema.validation.fieldMappingRequired': 'قم بربط حقل واحد على الأقل',

  // اختيار نوع القائمة (نظام / ويب هوك / مخصص / نظام+ويب هوك)
  'dataLists.schema.tabs.basic': 'أساسي',
  'dataLists.schema.tabs.fields': 'الحقول',
  'dataLists.schema.tabs.webhook': 'ويب هوك',
  'dataLists.schema.tabs.access': 'الصلاحيات',
  'dataLists.schema.shapeSection': 'نوع القائمة',
  'dataLists.schema.shapeLocked': 'لا يمكن تغيير نوع القائمة بعد الإنشاء.',
  'dataLists.schema.columnsSourceLabel': 'الأعمدة',
  'dataLists.schema.columnsSource.custom': 'أعمدة مخصصة',
  'dataLists.schema.columnsSource.system': 'وحدة نظام',
  'dataLists.schema.dataSourceLabel': 'البيانات',
  'dataLists.schema.dataSource.manual': 'إدخال يدوي',
  'dataLists.schema.dataSource.webhook': 'ويب هوك مباشر',
  'dataLists.schema.systemModuleLabel': 'الوحدة',
  'dataLists.schema.systemModule.contacts': 'جهات الاتصال',
  'dataLists.schema.systemModule.products': 'المنتجات',
  'dataLists.schema.systemModule.catalog': 'الكتالوج',
  'dataLists.schema.systemModule.calendar': 'التقويم',
  'dataLists.schema.systemModule.orders': 'الطلبات',
  'dataLists.schema.systemModuleColumnsHint': 'ستعرض هذه القائمة {{count}} عمود ثابت من الوحدة — قم بتنزيل نموذج لتعبئتها بالجملة.',
  'dataLists.schema.resyncColumns': 'تحديث الأعمدة من الوحدة',
  'dataLists.schema.resyncColumnsSuccess': 'تم تحديث الأعمدة من الوحدة',
  'dataLists.schema.resyncColumnsFailed': 'فشل تحديث الأعمدة',
  'dataLists.schema.customColumnsSection': 'حقول مخصصة',
  'dataLists.schema.customColumnsHint': 'حقول إضافية بجانب أعمدة الوحدة نفسها أعلاه — هذه فقط هي التي يمكن إضافتها أو تعديلها أو حذفها هنا.',
  'httpRequestBuilder.urlLabel': 'الرابط',
  'httpRequestBuilder.headersLabel': 'الترويسات (Headers)',
  'httpRequestBuilder.noHeaders': 'لا توجد ترويسات مخصصة.',
  'httpRequestBuilder.headerKeyPlaceholder': 'اسم الترويسة (مثال: User-Agent)',
  'httpRequestBuilder.headerValuePlaceholder': 'القيمة',
  'httpRequestBuilder.addHeader': 'إضافة ترويسة',
  'httpRequestBuilder.bodyTemplateLabel': 'محتوى الطلب (JSON، اختياري)',
  'httpRequestBuilder.bodyTemplatePlaceholder': '{ "key": "value" }',
  'httpRequestBuilder.responseRootPathLabel': 'مسار المصفوفة في الاستجابة (اختياري)',
  'dataLists.schema.webhook.title': 'إعدادات الويب هوك',
  'dataLists.schema.webhook.urlLabel': 'رابط الويب هوك',
  'dataLists.schema.webhook.responseRootPathLabel': 'مسار المصفوفة في الاستجابة (اختياري)',
  'dataLists.schema.webhook.test': 'اختبار الويب هوك',
  'dataLists.schema.webhook.testing': 'جارٍ الاختبار...',
  'dataLists.schema.webhook.testSuccess': 'استجاب الويب هوك بنجاح',
  'dataLists.schema.webhook.testFailed': 'فشل الوصول إلى الويب هوك',
  'dataLists.schema.webhook.mappingSection': 'ربط الحقول',
  'dataLists.schema.webhook.mappingHint': 'اربط كل عمود بمسار الحقل في استجابة الويب هوك.',
  'dataLists.schema.webhook.sourcePathPlaceholder': 'مثال: customer.email',
  'dataLists.schema.webhook.externalId': 'استخدام كمعرّف خارجي',
  'dataLists.schema.webhook.productSkuField': 'استخدام كرمز المنتج (SKU)',
  'dataLists.schema.webhook.contactIdField': 'استخدام كمعرّف جهة الاتصال',
  'dataLists.schema.webhook.contactIdentifierField': 'استخدام كمعرّف تعريفي لجهة الاتصال',
  'dataLists.schema.webhook.sampleHint': 'تم استلام {{count}} صف تجريبي من آخر اختبار.',
  'dataLists.schema.webhook.mapperNeedsSample': 'اختبر الويب هوك لاكتشاف مسارات الحقول تلقائيًا، أو اربط الأعمدة يدويًا أدناه.',
  'dataLists.schema.webhook.mode.field': 'حقل',
  'dataLists.schema.webhook.mode.fixed': 'ثابت',
  'dataLists.schema.webhook.mode.expression': 'تعبير',
  'dataLists.schema.webhook.fixedValuePlaceholder': 'نفس القيمة لكل صف',
  'dataLists.schema.webhook.expressionPlaceholder': 'مثال: {{firstName}} {{lastName}}',
  'dataLists.schema.webhook.expressionHint': 'ادمج الحقول باستخدام {{fieldPath}} — يبقى أي نص خارج الأقواس كما هو.',
  'dataLists.schema.webhook.notConnected': 'غير مرتبط — اسحب حقلاً هنا أو اضغط لكتابة مسار',
  'dataLists.schema.webhook.connectedTo': 'مرتبط بـ {{path}}',
  'dataLists.schema.webhook.sourceFieldsTitle': 'حقول الويب هوك',
  'dataLists.schema.webhook.targetColumnsTitle': 'أعمدة القائمة',
  'dataLists.schema.webhook.dragHint': 'اسحب خطًا من حقل على اليسار إلى عمود على اليمين.',
  'dataLists.schema.webhook.selectFieldPlaceholder': 'ابحث عن حقل أو اختره…',
  'dataLists.schema.webhook.typeManually': 'اكتب المسار يدويًا بدلاً من ذلك',
  'dataLists.schema.webhook.noFieldsDetected': 'لم يتم اكتشاف أي حقول بعد — اختبر الويب هوك أولاً، أو اكتب مسارًا يدويًا.',
  'dataLists.schema.webhook.itemsMappingSection': 'تعيين العناصر (طلبات / عروض أسعار متعددة العناصر)',
  'dataLists.schema.webhook.itemsMappingHint': 'قم بتهيئة هذا إذا كان كل صف من الويب هوك يمثل طلبًا أو عرض سعر واحدًا يحتوي على عناصر متعددة متداخلة بداخله. اترك مسار المصفوفة فارغًا للاستمرار في استخدام حقل رمز المنتج الفردي أعلاه. لا يوجد منتج افتراضي/احتياطي — أي صف لا يتطابق مع رمز منتج حقيقي سيفشل.',
  'dataLists.schema.webhook.itemsMappingArrayBadge': 'مصفوفة واحدة — الحقول أدناه تُقرأ من كل عنصر بداخلها',
  'dataLists.schema.webhook.itemsMappingSubFieldsHint': 'كل حقل أدناه هو مسار داخل عنصر واحد من المصفوفة أعلاه، وليس تعيينًا منفصلاً.',
  'dataLists.schema.webhook.itemsArrayPathLabel': 'مسار مصفوفة العناصر',
  'dataLists.schema.webhook.itemsQuantityPathLabel': 'حقل الكمية (داخل كل عنصر)',
  'dataLists.schema.webhook.itemsSkuPathLabel': 'حقل رمز المنتج (داخل كل عنصر)',
  'dataLists.schema.webhook.itemsNamePathLabel': 'حقل الاسم (داخل كل عنصر، احتياطي)',
  'dataLists.schema.webhook.itemsPricePathLabel': 'حقل السعر (داخل كل عنصر، احتياطي)',
  'dataLists.schema.webhook.relationsSection': 'العلاقات',
  'dataLists.schema.webhook.relationsHint': 'الحقل الذي سيتم البحث فيه ضمن المنتجات/جهات الاتصال عند تحليل عناصر وعميل هذه القائمة. تظهر فقط الحقول المعلّمة "فريدة" — أضف حقلاً مخصصًا فريدًا على قائمة بيانات تلك الوحدة إذا كان النظام الخارجي يستخدم معرّفًا لا يملك DISLIX حقلاً ثابتًا له (مثل "معرّف المنتج الخارجي").',
  'dataLists.schema.webhook.relationProductsLabel': 'البحث في المنتجات باستخدام',
  'dataLists.schema.webhook.relationContactsLabel': 'البحث في جهات الاتصال باستخدام',
  'dataLists.schema.webhook.relationDefaultPlaceholder': 'الافتراضي ({{field}})',
  'dataLists.schema.webhook.syncSection': 'المزامنة الدورية',
  'dataLists.schema.webhook.triggerOutboundWebhooksLabel': 'إعلام ويب هوكس الوصول للمطورين عند المزامنة',
  'dataLists.schema.webhook.triggerOutboundWebhooksHint': 'معطّل افتراضيًا. عند إنشاء أو تحديث سجل من خلال المزامنة، يمكن أن يؤدي ذلك أيضًا إلى تشغيل الويب هوك الصادر الخاص بمنشأتك (الإعدادات > الوصول للمطورين) لنفس الحدث — مثل product.updated. اترك هذا الخيار معطّلاً إذا كان النظام الخارجي نفسه هو مصدر هذه المزامنة ومستقبل ذلك الويب هوك أيضًا، لأن ذلك قد يسبب حلقة تكرار أو إغراقه برسالة لكل سجل تتم مزامنته. فعّل هذا الخيار فقط إذا كان نظام مختلف يحتاج لمعرفة هذه التغييرات الناتجة عن المزامنة.',
  'schedulePicker.enable': 'التشغيل حسب جدول زمني',
  'schedulePicker.type.minutes': 'دقائق',
  'schedulePicker.type.hours': 'ساعات',
  'schedulePicker.type.daily': 'يوميًا',
  'schedulePicker.type.weekly': 'أسبوعيًا',
  'schedulePicker.type.monthly': 'شهريًا',
  'schedulePicker.type.quarterly': 'ربع سنوي',
  'schedulePicker.type.yearly': 'سنويًا',
  'schedulePicker.everyMinutesLabel': 'كل N دقيقة',
  'schedulePicker.everyHoursLabel': 'كل N ساعة',
  'schedulePicker.hourLabel': 'الساعة (0-23)',
  'schedulePicker.minuteLabel': 'الدقيقة (0-59)',
  'schedulePicker.timeLabel': 'الوقت',
  'schedulePicker.timezoneLabel': 'المنطقة الزمنية',
  'schedulePicker.dayOfMonthLabel': 'يوم الشهر (1-28)',
  'schedulePicker.quarterlyHint': 'يعمل في {{months}}.',
  'schedulePicker.summary.minutes': 'يعمل كل {{n}} دقيقة',
  'schedulePicker.summary.hours': 'يعمل كل {{n}} ساعة',
  'schedulePicker.summary.daily': 'يعمل يوميًا في {{time}} {{tz}}',
  'schedulePicker.summary.weekly': 'يعمل أيام {{days}} في {{time}} {{tz}}',
  'schedulePicker.summary.monthly': 'يعمل في اليوم {{day}} من كل شهر في {{time}} {{tz}}',
  'schedulePicker.summary.quarterly': 'يعمل في اليوم {{day}} من {{months}} في {{time}} {{tz}}',
  'schedulePicker.summary.yearly': 'يعمل في {{month}} {{day}} في {{time}} {{tz}}',
  'dataLists.schema.webhook.syncIntervalHint': 'اتركه فارغًا للمزامنة فقط عند عرض هذه القائمة. حدد فترة زمنية للمزامنة تلقائيًا في الخلفية.',
  'dataLists.schema.webhook.syncIntervalLabel': 'المزامنة كل N دقيقة',
  'dataLists.schema.webhook.maxRetriesLabel': 'الحد الأقصى لإعادة المحاولة',
  'dataLists.schema.webhook.retryDelayLabel': 'تأخير إعادة المحاولة (ثوانٍ)',
  'dataLists.schema.webhook.syncNow': 'مزامنة الآن',
  'dataLists.schema.webhook.syncingNow': 'جارٍ المزامنة...',
  'dataLists.schema.webhook.syncNowSuccess': 'تمت المزامنة بنجاح',
  'dataLists.schema.webhook.syncNowFailed': 'فشلت المزامنة',
  'dataLists.schema.webhook.loadingSyncHistory': 'جارٍ تحميل حالة آخر مزامنة...',
  'dataLists.schema.webhook.lastSyncSuccess': 'تمت آخر مزامنة بنجاح في {{time}}',
  'dataLists.schema.webhook.lastSyncFailed': 'فشلت آخر مزامنة: {{error}}',
  'dataLists.schema.webhook.syncOutcomeSummary': 'تمت مزامنة {{synced}}، تم تحديث {{updated}}، تم إعادة تفعيل {{reactivated}}، تم تخطي {{skipped}}، تمت إزالة {{removed}}، وفشل {{failed}}',
  'dataLists.schema.webhook.syncOutcomeFailureRow': 'الصف {{row}}: {{error}}',
  'dataLists.schema.webhook.syncOutcomeFailureGeneral': '{{error}}',
  'dataLists.schema.webhook.viewRuns': 'عرض عمليات المزامنة والسجل ←',
  'dataLists.runs.nextRun': 'التشغيل المجدول التالي',
  'dataLists.runs.manualOnly': 'لا يوجد جدول — يتم التشغيل فقط عند المزامنة يدويًا',
  'dataLists.runs.inTime': 'بعد {{time}}',
  'dataLists.runs.dueNow': 'مستحق الآن',
  'dataLists.runs.runningSince': 'المزامنة قيد التشغيل منذ {{time}} — يمكنك مغادرة هذه الشاشة',
  'dataLists.runs.syncRunning': 'المزامنة قيد التنفيذ…',
  'dataLists.runs.syncNowHint': 'تعمل في الخلفية تمامًا مثل التشغيل المجدول، لذا لن تنتهي مهلة المصادر الكبيرة بعد الآن.',
  'dataLists.runs.started': 'بدأت المزامنة في الخلفية',
  'dataLists.runs.alreadyRunning': 'هناك مزامنة قيد التشغيل بالفعل لهذه القائمة',
  'dataLists.runs.history': 'سجل التشغيل',
  'dataLists.runs.refresh': 'تحديث',
  'dataLists.runs.empty': 'لا توجد عمليات تشغيل بعد.',
  'dataLists.runs.status.success': 'نجحت',
  'dataLists.runs.status.partial': 'اكتملت مع أخطاء',
  'dataLists.runs.status.failed': 'فشلت',
  'dataLists.runs.status.running': 'قيد التشغيل',
  'dataLists.runs.status.pending': 'قيد الانتظار',
  'dataLists.runs.trigger.manual': 'يدوي',
  'dataLists.runs.trigger.scheduled': 'مجدول',
  'dataLists.runs.attempt': 'المحاولة {{n}}',
  'dataLists.runs.summary': '{{created}} أُنشئ، {{updated}} حُدّث، {{removed}} حُذف، {{failed}} فشل',
  'dataLists.runs.startedAt': 'البدء',
  'dataLists.runs.finishedAt': 'الانتهاء',
  'dataLists.runs.counts.fetched': 'تم جلبه',
  'dataLists.runs.counts.created': 'أُنشئ',
  'dataLists.runs.counts.updated': 'حُدّث',
  'dataLists.runs.counts.reactivated': 'أُعيد تفعيله',
  'dataLists.runs.counts.skipped': 'تم تخطيه',
  'dataLists.runs.counts.removed': 'حُذف',
  'dataLists.runs.counts.failed': 'فشل',
  'dataLists.runs.error': 'الخطأ',
  'dataLists.runs.showStack': 'عرض التفاصيل التقنية',
  'dataLists.runs.hideStack': 'إخفاء التفاصيل التقنية',
  'dataLists.runs.failures': 'الصفوف الفاشلة ({{count}})',
  'dataLists.runs.rowN': 'الصف {{n}}',
  'dataLists.runs.removal': 'حذف',
  'dataLists.runs.moreNotListed': '{{count}} أخرى غير معروضة',
  'dataLists.runs.records': 'السجلات',
  'dataLists.runs.priceBefore': 'قبل (السعر / سعر البيع)',
  'dataLists.runs.priceMapped': 'القيم المربوطة (السعر / سعر البيع)',
  'dataLists.runs.priceSaved': 'المحفوظ (السعر / سعر البيع)',
  'dataLists.runs.priceFinal': 'نهاية المزامنة (السعر / سعر البيع)',
  'dataLists.runs.priceMismatch': 'الأسعار المحفوظة لا تطابق هذا الصف من المصدر',
  'dataLists.runs.filterAll': 'الكل',
  'dataLists.runs.showMore': 'عرض المزيد ({{count}})',
  'dataLists.runs.recordsTruncated': 'يتم عرض أول {{count}} سجل فقط.',
  'dataLists.runs.log': 'سجل التشغيل التفصيلي',
  'dataLists.runs.noDetails': 'لم يتم حفظ تفاصيل السجلات لهذا التشغيل.',
  'storefront.shop': 'المتجر',
  'storefront.product': 'المنتج',
  'storefront.loading': 'جارٍ التحميل…',
  'storefront.loadFailed': 'تعذّر تحميل الصفحة. تحقق من اتصالك وحاول مرة أخرى.',
  'storefront.notFound': 'هذا المنتج لم يعد متاحًا.',
  'storefront.retry': 'إعادة المحاولة',
  'storefront.itemsCount': '{{count}} منتجات',
  'storefront.oneItem': 'منتج واحد',
  'storefront.search': 'ابحث عن منتج',
  'storefront.noResults': 'لا توجد منتجات تطابق "{{query}}"',
  'storefront.empty': 'لا توجد منتجات بعد',
  'storefront.emptyBody': 'تابعنا قريبًا لمنتجات جديدة.',
  'storefront.addToCart': 'أضف إلى السلة',
  'storefront.chooseOptions': 'اختر الخيارات',
  'storefront.outOfStock': 'غير متوفر',
  'storefront.inStock': 'متوفر',
  'storefront.preorder': 'طلب مسبق',
  'storefront.backorder': 'طلب مؤجل',
  'storefront.unitsAvailable': 'متاح {{count}}',
  'storefront.price': 'السعر',
  'storefront.added': 'تمت الإضافة إلى السلة',
  'storefront.viewCart': 'عرض السلة',
  'storefront.poweredBy': 'مدعوم من DISLIX',
  'storefront.close': 'إغلاق',
  'storefront.gridView': 'عرض شبكي',
  'storefront.slideView': 'عرض الشرائح',
  'storefront.description': 'الوصف',
  'storefront.details': 'تفاصيل المنتج',
  'storefront.sku': 'رمز المنتج',
  'storefront.barcode': 'الباركود',
  'storefront.weight': 'الوزن',
  'storefront.addons': 'الإضافات',
  'storefront.required': 'مطلوب',
  'storefront.add': 'إضافة',
  'storefront.variant': 'الخيار',
  'storefront.selectVariant': 'اختر خيارًا ({{count}})',
  'storefront.addAgain': 'أضف مرة أخرى ({{count}} في السلة)',
  'storefront.requiredAddonsMissing': 'يرجى اختيار: {{names}}',
  'storefront.noImage': 'لا توجد صورة',
  'storefront.imageUnavailable': 'الصورة غير متاحة',
  'storefront.cart.otherNumber': 'لديك سلة من رقمك الآخر: {{count}} منتجات · {{total}}',
  'storefront.cart.continueHere': 'أكملها هنا',
  'storefront.cart.startNew': 'ابدأ سلة جديدة',
  'storefront.cart.total': 'الإجمالي',
  'storefront.cart.deliveryNote': 'يتم اختيار التوصيل عند إتمام الطلب.',
  'storefront.cart.title': 'سلة التسوق',
  'storefront.cart.empty': 'سلتك فارغة',
  'storefront.cart.emptyBody': 'تصفح المنتجات وأضف ما يعجبك للبدء.',
  'storefront.cart.startShopping': 'ابدأ التسوق',
  'storefront.cart.continueShopping': 'متابعة التسوق',
  'storefront.cart.subtotal': 'المجموع الفرعي',
  'storefront.cart.each': '{{price}} للقطعة',
  'storefront.cart.remove': 'حذف',
  'storefront.cart.checkout': 'إتمام الطلب',
  'storefront.cart.feesNote': 'يتم احتساب التوصيل والضرائب عند إتمام الطلب.',
  'storefront.checkout.title': 'إتمام الطلب',
  'storefront.checkout.stepDetails': 'البيانات',
  'storefront.checkout.stepDelivery': 'التوصيل',
  'storefront.checkout.stepReview': 'المراجعة',
  'storefront.checkout.contact': 'بياناتك',
  'storefront.checkout.name': 'الاسم بالكامل',
  'storefront.checkout.namePlaceholder': 'اكتب اسمك بالكامل',
  'storefront.checkout.phone': 'رقم الهاتف',
  'storefront.checkout.phonePlaceholder': 'مثال: 01000000000',
  'storefront.checkout.email': 'البريد الإلكتروني (اختياري)',
  'storefront.checkout.location': 'موقع التوصيل',
  'storefront.checkout.locationHint': 'حدد موقعك لنحسب رسوم التوصيل ونصل إليك بسهولة.',
  'storefront.checkout.setLocation': 'تحديد موقع التوصيل',
  'storefront.checkout.changeLocation': 'تغيير',
  'storefront.checkout.detectingLocation': 'جارٍ تحديد موقعك…',
  'storefront.checkout.address': 'تفاصيل العنوان (اختياري)',
  'storefront.checkout.addressPlaceholder': 'المبنى، الدور، الشقة، علامة مميزة',
  'storefront.checkout.notes': 'ملاحظات الطلب (اختياري)',
  'storefront.checkout.notesPlaceholder': 'تعليمات خاصة، تفضيلات التوصيل…',
  'storefront.checkout.shipping': 'طريقة التوصيل',
  'storefront.checkout.findingShipping': 'جارٍ البحث عن خيارات التوصيل…',
  'storefront.checkout.free': 'مجاني',
  'storefront.checkout.days': '{{min}}–{{max}} أيام',
  'storefront.checkout.express': 'توصيل سريع',
  'storefront.checkout.optionalAddons': 'إضافات',
  'storefront.checkout.promo': 'كود الخصم',
  'storefront.checkout.promoPlaceholder': 'أدخل كود الخصم',
  'storefront.checkout.referral': 'كود الإحالة',
  'storefront.checkout.referralPlaceholder': 'أدخل كود الإحالة',
  'storefront.checkout.apply': 'تطبيق',
  'storefront.checkout.youSave': 'وفّرت {{amount}}',
  'storefront.checkout.invalidCode': 'هذا الكود غير صالح',
  'storefront.checkout.codeCheckFailed': 'تعذّر التحقق من الكود. حاول مرة أخرى.',
  'storefront.checkout.orderItems': 'طلبك',
  'storefront.checkout.summary': 'ملخص الدفع',
  'storefront.checkout.subtotal': 'المجموع الفرعي',
  'storefront.checkout.shippingLine': 'التوصيل — {{name}}',
  'storefront.checkout.coupon': 'كود الخصم "{{code}}"',
  'storefront.checkout.referralLine': 'كود الإحالة "{{code}}"',
  'storefront.checkout.optionalLine': '{{name}} (اختياري)',
  'storefront.checkout.total': 'الإجمالي',
  'storefront.checkout.payOnDelivery': 'الدفع عند الاستلام',
  'storefront.checkout.deliverTo': 'التوصيل إلى',
  'storefront.checkout.edit': 'تعديل',
  'storefront.checkout.continue': 'متابعة',
  'storefront.checkout.placeOrder': 'تأكيد الطلب · {{total}}',
  'storefront.checkout.placing': 'جارٍ إرسال طلبك…',
  'storefront.checkout.nameRequired': 'يرجى إدخال اسمك',
  'storefront.checkout.phoneRequired': 'يرجى إدخال رقم هاتف صحيح',
  'storefront.checkout.emailInvalid': 'يرجى إدخال بريد إلكتروني صحيح أو تركه فارغًا',
  'storefront.checkout.shippingRequired': 'يرجى اختيار طريقة التوصيل',
  'storefront.checkout.orderFailed': 'تعذّر إرسال طلبك. يرجى المحاولة مرة أخرى.',
  'storefront.checkout.cartEmpty': 'سلتك فارغة',
  'storefront.checkout.missingStore': 'هذا الرابط ينقصه بيانات المتجر. يرجى فتحه مرة أخرى من المحادثة.',
  'storefront.success.title': 'تم إرسال طلبك!',
  'storefront.success.orderNumber': 'طلب رقم #{{number}}',
  'storefront.success.body': 'شكرًا لك! استلم المتجر طلبك وسيتواصل معك لتأكيده.',
  'storefront.success.sentWhatsApp': 'أرسلنا الفاتورة إلى واتساب ({{phone}}). يرجى تأكيد الطلب هناك.',
  'storefront.success.sentChat': 'أرسلنا تأكيد الطلب إلى محادثتك مع المتجر.',
  'storefront.success.track': 'تتبع طلبي',
  'storefront.success.invoice': 'عرض الفاتورة',
  'storefront.success.continue': 'متابعة التسوق',
  'storefront.success.total': 'الإجمالي',
  'vendors.minimumOrder.section': 'الحد الأدنى للطلب',
  'vendors.minimumOrder.hint': 'يجب أن يتضمن الطلب منتجات هذا المورد بقيمة لا تقل عن هذا المبلغ. اتركه فارغًا لعدم وجود حد أدنى.',
  'vendors.minimumOrder.amount': 'الحد الأدنى لقيمة الطلب',
  'vendors.minimumOrder.currency': 'العملة',
  'vendors.minimumOrder.none': 'بدون حد أدنى',
  'vendors.minimumOrder.invalidTitle': 'مبلغ غير صالح',
  'vendors.minimumOrder.invalidAmount': 'يجب أن يكون الحد الأدنى للطلب رقمًا يساوي 0 أو أكثر.',
  'products.minimumOrderQuantity.label': 'الحد الأدنى لكمية الطلب',
  'products.minimumOrderQuantity.placeholder': 'بدون حد أدنى',
  'products.minimumOrderQuantity.hint': 'يجب أن يتضمن الطلب هذه الكمية على الأقل (لكل الخيارات معًا).',
  'orders.form.currency': 'العملة',
  'mapPicker.searchPlaceholder': 'ابحث عن مكان أو الصق رابط خرائط جوجل / آبل',
  'mapPicker.resolvingLink': 'جارٍ فتح رابط الخريطة…',
  'mapPicker.linkFailed': 'تعذّر العثور على موقع في هذا الرابط. تحقق من الرابط أو ابحث باسم المكان.',
  'visitWorkspace.title': 'الزيارة',
  'visitWorkspace.startedAt': 'بدأت {{time}}',
  'visitWorkspace.directions': 'الاتجاهات',
  'visitWorkspace.locating': 'جارٍ تحديد موقعك…',
  'visitWorkspace.distance': 'أنت على بعد {{distance}}',
  'visitWorkspace.inRange': 'داخل نطاق تسجيل الحضور',
  'visitWorkspace.outOfRange': 'تسجيل الحضور يتطلب {{radius}} م أو أقل',
  'visitWorkspace.checkLocation': 'تحقق من المسافة',
  'visitWorkspace.rulesTitle': 'قواعد الزيارة',
  'visitWorkspace.rules.radius': 'سجّل الحضور ضمن {{radius}} م من الموقع',
  'visitWorkspace.rules.radiusOverride': 'سجّل الحضور ضمن {{radius}} م (أو اذكر السبب)',
  'visitWorkspace.rules.startPhotos': 'صورة واحدة على الأقل للبدء ({{count}})',
  'visitWorkspace.rules.endPhotos': 'صورة واحدة على الأقل للإنهاء ({{count}})',
  'visitWorkspace.rules.cameraOnly': 'يجب التقاط الصور بالكاميرا',
  'visitWorkspace.rules.duration': 'المدة المتوقعة: {{minutes}} دقيقة',
  'visitWorkspace.rules.dueBy': 'مستحقة قبل {{time}}',
  'visitWorkspace.notYours': 'هذه الزيارة مسندة لشخص آخر.',
  'visitWorkspace.geofenceBlocked': 'أنت على بعد {{distance}} من الموقع — يجب أن تكون ضمن {{radius}} م للبدء.',
  'visitWorkspace.start': 'بدء الزيارة',
  'visitWorkspace.needLocation': 'بانتظار موقعك لتسجيل الحضور.',
  'visitWorkspace.needStartPhotos': 'أضف صور البدء المطلوبة أولًا.',
  'visitWorkspace.needReason': 'أنت خارج النطاق — أضف سببًا للبدء.',
  'visitWorkspace.actionsTitle': 'أثناء الزيارة',
  'visitWorkspace.addQuotation': 'عرض سعر',
  'visitWorkspace.addOrder': 'طلب',
  'visitWorkspace.addVendor': 'إضافة كمورد',
  'visitWorkspace.notePlaceholder': 'أضف ملاحظة عن هذه الزيارة…',
  'visitWorkspace.noteTag': '[زيارة]',
  'visitWorkspace.noteAdded': 'تمت إضافة الملاحظة إلى جهة الاتصال',
  'visitWorkspace.end': 'إنهاء الزيارة',
  'visitWorkspace.confirmEnd': 'إنهاء الزيارة',
  'visitWorkspace.outcomeNoteOptional': 'ملاحظة (اختياري)',
  'visitWorkspace.assigneeChosen': 'تم اختيار المسؤول',
  'visitWorkspace.needEndPhotos': 'أضف صور الإنهاء المطلوبة للإنهاء.',
  'visitWorkspace.ended': 'انتهت الزيارة — {{outcome}}',
  'visitWorkspace.viewVendor': 'عرض المورد',
  'visitWorkspace.activitiesTitle': 'ما تم خلال هذه الزيارة',
  'visitWorkspace.activity.order': 'تم إنشاء طلب',
  'visitWorkspace.activity.quotation': 'تم إنشاء عرض سعر',
  'visitWorkspace.activity.vendor': 'تمت الإضافة كمورد',
  'visitWorkspace.activity.reminder': 'تم ضبط تذكير',
  'visitWorkspace.activity.list': 'تمت الإضافة إلى قائمة',
  'visitWorkspace.activity.assignment': 'تم تغيير الإسناد',
  'visitWorkspace.activity.note': 'ملاحظة',
  'contactEdit.vendor.linked': 'المورد: {{name}}',
  'contactEdit.vendor.view': 'عرض',
  'contactEdit.vendor.add': 'إضافة كمورد',
  'visitWorkspace.turnByTurn': 'الملاحة خطوة بخطوة',
  'orderMinimums.title': 'لم يتم الوصول إلى الحد الأدنى للطلب',
  'orderMinimums.productLine': '{{name}}: الحد الأدنى للكمية {{min}} (لديك {{qty}})',
  'orderMinimums.vendorLine': '{{name}}: الحد الأدنى للطلب {{min}} — أضف {{remaining}}',
  'storefront.minQty': 'الحد الأدنى {{count}}',
  'storefront.minQtyLong': 'الحد الأدنى لكمية الطلب: {{count}}',
  'storefront.vendorMinimum': 'الحد الأدنى لطلب منتجات {{name}}: {{amount}}',
  'dataLists.schema.tabs.runs': 'عمليات التشغيل',

  // تسميات أنواع الأعمدة
  'dataLists.type.text': 'نص',
  'dataLists.type.number': 'رقم',
  'dataLists.type.boolean': 'نعم / لا',
  'dataLists.type.date': 'تاريخ',
  'dataLists.type.phone': 'هاتف',
  'dataLists.type.voice': 'صوت',
  'dataLists.type.image': 'صورة',
  'dataLists.type.video': 'فيديو',
  'dataLists.type.object': 'كائن (JSON)',
  'dataLists.type.relation': 'علاقة',
  'dataLists.type.repeater': 'مكرر',

  // شاشة السجلات
  'dataLists.records.title': 'السجلات',
  'dataLists.records.subtitle.count': '{{count}} سجل',
  'dataLists.records.subtitle.countOne': 'سجل واحد',
  'dataLists.records.searchPlaceholder': 'ابحث في السجلات...',
  'dataLists.records.add': 'إضافة سجل',
  'dataLists.records.bulkAdd': 'إضافة جماعية',
  'dataLists.records.empty.title': 'لا توجد سجلات بعد',
  'dataLists.records.empty.message': 'أضف أول سجل إلى هذه القائمة.',
  'dataLists.records.empty.webhookMessage': 'لم يتم استلام بيانات من الويب هوك بعد.',
  'dataLists.records.liveWebhookBadge': 'مباشر من الويب هوك — للقراءة فقط',
  'dataLists.records.template.download': 'تنزيل النموذج',
  'dataLists.records.template.upload': 'رفع النموذج المعبأ',
  'dataLists.records.template.downloadFailed': 'فشل تنزيل النموذج',
  'dataLists.records.template.importFailed': 'فشل استيراد النموذج',
  'dataLists.records.template.importSuccess': 'تم استيراد {{count}} من {{total}} صف',
  'dataLists.records.loading': 'جارٍ تحميل السجلات...',
  'dataLists.records.loadFailed': 'فشل تحميل السجلات',
  'dataLists.records.delete.title': 'حذف السجل',
  'dataLists.records.delete.message': 'هل أنت متأكد من حذف هذا السجل؟ لا يمكن التراجع عن هذا الإجراء.',
  'dataLists.records.delete.success': 'تم حذف السجل بنجاح',
  'dataLists.records.delete.failed': 'فشل حذف السجل',
  'dataLists.records.emptyValue': '—',

  // نموذج السجل
  'dataLists.recordForm.createTitle': 'سجل جديد',
  'dataLists.recordForm.editTitle': 'تعديل السجل',
  'dataLists.recordForm.save': 'حفظ',
  'dataLists.recordForm.create': 'إنشاء',
  'dataLists.recordForm.saving': 'جارٍ الحفظ...',
  'dataLists.recordForm.assignedSection': 'مُسنَد إلى',
  'dataLists.recordForm.assignUser': 'إسناد مستخدم',
  'dataLists.recordForm.createSuccess': 'تم إنشاء السجل بنجاح',
  'dataLists.recordForm.updateSuccess': 'تم تحديث السجل بنجاح',
  'dataLists.recordForm.saveFailed': 'فشل حفظ السجل',
  'dataLists.recordForm.loadFailed': 'فشل تحميل السجل',
  'dataLists.recordForm.uploadFailed': 'فشل رفع ملف واحد أو أكثر',
  'dataLists.recordForm.validation.title': 'يرجى تصحيح الأخطاء',
  'dataLists.recordForm.validation.required': 'هذا الحقل مطلوب',
  'dataLists.recordForm.validation.invalidJson': 'صيغة JSON غير صحيحة',
  'dataLists.recordForm.validation.notNumber': 'يجب أن يكون رقمًا',
  'dataLists.recordForm.validation.min': 'يجب ألا يقل عن {{min}}',
  'dataLists.recordForm.validation.max': 'يجب ألا يزيد عن {{max}}',

  // عارض الحقول
  'dataLists.field.textPlaceholder': 'أدخل نصًا',
  'dataLists.field.numberPlaceholder': 'أدخل رقمًا',
  'dataLists.field.jsonPlaceholder': '{ "key": "value" }',
  'dataLists.field.selectOption': 'اختر خيارًا',
  'dataLists.field.pickFile': 'اختر ملفًا',
  'dataLists.field.pickImage': 'اختر صورة',
  'dataLists.field.pickVideo': 'اختر فيديو',
  'dataLists.field.pickVoice': 'اختر ملفًا صوتيًا',
  'dataLists.field.recordVoice': 'سجل ملاحظة صوتية',
  'dataLists.field.uploading': 'جارٍ الرفع...',
  'dataLists.field.fileSelected': 'تم اختيار الملف',
  'dataLists.field.replaceFile': 'استبدال',
  'dataLists.field.removeFile': 'إزالة',
  'dataLists.field.selectRecord': 'اختر سجلًا',
  'dataLists.field.addAnotherRecord': 'إضافة سجل آخر',
  'dataLists.field.permissionTitle': 'إذن مطلوب',
  'dataLists.field.permissionMessage': 'يرجى منح الإذن للوصول إلى مكتبة الوسائط.',
  'dataLists.field.repeaterRow': 'الصف {{number}}',
  'dataLists.field.addRow': 'إضافة صف',
  'dataLists.field.quantityPlaceholder': 'الكمية',
  'dataLists.field.addProducts': 'إضافة منتجات',
  'dataLists.field.selectProductsTitle': 'اختر المنتجات',

  // منتقي سجلات العلاقة
  'dataLists.recordPicker.title': 'اختر سجلًا',
  'dataLists.recordPicker.searchPlaceholder': 'ابحث في السجلات...',
  'dataLists.recordPicker.empty': 'لم يُعثر على سجلات',
  'dataLists.recordPicker.loading': 'جارٍ تحميل السجلات...',
  'dataLists.recordPicker.unnamed': 'سجل بلا عنوان',
  'dataLists.recordPicker.done': 'تم ({{count}} محدد)',

  // عقدة التدفق — الكتابة في قائمة بيانات
  'dataLists.flowNode.label': 'الكتابة في قائمة بيانات',
  'dataLists.flowNode.description': 'إنشاء أو تحديث أو بحث أو حذف سجل في قائمة بيانات',
  'dataLists.flowNode.listLabel': 'قائمة البيانات *',
  'dataLists.flowNode.selectList': 'اختر قائمة بيانات',
  'dataLists.flowNode.listSelected': 'تم اختيار القائمة',
  'dataLists.flowNode.pickerTitle': 'اختر قائمة بيانات',
  'dataLists.flowNode.pickerEmpty': 'لم يُعثر على قوائم بيانات',
  'dataLists.flowNode.operationLabel': 'العملية',
  'dataLists.flowNode.operation.create': 'إنشاء',
  'dataLists.flowNode.operation.update': 'تحديث',
  'dataLists.flowNode.operation.find': 'بحث',
  'dataLists.flowNode.operation.delete': 'حذف',
  'dataLists.flowNode.valueMappings': 'القيم',
  'dataLists.flowNode.valueMappingsHint': 'عيّن لكل عمود قيمة أو قالبًا، مثل {{contact.name}}.',
  'dataLists.flowNode.matchCriteria': 'معايير المطابقة',
  'dataLists.flowNode.matchCriteriaHint': 'ابحث عن السجلات التي يتطابق فيها كل عمود. تفوز أحدث نتيجة.',
  'dataLists.flowNode.selectColumn': 'اختر عمودًا',
  'dataLists.flowNode.valuePlaceholder': 'قيمة أو {{variable}}',
  'dataLists.flowNode.addRow': 'إضافة صف',
  'dataLists.flowNode.operator.eq': 'يساوي',
  'dataLists.flowNode.operator.contains': 'يحتوي على',
  'dataLists.flowNode.operator.gt': 'أكبر من',
  'dataLists.flowNode.operator.lt': 'أصغر من',
  'dataLists.flowNode.operator.gte': 'أكبر من أو يساوي',
  'dataLists.flowNode.operator.lte': 'أصغر من أو يساوي',
  'dataLists.flowNode.saveResultAs': 'حفظ النتيجة باسم (اختياري)',
  'dataLists.flowNode.saveResultAsPlaceholder': 'مثال: foundRecord',
  'dataLists.flowNode.saveResultAsHint': 'يُحفظ السجل المطابق تحت هذا الاسم لاستخدامه في العقد اللاحقة.',
  'dataLists.flowNode.then': 'ثم',
  'dataLists.flowNode.validation.listRequired': 'اختر قائمة بيانات',
  'dataLists.flowNode.validation.operationRequired': 'اختر عملية',
  'dataLists.flowNode.validation.mappingRequired': 'أضف تعيين قيمة واحدًا على الأقل',
  'dataLists.flowNode.validation.matchRequired': 'أضف معيار مطابقة واحدًا على الأقل',

  // Flow builder — add-node picker
  'flows.nodePicker.title': 'إضافة عقدة',
  'flows.nodePicker.searchPlaceholder': 'ابحث عن عقدة...',
  'flows.nodePicker.noResults': 'لا توجد عقد مطابقة لبحثك',
  'flows.nodePicker.frequentlyUsed': 'الأكثر استخدامًا',
  'flows.nodePicker.whatsappOnly': 'واتساب فقط',
  'flows.nodePicker.facebookOnly': 'فيسبوك فقط',
  'flows.nodePicker.category.messaging': 'المراسلة',
  'flows.nodePicker.category.logic': 'المنطق والتوجيه',
  'flows.nodePicker.category.data': 'البيانات',
  'flows.nodePicker.category.people': 'الأشخاص',
  'flows.nodePicker.category.commerce': 'التجارة',
  'flows.nodePicker.category.integrations': 'التكاملات',
  'flows.nodePicker.category.control': 'التحكم',

  // Flow node — check_language
  'flows.checkLanguage.label': 'التحقق من اللغة',
  'flows.checkLanguage.description': 'اكتشاف لغة الرسالة والتوجيه بناءً عليها',
  'flows.checkLanguage.inputLabel': 'النص المراد اكتشافه *',
  'flows.checkLanguage.inputPlaceholder': '{{Start.input.text}}',
  'flows.checkLanguage.inputHint': 'متغير أو قالب — عادةً الرسالة التي أطلقت هذا المسار',
  'flows.checkLanguage.saveResultAs': 'حفظ اللغة المكتشفة باسم (اختياري)',
  'flows.checkLanguage.routesLabel': 'المسارات',
  'flows.checkLanguage.addRoute': 'إضافة مسار',
  'flows.checkLanguage.routeLanguages': 'اللغات',
  'flows.checkLanguage.selectLanguages': 'اختر اللغات',
  'flows.checkLanguage.routeNextNode': 'الانتقال إلى',
  'flows.checkLanguage.defaultRoute': 'جميع اللغات الأخرى تنتقل إلى',
  'flows.checkLanguage.searchLanguage': 'ابحث عن لغة...',
  'flows.checkLanguage.validation.inputRequired': 'أضف رسالة أو متغيرًا لاكتشاف لغته',
  'flows.checkLanguage.validation.routeLanguagesRequired': 'كل مسار يحتاج إلى لغة واحدة على الأقل',

  // ─── Business creation wizard ────────────────────────────────────────────
  'business.details': 'تفاصيل النشاط التجاري',
  'business.name': 'اسم النشاط التجاري',
  'business.email': 'البريد الإلكتروني للنشاط التجاري',
  'business.industry': 'المجال',
  'industry.select': 'اختر مجال نشاطك',
  'industry.search': 'ابحث عن مجال…',
  'industry.none': 'لا يوجد مجال مطابق',
  'industry.otherPlaceholder': 'اكتب مجال نشاطك',
  'industry.retail': 'تجارة التجزئة',
  'industry.ecommerce': 'التجارة الإلكترونية',
  'industry.wholesale_distribution': 'الجملة والتوزيع',
  'industry.food_beverage': 'المطاعم والمقاهي',
  'industry.hospitality_travel': 'الضيافة والسفر',
  'industry.real_estate': 'العقارات',
  'industry.construction': 'البناء والمقاولات',
  'industry.manufacturing': 'التصنيع',
  'industry.healthcare': 'الرعاية الصحية والعيادات',
  'industry.pharma_medical': 'الصيدليات والمستلزمات الطبية',
  'industry.beauty_wellness': 'التجميل والعناية',
  'industry.education_training': 'التعليم والتدريب',
  'industry.automotive': 'السيارات',
  'industry.logistics_shipping': 'الخدمات اللوجستية والشحن',
  'industry.professional_services': 'الخدمات المهنية (قانونية، محاسبية، استشارية)',
  'industry.technology_software': 'التقنية والبرمجيات',
  'industry.marketing_media': 'التسويق والإعلام',
  'industry.finance_insurance': 'المالية والتأمين',
  'industry.events': 'الفعاليات',
  'industry.home_services': 'الخدمات المنزلية والصيانة',
  'industry.fashion_apparel': 'الأزياء والملابس',
  'industry.electronics': 'الإلكترونيات',
  'industry.furniture_home': 'الأثاث والمنزل',
  'industry.agriculture_food': 'الزراعة والإنتاج الغذائي',
  'industry.nonprofit': 'غير ربحي',
  'industry.other': 'أخرى',
  'business.description': 'الوصف (اختياري)',
  'business.location': 'موقع النشاط التجاري',
  'business.searchLocation': 'ابحث عن موقع نشاطك التجاري',
  'business.address': 'العنوان',
  'business.city': 'المدينة',
  'business.country': 'الدولة',
  'business.picture': 'صورة النشاط التجاري',
  'business.phone': 'هاتف النشاط التجاري',
  'business.createYourBusiness': 'أنشئ نشاطك التجاري',
  'common.skipForNow': 'تخطَّ الآن',
  'auth.verificationCode': 'رمز التحقق',
  'auth.verified': 'تم التحقق',
  'auth.verify': 'تحقق',
  'auth.sendCode': 'إرسال الرمز',
  'auth.finish': 'إنهاء',
  'auth.setUpChannels': 'قم بإعداد قنواتك',
  'auth.setUpChannelsSubtitle': 'اربط قنواتك الآن، أو تخطَّ ذلك وأكمله لاحقًا من الشاشة الرئيسية.',
  'auth.setUpNow': 'إعداد',
  'auth.finishForNow': 'تخطَّ الآن — اذهب للرئيسية',
  'auth.skipStep': 'تخطَّ هذه الخطوة',
  'auth.channelWhatsApp': 'واتساب',
  'auth.channelWhatsAppDescription': 'اربط رقم واتساب بزنس الخاص بك.',
  'auth.channelFacebookMessenger': 'ماسنجر فيسبوك',
  'auth.channelFacebookMessengerDescription': 'اربط صفحة فيسبوك لماسنجر.',
  'auth.channelXTwitter': 'إكس (تويتر)',
  'auth.channelXTwitterDescription': 'اربط حسابك على إكس.',
  'auth.channelPhone': 'الهاتف',
  'auth.channelPhoneDescription': 'فعّل الاتصال الهاتفي لفريقك.',
  'auth.backToSetupSteps': 'العودة لخطوات الإعداد',
  'auth.choosePlan': 'اختر خطتك',
  'auth.trialSubtitle': 'كل خطة تبدأ بتجربة مجانية لمدة أسبوع — بدون دفع الآن.',
  'auth.startTrial': 'ابدأ التجربة المجانية',
  'subscription.popular': 'الأكثر شيوعًا',
  'subscription.free': 'مجانًا',
  'planSelection.loadFailedTitle': 'تعذّر تحميل الخطط',
  'planSelection.loadFailedMessage': 'يُرجى المحاولة مرة أخرى.',
  'planSelection.noBusinessTitle': 'لم يتم اختيار نشاط تجاري',
  'planSelection.noBusinessMessage': 'يُرجى إنشاء أو اختيار نشاط تجاري أولاً.',
  'planSelection.trialStartedTitle': 'تم بدء التجربة',
  'planSelection.trialStartedMessage': 'تم تفعيل تجربتك المجانية لمدة أسبوع.',
  'planSelection.activateFailedTitle': 'تعذّر تفعيل التجربة',
  'planSelection.activateFailedMessage': 'يُرجى المحاولة مرة أخرى.',

  // ─── Business Permissions (Users & Departments Rebuild) ───────────────────
  'permissions.screenTitle': 'الصلاحيات',
  'permissions.generalSection.title': 'صلاحيات النشاط التجاري العامة',
  'permissions.systemSection.title': 'صلاحيات النظام',
  'permissions.otherSection.title': 'أخرى',
  'permissions.search.placeholder': 'ابحث عن الصلاحيات...',
  'permissions.search.noResults': 'لا توجد صلاحيات مطابقة لبحثك',
  'permissions.enableAll': 'تفعيل الكل',
  'permissions.disableAll': 'تعطيل الكل',
  'permissions.resetToDepartmentDefault': 'إعادة التعيين لافتراضي القسم',
  'permissions.summaryChip.label': '{{count}} ممنوحة',
  'permissions.summaryChip.empty': 'لم يتم منح أي صلاحيات بعد',
  'permissions.summaryChip.manageLink': 'إدارة الصلاحيات',
  'permissions.targetPicker.usersTab': 'المستخدمون',
  'permissions.targetPicker.departmentsTab': 'الأقسام',
  'permissions.targetPicker.editingFor': 'تعديل صلاحيات: {{name}}',
  'permissions.targetPicker.change': 'تغيير',
  'permissions.targetPicker.selectTarget': 'اختر مستخدمًا أو قسمًا لإدارة صلاحياته',
  'permissions.unsavedChangesWarning.title': 'تغييرات غير محفوظة',
  'permissions.unsavedChangesWarning.message': 'لديك تغييرات في الصلاحيات لم يتم حفظها. هل أنت متأكد من رغبتك في المغادرة؟',
  'permissions.save': 'حفظ التغييرات',
  'permissions.cancel': 'إلغاء',
  'permissions.saveSuccess': 'تم تحديث الصلاحيات بنجاح',
  'permissions.saveFailed': 'فشل تحديث الصلاحيات',
  'permissions.levels.none': 'بلا',
  'permissions.levels.view': 'عرض',
  'permissions.levels.edit': 'تعديل',
  'permissions.levels.admin': 'إدارة',
  'permissions.inherited': 'موروث',
  'permissions.categoryLabel.general': 'عام',
  'permissions.categoryLabel.wabu': 'واتساب',
  'permissions.categoryLabel.fbm': 'ماسنجر',
  'permissions.categoryLabel.sms': 'الرسائل النصية',
  'permissions.categoryLabel.email': 'البريد الإلكتروني',
  'permissions.categoryLabel.telegram': 'تيليجرام',
  'permissions.categoryLabel.instagram': 'انستغرام',
  'permissions.categoryLabel.contacts': 'جهات الاتصال',
  'permissions.categoryLabel.reports': 'التقارير',
  'permissions.categoryLabel.phone': 'المكالمات',
  'permissions.categoryLabel.notifications': 'الإشعارات',
  'permissions.categoryLabel.storage': 'التخزين',
  'userSetup.bulk.selectAll': 'تحديد الكل',
  'userSetup.bulk.selectedCount': '{{count}} محدد',
  'userSetup.bulk.changeRole': 'تغيير الدور',
  'userSetup.bulk.assignDepartment': 'تعيين القسم',
  'userSetup.bulk.setPermissions': 'تعيين الصلاحيات',
  'userSetup.bulk.remove': 'إزالة',
  'userSetup.bulk.confirmRemoveTitle': 'إزالة المستخدمين',
  'userSetup.bulk.confirmRemoveMessage': 'هل أنت متأكد من رغبتك في إزالة {{count}} مستخدم(ين) من هذا النشاط التجاري؟',
  'userSetup.bulk.exitSelection': 'إلغاء التحديد',
  'userSetup.bulk.enterSelection': 'تحديد',
  'userSetup.bulk.roleUpdateSuccess': 'تم تحديث {{count}} مستخدم(ين)',
  'userSetup.bulk.removeSuccess': 'تم إزالة {{count}} مستخدم(ين)',
  'userSetup.bulk.departmentAssignSuccess': 'تم تعيين {{count}} مستخدم(ين)',
  'departments.memberCount': '{{count}} أعضاء',
  'departments.bulk.manageMembers': 'إدارة الأعضاء',
  'departments.bulk.setPermissions': 'تعيين الصلاحيات',
  'departments.bulk.selectAll': 'تحديد الكل',
  'departments.bulk.selectedCount': '{{count}} محدد',
  'departments.bulk.exitSelection': 'إلغاء التحديد',
  'departments.bulk.enterSelection': 'تحديد',
  'departments.bulk.membersAddSuccess': 'تمت إضافة {{count}} عضو(اء)',
  'departments.bulk.permissionsSetSuccess': 'تم تحديث الصلاحيات لـ {{count}} قسم(أقسام)',
  'departments.profilePane.title': 'الأقسام',
  'departments.profilePane.selectPrompt': 'اختر قسمًا لتعديل ملفه.',
  'departments.profilePane.nameLabel': 'الاسم',
  'departments.profilePane.namePlaceholder': 'اسم القسم',
  'departments.profilePane.descriptionLabel': 'الوصف',
  'departments.profilePane.descriptionPlaceholder': 'وصف القسم',
  'departments.profilePane.active': 'نشط',
  'departments.profilePane.inactive': 'غير نشط',
  'departments.profilePane.saveChanges': 'حفظ التغييرات',
  'departments.profilePane.deleteDepartment': 'حذف القسم',
  'permissions.general.editBusinessProfile.label': "تعديل ملف الأعمال",
  'permissions.general.editBusinessProfile.description': "عرض وتعديل اسم النشاط التجاري والشعار والعنوان ومعلومات الاتصال",
  'permissions.general.manageSubscriptionBilling.label': "إدارة الاشتراك والفواتير",
  'permissions.general.manageSubscriptionBilling.description': "عرض أو تغيير الخطة وطرق الدفع والفواتير",
  'permissions.general.manageUsers.label': "إدارة المستخدمين",
  'permissions.general.manageUsers.description': "عرض الفريق ودعوة المستخدمين وتعديل الأدوار أو إزالتهم",
  'permissions.general.manageDepartments.label': "إدارة الأقسام",
  'permissions.general.manageDepartments.description': "عرض أو إنشاء أو تعديل أو حذف الأقسام وإدارة العضوية",
  'permissions.general.managePermissions.label': "إدارة الصلاحيات",
  'permissions.general.managePermissions.description': "منح أو إلغاء الصلاحيات للمستخدمين والأقسام الأخرى",
  'permissions.general.manageChannelsConnections.label': "إدارة اتصالات القنوات",
  'permissions.general.manageChannelsConnections.description': "عرض أو إعادة تهيئة أو توصيل أو فصل أي قناة مراسلة",
  'permissions.general.manageIntegrationsApiKeys.label': "إدارة التكاملات ومفاتيح API",
  'permissions.general.manageIntegrationsApiKeys.description': "عرض أو إدارة تكاملات الطرف الثالث ومفاتيح API",
  'permissions.general.viewReportsAnalytics.label': "عرض التقارير والتحليلات",
  'permissions.general.viewReportsAnalytics.description': "عرض التقارير والتحليلات على مستوى النشاط التجاري",
  'permissions.general.leadFinder.label': 'باحث العملاء',
  'permissions.general.leadFinder.description': 'البحث عن الأنشطة التجارية على الخريطة والويب ومراجعتها وإضافتها كجهات اتصال أو موردين.',
  'permissions.general.manageDataLists.label': "إدارة قوائم البيانات",
  'permissions.general.manageDataLists.description': "عرض أو تعديل السجلات أو إنشاء/حذف قوائم البيانات",
  'permissions.general.manageContactsGlobal.label': "إدارة جميع جهات الاتصال",
  'permissions.general.manageContactsGlobal.description': "إدارة جهات الاتصال على مستوى النشاط التجاري: تصدير أو دمج أو حذف جماعي",
  'permissions.general.manageAutomationFlows.label': "إدارة مسارات الأتمتة",
  'permissions.general.manageAutomationFlows.description': "عرض أو تعديل أو نشر أو حذف مسارات الأتمتة",
  'permissions.general.manageQuickReplies.label': "إدارة الردود السريعة",
  'permissions.general.manageQuickReplies.description': "عرض أو تعديل مجموعات الردود السريعة",
  'permissions.general.manageCalendarBookings.label': "إدارة التقويم والحجوزات",
  'permissions.general.manageCalendarBookings.description': "عرض أو تعديل التقويمات والحجوزات",
  'permissions.general.manageProductsCatalog.label': "إدارة المنتجات والكتالوج",
  'permissions.general.manageProductsCatalog.description': "عرض أو تعديل أو إنشاء أو حذف المنتجات والكتالوجات",
  'permissions.general.manageVendors.label': "إدارة الموردين",
  'permissions.general.manageVendors.description': "عرض أو تعديل أو إنشاء أو حذف الموردين والمنتجات المرتبطة بهم",
  'permissions.general.manageOrders.label': "إدارة الطلبات",
  'permissions.general.manageOrders.description': "عرض أو تعديل الطلبات",
  'permissions.general.exportBusinessData.label': "تصدير بيانات النشاط التجاري",
  'permissions.general.exportBusinessData.description': "تصدير البيانات على مستوى النشاط التجاري",
  'permissions.wabu.messaging.label': "المراسلة",
  'permissions.wabu.messaging.description': "عرض وإرسال الرسائل في محادثات واتساب",
  'permissions.wabu.useTemplates.label': "استخدام قوالب الرسائل",
  'permissions.wabu.useTemplates.description': "إرسال قوالب رسائل واتساب المعتمدة مسبقًا",
  'permissions.wabu.useAutomationFlows.label': "استخدام مسارات الأتمتة",
  'permissions.wabu.useAutomationFlows.description': "تشغيل وإدارة مسارات الأتمتة لـ واتساب",
  'permissions.wabu.viewAnalytics.label': "عرض التحليلات",
  'permissions.wabu.viewAnalytics.description': "عرض تحليلات الأداء لـ واتساب",
  'permissions.wabu.manageChannelConnection.label': "إدارة اتصال القناة",
  'permissions.wabu.manageChannelConnection.description': "إعادة تهيئة أو توصيل/فصل قناة واتساب",
  'permissions.wabu.exportContacts.label': "تصدير جهات الاتصال",
  'permissions.wabu.exportContacts.description': "تصدير قائمة جهات الاتصال التي تم جمعها من واتساب",
  'permissions.wabu.deleteConversations.label': "حذف المحادثات",
  'permissions.wabu.deleteConversations.description': "حذف محادثات واتساب نهائيًا",
  'permissions.wabu.assignConversations.label': "تعيين المحادثات",
  'permissions.wabu.assignConversations.description': "تعيين محادثات واتساب للمستخدمين أو الأقسام",
  'permissions.wabu.viewAllConversations.label': "عرض جميع المحادثات",
  'permissions.wabu.viewAllConversations.description': "رؤية كل محادثات واتساب، وليس المُعينة فقط",
  'permissions.wabu.manageContactTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.wabu.manageContactTags.description': "إضافة أو إزالة الوسوم على جهات اتصال واتساب",
  'permissions.fbm.messaging.label': "المراسلة",
  'permissions.fbm.messaging.description': "عرض وإرسال الرسائل في محادثات ماسنجر",
  'permissions.fbm.useTemplates.label': "استخدام قوالب الرسائل",
  'permissions.fbm.useTemplates.description': "إرسال قوالب رسائل ماسنجر المعتمدة مسبقًا",
  'permissions.fbm.useAutomationFlows.label': "استخدام مسارات الأتمتة",
  'permissions.fbm.useAutomationFlows.description': "تشغيل وإدارة مسارات الأتمتة لـ ماسنجر",
  'permissions.fbm.viewAnalytics.label': "عرض التحليلات",
  'permissions.fbm.viewAnalytics.description': "عرض تحليلات الأداء لـ ماسنجر",
  'permissions.fbm.manageChannelConnection.label': "إدارة اتصال القناة",
  'permissions.fbm.manageChannelConnection.description': "إعادة تهيئة أو توصيل/فصل قناة ماسنجر",
  'permissions.fbm.exportContacts.label': "تصدير جهات الاتصال",
  'permissions.fbm.exportContacts.description': "تصدير قائمة جهات الاتصال التي تم جمعها من ماسنجر",
  'permissions.fbm.deleteConversations.label': "حذف المحادثات",
  'permissions.fbm.deleteConversations.description': "حذف محادثات ماسنجر نهائيًا",
  'permissions.fbm.assignConversations.label': "تعيين المحادثات",
  'permissions.fbm.assignConversations.description': "تعيين محادثات ماسنجر للمستخدمين أو الأقسام",
  'permissions.fbm.viewAllConversations.label': "عرض جميع المحادثات",
  'permissions.fbm.viewAllConversations.description': "رؤية كل محادثات ماسنجر، وليس المُعينة فقط",
  'permissions.fbm.manageContactTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.fbm.manageContactTags.description': "إضافة أو إزالة الوسوم على جهات اتصال ماسنجر",
  'permissions.sms.messaging.label': "المراسلة",
  'permissions.sms.messaging.description': "عرض وإرسال الرسائل في محادثات الرسائل النصية",
  'permissions.sms.useTemplates.label': "استخدام قوالب الرسائل",
  'permissions.sms.useTemplates.description': "إرسال قوالب رسائل الرسائل النصية المعتمدة مسبقًا",
  'permissions.sms.useAutomationFlows.label': "استخدام مسارات الأتمتة",
  'permissions.sms.useAutomationFlows.description': "تشغيل وإدارة مسارات الأتمتة لـ الرسائل النصية",
  'permissions.sms.viewAnalytics.label': "عرض التحليلات",
  'permissions.sms.viewAnalytics.description': "عرض تحليلات الأداء لـ الرسائل النصية",
  'permissions.sms.manageChannelConnection.label': "إدارة اتصال القناة",
  'permissions.sms.manageChannelConnection.description': "إعادة تهيئة أو توصيل/فصل قناة الرسائل النصية",
  'permissions.sms.exportContacts.label': "تصدير جهات الاتصال",
  'permissions.sms.exportContacts.description': "تصدير قائمة جهات الاتصال التي تم جمعها من الرسائل النصية",
  'permissions.sms.deleteConversations.label': "حذف المحادثات",
  'permissions.sms.deleteConversations.description': "حذف محادثات الرسائل النصية نهائيًا",
  'permissions.sms.assignConversations.label': "تعيين المحادثات",
  'permissions.sms.assignConversations.description': "تعيين محادثات الرسائل النصية للمستخدمين أو الأقسام",
  'permissions.sms.viewAllConversations.label': "عرض جميع المحادثات",
  'permissions.sms.viewAllConversations.description': "رؤية كل محادثات الرسائل النصية، وليس المُعينة فقط",
  'permissions.sms.manageContactTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.sms.manageContactTags.description': "إضافة أو إزالة الوسوم على جهات اتصال الرسائل النصية",
  'permissions.email.messaging.label': "المراسلة",
  'permissions.email.messaging.description': "عرض وإرسال الرسائل في محادثات البريد الإلكتروني",
  'permissions.email.useTemplates.label': "استخدام قوالب الرسائل",
  'permissions.email.useTemplates.description': "إرسال قوالب رسائل البريد الإلكتروني المعتمدة مسبقًا",
  'permissions.email.useAutomationFlows.label': "استخدام مسارات الأتمتة",
  'permissions.email.useAutomationFlows.description': "تشغيل وإدارة مسارات الأتمتة لـ البريد الإلكتروني",
  'permissions.email.viewAnalytics.label': "عرض التحليلات",
  'permissions.email.viewAnalytics.description': "عرض تحليلات الأداء لـ البريد الإلكتروني",
  'permissions.email.manageChannelConnection.label': "إدارة اتصال القناة",
  'permissions.email.manageChannelConnection.description': "إعادة تهيئة أو توصيل/فصل قناة البريد الإلكتروني",
  'permissions.email.exportContacts.label': "تصدير جهات الاتصال",
  'permissions.email.exportContacts.description': "تصدير قائمة جهات الاتصال التي تم جمعها من البريد الإلكتروني",
  'permissions.email.deleteConversations.label': "حذف المحادثات",
  'permissions.email.deleteConversations.description': "حذف محادثات البريد الإلكتروني نهائيًا",
  'permissions.email.assignConversations.label': "تعيين المحادثات",
  'permissions.email.assignConversations.description': "تعيين محادثات البريد الإلكتروني للمستخدمين أو الأقسام",
  'permissions.email.viewAllConversations.label': "عرض جميع المحادثات",
  'permissions.email.viewAllConversations.description': "رؤية كل محادثات البريد الإلكتروني، وليس المُعينة فقط",
  'permissions.email.manageContactTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.email.manageContactTags.description': "إضافة أو إزالة الوسوم على جهات اتصال البريد الإلكتروني",
  'permissions.telegram.messaging.label': "المراسلة",
  'permissions.telegram.messaging.description': "عرض وإرسال الرسائل في محادثات تيليجرام",
  'permissions.telegram.useTemplates.label': "استخدام قوالب الرسائل",
  'permissions.telegram.useTemplates.description': "إرسال قوالب رسائل تيليجرام المعتمدة مسبقًا",
  'permissions.telegram.useAutomationFlows.label': "استخدام مسارات الأتمتة",
  'permissions.telegram.useAutomationFlows.description': "تشغيل وإدارة مسارات الأتمتة لـ تيليجرام",
  'permissions.telegram.viewAnalytics.label': "عرض التحليلات",
  'permissions.telegram.viewAnalytics.description': "عرض تحليلات الأداء لـ تيليجرام",
  'permissions.telegram.manageChannelConnection.label': "إدارة اتصال القناة",
  'permissions.telegram.manageChannelConnection.description': "إعادة تهيئة أو توصيل/فصل قناة تيليجرام",
  'permissions.telegram.exportContacts.label': "تصدير جهات الاتصال",
  'permissions.telegram.exportContacts.description': "تصدير قائمة جهات الاتصال التي تم جمعها من تيليجرام",
  'permissions.telegram.deleteConversations.label': "حذف المحادثات",
  'permissions.telegram.deleteConversations.description': "حذف محادثات تيليجرام نهائيًا",
  'permissions.telegram.assignConversations.label': "تعيين المحادثات",
  'permissions.telegram.assignConversations.description': "تعيين محادثات تيليجرام للمستخدمين أو الأقسام",
  'permissions.telegram.viewAllConversations.label': "عرض جميع المحادثات",
  'permissions.telegram.viewAllConversations.description': "رؤية كل محادثات تيليجرام، وليس المُعينة فقط",
  'permissions.telegram.manageContactTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.telegram.manageContactTags.description': "إضافة أو إزالة الوسوم على جهات اتصال تيليجرام",
  'permissions.instagram.messaging.label': "المراسلة",
  'permissions.instagram.messaging.description': "عرض وإرسال الرسائل في محادثات انستغرام",
  'permissions.instagram.useTemplates.label': "استخدام قوالب الرسائل",
  'permissions.instagram.useTemplates.description': "إرسال قوالب رسائل انستغرام المعتمدة مسبقًا",
  'permissions.instagram.useAutomationFlows.label': "استخدام مسارات الأتمتة",
  'permissions.instagram.useAutomationFlows.description': "تشغيل وإدارة مسارات الأتمتة لـ انستغرام",
  'permissions.instagram.viewAnalytics.label': "عرض التحليلات",
  'permissions.instagram.viewAnalytics.description': "عرض تحليلات الأداء لـ انستغرام",
  'permissions.instagram.manageChannelConnection.label': "إدارة اتصال القناة",
  'permissions.instagram.manageChannelConnection.description': "إعادة تهيئة أو توصيل/فصل قناة انستغرام",
  'permissions.instagram.exportContacts.label': "تصدير جهات الاتصال",
  'permissions.instagram.exportContacts.description': "تصدير قائمة جهات الاتصال التي تم جمعها من انستغرام",
  'permissions.instagram.deleteConversations.label': "حذف المحادثات",
  'permissions.instagram.deleteConversations.description': "حذف محادثات انستغرام نهائيًا",
  'permissions.instagram.assignConversations.label': "تعيين المحادثات",
  'permissions.instagram.assignConversations.description': "تعيين محادثات انستغرام للمستخدمين أو الأقسام",
  'permissions.instagram.viewAllConversations.label': "عرض جميع المحادثات",
  'permissions.instagram.viewAllConversations.description': "رؤية كل محادثات انستغرام، وليس المُعينة فقط",
  'permissions.instagram.manageContactTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.instagram.manageContactTags.description': "إضافة أو إزالة الوسوم على جهات اتصال انستغرام",
  'permissions.contacts.view.label': "عرض جهات الاتصال",
  'permissions.contacts.view.description': "بلا: فقط جهات الاتصال المسندة لهذا المستخدم أو قسمه. عرض: جميع جهات اتصال النشاط التجاري.",
  'permissions.contacts.viewMobileNumber.label': "عرض رقم الهاتف المحمول",
  'permissions.contacts.viewMobileNumber.description': "عرض أرقام الهواتف المحمولة لجهات الاتصال",
  'permissions.contacts.manage.label': "إدارة جهات الاتصال",
  'permissions.contacts.manage.description': "إنشاء أو تعديل أو حذف أو دمج جهات الاتصال. مستقلة عن صلاحية عرض جهات الاتصال.",
  'permissions.contacts.import.label': "استيراد جهات الاتصال",
  'permissions.contacts.import.description': "استيراد جهات الاتصال من ملف أو من الجهاز، بما في ذلك الحملات",
  'permissions.contacts.export.label': "تصدير جهات الاتصال",
  'permissions.contacts.export.description': "تصدير قائمة جهات الاتصال",
  'permissions.contacts.manageTags.label': "إدارة وسوم جهات الاتصال",
  'permissions.contacts.manageTags.description': "إضافة أو إزالة وسوم جهات الاتصال",
  'permissions.contacts.manageNotes.label': "إدارة ملاحظات جهات الاتصال",
  'permissions.contacts.manageNotes.description': "إضافة أو إزالة ملاحظات على جهة الاتصال",
  'permissions.contacts.manageAssignments.label': "إدارة تعيينات جهات الاتصال",
  'permissions.contacts.manageAssignments.description': "تعيين جهات الاتصال للمستخدمين أو الأقسام",
  'permissions.reports.view.label': "عرض التقارير",
  'permissions.reports.view.description': "عرض: بياناته الخاصة فقط. تعديل: بيانات فريقه أيضًا (مدير). مسؤول: كل البيانات دون قيود.",
  'permissions.reports.export.label': "تصدير واستيراد التقارير",
  'permissions.reports.export.description': "تصدير بيانات التقارير واستيراد قوالب التقارير المحفوظة",
  'permissions.reports.manageSavedReports.label': "التقارير المحفوظة",
  'permissions.reports.manageSavedReports.description': "عرض: تحميل التقارير المحفوظة من الآخرين كقوالب. تعديل: إنشاء وتعديل وحذف تقاريره المحفوظة الخاصة.",
  'permissions.phone.viewCallHistory.label': "عرض سجل المكالمات",
  'permissions.phone.viewCallHistory.description': "عرض: مكالماته الخاصة فقط. تعديل: مكالمات فريقه أيضًا (مدير). مسؤول: كل مكالمات النشاط التجاري دون قيود.",
  'permissions.phone.playRecording.label': "تشغيل تسجيلات المكالمات",
  'permissions.phone.playRecording.description': "الاستماع إلى تسجيلات المكالمات الظاهرة ضمن صلاحية عرض سجل المكالمات",
  'permissions.phone.downloadRecording.label': "تنزيل تسجيلات المكالمات",
  'permissions.phone.downloadRecording.description': "حفظ أو مشاركة نسخة من تسجيل مكالمة",
  'permissions.notifications.manageSettings.label': "إدارة إعدادات الإشعارات",
  'permissions.notifications.manageSettings.description': "عرض أو تعديل إعدادات الإشعارات",
  'permissions.notifications.sendBroadcast.label': "إرسال إشعارات جماعية",
  'permissions.notifications.sendBroadcast.description': "إرسال إشعارات جماعية إلى الفريق",
  'permissions.storage.upload.label': "رفع الملفات",
  'permissions.storage.upload.description': "رفع الوسائط/الملفات إلى التخزين",
  'permissions.storage.manage.label': "إدارة التخزين",
  'permissions.storage.manage.description': "حذف الملفات الخاصة، أو إدارة الحصة وأي ملف",

  // Calendar — BusinessCalendarScreen.tsx
  'calendar.business.searchPlaceholder': "البحث عن الأحداث...",
  'calendar.business.selectDate': "اختر تاريخًا",
  'calendar.business.unknownCalendar': "تقويم غير معروف",
  'calendar.business.untitledEvent': "حدث بدون عنوان",
  'calendar.business.noEventsFound': "لم يتم العثور على أحداث",
  'calendar.business.noEventsForDay': "لا توجد أحداث لهذا اليوم",
  'calendar.business.tryAdjustingFilters': "جرّب تعديل عوامل التصفية",
  'calendar.business.createFirstEvent': "أنشئ أول حدث لك للبدء",
  'calendar.business.allCalendars': "كل التقاويم",
  'calendar.business.loadCalendarsFailed': "فشل تحميل التقاويم",

  // Calendar — CalendarCreateScreen.tsx
  'calendar.create.businessRequired': "معلومات النشاط التجاري مطلوبة",
  'calendar.create.userRequired': "معلومات المستخدم مطلوبة",
  'calendar.create.title': "التقويم",
  'calendar.create.subtitle': "أنشئ تقويمًا جديدًا لنشاطك التجاري",
  'calendar.create.personalTitle': "تقويم شخصي",
  'calendar.create.personalSubtitle': "أنشئ تقويمًا خاصًا بجدولك الشخصي",
  'calendar.create.successMessage': "تم إنشاء التقويم بنجاح",
  'calendar.create.failedMessage': "فشل إنشاء التقويم",
  'calendar.create.submitLabel': "إنشاء تقويم",

  // Calendar — CalendarBookingScreen.tsx
  'calendar.booking.bookingFailedError': "فشل الحجز",
  'calendar.booking.pickFileFailedError': "فشل اختيار الملف",
  'calendar.booking.selectTimeTitle': "اختر الوقت",
  'calendar.booking.selectAppointmentTitle': "اختر موعدًا",
  'calendar.booking.eventDetailsTitle': "تفاصيل الحدث",
  'calendar.booking.selectDateTitle': "اختر تاريخًا",
  'calendar.booking.noSlotsForDay': "لا توجد أوقات متاحة لهذا اليوم",
  'calendar.booking.available': "متاح",
  'calendar.booking.eventFallback': "حدث",
  'calendar.booking.untitledEvent': "حدث بدون عنوان",
  'calendar.booking.timeRangeTo': "إلى",
  'calendar.booking.cancelButton': "إلغاء",
  'calendar.booking.bookButton': "احجز",
  'calendar.booking.viewExistingAppointments': "عرض المواعيد الحالية",
  'calendar.booking.appointmentsOnDay': "{{count}} {{label}} في هذا اليوم",
  'calendar.booking.appointmentSingular': "موعد",
  'calendar.booking.appointmentPlural': "مواعيد",
  'calendar.booking.hourLabel': "الساعة",
  'calendar.booking.minuteLabel': "الدقيقة",
  'calendar.booking.periodLabel': "الفترة",
  'calendar.booking.durationLabel': "المدة",
  'calendar.booking.durationMinutes': "{{minutes}} دقيقة",
  'calendar.booking.durationSlots': "فترات {{minutes}} دقيقة",
  'calendar.booking.notesLabel': "ملاحظات (اختياري)",
  'calendar.booking.notesPlaceholder': "أضف أي ملاحظات إضافية...",
  'calendar.booking.joinUrlLabel': "رابط الانضمام (اختياري)",
  'calendar.booking.joinUrlPlaceholder': "https://meet.example.com/...",
  'calendar.booking.attachmentsLabel': "المرفقات (اختياري)",
  'calendar.booking.addFileButton': "إضافة ملف",
  'calendar.booking.createNewAppointment': "إنشاء موعد جديد",
  'calendar.booking.addNewAppointmentForDay': "أضف موعدًا جديدًا لهذا اليوم",
  'calendar.booking.calendarFallback': "التقويم",
  'calendar.booking.titleLabel': "العنوان",
  'calendar.booking.descriptionLabel': "الوصف",
  'calendar.booking.locationLabel': "الموقع",
  'calendar.booking.meetingLinkLabel': "رابط الاجتماع",
  'calendar.booking.attachmentsWithCount': "المرفقات ({{count}})",
  'calendar.booking.attachmentFallback': "مرفق {{number}}",
  'calendar.booking.autoCloseText': "سيتم إغلاق هذه النافذة تلقائيًا",

  // Calendar — CalendarEditScreen.tsx
  'calendar.edit.loading': "جارٍ تحميل التقويم...",
  'calendar.edit.notFound': "التقويم غير موجود",
  'calendar.edit.loadFailed': "فشل تحميل التقويم",
  'calendar.edit.calendarIdRequired': "معرّف التقويم مطلوب",
  'calendar.edit.businessRequired': "معلومات النشاط التجاري مطلوبة",
  'calendar.edit.updateSuccess': "تم تحديث التقويم بنجاح",
  'calendar.edit.updateFailed': "فشل تحديث التقويم",
  'calendar.edit.title': "التقويم",
  'calendar.edit.subtitle': "تعديل إعدادات التقويم",
  'calendar.edit.submitLabel': "تحديث التقويم",

  // Calendar — CalendarListScreen.tsx
  'calendar.list.loading': "جارٍ تحميل التقاويم...",
  'calendar.list.loadFailed': "فشل تحميل التقاويم",
  'calendar.list.companyCalendars': "تقاويم الشركة",
  'calendar.list.myPersonalCalendar': "تقويمي الشخصي",
  'calendar.list.noCompanyCalendars': "لم يتم العثور على تقاويم للشركة.",
  'calendar.list.noPersonalCalendar': "لا يوجد تقويم شخصي بعد — أنشئ واحدًا لمزامنة جدولك الخاص.",
  'calendar.list.createBusinessCalendar': "إنشاء تقويم للشركة",
  'calendar.list.createPersonalCalendar': "إنشاء تقويم شخصي",
  'calendar.list.deleteSuccess': "تم حذف التقويم بنجاح",
  'calendar.list.deleteFailed': "فشل حذف التقويم",
  'calendar.list.deleteTitle': "حذف التقويم",
  'calendar.list.deleteMessage': "هل أنت متأكد أنك تريد حذف هذا التقويم؟ سيتم أيضًا حذف جميع الأحداث في هذا التقويم.",
  'calendar.list.deleteConfirm': "حذف",
  'calendar.list.deleteCancel': "إلغاء",
  'calendar.list.retry': "إعادة المحاولة",

  // Calendar — EventCreateScreen.tsx
  'calendar.eventCreate.missingInfo': "معلومات النشاط التجاري أو التقويم مفقودة",
  'calendar.eventCreate.successMessage': "تم إنشاء الحدث بنجاح",
  'calendar.eventCreate.failedMessage': "فشل إنشاء الحدث",
  'calendar.eventCreate.title': "إنشاء حدث",
  'calendar.eventCreate.submitLabel': "إنشاء حدث",

  // Calendar — EventForm.tsx
  'calendar.eventForm.defaultSubmitLabel': "حفظ الحدث",
  'calendar.eventForm.titleRequired': "عنوان الحدث مطلوب",
  'calendar.eventForm.endDateAfterStartDate': "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
  'calendar.eventForm.endTimeAfterStartTime': "يجب أن يكون وقت الانتهاء بعد وقت البدء",
  'calendar.eventForm.endDateTimeAfterStart': "يجب أن يكون تاريخ ووقت الانتهاء بعد تاريخ ووقت البدء",
  'calendar.eventForm.meetingUrlRequired': "رابط الاجتماع مطلوب للاجتماعات عبر الإنترنت",
  'calendar.eventForm.selectCalendarError': "الرجاء اختيار تقويم",
  'calendar.eventForm.invalidDate': "تاريخ غير صالح",
  'calendar.eventForm.uploadAttachmentFailed': "فشل تحميل المرفق",
  'calendar.eventForm.pickAttachmentFailed': "فشل اختيار المرفق. حاول مرة أخرى.",
  'calendar.eventForm.titleLabel': "عنوان الحدث *",
  'calendar.eventForm.titlePlaceholder': "مثال: اجتماع فريق، مكالمة عميل",
  'calendar.eventForm.calendarLabel': "التقويم *",
  'calendar.eventForm.selectCalendarPlaceholder': "اختر تقويمًا",
  'calendar.eventForm.descriptionLabel': "الوصف",
  'calendar.eventForm.descriptionPlaceholder': "وصف الحدث",
  'calendar.eventForm.contactsLabel': "جهات الاتصال",
  'calendar.eventForm.selectContactsPlaceholder': "اختر جهات الاتصال",
  'calendar.eventForm.contactsSelectedCount': "تم اختيار {{count}} {{label}}",
  'calendar.eventForm.contactSingular': "جهة اتصال",
  'calendar.eventForm.contactPlural': "جهات اتصال",
  'calendar.eventForm.searchContactsPlaceholder': "ابحث في جهات الاتصال...",
  'calendar.eventForm.loadingContacts': "جارٍ تحميل جهات الاتصال...",
  'calendar.eventForm.noContactsFound': "لم يتم العثور على جهات اتصال",
  'calendar.eventForm.noContactsAvailable': "لا توجد جهات اتصال متاحة",
  'calendar.eventForm.unknownContact': "جهة اتصال غير معروفة",
  'calendar.eventForm.unknownContactShort': "غير معروف",
  'calendar.eventForm.allDayEventLabel': "حدث طوال اليوم",
  'calendar.eventForm.dateTimeLabel': "التاريخ والوقت *",
  'calendar.eventForm.startDateLabel': "تاريخ البدء",
  'calendar.eventForm.endDateLabel': "تاريخ الانتهاء",
  'calendar.eventForm.startLabel': "البدء",
  'calendar.eventForm.endLabel': "الانتهاء",
  'calendar.eventForm.meetingTypeLabel': "نوع الاجتماع",
  'calendar.eventForm.locationNameLabel': "اسم الموقع",
  'calendar.eventForm.locationNamePlaceholder': "مثال: قاعة الاجتماعات أ",
  'calendar.eventForm.addressLabel': "العنوان",
  'calendar.eventForm.addressPlaceholder': "العنوان الكامل",
  'calendar.eventForm.meetingProviderLabel': "مزوّد الاجتماع",
  'calendar.eventForm.meetingUrlLabel': "رابط الاجتماع *",
  'calendar.eventForm.meetingUrlPlaceholder': "https://...",
  'calendar.eventForm.meetingPasswordLabel': "كلمة مرور الاجتماع",
  'calendar.eventForm.optionalPlaceholder': "اختياري",
  'calendar.eventForm.attachmentsLabel': "المرفقات",
  'calendar.eventForm.uploadingText': "جارٍ التحميل...",
  'calendar.eventForm.addAttachmentButton': "إضافة مرفق",
  'calendar.eventForm.notesLabel': "الملاحظات",
  'calendar.eventForm.noteContentPlaceholder': "محتوى الملاحظة",
  'calendar.eventForm.addNotePlaceholder': "أضف ملاحظة...",
  'calendar.eventForm.remindersLabel': "التذكيرات",
  'calendar.eventForm.remindersHelperText': "احصل على إشعار قبل بدء هذا الحدث",
  'calendar.eventForm.reminderAtTimeOfEvent': "عند وقت الحدث",
  'calendar.eventForm.reminderMinutes5': "قبل 5 دقائق",
  'calendar.eventForm.reminderMinutes15': "قبل 15 دقيقة",
  'calendar.eventForm.reminderMinutes30': "قبل 30 دقيقة",
  'calendar.eventForm.reminderHour1': "قبل ساعة",
  'calendar.eventForm.reminderDay1': "قبل يوم",
  'calendar.eventForm.reminderMinutesBefore': "قبل {{count}} دقيقة",
  'calendar.eventForm.reminderHoursBefore': "قبل {{count}} ساعة",
  'calendar.eventForm.reminderDaysBefore': "قبل {{count}} يوم",
  'calendar.eventForm.reminderCustomPlaceholder': "دقائق مخصصة قبل الحدث",
  'calendar.eventForm.cancelButton': "إلغاء",

  // Calendar — EventDetailScreen.tsx
  'calendar.eventDetail.loadFailed': "فشل تحميل الحدث",
  'calendar.eventDetail.deleteSuccess': "تم حذف الحدث بنجاح",
  'calendar.eventDetail.deleteFailed': "فشل حذف الحدث",
  'calendar.eventDetail.title': "تفاصيل الحدث",
  'calendar.eventDetail.loading': "جارٍ تحميل الحدث...",
  'calendar.eventDetail.dateTimeSection': "التاريخ والوقت",
  'calendar.eventDetail.allDay': "طوال اليوم",
  'calendar.eventDetail.until': "حتى {{date}}",
  'calendar.eventDetail.timezone': "المنطقة الزمنية: {{timezone}}",
  'calendar.eventDetail.descriptionSection': "الوصف",
  'calendar.eventDetail.locationSection': "الموقع",
  'calendar.eventDetail.onlineMeetingSection': "اجتماع عبر الإنترنت",
  'calendar.eventDetail.customProvider': "مخصص",
  'calendar.eventDetail.joinMeeting': "الانضمام إلى الاجتماع",
  'calendar.eventDetail.password': "كلمة المرور: {{password}}",
  'calendar.eventDetail.attachmentsSection': "المرفقات ({{count}})",
  'calendar.eventDetail.attachmentFallback': "مرفق {{number}}",
  'calendar.eventDetail.attendeesSection': "الحضور ({{count}})",
  'calendar.eventDetail.myRsvpSection': "ردي",
  'calendar.eventDetail.rsvpAccept': "قبول",
  'calendar.eventDetail.rsvpTentative': "ربما",
  'calendar.eventDetail.rsvpDecline': "رفض",
  'calendar.eventDetail.rsvpUpdated': "تم حفظ ردك",
  'calendar.eventDetail.rsvpFailed': "تعذر حفظ ردك",
  'calendar.eventDetail.deleteTitle': "حذف الحدث",
  'calendar.eventDetail.deleteMessage': "هل أنت متأكد أنك تريد حذف هذا الحدث؟",
  'calendar.eventDetail.deleteConfirm': "حذف",
  'calendar.eventDetail.deleteCancel': "إلغاء",
  'calendar.eventDetail.editButton': "تعديل",
  'calendar.eventDetail.deleteButton': "حذف",

  // Calendar — EventListScreen.tsx
  'calendar.eventList.noSelection': "لم يتم تحديد تقويم أو نشاط تجاري",
  'calendar.eventList.loadFailed': "فشل تحميل الأحداث",
  'calendar.eventList.deleteSuccess': "تم حذف الحدث بنجاح",
  'calendar.eventList.deleteFailed': "فشل حذف الحدث",
  'calendar.eventList.fallbackTitle': "الأحداث",
  'calendar.eventList.loading': "جارٍ تحميل الأحداث...",
  'calendar.eventList.retry': "إعادة المحاولة",
  'calendar.eventList.noEventsFound': "لم يتم العثور على أحداث",
  'calendar.eventList.createFirstEvent': "أنشئ أول حدث لك للبدء",
  'calendar.eventList.createEvent': "إنشاء حدث",
  'calendar.eventList.deleteTitle': "حذف الحدث",
  'calendar.eventList.deleteMessage': "هل أنت متأكد أنك تريد حذف هذا الحدث؟",
  'calendar.eventList.deleteConfirm': "حذف",
  'calendar.eventList.deleteCancel': "إلغاء",

  // Calendar — CalendarForm.tsx
  'calendar.calendarForm.nameLabel': "اسم التقويم *",
  'calendar.calendarForm.namePlaceholder': "مثال: تقويم العمل، التقويم الشخصي",
  'calendar.calendarForm.descriptionLabel': "الوصف",
  'calendar.calendarForm.descriptionPlaceholder': "وصف مختصر لهذا التقويم",
  'calendar.calendarForm.colorLabel': "اللون *",
  'calendar.calendarForm.timezoneLabel': "المنطقة الزمنية *",
  'calendar.calendarForm.visibilityLabel': "الظهور",
  'calendar.calendarForm.visibilityPrivate': "خاص",
  'calendar.calendarForm.visibilityPublic': "عام",
  'calendar.calendarForm.visibilityShared': "مشترك",
  'calendar.calendarForm.setDefaultLabel': "تعيين كتقويم افتراضي",
  'calendar.calendarForm.setDefaultDescription': "سيتم استخدام هذا التقويم كافتراضي للأحداث الجديدة",
  'calendar.calendarForm.activeLabel': "نشط",
  'calendar.calendarForm.activeDescription': "التقاويم غير النشطة لن تظهر في قائمة التقاويم",
  'calendar.calendarForm.availabilityLabel': "التوفر",
  'calendar.calendarForm.availabilityHelperText': "حدد متى يكون هذا التقويم متاحًا",
  'calendar.calendarForm.availabilityModeAllTime': "طوال الوقت",
  'calendar.calendarForm.availabilityModePeriod': "فترة",
  'calendar.calendarForm.availabilityModeDays': "أيام",
  'calendar.calendarForm.startDateLabel': "تاريخ البدء",
  'calendar.calendarForm.endDateLabel': "تاريخ الانتهاء",
  'calendar.calendarForm.selectDatePlaceholder': "اختر تاريخًا",
  'calendar.calendarForm.allDayLabel': "طوال اليوم",
  'calendar.calendarForm.allDayDescription': "متاح على مدار 24 ساعة أو نطاق زمني محدد",
  'calendar.calendarForm.startTimeLabel': "وقت البدء",
  'calendar.calendarForm.endTimeLabel': "وقت الانتهاء",
  'calendar.calendarForm.selectDaysOfWeekLabel': "اختر أيام الأسبوع",
  'calendar.calendarForm.daySunShort': "أحد",
  'calendar.calendarForm.dayMonShort': "اثنين",
  'calendar.calendarForm.dayTueShort': "ثلاثاء",
  'calendar.calendarForm.dayWedShort': "أربعاء",
  'calendar.calendarForm.dayThuShort': "خميس",
  'calendar.calendarForm.dayFriShort': "جمعة",
  'calendar.calendarForm.daySatShort': "سبت",
  'calendar.calendarForm.slotDurationLabel': "مدة الفترة الزمنية (بالدقائق)",
  'calendar.calendarForm.slotDurationPlaceholder': "مثال: 30",
  'calendar.calendarForm.maxBookingsPerSlotLabel': "الحد الأقصى للحجوزات لكل فترة",
  'calendar.calendarForm.maxBookingsPerSlotPlaceholder': "1",
  'calendar.calendarForm.slotDurationHelperText': "اترك مدة الفترة الزمنية فارغة لاعتبار نافذة التوفر بأكملها فترة واحدة قابلة للحجز.",
  'calendar.calendarForm.cancelButton': "إلغاء",
  'calendar.calendarForm.saveButton': "حفظ التقويم",
  'calendar.calendarForm.nameRequiredError': "اسم التقويم مطلوب",
  'calendar.calendarForm.nameMinLengthError': "يجب أن يتكون اسم التقويم من حرفين على الأقل",
  'calendar.calendarForm.timezoneRequiredError': "المنطقة الزمنية مطلوبة",
  'calendar.calendarForm.startDateRequiredError': "تاريخ البدء مطلوب",
  'calendar.calendarForm.endDateRequiredError': "تاريخ الانتهاء مطلوب",
  'calendar.calendarForm.endDateAfterStartError': "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
  'calendar.calendarForm.selectAtLeastOneDayError': "الرجاء اختيار يوم واحد على الأقل",
  'calendar.calendarForm.startTimeRequiredError': "وقت البدء مطلوب",
  'calendar.calendarForm.endTimeRequiredError': "وقت الانتهاء مطلوب",
  'calendar.calendarForm.endTimeAfterStartError': "يجب أن يكون وقت الانتهاء بعد وقت البدء",

  // Calendar — CalendarGoogleSync.tsx
  'calendar.googleSync.title': "المزامنة مع جوجل",
  'calendar.googleSync.helperText': "حافظ على مزامنة هذا التقويم مع تقويم جوجل — ستظهر الأحداث المضافة من أي جانب في الجانبين.",
  'calendar.googleSync.connectButton': "ربط تقويم جوجل",
  'calendar.googleSync.connectedTitle': "تم الربط",
  'calendar.googleSync.connectedMessage': "تم ربط {{email}}",
  'calendar.googleSync.connectFailedTitle': "تعذر الربط",
  'calendar.googleSync.pickCalendar': "اختر تقويم جوجل للمزامنة",
  'calendar.googleSync.hidePicker': "إخفاء تقويمات جوجل",
  'calendar.googleSync.noGoogleCalendars': "لم يتم العثور على تقويمات في حساب جوجل هذا.",
  'calendar.googleSync.linkedTitle': "تم ربط التقويم",
  'calendar.googleSync.linkedMessage': "أصبح \"{{name}}\" قيد المزامنة الآن.",
  'calendar.googleSync.linkFailedTitle': "تعذر ربط التقويم",
  'calendar.googleSync.updateFailedTitle': "تعذر التحديث",
  'calendar.googleSync.genericRetry': "يرجى المحاولة مرة أخرى.",
  'calendar.googleSync.tapToChange': "اضغط للتغيير",
  'calendar.googleSync.syncEnabledLabel': "المزامنة مفعّلة",
  'calendar.googleSync.directionInbound': "جوجل ← DISLIX",
  'calendar.googleSync.directionOutbound': "DISLIX ← جوجل",
  'calendar.googleSync.directionBoth': "الاتجاهان",
  'calendar.googleSync.changeCalendar': "تغيير التقويم",
  'calendar.googleSync.unlinkCalendar': "إلغاء الربط",
  'calendar.googleSync.unlinkFailedTitle': "تعذر إلغاء ربط التقويم",

  // Calendar — EventEditScreen.tsx
  'calendar.eventEdit.missingInfo': "معلومات مطلوبة مفقودة",
  'calendar.eventEdit.updateSuccess': "تم تحديث الحدث بنجاح",
  'calendar.eventEdit.updateFailed': "فشل تحديث الحدث",
  'calendar.eventEdit.selectCalendarError': "الرجاء اختيار تقويم",
  'calendar.eventEdit.createSuccess': "تم إنشاء الحدث بنجاح",
  'calendar.eventEdit.createFailed': "فشل إنشاء الحدث",
  'calendar.eventEdit.saveFailedUpdate': "فشل تحديث الحدث",
  'calendar.eventEdit.saveFailedCreate': "فشل إنشاء الحدث",
  'calendar.eventEdit.loadFailed': "فشل تحميل الحدث",
  'calendar.eventEdit.loading': "جارٍ تحميل الحدث...",
  'calendar.eventEdit.notFound': "الحدث غير موجود",
  'calendar.eventEdit.loadingCalendars': "جارٍ تحميل التقاويم...",
  'calendar.eventEdit.noCalendarsAvailable': "لا توجد تقاويم متاحة. الرجاء إنشاء تقويم أولاً.",
  'calendar.eventEdit.editTitle': "تعديل الحدث",
  'calendar.eventEdit.createTitle': "إنشاء حدث",
  'calendar.eventEdit.updateSubtitle': "تحديث تفاصيل الحدث",
  'calendar.eventEdit.createSubtitle': "إضافة حدث جديد",
  'calendar.eventEdit.untitledEvent': "حدث بدون عنوان",
  'calendar.eventEdit.dateTimeSection': "التاريخ والوقت",
  'calendar.eventEdit.allDay': "طوال اليوم",
  'calendar.eventEdit.attendeesSection': "الحضور وجهات الاتصال",
  'calendar.eventEdit.externalAttendeeFallback': "حضور خارجي",
  'calendar.eventEdit.userIdLabel': "معرّف المستخدم: {{userId}}",
  'calendar.eventEdit.onlineMeetingSection': "اجتماع عبر الإنترنت",
  'calendar.eventEdit.locationSection': "الموقع",
  'calendar.eventEdit.joinMeeting': "الانضمام إلى الاجتماع",
  'calendar.eventEdit.eventDetailsSection': "تفاصيل الحدث",
  'calendar.eventEdit.updateSubmitLabel': "تحديث الحدث",
  'calendar.eventEdit.createSubmitLabel': "إنشاء حدث",
  'calendar.eventEdit.deleteSuccess': "تم حذف الحدث بنجاح",
  'calendar.eventEdit.deleteFailed': "فشل حذف الحدث",
  'calendar.eventEdit.deleteTitle': "حذف الحدث",
  'calendar.eventEdit.deleteMessage': "هل أنت متأكد أنك تريد حذف هذا الحدث؟",
  'calendar.eventEdit.deleteConfirm': "حذف",
  'calendar.eventEdit.deleteCancel': "إلغاء",

  // Calendar — CalendarList.tsx
  'calendar.calendarList.loading': "جارٍ تحميل التقاويم...",
  'calendar.calendarList.emptyDefault': "لم يتم العثور على تقاويم",

  // Calendar — CalendarMonthView.tsx
  'calendar.monthView.untitledEvent': "بدون عنوان",
  'calendar.monthView.moreEvents': "+{{count}} أخرى",
  'calendar.monthView.daySun': "أحد",
  'calendar.monthView.dayMon': "اثنين",
  'calendar.monthView.dayTue': "ثلاثاء",
  'calendar.monthView.dayWed': "أربعاء",
  'calendar.monthView.dayThu': "خميس",
  'calendar.monthView.dayFri': "جمعة",
  'calendar.monthView.daySat': "سبت",

  // Calendar — EventCard.tsx
  'calendar.eventCard.allDay': "طوال اليوم",
  'calendar.eventCard.until': "حتى {{date}}",
  'calendar.eventCard.online': "عبر الإنترنت",
  'calendar.eventCard.acceptedCount': "{{accepted}}/{{total}} موافقة",

  // Calendar — CalendarCard.tsx
  'calendar.calendarCard.default': "افتراضي",
  'calendar.calendarCard.eventCount': "{{count}} حدث",
  'calendar.calendarCard.inactive': "غير نشط",
  'calendar.calendarCard.visibilityPublic': "عام",
  'calendar.calendarCard.visibilityPrivate': "خاص",
  'calendar.calendarCard.visibilityShared': "مشترك",

  // ─── Visits setup ───────────────────────────────────────────────────────────
  'visitsSetup.title': 'إعداد الزيارات',
  'visitsSetup.enablePrompt': 'فعّل الزيارات الميدانية لضبط الإعدادات الافتراضية، والنطاق الجغرافي، ومتطلبات الصور، والنتائج.',
  'visitsSetup.enableButton': 'تفعيل الزيارات',
  'visitsSetup.disableButton': 'إيقاف الزيارات',
  'visitsSetup.disableConfirmTitle': 'إيقاف الزيارات؟',
  'visitsSetup.disableConfirmMessage': 'سيؤدي هذا إلى إزالة جميع إعدادات الزيارات. لن يتأثر سجل الزيارات الحالية.',
  'visitsSetup.sections.defaults': 'الإعدادات الافتراضية',
  'visitsSetup.sections.location': 'فرض الموقع',
  'visitsSetup.sections.photos': 'متطلبات الصور',
  'visitsSetup.sections.eligibility': 'الأهلية',
  'visitsSetup.sections.outcomes': 'النتائج',
  'visitsSetup.sections.calendar': 'إعدادات التقويم الافتراضية',
  'visitsSetup.sections.routing': 'اتجاهات المسار',
  'visitsSetup.fields.expectedDurationMinutes': 'المدة المتوقعة (دقائق)',
  'visitsSetup.fields.dailyVisitTarget': 'الهدف اليومي للزيارات',
  'visitsSetup.fields.defaultCampaignDurationDays': 'مدة الحملة الافتراضية (أيام)',
  'visitsSetup.fields.defaultVisitWindowHours': 'نافذة الزيارة الافتراضية (ساعات)',
  'visitsSetup.fields.locationEnabled': 'فرض الموقع',
  'visitsSetup.fields.radiusMeters': 'النطاق المسموح به (متر)',
  'visitsSetup.fields.maxAccuracyMeters': 'أقصى دقة لتحديد الموقع (متر)',
  'visitsSetup.fields.allowOverride': 'السماح بالتجاوز مع إبداء السبب',
  'visitsSetup.fields.requireOnStart': 'طلب صورة عند البدء',
  'visitsSetup.fields.requireOnEnd': 'طلب صورة عند الانتهاء',
  'visitsSetup.fields.minPhotosOnStart': 'الحد الأدنى للصور عند البدء',
  'visitsSetup.fields.minPhotosOnEnd': 'الحد الأدنى للصور عند الانتهاء',
  'visitsSetup.fields.maxPhotos': 'الحد الأقصى للصور',
  'visitsSetup.fields.cameraOnlyNote': 'التقاط بالكاميرا فقط — لا يُسمح برفع صور من المعرض',
  'visitsSetup.fields.eligibleUsers': 'المستخدمون المؤهلون',
  'visitsSetup.fields.eligibleDepartments': 'الأقسام المؤهلة',
  'visitsSetup.fields.selectUsers': 'اختر المستخدمين',
  'visitsSetup.fields.selectDepartments': 'اختر الأقسام',
  'visitsSetup.fields.autoCreateEvent': 'إنشاء حدث تقويم تلقائيًا',
  'visitsSetup.fields.useRoadRouting': 'استخدام الاتجاهات وفق الطرق',
  'visitsSetup.fields.useRoadRoutingHint': 'يتطلب تفعيل خدمة تحديد المسار المستضافة ذاتياً على الخادم. عند الإيقاف، أو إذا كانت الخدمة غير متاحة، تُستخدم مسافة الخط المستقيم بدلاً من ذلك.',
  'visitsSetup.fields.reminderOffsets': 'أوقات التذكير (بالدقائق، مفصولة بفواصل)',
  'visitsSetup.fields.defaultCalendarId': 'معرّف التقويم الافتراضي',
  'visitsSetup.outcomes.addOutcome': 'إضافة نتيجة',
  'visitsSetup.outcomes.editTitle': 'تعديل النتيجة',
  'visitsSetup.outcomes.label': 'التسمية',
  'visitsSetup.outcomes.labelAr': 'التسمية (عربي)',
  'visitsSetup.outcomes.icon': 'الأيقونة',
  'visitsSetup.outcomes.color': 'اللون',
  'visitsSetup.outcomes.resultType': 'نوع النتيجة',
  'visitsSetup.outcomes.resultTypeSuccess': 'نجاح',
  'visitsSetup.outcomes.resultTypeNeutral': 'محايد',
  'visitsSetup.outcomes.resultTypeFailure': 'فشل',
  'visitsSetup.outcomes.active': 'نشط',
  'visitsSetup.outcomes.actionType': 'الإجراء',
  'visitsSetup.outcomes.actionNone': 'بدون',
  'visitsSetup.outcomes.actionReschedule': 'إعادة الجدولة',
  'visitsSetup.outcomes.actionReminder': 'إنشاء تذكير',
  'visitsSetup.outcomes.actionAssign': 'تعيين/إعادة تعيين',
  'visitsSetup.outcomes.actionNote': 'إضافة ملاحظة',
  'visitsSetup.outcomes.removeConfirmTitle': 'إزالة النتيجة؟',
  'visitsSetup.outcomes.removeConfirmMessage': 'لن تكون هذه النتيجة متاحة بعد الآن للزيارات الجديدة.',
  'visitsSetup.save': 'حفظ',
  'visitsSetup.cancel': 'إلغاء',
  'visitsSetup.savedSuccess': 'تم الحفظ بنجاح',
  'visitsSetup.saveFailed': 'فشل الحفظ',

  // ─── الزيارات (المرحلة 2 — إدارة وتنفيذ الزيارة الفردية) ─────────────────────
  'visits.common.save': 'حفظ',
  'visits.common.cancel': 'إلغاء',
  'visits.errors.generic': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'visits.status.pending': 'قيد الانتظار',
  'visits.status.scheduled': 'مجدولة',
  'visits.status.in_progress': 'قيد التنفيذ',
  'visits.status.completed': 'مكتملة',
  'visits.status.missed': 'فائتة',
  'visits.status.cancelled': 'ملغاة',
  'visits.status.rescheduled': 'أعيدت جدولتها',
  'visits.priority.low': 'منخفضة',
  'visits.priority.normal': 'عادية',
  'visits.priority.high': 'عالية',
  'visits.priority.urgent': 'عاجلة',

  'visits.filters.all': 'الكل',
  'visits.filters.active': 'نشطة',
  'visits.list.title': 'الزيارات',
  'visits.list.createVisit': 'إنشاء زيارة',
  'visits.list.createVisitSubtitle': 'جدولة زيارة ميدانية واحدة',
  'visits.list.createCampaign': 'إنشاء حملة',
  'visits.list.createCampaignSubtitle': 'خطط ووزّع الزيارات على مجموعة من جهات الاتصال',
  'visits.list.createMenuTitle': 'ماذا تريد أن تنشئ؟',
  'visits.list.contact': 'جهة الاتصال',
  'visits.list.noSchedule': 'غير مجدولة',
  'visits.list.empty': 'لا توجد زيارات',
  'visits.list.routeButton': 'المسار',
  'visits.list.campaignsButton': 'الحملات',
  'visits.list.settingsButton': 'إعدادات الزيارات',
  'visits.route.title': 'المسار',
  'visits.route.titleForCampaign': 'مسار الحملة',
  'visits.route.visitsCount': 'تم اختيار {{selected}} من {{total}} زيارة',
  'visits.route.selectAll': 'تحديد الكل',
  'visits.route.deselectAll': 'إلغاء تحديد الكل',
  'visits.route.noEligibleVisits': 'لا توجد زيارات مؤهلة لتحديد المسار الآن',
  'visits.route.anchorCurrentLocation': 'موقعي الحالي',
  'visits.route.anchorManual': 'إدخال الإحداثيات',
  'visits.route.latitude': 'خط العرض',
  'visits.route.longitude': 'خط الطول',
  'visits.route.directionsMode': 'وضع الاتجاهات',
  'visits.route.modeDriving': 'قيادة',
  'visits.route.modeWalking': 'مشي',
  'visits.route.modeCycling': 'دراجة',
  'visits.route.modeMotorcycle': 'دراجة نارية',
  'visits.route.compute': 'حساب المسار',
  'visits.route.openInMaps': 'فتح في الخرائط',
  'visits.route.fallbackBanner': 'استخدام المسافة المباشرة - خدمة التوجيه غير متاحة',
  'visits.route.notIncluded': 'غير مضمّن',
  'visits.route.notIncludedNote': 'تعذر تحديد مسار لهذه الزيارات - الموقع مفقود',
  'visits.route.totalDistance': 'إجمالي المسافة',
  'visits.route.noVisitsSelected': 'اختر زيارة واحدة على الأقل',
  'visits.route.noAnchor': 'حدد نقطة بداية أولاً',

  'visits.detail.title': 'تفاصيل الزيارة',
  'visits.detail.overview': 'نظرة عامة',
  'visits.detail.startNextVisit': 'بدء الزيارة التالية',
  'visits.detail.contact': 'جهة الاتصال',
  'visits.detail.unknownContact': 'جهة اتصال غير معروفة',
  'visits.detail.viewProfile': 'عرض الملف الشخصي',
  'visits.detail.viewOnDislixMaps': 'عرض على خرائط DISLIX',
  'visits.map.closeDirections': 'إغلاق الاتجاهات',
  'visits.map.expand': 'تكبير الخريطة',
  'visits.detail.backToVisits': 'العودة إلى الزيارات',
  'visits.detail.backToHome': 'العودة إلى الرئيسية',
  'visits.detail.partOfCampaign': 'جزء من حملة',
  'visits.detail.singleVisit': 'زيارة منفردة',
  'visits.detail.targetLocation': 'الموقع المستهدف',
  'visits.detail.schedule': 'الجدولة',
  'visits.detail.scheduledFor': 'موعد الزيارة',
  'visits.detail.dueBy': 'الموعد النهائي',
  'visits.detail.expectedDuration': 'المدة المتوقعة',
  'visits.detail.minutes': 'دقائق',
  'visits.detail.assignment': 'الإسناد',
  'visits.detail.assignedUser': 'المستخدم المسند إليه',
  'visits.detail.assignedDepartment': 'القسم المسند إليه',
  'visits.detail.geoStamps': 'سجلات الموقع',
  'visits.detail.startGeoStamp': 'موقع البدء',
  'visits.detail.endGeoStamp': 'موقع الانتهاء',
  'visits.detail.photos': 'الصور',
  'visits.detail.outcome': 'النتيجة',
  'visits.detail.action': 'الإجراء',
  'visits.detail.notes': 'الملاحظات',
  'visits.detail.addNote': 'إضافة ملاحظة',
  'visits.detail.notePlaceholder': 'اكتب ملاحظة...',
  'visits.detail.noNotes': 'لا توجد ملاحظات بعد',
  'visits.detail.startVisit': 'بدء الزيارة',
  'visits.detail.continueVisit': 'متابعة الزيارة',
  'visits.detail.claimVisit': 'استلام الزيارة',
  'visits.detail.cancelVisit': 'إلغاء الزيارة',
  'visits.detail.cancelConfirmTitle': 'إلغاء هذه الزيارة؟',
  'visits.detail.cancelConfirmMessage': 'سيتم تعليم هذه الزيارة كملغاة. لا يمكن التراجع عن هذا الإجراء.',
  'visits.detail.cancelReasonLabel': 'سبب الإلغاء',
  'visits.detail.cancelReasonPlaceholder': 'لماذا يتم إلغاء هذه الزيارة؟',
  'visits.detail.getDirections': 'الحصول على الاتجاهات',
  'visits.detail.previousVisits': 'الزيارات السابقة',
  'visits.detail.contactNotes': 'ملاحظات جهة الاتصال',
  'visits.detail.contactNotePlaceholder': 'أضف ملاحظة حول جهة الاتصال هذه...',

  'visits.create.title': 'إنشاء زيارة',
  'visits.create.contactSection': 'جهة الاتصال',
  'visits.create.selectContact': 'اختر جهة اتصال',
  'visits.create.changeContact': 'تغيير جهة الاتصال',
  'visits.create.searchContacts': 'ابحث عن جهات الاتصال...',
  'visits.create.noContactsFound': 'لم يتم العثور على جهات اتصال',
  'visits.create.assigneeSection': 'المسؤول',
  'visits.create.assignToUser': 'إسناد إلى مستخدم',
  'visits.create.assignToDepartment': 'إسناد إلى قسم',
  'visits.create.selectUser': 'اختر مستخدمًا',
  'visits.create.selectDepartment': 'اختر قسمًا',
  'visits.create.prioritySection': 'الأولوية',
  'visits.create.scheduleSection': 'الجدولة',
  'visits.create.scheduledDate': 'تاريخ الزيارة',
  'visits.create.scheduledTime': 'وقت الزيارة',
  'visits.create.expectedDuration': 'المدة المتوقعة (دقائق)',
  'visits.create.expectedDurationPlaceholder': 'تُستخدم القيمة الافتراضية للنشاط التجاري',
  'visits.create.createCalendarEvent': 'إنشاء حدث تقويم',
  'visits.create.submit': 'إنشاء الزيارة',
  'visits.create.errors.contactRequired': 'يرجى اختيار جهة اتصال',
  'visits.create.errors.assigneeRequired': 'يرجى إسناد هذه الزيارة إلى مستخدم أو قسم',
  'visits.create.errors.scheduleRequiredForCalendar': 'مطلوب تاريخ جدولة لمزامنة هذه الزيارة مع التقويم',
  'visits.create.errors.contactNoLocation': 'لا يوجد لدى جهة الاتصال هذه موقع أو رابط خرائط أو عنوان، لذا لا يمكن إنشاء زيارة لها. يرجى إضافة موقع لجهة الاتصال أولاً.',

  'visits.execute.title': 'تنفيذ الزيارة',
  'visits.execute.targetLocation': 'الموقع المستهدف',
  'visits.execute.refreshLocation': 'تحديث الموقع',
  'visits.execute.distanceFromYou': 'أنت على بعد {{distance}} متر من الهدف',
  'visits.execute.startPhotos': 'صور البدء',
  'visits.execute.endPhotos': 'صور الانتهاء',
  'visits.execute.overrideReason': 'سبب التجاوز (اختياري)',
  'visits.execute.overrideReasonPlaceholder': 'لماذا أنت خارج النطاق المسموح به؟',
  'visits.execute.startVisit': 'بدء الزيارة',
  'visits.execute.viewOnDislixMaps': 'عرض على خرائط DISLIX',
  'visits.execute.ongoingVisitTitle': 'لديك زيارة جارية',
  'visits.execute.ongoingVisitMessage': 'يجب عليك إنهاء الزيارة الجارية قبل بدء زيارة أخرى.',
  'visits.execute.ongoingVisitAction': 'الذهاب إلى الزيارة الجارية',
  'visits.execute.closeToTarget': 'أنت قريب من الوجهة — اضغط لبدء الزيارة',
  'visits.execute.inProgress': 'الزيارة قيد التنفيذ',
  'visits.execute.liveDirectionsFallback': 'استخدام مسافة الخط المستقيم — خدمة تحديد المسار غير متاحة',
  'visits.execute.unnamedRoad': 'طريق غير مسمى',
  'visits.execute.etaApprox': '~{{minutes}} دقيقة (بحسب السرعة المعتادة للطريق)',
  'visits.execute.blockedNoLocation': 'في انتظار تحديد موقعك قبل بدء الزيارة.',
  'visits.execute.blockedMissingStartPhotos': 'أضف {{count}} صورة على الأقل قبل البدء.',
  'visits.execute.blockedMissingEndPhotos': 'أضف {{count}} صورة على الأقل قبل الإنهاء.',
  'visits.execute.onTheWay': 'في الطريق',
  'visits.execute.routeFastest': 'أسرع مسار',
  'visits.execute.routeAlternative': 'مسار بديل {{number}}',
  'visits.execute.addNoteQuick': 'أضف ملاحظة سريعة',
  'visits.execute.endVisit': 'إنهاء الزيارة',
  'visits.execute.selectOutcome': 'اختر النتيجة',
  'visits.execute.rescheduleHours': 'عدد الساعات من الآن',
  'visits.execute.reminderMinutes': 'عدد الدقائق من الآن',
  'visits.execute.selectAssignee': 'اختر المسؤول',
  'visits.execute.outcomeNote': 'ملاحظة',
  'visits.execute.confirm': 'تأكيد',
  'visits.execute.errors.locationPermissionDenied': 'إذن الموقع مطلوب لبدء الزيارة',
  'visits.execute.errors.locationFailed': 'تعذر الحصول على موقعك الحالي',
  'visits.execute.errors.cameraPermissionDenied': 'إذن الكاميرا مطلوب لالتقاط صورة',
  'visits.execute.errors.photoUploadFailed': 'فشل رفع الصورة',
  'visits.execute.errors.tooFarAway': 'أنت على بعد {{distance}} متر، يجب أن تكون ضمن {{radius}} متر',
  'visits.execute.errors.assigneeRequired': 'يرجى اختيار مستخدم أو قسم',
  'visits.execute.errors.noteRequired': 'يرجى إدخال ملاحظة',

  'visitCampaigns.status.draft': 'مسودة',
  'visitCampaigns.status.active': 'نشطة',
  'visitCampaigns.status.paused': 'متوقفة مؤقتًا',
  'visitCampaigns.status.completed': 'مكتملة',
  'visitCampaigns.status.cancelled': 'ملغاة',

  'visitCampaigns.list.title': 'الحملات',
  'visitCampaigns.list.createCampaign': 'إنشاء حملة',
  'visitCampaigns.list.empty': 'لا توجد حملات',
  'visitCampaigns.list.contactCount': '{{count}} جهة اتصال',

  'visitCampaigns.create.title': 'إنشاء حملة',
  'visitCampaigns.create.back': 'رجوع',
  'visitCampaigns.create.next': 'التالي',
  'visitCampaigns.create.done': 'تم',
  'visitCampaigns.create.basicsSection': 'أساسيات الحملة',
  'visitCampaigns.create.name': 'الاسم',
  'visitCampaigns.create.namePlaceholder': 'مثال: زيارات العملاء للربع الثالث',
  'visitCampaigns.create.description': 'الوصف',
  'visitCampaigns.create.descriptionPlaceholder': 'وصف اختياري',
  'visitCampaigns.create.startDate': 'تاريخ البدء',
  'visitCampaigns.create.endDate': 'تاريخ الانتهاء',
  'visitCampaigns.create.expectedDuration': 'المدة المتوقعة (بالدقائق)',
  'visitCampaigns.create.expectedDurationPlaceholder': 'افتراضيًا حسب إعدادات النشاط التجاري',
  'visitCampaigns.create.dailyVisitTarget': 'الهدف اليومي للزيارات',
  'visitCampaigns.create.dailyVisitTargetPlaceholder': 'هدف يومي اختياري',
  'visitCampaigns.create.assignmentSection': 'التعيين للأقسام/المستخدمين',
  'visitCampaigns.create.assignedDepartments': 'الأقسام المعينة',
  'visitCampaigns.create.assignedUsers': 'المستخدمون المعينون',
  'visitCampaigns.create.selectDepartments': 'اختر الأقسام',
  'visitCampaigns.create.selectUsers': 'اختر المستخدمين',
  'visitCampaigns.create.selectedCount': '{{count}} محدد',
  'visitCampaigns.create.contactPoolSection': 'مجموعة جهات الاتصال',
  'visitCampaigns.create.contactCountSoFar': 'تم إرفاق {{count}} جهة اتصال حتى الآن',
  'visitCampaigns.create.selectContactsTab': 'اختيار جهات الاتصال',
  'visitCampaigns.create.uploadFileTab': 'رفع ملف',
  'visitCampaigns.create.searchAndSelectContacts': 'البحث واختيار جهات الاتصال',
  'visitCampaigns.create.attachSelected': 'إرفاق {{count}} جهات اتصال',
  'visitCampaigns.create.chooseFile': 'اختر ملفًا',
  'visitCampaigns.create.uploadingProgress': 'جارٍ الرفع... {{percent}}%',
  'visitCampaigns.create.uploadStillProcessing': 'يستغرق هذا وقتًا أطول من المتوقع. الاستيراد ما زال قيد التشغيل في الخلفية.',
  'visitCampaigns.create.contactsAttached': 'تم إرفاق {{count}} جهة اتصال',
  'visitCampaigns.create.pendingAttachNote': 'سيتم إرفاق {{count}} إضافية عند التفعيل',
  'visitCampaigns.create.skippedNoLocation': 'تم تخطي {{count}} جهة اتصال (لا يوجد موقع مسجل)',
  'visitCampaigns.create.reviewSection': 'المراجعة والتفعيل',
  'visitCampaigns.create.activateCampaign': 'تفعيل الحملة',
  'visitCampaigns.create.saveAsDraft': 'حفظ كمسودة',
  'visitCampaigns.create.errors.nameRequired': 'يرجى إدخال اسم الحملة',
  'visitCampaigns.create.errors.datesRequired': 'يرجى اختيار تاريخ بدء وانتهاء',
  'visitCampaigns.create.errors.assignmentRequired': 'يجب تعيين قسم أو مستخدم واحد على الأقل قبل إضافة جهات الاتصال',
  'visitCampaigns.create.errors.mustAssignFirst': 'يجب أن يحتوي الحملة على قسم أو مستخدم معين واحد على الأقل قبل إرفاق جهات الاتصال',
  'visitCampaigns.create.errors.noContactsBeforeActivate': 'أضف جهة اتصال واحدة على الأقل إلى هذه الحملة قبل تفعيلها',

  'visitCampaigns.detail.title': 'تفاصيل الحملة',
  'visitCampaigns.detail.activate': 'تفعيل',
  'visitCampaigns.detail.activated': 'تم تفعيل الحملة',
  'visitCampaigns.detail.cancelCampaign': 'إلغاء الحملة',
  'visitCampaigns.detail.cancelConfirmTitle': 'هل تريد إلغاء هذه الحملة؟',
  'visitCampaigns.detail.cancelConfirmMessage': 'سيؤدي هذا إلى إلغاء الحملة وجميع زياراتها غير المكتملة. لا يمكن التراجع عن هذا الإجراء.',
  'visitCampaigns.detail.addContacts': 'إضافة جهات اتصال',
  'visitCampaigns.detail.distribute': 'توزيع',
  'visitCampaigns.detail.route': 'المسار',
  'visitCampaigns.detail.autoDistributedNote': 'تم توزيع الزيارات تلقائيًا على المستخدمين المعينين عند إرفاق جهات الاتصال.',
  'visitCampaigns.detail.visitsSection': 'الزيارات',
  'visitCampaigns.detail.kpiVisitsCreated': 'الزيارات المُنشأة',
  'visitCampaigns.detail.kpiEstimatedTime': 'الوقت الميداني المقدر',
  'visitCampaigns.detail.kpiHours': '~{{hours}} ساعة',
  'visitCampaigns.detail.kpiDaysValue': '~{{days}} يوم',
  'visitCampaigns.detail.kpiDailyTarget': 'هدف {{target}}/يوم',
  'visitOverride.title': 'تجاوز الإعدادات الافتراضية',
  'visitOverride.locationGroup': 'فرض الموقع',
  'visitOverride.locationEnabled': 'فرض موقع تسجيل الوصول',
  'visitOverride.radiusMeters': 'نطاق تسجيل الوصول (متر)',
  'visitOverride.maxAccuracyMeters': 'أقصى دقة GPS مسموح بها (متر)',
  'visitOverride.allowOverrideWithReason': 'السماح بالتجاوز مع ذكر السبب',
  'visitOverride.photosGroup': 'متطلبات الصور',
  'visitOverride.requireOnStart': 'طلب صورة للبدء',
  'visitOverride.minPhotosOnStart': 'الحد الأدنى للصور عند البدء',
  'visitOverride.requireOnEnd': 'طلب صورة للإنهاء',
  'visitOverride.minPhotosOnEnd': 'الحد الأدنى للصور عند الإنهاء',
  'visitOverride.maxPhotos': 'الحد الأقصى للصور',
  'visitOverride.calendarGroup': 'التقويم',
  'visitOverride.autoCreateEvent': 'إنشاء حدث تقويم تلقائياً',
  'visitOverride.inheritPlaceholder': 'استخدام الإعداد الافتراضي',
  'visitOverride.saved': 'تم حفظ الإعدادات المخصصة',
  'visitOverride.save': 'حفظ الإعدادات المخصصة',

  'visitCampaigns.distribute.title': 'توزيع الزيارات',
  'visitCampaigns.distribute.autoSection': 'التوزيع التلقائي',
  'visitCampaigns.distribute.usingDepartment': 'باستخدام القسم: {{name}}',
  'visitCampaigns.distribute.autoDistributeButton': 'توزيع تلقائي بالتساوي',
  'visitCampaigns.distribute.autoDistributed': 'تم توزيع {{count}} زيارة',
  'visitCampaigns.distribute.unassignedSection': 'غير معينة ({{count}})',
  'visitCampaigns.distribute.noUnassigned': 'لا توجد زيارات غير معينة',
  'visitCampaigns.distribute.assign': 'تعيين',
  'visitCampaigns.distribute.reassign': 'إعادة تعيين',

  'permissions.visits.view.label': 'عرض الزيارات',
  'permissions.visits.view.description': 'رؤية الزيارات المسندة إليك. مستوى المدير يرى أيضًا زيارات القسم؛ ومستوى المسؤول يرى الجميع.',
  'permissions.visits.execute.label': 'تنفيذ الزيارات',
  'permissions.visits.execute.description': 'بدء وإنهاء وتسجيل نتائج الزيارات المسندة إليك.',
  'permissions.visits.manageVisits.label': 'إدارة الزيارات',
  'permissions.visits.manageVisits.description': 'إنشاء وتعديل الزيارات الفردية. مستوى المسؤول يمكنه الحذف أيضًا.',
  'permissions.visits.manageCampaigns.label': 'إدارة الحملات',
  'permissions.visits.manageCampaigns.description': 'إنشاء وتعديل حملات الزيارات ومجموعات جهات الاتصال الخاصة بها. مستوى المسؤول يمكنه الحذف أيضًا.',
  'permissions.visits.distribute.label': 'توزيع الزيارات',
  'permissions.visits.distribute.description': 'تعيين أو إعادة توازن مجموعات زيارات القسم بين أعضاء الفريق.',
  'permissions.visits.manageConfig.label': 'إدارة إعدادات الزيارات',
  'permissions.visits.manageConfig.description': 'تفعيل/إيقاف خدمة الزيارات وضبط الإعدادات الافتراضية والفرض والنتائج.',
  'permissions.visits.overrideGeofence.label': 'تجاوز النطاق الجغرافي',
  'permissions.visits.overrideGeofence.description': 'بدء زيارة خارج نطاق الموقع المسموح به، مع ذكر السبب.',
  'permissions.visits.viewPhotos.label': 'عرض صور الزيارات',
  'permissions.visits.viewPhotos.description': 'رؤية الصور الملتقطة أثناء بدء وإنهاء الزيارة.',
  'permissions.task.viewHistory.label': 'سجل المهام',
  'permissions.task.viewHistory.description': 'عرض وإعادة إرسال عمليات تشغيل المهام (مثل الإرسال الجماعي عبر واتساب). مستوى العرض يظهر مهامك فقط، مستوى المدير يضيف مهام فريقك، ومستوى المسؤول يعرض جميع مهام النشاط التجاري.',

  // ─── Product Selector Modal ─────────────────────────────────────────────────
  'productSelector.title': 'اختر المنتجات',
  'productSelector.selectedCount': '{{count}} محدد',
  'productSelector.searchPlaceholder': 'ابحث عن المنتجات...',
  'productSelector.createNewProduct': 'إنشاء منتج جديد',
  'productSelector.productNamePlaceholder': 'اسم المنتج',
  'productSelector.pricePlaceholder': 'السعر',
  'productSelector.creating': 'جارٍ الإنشاء...',
  'productSelector.createAndSelect': 'إنشاء وتحديد',
  'productSelector.loadingProducts': 'جارٍ تحميل المنتجات...',
  'productSelector.noProductsFound': 'لا توجد منتجات',
  'productSelector.tryDifferentSearch': 'جرّب كلمة بحث مختلفة',
  'productSelector.createProductsFirst': 'أنشئ منتجات أولاً',
  'productSelector.addSelected': 'إضافة المحدد',

  // ─── Quotations: List ────────────────────────────────────────────────────────
  'quotations.list.title': 'عروض الأسعار',
  'quotations.list.templates': 'القوالب',
  'quotations.list.newQuotation': 'عرض سعر جديد',
  'quotations.list.searchPlaceholder': 'ابحث عن عروض الأسعار...',
  'quotations.list.countSingular': '{{count}} عرض سعر',
  'quotations.list.countPlural': '{{count}} عروض أسعار',
  'quotations.list.empty': 'لا توجد عروض أسعار بعد',
  'quotations.list.emptyHint': 'اضغط + لإنشاء أول عرض سعر',
  'quotations.list.loadError': 'فشل تحميل عروض الأسعار',
  'quotations.list.all': 'الكل',
  'quotations.list.view': 'عرض',
  'quotations.list.validUntil': 'صالح حتى {{date}}',
  'quotations.list.numberCopied': 'تم نسخ رقم عرض السعر',
  'quotations.list.emptyFiltered': 'لا توجد عروض أسعار بهذه الحالة',
  'quotations.filters.title': 'الترتيب والتصفية',
  'quotations.filters.validUntil': 'صالح حتى',
  'quotations.filters.createdBy': 'أنشأه',
  'quotations.filters.currency': 'العملة',
  'quotations.filters.remove': 'إزالة الفلتر',
  'quotations.filters.reset': 'إعادة تعيين',
  'quotations.filters.clear': 'مسح عوامل التصفية',
  'quotations.filters.apply': 'تطبيق',
  'quotations.filters.applyWithCount': 'تطبيق ({{count}})',
  'quotations.filters.activeCount': '{{count}} عامل تصفية مفعل',
  'quotations.filters.sort': 'ترتيب حسب',
  'quotations.filters.sort.newest': 'الأحدث',
  'quotations.filters.sort.oldest': 'الأقدم',
  'quotations.filters.sort.totalDesc': 'الأعلى قيمة',
  'quotations.filters.sort.totalAsc': 'الأقل قيمة',
  'quotations.filters.sort.expiringSoon': 'الأقرب انتهاءً',
  'quotations.filters.status': 'الحالة',
  'quotations.filters.statusHint': 'اختر حالة أو أكثر.',
  'quotations.filters.created': 'تاريخ الإنشاء',
  'quotations.filters.anyDate': 'أي تاريخ',
  'quotations.filters.validity': 'الصلاحية',
  'quotations.filters.validity.valid': 'ما زال صالحًا',
  'quotations.filters.validity.expired': 'منتهي',
  'quotations.filters.validity.none': 'بدون تاريخ انتهاء',
  'quotations.filters.total': 'الإجمالي',
  'quotations.filters.min': 'من',
  'quotations.filters.max': 'إلى',

  // ─── Quotations: Form ────────────────────────────────────────────────────────
  'quotations.form.editTitle': 'تعديل عرض السعر',
  'quotations.form.newTitle': 'عرض سعر جديد',
  'quotations.form.customer': 'العميل',
  'quotations.form.email': 'البريد الإلكتروني',
  'quotations.form.emailPlaceholder': 'customer@example.com',
  'quotations.form.address': 'العنوان',
  'quotations.form.addressPlaceholder': 'عنوان التسليم/الفوترة',
  'quotations.form.location': 'الموقع',
  'quotations.form.locationHint': '(اختياري — حدده على الخريطة)',
  'quotations.form.selectLocation': 'اختر الموقع',
  'quotations.form.items': 'العناصر',
  'quotations.form.addProduct': 'إضافة منتج',
  'quotations.form.addCustomLine': 'إضافة بند مخصص',
  'quotations.form.lineDescriptionPlaceholder': 'وصف البند',
  'quotations.form.pricePlaceholder': 'السعر',
  'quotations.form.qtyPlaceholder': 'الكمية',
  'quotations.form.addLine': 'إضافة البند',
  'quotations.form.noItemsYet': 'لا توجد عناصر بعد — أضف منتجًا أو بندًا مخصصًا',
  'quotations.form.qty': 'الكمية',
  'quotations.form.unitPrice': 'سعر الوحدة',
  'quotations.form.total': 'الإجمالي',
  'quotations.form.charges': 'الرسوم',
  'quotations.form.tax': 'الضريبة',
  'quotations.form.shipping': 'الشحن',
  'quotations.form.discount': 'الخصم',
  'quotations.form.currencyFailed': 'تعذّر التحويل إلى هذه العملة. حاول مرة أخرى.',
  'quotations.form.currency': 'العملة',
  'quotations.form.subtotal': 'المجموع الفرعي',
  'quotations.form.notesPlaceholder': 'أضف ملاحظة حول عرض السعر هذا...',
  'quotations.form.missingInfoTitle': 'معلومات ناقصة',
  'quotations.form.missingInfoMessage': 'اسم العميل ورقم الهاتف مطلوبان',
  'quotations.form.noItemsTitle': 'لا توجد عناصر',
  'quotations.form.noItemsMessage': 'أضف عنصرًا واحدًا على الأقل',
  'quotations.form.savedTitle': 'تم الحفظ',
  'quotations.form.updatedMessage': 'تم تحديث عرض السعر بنجاح',
  'quotations.form.createdMessage': 'تم إنشاء عرض السعر بنجاح',
  'quotations.form.saveError': 'فشل حفظ عرض السعر',
  'quotations.form.addProducts': 'إضافة منتجات',
  'quotations.form.shippingMethod': 'طريقة الشحن',
  'quotations.form.selectShippingMethod': 'اختر طريقة الشحن',
  'quotations.form.selectShippingMethodTitle': 'اختيار طريقة الشحن',
  'quotations.form.noShippingMethods': 'لا توجد طرق شحن معدة',
  'quotations.form.free': 'مجاني',
  'quotations.form.zoneLabel': 'المنطقة: {{zone}}',
  'quotations.form.otherAreaFallback': 'منطقة أخرى (سعر احتياطي)',
  'quotations.form.otherArea': 'منطقة أخرى',
  'quotations.form.freeShippingHint': 'أضف {{amount}} أخرى للحصول على شحن مجاني',
  'quotations.form.express': 'سريع',
  'quotations.form.couponCodePlaceholder': 'كود الخصم',
  'quotations.form.apply': 'تطبيق',
  'quotations.form.couponAppliedTitle': 'تم تطبيق الكوبون',
  'quotations.form.couponAppliedMessage': 'تم توفير {{amount}}',
  'quotations.form.invalidCouponTitle': 'كوبون غير صالح',
  'quotations.form.invalidCouponMessage': 'الكوبون غير صالح',
  'quotations.form.businessNotFound': 'النشاط التجاري غير موجود',
  'quotations.form.shippingZoneUnavailableTitle': 'المنطقة غير متاحة',
  'quotations.form.shippingZoneUnavailableMessage': 'الموقع المحدد يقع خارج مناطق طريقة الشحن هذه.',
  'quotations.form.manualDiscount': 'الخصم',

  // ─── Quotations: Detail ──────────────────────────────────────────────────────
  'quotations.detail.title': 'عرض السعر',
  'quotations.detail.edit': 'تعديل',
  'quotations.detail.delete': 'حذف',
  'quotations.detail.viewConvertedOrder': 'عرض الطلب المحوّل ←',
  'quotations.detail.customer': 'العميل',
  'quotations.detail.items': 'العناصر',
  'quotations.detail.subtotal': 'المجموع الفرعي',
  'quotations.detail.tax': 'الضريبة',
  'quotations.detail.shipping': 'الشحن',
  'quotations.detail.discount': 'الخصم',
  'quotations.detail.total': 'الإجمالي',
  'quotations.detail.notes': 'ملاحظات',
  'quotations.detail.viewPdf': 'عرض PDF',
  'quotations.detail.generatePdf': 'إنشاء PDF',
  'quotations.detail.regeneratePdf': 'إعادة إنشاء PDF',
  'quotations.detail.convertToOrder': 'تحويل إلى طلب',
  'quotations.detail.deleteTitle': 'حذف عرض السعر',
  'quotations.detail.deleteMessage': 'هل أنت متأكد من حذف عرض السعر هذا؟ لا يمكن التراجع عن هذا الإجراء.',
  'quotations.detail.deletedMessage': 'تم حذف عرض السعر',
  'quotations.detail.deleteError': 'فشل حذف عرض السعر',
  'quotations.detail.notFound': 'عرض السعر غير موجود',
  'quotations.detail.loadError': 'فشل تحميل عرض السعر',
  'quotations.detail.pdfError': 'فشل إنشاء ملف PDF',
  'quotations.detail.convertedTitle': 'تم التحويل',
  'quotations.detail.convertedMessage': 'تم إنشاء الطلب {{orderNumber}} بنجاح',
  'quotations.detail.convertError': 'فشل تحويل عرض السعر',

  // ─── Quotations: Templates ───────────────────────────────────────────────────
  'quotations.templates.title': 'القوالب',
  'quotations.templates.headerTitle': 'قوالب عروض الأسعار والفواتير',
  'quotations.templates.noCustomTemplates': 'لا توجد قوالب مخصصة بعد',
  'quotations.templates.noCustomTemplatesHint': 'تستخدم عروض الأسعار قالبًا افتراضيًا مدمجًا حتى تنشئ قالبًا خاصًا بك',
  'quotations.templates.newTemplate': 'قالب جديد',
  'quotations.templates.empty': 'لا توجد قوالب بعد',
  'quotations.templates.emptyHint': 'اضغط + لإنشاء أول قالب',
  'quotations.templates.default': 'افتراضي',
  'quotations.templates.loadError': 'فشل تحميل القوالب',
  'quotations.templates.deleteTitle': 'حذف القالب',
  'quotations.templates.deleteMessage': 'هل أنت متأكد من حذف هذا القالب؟ لا يمكن التراجع عن هذا الإجراء.',
  'quotations.templates.deletedMessage': 'تم حذف القالب',
  'quotations.templates.deleteError': 'فشل حذف القالب',

  // ─── Quotations: Template Editor ─────────────────────────────────────────────
  'quotations.templateEditor.editTitle': 'تعديل القالب',
  'quotations.templateEditor.newTitle': 'قالب جديد',
  'quotations.templateEditor.nameLabel': 'اسم القالب *',
  'quotations.templateEditor.namePlaceholder': 'مثال: عرض سعر قياسي',
  'quotations.templateEditor.type': 'النوع',
  'quotations.templateEditor.typeQuotation': 'عرض سعر',
  'quotations.templateEditor.typeInvoice': 'فاتورة',
  'quotations.templateEditor.logoUrl': 'رابط الشعار',
  'quotations.templateEditor.primaryColor': 'اللون الأساسي',
  'quotations.templateEditor.secondaryColor': 'اللون الثانوي',
  'quotations.templateEditor.useAsDefault': 'استخدام كقالب {{type}} افتراضي',
  'quotations.templateEditor.htmlContent': 'محتوى HTML',
  'quotations.templateEditor.missingNameTitle': 'الاسم مفقود',
  'quotations.templateEditor.missingNameMessage': 'اسم القالب مطلوب',
  'quotations.templateEditor.savedTitle': 'تم الحفظ',
  'quotations.templateEditor.updatedMessage': 'تم تحديث القالب بنجاح',
  'quotations.templateEditor.createdMessage': 'تم إنشاء القالب بنجاح',
  'quotations.templateEditor.saveError': 'فشل حفظ القالب',
  'quotations.templateEditor.loadError': 'فشل تحميل القالب',
  'quotations.templateEditor.preview': 'معاينة',
  'quotations.templateEditor.previewTitle': 'معاينة القالب',
  'quotations.templateEditor.previewError': 'فشل إنشاء المعاينة',
  'quotations.templateEditor.settings': 'إعدادات القالب',
  'quotations.templateEditor.canvasView': 'لوحة التصميم',
  'quotations.templateEditor.codeView': 'الكود',
  'quotations.templateEditor.notDefaultHint': 'ليس القالب الافتراضي — لن تستخدمه عروض الأسعار حتى يتم تعيينه كافتراضي.',
};
